var n, l$3, u$4, i$4, o$1, r$4, f$3, e$1, c$3, s$3, a$3, h$2 = {}, v$2 = [], p$3 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, y$2 = Array.isArray;
function d$2(n2, l2) {
  for (var u2 in l2) n2[u2] = l2[u2];
  return n2;
}
function w$3(n2) {
  n2 && n2.parentNode && n2.parentNode.removeChild(n2);
}
function _$1(l2, u2, t2) {
  var i2, o2, r2, f2 = {};
  for (r2 in u2) "key" == r2 ? i2 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : f2[r2] = u2[r2];
  if (arguments.length > 2 && (f2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps) for (r2 in l2.defaultProps) void 0 === f2[r2] && (f2[r2] = l2.defaultProps[r2]);
  return g$2(l2, f2, i2, o2, null);
}
function g$2(n2, t2, i2, o2, r2) {
  var f2 = { type: n2, props: t2, key: i2, ref: o2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == r2 ? ++u$4 : r2, __i: -1, __u: 0 };
  return null == r2 && null != l$3.vnode && l$3.vnode(f2), f2;
}
function m$2() {
  return { current: null };
}
function b$2(n2) {
  return n2.children;
}
function k$2(n2, l2) {
  this.props = n2, this.context = l2;
}
function x$2(n2, l2) {
  if (null == l2) return n2.__ ? x$2(n2.__, n2.__i + 1) : null;
  for (var u2; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) return u2.__e;
  return "function" == typeof n2.type ? x$2(n2) : null;
}
function C$2(n2) {
  var l2, u2;
  if (null != (n2 = n2.__) && null != n2.__c) {
    for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) {
      n2.__e = n2.__c.base = u2.__e;
      break;
    }
    return C$2(n2);
  }
}
function S(n2) {
  (!n2.__d && (n2.__d = true) && i$4.push(n2) && !M$1.__r++ || o$1 !== l$3.debounceRendering) && ((o$1 = l$3.debounceRendering) || r$4)(M$1);
}
function M$1() {
  var n2, u2, t2, o2, r2, e2, c2, s2;
  for (i$4.sort(f$3); n2 = i$4.shift(); ) n2.__d && (u2 = i$4.length, o2 = void 0, e2 = (r2 = (t2 = n2).__v).__e, c2 = [], s2 = [], t2.__P && ((o2 = d$2({}, r2)).__v = r2.__v + 1, l$3.vnode && l$3.vnode(o2), O$1(t2.__P, o2, r2, t2.__n, t2.__P.namespaceURI, 32 & r2.__u ? [e2] : null, c2, null == e2 ? x$2(r2) : e2, !!(32 & r2.__u), s2), o2.__v = r2.__v, o2.__.__k[o2.__i] = o2, j$2(c2, o2, s2), o2.__e != e2 && C$2(o2)), i$4.length > u2 && i$4.sort(f$3));
  M$1.__r = 0;
}
function P$2(n2, l2, u2, t2, i2, o2, r2, f2, e2, c2, s2) {
  var a2, p2, y2, d2, w2, _2 = t2 && t2.__k || v$2, g2 = l2.length;
  for (u2.__d = e2, $$1(u2, l2, _2), e2 = u2.__d, a2 = 0; a2 < g2; a2++) null != (y2 = u2.__k[a2]) && (p2 = -1 === y2.__i ? h$2 : _2[y2.__i] || h$2, y2.__i = a2, O$1(n2, y2, p2, i2, o2, r2, f2, e2, c2, s2), d2 = y2.__e, y2.ref && p2.ref != y2.ref && (p2.ref && N$1(p2.ref, null, y2), s2.push(y2.ref, y2.__c || d2, y2)), null == w2 && null != d2 && (w2 = d2), 65536 & y2.__u || p2.__k === y2.__k ? e2 = I$1(y2, e2, n2) : "function" == typeof y2.type && void 0 !== y2.__d ? e2 = y2.__d : d2 && (e2 = d2.nextSibling), y2.__d = void 0, y2.__u &= -196609);
  u2.__d = e2, u2.__e = w2;
}
function $$1(n2, l2, u2) {
  var t2, i2, o2, r2, f2, e2 = l2.length, c2 = u2.length, s2 = c2, a2 = 0;
  for (n2.__k = [], t2 = 0; t2 < e2; t2++) null != (i2 = l2[t2]) && "boolean" != typeof i2 && "function" != typeof i2 ? (r2 = t2 + a2, (i2 = n2.__k[t2] = "string" == typeof i2 || "number" == typeof i2 || "bigint" == typeof i2 || i2.constructor == String ? g$2(null, i2, null, null, null) : y$2(i2) ? g$2(b$2, { children: i2 }, null, null, null) : void 0 === i2.constructor && i2.__b > 0 ? g$2(i2.type, i2.props, i2.key, i2.ref ? i2.ref : null, i2.__v) : i2).__ = n2, i2.__b = n2.__b + 1, o2 = null, -1 !== (f2 = i2.__i = L$1(i2, u2, r2, s2)) && (s2--, (o2 = u2[f2]) && (o2.__u |= 131072)), null == o2 || null === o2.__v ? (-1 == f2 && a2--, "function" != typeof i2.type && (i2.__u |= 65536)) : f2 !== r2 && (f2 == r2 - 1 ? a2-- : f2 == r2 + 1 ? a2++ : (f2 > r2 ? a2-- : a2++, i2.__u |= 65536))) : i2 = n2.__k[t2] = null;
  if (s2) for (t2 = 0; t2 < c2; t2++) null != (o2 = u2[t2]) && 0 == (131072 & o2.__u) && (o2.__e == n2.__d && (n2.__d = x$2(o2)), V$1(o2, o2));
}
function I$1(n2, l2, u2) {
  var t2, i2;
  if ("function" == typeof n2.type) {
    for (t2 = n2.__k, i2 = 0; t2 && i2 < t2.length; i2++) t2[i2] && (t2[i2].__ = n2, l2 = I$1(t2[i2], l2, u2));
    return l2;
  }
  n2.__e != l2 && (l2 && n2.type && !u2.contains(l2) && (l2 = x$2(n2)), u2.insertBefore(n2.__e, l2 || null), l2 = n2.__e);
  do {
    l2 = l2 && l2.nextSibling;
  } while (null != l2 && 8 === l2.nodeType);
  return l2;
}
function H$1(n2, l2) {
  return l2 = l2 || [], null == n2 || "boolean" == typeof n2 || (y$2(n2) ? n2.some(function(n3) {
    H$1(n3, l2);
  }) : l2.push(n2)), l2;
}
function L$1(n2, l2, u2, t2) {
  var i2 = n2.key, o2 = n2.type, r2 = u2 - 1, f2 = u2 + 1, e2 = l2[u2];
  if (null === e2 || e2 && i2 == e2.key && o2 === e2.type && 0 == (131072 & e2.__u)) return u2;
  if (t2 > (null != e2 && 0 == (131072 & e2.__u) ? 1 : 0)) for (; r2 >= 0 || f2 < l2.length; ) {
    if (r2 >= 0) {
      if ((e2 = l2[r2]) && 0 == (131072 & e2.__u) && i2 == e2.key && o2 === e2.type) return r2;
      r2--;
    }
    if (f2 < l2.length) {
      if ((e2 = l2[f2]) && 0 == (131072 & e2.__u) && i2 == e2.key && o2 === e2.type) return f2;
      f2++;
    }
  }
  return -1;
}
function T$2(n2, l2, u2) {
  "-" === l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || p$3.test(l2) ? u2 : u2 + "px";
}
function A$2(n2, l2, u2, t2, i2) {
  var o2;
  n: if ("style" === l2) if ("string" == typeof u2) n2.style.cssText = u2;
  else {
    if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2) for (l2 in t2) u2 && l2 in u2 || T$2(n2.style, l2, "");
    if (u2) for (l2 in u2) t2 && u2[l2] === t2[l2] || T$2(n2.style, l2, u2[l2]);
  }
  else if ("o" === l2[0] && "n" === l2[1]) o2 = l2 !== (l2 = l2.replace(/(PointerCapture)$|Capture$/i, "$1")), l2 = l2.toLowerCase() in n2 || "onFocusOut" === l2 || "onFocusIn" === l2 ? l2.toLowerCase().slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + o2] = u2, u2 ? t2 ? u2.u = t2.u : (u2.u = e$1, n2.addEventListener(l2, o2 ? s$3 : c$3, o2)) : n2.removeEventListener(l2, o2 ? s$3 : c$3, o2);
  else {
    if ("http://www.w3.org/2000/svg" == i2) l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if ("width" != l2 && "height" != l2 && "href" != l2 && "list" != l2 && "form" != l2 && "tabIndex" != l2 && "download" != l2 && "rowSpan" != l2 && "colSpan" != l2 && "role" != l2 && "popover" != l2 && l2 in n2) try {
      n2[l2] = null == u2 ? "" : u2;
      break n;
    } catch (n3) {
    }
    "function" == typeof u2 || (null == u2 || false === u2 && "-" !== l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, "popover" == l2 && 1 == u2 ? "" : u2));
  }
}
function F$2(n2) {
  return function(u2) {
    if (this.l) {
      var t2 = this.l[u2.type + n2];
      if (null == u2.t) u2.t = e$1++;
      else if (u2.t < t2.u) return;
      return t2(l$3.event ? l$3.event(u2) : u2);
    }
  };
}
function O$1(n2, u2, t2, i2, o2, r2, f2, e2, c2, s2) {
  var a2, h2, v2, p2, w2, _2, g2, m2, x2, C2, S2, M2, $2, I2, H2, L2, T2 = u2.type;
  if (void 0 !== u2.constructor) return null;
  128 & t2.__u && (c2 = !!(32 & t2.__u), r2 = [e2 = u2.__e = t2.__e]), (a2 = l$3.__b) && a2(u2);
  n: if ("function" == typeof T2) try {
    if (m2 = u2.props, x2 = "prototype" in T2 && T2.prototype.render, C2 = (a2 = T2.contextType) && i2[a2.__c], S2 = a2 ? C2 ? C2.props.value : a2.__ : i2, t2.__c ? g2 = (h2 = u2.__c = t2.__c).__ = h2.__E : (x2 ? u2.__c = h2 = new T2(m2, S2) : (u2.__c = h2 = new k$2(m2, S2), h2.constructor = T2, h2.render = q$2), C2 && C2.sub(h2), h2.props = m2, h2.state || (h2.state = {}), h2.context = S2, h2.__n = i2, v2 = h2.__d = true, h2.__h = [], h2._sb = []), x2 && null == h2.__s && (h2.__s = h2.state), x2 && null != T2.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = d$2({}, h2.__s)), d$2(h2.__s, T2.getDerivedStateFromProps(m2, h2.__s))), p2 = h2.props, w2 = h2.state, h2.__v = u2, v2) x2 && null == T2.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), x2 && null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
    else {
      if (x2 && null == T2.getDerivedStateFromProps && m2 !== p2 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(m2, S2), !h2.__e && (null != h2.shouldComponentUpdate && false === h2.shouldComponentUpdate(m2, h2.__s, S2) || u2.__v === t2.__v)) {
        for (u2.__v !== t2.__v && (h2.props = m2, h2.state = h2.__s, h2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.some(function(n3) {
          n3 && (n3.__ = u2);
        }), M2 = 0; M2 < h2._sb.length; M2++) h2.__h.push(h2._sb[M2]);
        h2._sb = [], h2.__h.length && f2.push(h2);
        break n;
      }
      null != h2.componentWillUpdate && h2.componentWillUpdate(m2, h2.__s, S2), x2 && null != h2.componentDidUpdate && h2.__h.push(function() {
        h2.componentDidUpdate(p2, w2, _2);
      });
    }
    if (h2.context = S2, h2.props = m2, h2.__P = n2, h2.__e = false, $2 = l$3.__r, I2 = 0, x2) {
      for (h2.state = h2.__s, h2.__d = false, $2 && $2(u2), a2 = h2.render(h2.props, h2.state, h2.context), H2 = 0; H2 < h2._sb.length; H2++) h2.__h.push(h2._sb[H2]);
      h2._sb = [];
    } else do {
      h2.__d = false, $2 && $2(u2), a2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s;
    } while (h2.__d && ++I2 < 25);
    h2.state = h2.__s, null != h2.getChildContext && (i2 = d$2(d$2({}, i2), h2.getChildContext())), x2 && !v2 && null != h2.getSnapshotBeforeUpdate && (_2 = h2.getSnapshotBeforeUpdate(p2, w2)), P$2(n2, y$2(L2 = null != a2 && a2.type === b$2 && null == a2.key ? a2.props.children : a2) ? L2 : [L2], u2, t2, i2, o2, r2, f2, e2, c2, s2), h2.base = u2.__e, u2.__u &= -161, h2.__h.length && f2.push(h2), g2 && (h2.__E = h2.__ = null);
  } catch (n3) {
    if (u2.__v = null, c2 || null != r2) {
      for (u2.__u |= c2 ? 160 : 128; e2 && 8 === e2.nodeType && e2.nextSibling; ) e2 = e2.nextSibling;
      r2[r2.indexOf(e2)] = null, u2.__e = e2;
    } else u2.__e = t2.__e, u2.__k = t2.__k;
    l$3.__e(n3, u2, t2);
  }
  else null == r2 && u2.__v === t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : u2.__e = z$2(t2.__e, u2, t2, i2, o2, r2, f2, c2, s2);
  (a2 = l$3.diffed) && a2(u2);
}
function j$2(n2, u2, t2) {
  u2.__d = void 0;
  for (var i2 = 0; i2 < t2.length; i2++) N$1(t2[i2], t2[++i2], t2[++i2]);
  l$3.__c && l$3.__c(u2, n2), n2.some(function(u3) {
    try {
      n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
        n3.call(u3);
      });
    } catch (n3) {
      l$3.__e(n3, u3.__v);
    }
  });
}
function z$2(u2, t2, i2, o2, r2, f2, e2, c2, s2) {
  var a2, v2, p2, d2, _2, g2, m2, b2 = i2.props, k2 = t2.props, C2 = t2.type;
  if ("svg" === C2 ? r2 = "http://www.w3.org/2000/svg" : "math" === C2 ? r2 = "http://www.w3.org/1998/Math/MathML" : r2 || (r2 = "http://www.w3.org/1999/xhtml"), null != f2) {
    for (a2 = 0; a2 < f2.length; a2++) if ((_2 = f2[a2]) && "setAttribute" in _2 == !!C2 && (C2 ? _2.localName === C2 : 3 === _2.nodeType)) {
      u2 = _2, f2[a2] = null;
      break;
    }
  }
  if (null == u2) {
    if (null === C2) return document.createTextNode(k2);
    u2 = document.createElementNS(r2, C2, k2.is && k2), c2 && (l$3.__m && l$3.__m(t2, f2), c2 = false), f2 = null;
  }
  if (null === C2) b2 === k2 || c2 && u2.data === k2 || (u2.data = k2);
  else {
    if (f2 = f2 && n.call(u2.childNodes), b2 = i2.props || h$2, !c2 && null != f2) for (b2 = {}, a2 = 0; a2 < u2.attributes.length; a2++) b2[(_2 = u2.attributes[a2]).name] = _2.value;
    for (a2 in b2) if (_2 = b2[a2], "children" == a2) ;
    else if ("dangerouslySetInnerHTML" == a2) p2 = _2;
    else if (!(a2 in k2)) {
      if ("value" == a2 && "defaultValue" in k2 || "checked" == a2 && "defaultChecked" in k2) continue;
      A$2(u2, a2, null, _2, r2);
    }
    for (a2 in k2) _2 = k2[a2], "children" == a2 ? d2 = _2 : "dangerouslySetInnerHTML" == a2 ? v2 = _2 : "value" == a2 ? g2 = _2 : "checked" == a2 ? m2 = _2 : c2 && "function" != typeof _2 || b2[a2] === _2 || A$2(u2, a2, _2, b2[a2], r2);
    if (v2) c2 || p2 && (v2.__html === p2.__html || v2.__html === u2.innerHTML) || (u2.innerHTML = v2.__html), t2.__k = [];
    else if (p2 && (u2.innerHTML = ""), P$2(u2, y$2(d2) ? d2 : [d2], t2, i2, o2, "foreignObject" === C2 ? "http://www.w3.org/1999/xhtml" : r2, f2, e2, f2 ? f2[0] : i2.__k && x$2(i2, 0), c2, s2), null != f2) for (a2 = f2.length; a2--; ) w$3(f2[a2]);
    c2 || (a2 = "value", "progress" === C2 && null == g2 ? u2.removeAttribute("value") : void 0 !== g2 && (g2 !== u2[a2] || "progress" === C2 && !g2 || "option" === C2 && g2 !== b2[a2]) && A$2(u2, a2, g2, b2[a2], r2), a2 = "checked", void 0 !== m2 && m2 !== u2[a2] && A$2(u2, a2, m2, b2[a2], r2));
  }
  return u2;
}
function N$1(n2, u2, t2) {
  try {
    if ("function" == typeof n2) {
      var i2 = "function" == typeof n2.__u;
      i2 && n2.__u(), i2 && null == u2 || (n2.__u = n2(u2));
    } else n2.current = u2;
  } catch (n3) {
    l$3.__e(n3, t2);
  }
}
function V$1(n2, u2, t2) {
  var i2, o2;
  if (l$3.unmount && l$3.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current !== n2.__e || N$1(i2, null, u2)), null != (i2 = n2.__c)) {
    if (i2.componentWillUnmount) try {
      i2.componentWillUnmount();
    } catch (n3) {
      l$3.__e(n3, u2);
    }
    i2.base = i2.__P = null;
  }
  if (i2 = n2.__k) for (o2 = 0; o2 < i2.length; o2++) i2[o2] && V$1(i2[o2], u2, t2 || "function" != typeof n2.type);
  t2 || w$3(n2.__e), n2.__c = n2.__ = n2.__e = n2.__d = void 0;
}
function q$2(n2, l2, u2) {
  return this.constructor(n2, u2);
}
function B$2(u2, t2, i2) {
  var o2, r2, f2, e2;
  l$3.__ && l$3.__(u2, t2), r2 = (o2 = "function" == typeof i2) ? null : i2 && i2.__k || t2.__k, f2 = [], e2 = [], O$1(t2, u2 = (!o2 && i2 || t2).__k = _$1(b$2, null, [u2]), r2 || h$2, h$2, t2.namespaceURI, !o2 && i2 ? [i2] : r2 ? null : t2.firstChild ? n.call(t2.childNodes) : null, f2, !o2 && i2 ? i2 : r2 ? r2.__e : t2.firstChild, o2, e2), j$2(f2, u2, e2);
}
function D$2(n2, l2) {
  B$2(n2, l2, D$2);
}
function E$1(l2, u2, t2) {
  var i2, o2, r2, f2, e2 = d$2({}, l2.props);
  for (r2 in l2.type && l2.type.defaultProps && (f2 = l2.type.defaultProps), u2) "key" == r2 ? i2 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : e2[r2] = void 0 === u2[r2] && void 0 !== f2 ? f2[r2] : u2[r2];
  return arguments.length > 2 && (e2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), g$2(l2.type, e2, i2 || l2.key, o2 || l2.ref, null);
}
function G$1(n2, l2) {
  var u2 = { __c: l2 = "__cC" + a$3++, __: n2, Consumer: function(n3, l3) {
    return n3.children(l3);
  }, Provider: function(n3) {
    var u3, t2;
    return this.getChildContext || (u3 = /* @__PURE__ */ new Set(), (t2 = {})[l2] = this, this.getChildContext = function() {
      return t2;
    }, this.componentWillUnmount = function() {
      u3 = null;
    }, this.shouldComponentUpdate = function(n4) {
      this.props.value !== n4.value && u3.forEach(function(n5) {
        n5.__e = true, S(n5);
      });
    }, this.sub = function(n4) {
      u3.add(n4);
      var l3 = n4.componentWillUnmount;
      n4.componentWillUnmount = function() {
        u3 && u3.delete(n4), l3 && l3.call(n4);
      };
    }), n3.children;
  } };
  return u2.Provider.__ = u2.Consumer.contextType = u2;
}
n = v$2.slice, l$3 = { __e: function(n2, l2, u2, t2) {
  for (var i2, o2, r2; l2 = l2.__; ) if ((i2 = l2.__c) && !i2.__) try {
    if ((o2 = i2.constructor) && null != o2.getDerivedStateFromError && (i2.setState(o2.getDerivedStateFromError(n2)), r2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(n2, t2 || {}), r2 = i2.__d), r2) return i2.__E = i2;
  } catch (l3) {
    n2 = l3;
  }
  throw n2;
} }, u$4 = 0, k$2.prototype.setState = function(n2, l2) {
  var u2;
  u2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = d$2({}, this.state), "function" == typeof n2 && (n2 = n2(d$2({}, u2), this.props)), n2 && d$2(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), S(this));
}, k$2.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = true, n2 && this.__h.push(n2), S(this));
}, k$2.prototype.render = b$2, i$4 = [], r$4 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$3 = function(n2, l2) {
  return n2.__v.__b - l2.__v.__b;
}, M$1.__r = 0, e$1 = 0, c$3 = F$2(false), s$3 = F$2(true), a$3 = 0;
var i$3;
function t$2(o2, e2) {
  return l$3.__a && l$3.__a(e2), o2;
}
null != (i$3 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0) && i$3.__PREACT_DEVTOOLS__ && i$3.__PREACT_DEVTOOLS__.attachPreact("10.24.3", l$3, { Fragment: b$2, Component: k$2 });
var t$1 = {};
function a$2(e2) {
  return e2.type === b$2 ? "Fragment" : "function" == typeof e2.type ? e2.type.displayName || e2.type.name : "string" == typeof e2.type ? e2.type : "#text";
}
var i$2 = [], s$2 = [];
function c$2() {
  return i$2.length > 0 ? i$2[i$2.length - 1] : null;
}
var l$2 = true;
function u$3(e2) {
  return "function" == typeof e2.type && e2.type != b$2;
}
function f$2(n2) {
  for (var e2 = [n2], o2 = n2; null != o2.__o; ) e2.push(o2.__o), o2 = o2.__o;
  return e2.reduce(function(n3, e3) {
    n3 += "  in " + a$2(e3);
    var o3 = e3.__source;
    return o3 ? n3 += " (at " + o3.fileName + ":" + o3.lineNumber + ")" : l$2 && console.warn("Add @babel/plugin-transform-react-jsx-source to get a more detailed component stack. Note that you should not add it to production builds of your App for bundle size reasons."), l$2 = false, n3 + "\n";
  }, "");
}
var d$1 = "function" == typeof WeakMap;
function p$2(n2) {
  var e2 = [];
  return n2.__k ? (n2.__k.forEach(function(n3) {
    n3 && "function" == typeof n3.type ? e2.push.apply(e2, p$2(n3)) : n3 && "string" == typeof n3.type && e2.push(n3.type);
  }), e2) : e2;
}
function h$1(n2) {
  return n2 ? "function" == typeof n2.type ? null == n2.__ ? null != n2.__e && null != n2.__e.parentNode ? n2.__e.parentNode.localName : "" : h$1(n2.__) : n2.type : "";
}
var v$1 = k$2.prototype.setState;
function y$1(n2) {
  return "table" === n2 || "tfoot" === n2 || "tbody" === n2 || "thead" === n2 || "td" === n2 || "tr" === n2 || "th" === n2;
}
k$2.prototype.setState = function(n2, e2) {
  return null == this.__v && null == this.state && console.warn('Calling "this.setState" inside the constructor of a component is a no-op and might be a bug in your application. Instead, set "this.state = {}" directly.\n\n' + f$2(c$2())), v$1.call(this, n2, e2);
};
var m$1 = /^(address|article|aside|blockquote|details|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|main|menu|nav|ol|p|pre|search|section|table|ul)$/, b$1 = k$2.prototype.forceUpdate;
function w$2(n2) {
  var e2 = n2.props, o2 = a$2(n2), t2 = "";
  for (var r2 in e2) if (e2.hasOwnProperty(r2) && "children" !== r2) {
    var i2 = e2[r2];
    "function" == typeof i2 && (i2 = "function " + (i2.displayName || i2.name) + "() {}"), i2 = Object(i2) !== i2 || i2.toString ? i2 + "" : Object.prototype.toString.call(i2), t2 += " " + r2 + "=" + JSON.stringify(i2);
  }
  var s2 = e2.children;
  return "<" + o2 + t2 + (s2 && s2.length ? ">..</" + o2 + ">" : " />");
}
k$2.prototype.forceUpdate = function(n2) {
  return null == this.__v ? console.warn('Calling "this.forceUpdate" inside the constructor of a component is a no-op and might be a bug in your application.\n\n' + f$2(c$2())) : null == this.__P && console.warn(`Can't call "this.forceUpdate" on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.

` + f$2(this.__v)), b$1.call(this, n2);
}, l$3.__m = function(n2, e2) {
  var o2 = n2.type, t2 = e2.map(function(n3) {
    return n3 && n3.localName;
  }).filter(Boolean);
  console.error("Expected a DOM node of type " + o2 + " but found " + t2.join(", ") + "as available DOM-node(s), this is caused by the SSR'd HTML containing different DOM-nodes compared to the hydrated one.\n\n" + f$2(n2));
}, function() {
  !function() {
    var n3 = l$3.__b, o3 = l$3.diffed, t2 = l$3.__, r3 = l$3.vnode, a2 = l$3.__r;
    l$3.diffed = function(n4) {
      u$3(n4) && s$2.pop(), i$2.pop(), o3 && o3(n4);
    }, l$3.__b = function(e2) {
      u$3(e2) && i$2.push(e2), n3 && n3(e2);
    }, l$3.__ = function(n4, e2) {
      s$2 = [], t2 && t2(n4, e2);
    }, l$3.vnode = function(n4) {
      n4.__o = s$2.length > 0 ? s$2[s$2.length - 1] : null, r3 && r3(n4);
    }, l$3.__r = function(n4) {
      u$3(n4) && s$2.push(n4), a2 && a2(n4);
    };
  }();
  var n2 = false, o2 = l$3.__b, r2 = l$3.diffed, c2 = l$3.vnode, l2 = l$3.__r, v2 = l$3.__e, b2 = l$3.__, g2 = l$3.__h, E2 = d$1 ? { useEffect: /* @__PURE__ */ new WeakMap(), useLayoutEffect: /* @__PURE__ */ new WeakMap(), lazyPropTypes: /* @__PURE__ */ new WeakMap() } : null, k2 = [];
  l$3.__e = function(n3, e2, o3, t2) {
    if (e2 && e2.__c && "function" == typeof n3.then) {
      var r3 = n3;
      n3 = new Error("Missing Suspense. The throwing component was: " + a$2(e2));
      for (var i2 = e2; i2; i2 = i2.__) if (i2.__c && i2.__c.__c) {
        n3 = r3;
        break;
      }
      if (n3 instanceof Error) throw n3;
    }
    try {
      (t2 = t2 || {}).componentStack = f$2(e2), v2(n3, e2, o3, t2), "function" != typeof n3.then && setTimeout(function() {
        throw n3;
      });
    } catch (n4) {
      throw n4;
    }
  }, l$3.__ = function(n3, e2) {
    if (!e2) throw new Error("Undefined parent passed to render(), this is the second argument.\nCheck if the element is available in the DOM/has the correct id.");
    var o3;
    switch (e2.nodeType) {
      case 1:
      case 11:
      case 9:
        o3 = true;
        break;
      default:
        o3 = false;
    }
    if (!o3) {
      var t2 = a$2(n3);
      throw new Error("Expected a valid HTML node as a second argument to render.	Received " + e2 + " instead: render(<" + t2 + " />, " + e2 + ");");
    }
    b2 && b2(n3, e2);
  }, l$3.__b = function(e2) {
    var r3 = e2.type;
    if (n2 = true, void 0 === r3) throw new Error("Undefined component passed to createElement()\n\nYou likely forgot to export your component or might have mixed up default and named imports" + w$2(e2) + "\n\n" + f$2(e2));
    if (null != r3 && "object" == typeof r3) {
      if (void 0 !== r3.__k && void 0 !== r3.__e) throw new Error("Invalid type passed to createElement(): " + r3 + "\n\nDid you accidentally pass a JSX literal as JSX twice?\n\n  let My" + a$2(e2) + " = " + w$2(r3) + ";\n  let vnode = <My" + a$2(e2) + " />;\n\nThis usually happens when you export a JSX literal and not the component.\n\n" + f$2(e2));
      throw new Error("Invalid type passed to createElement(): " + (Array.isArray(r3) ? "array" : r3));
    }
    if (void 0 !== e2.ref && "function" != typeof e2.ref && "object" != typeof e2.ref && !("$$typeof" in e2)) throw new Error(`Component's "ref" property should be a function, or an object created by createRef(), but got [` + typeof e2.ref + "] instead\n" + w$2(e2) + "\n\n" + f$2(e2));
    if ("string" == typeof e2.type) {
      for (var i2 in e2.props) if ("o" === i2[0] && "n" === i2[1] && "function" != typeof e2.props[i2] && null != e2.props[i2]) throw new Error(`Component's "` + i2 + '" property should be a function, but got [' + typeof e2.props[i2] + "] instead\n" + w$2(e2) + "\n\n" + f$2(e2));
    }
    if ("function" == typeof e2.type && e2.type.propTypes) {
      if ("Lazy" === e2.type.displayName && E2 && !E2.lazyPropTypes.has(e2.type)) {
        var s2 = "PropTypes are not supported on lazy(). Use propTypes on the wrapped component itself. ";
        try {
          var c3 = e2.type();
          E2.lazyPropTypes.set(e2.type, true), console.warn(s2 + "Component wrapped in lazy() is " + a$2(c3));
        } catch (n3) {
          console.warn(s2 + "We will log the wrapped component's name once it is loaded.");
        }
      }
      var l3 = e2.props;
      e2.type.__f && delete (l3 = function(n3, e3) {
        for (var o3 in e3) n3[o3] = e3[o3];
        return n3;
      }({}, l3)).ref, function(n3, e3, o3, r4, a2) {
        Object.keys(n3).forEach(function(o4) {
          var i3;
          try {
            i3 = n3[o4](e3, o4, r4, "prop", null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (n4) {
            i3 = n4;
          }
          i3 && !(i3.message in t$1) && (t$1[i3.message] = true, console.error("Failed prop type: " + i3.message + (a2 && "\n" + a2() || "")));
        });
      }(e2.type.propTypes, l3, 0, a$2(e2), function() {
        return f$2(e2);
      });
    }
    o2 && o2(e2);
  };
  var T2, _2 = 0;
  l$3.__r = function(e2) {
    l2 && l2(e2), n2 = true;
    var o3 = e2.__c;
    if (o3 === T2 ? _2++ : _2 = 1, _2 >= 25) throw new Error("Too many re-renders. This is limited to prevent an infinite loop which may lock up your browser. The component causing this is: " + a$2(e2));
    T2 = o3;
  }, l$3.__h = function(e2, o3, t2) {
    if (!e2 || !n2) throw new Error("Hook can only be invoked from render methods.");
    g2 && g2(e2, o3, t2);
  };
  var O2 = function(n3, e2) {
    return { get: function() {
      var o3 = "get" + n3 + e2;
      k2 && k2.indexOf(o3) < 0 && (k2.push(o3), console.warn("getting vnode." + n3 + " is deprecated, " + e2));
    }, set: function() {
      var o3 = "set" + n3 + e2;
      k2 && k2.indexOf(o3) < 0 && (k2.push(o3), console.warn("setting vnode." + n3 + " is not allowed, " + e2));
    } };
  }, I2 = { nodeName: O2("nodeName", "use vnode.type"), attributes: O2("attributes", "use vnode.props"), children: O2("children", "use vnode.props.children") }, M2 = Object.create({}, I2);
  l$3.vnode = function(n3) {
    var e2 = n3.props;
    if (null !== n3.type && null != e2 && ("__source" in e2 || "__self" in e2)) {
      var o3 = n3.props = {};
      for (var t2 in e2) {
        var r3 = e2[t2];
        "__source" === t2 ? n3.__source = r3 : "__self" === t2 ? n3.__self = r3 : o3[t2] = r3;
      }
    }
    n3.__proto__ = M2, c2 && c2(n3);
  }, l$3.diffed = function(e2) {
    var o3, t2 = e2.type, i2 = e2.__;
    if (e2.__k && e2.__k.forEach(function(n3) {
      if ("object" == typeof n3 && n3 && void 0 === n3.type) {
        var o4 = Object.keys(n3).join(",");
        throw new Error("Objects are not valid as a child. Encountered an object with the keys {" + o4 + "}.\n\n" + f$2(e2));
      }
    }), e2.__c === T2 && (_2 = 0), "string" == typeof t2 && (y$1(t2) || "p" === t2 || "a" === t2 || "button" === t2)) {
      var s2 = h$1(i2);
      if ("" !== s2 && y$1(t2)) "table" === t2 && "td" !== s2 && y$1(s2) ? (console.log(s2, i2.__e), console.error("Improper nesting of table. Your <table> should not have a table-node parent." + w$2(e2) + "\n\n" + f$2(e2))) : "thead" !== t2 && "tfoot" !== t2 && "tbody" !== t2 || "table" === s2 ? "tr" === t2 && "thead" !== s2 && "tfoot" !== s2 && "tbody" !== s2 ? console.error("Improper nesting of table. Your <tr> should have a <thead/tbody/tfoot> parent." + w$2(e2) + "\n\n" + f$2(e2)) : "td" === t2 && "tr" !== s2 ? console.error("Improper nesting of table. Your <td> should have a <tr> parent." + w$2(e2) + "\n\n" + f$2(e2)) : "th" === t2 && "tr" !== s2 && console.error("Improper nesting of table. Your <th> should have a <tr>." + w$2(e2) + "\n\n" + f$2(e2)) : console.error("Improper nesting of table. Your <thead/tbody/tfoot> should have a <table> parent." + w$2(e2) + "\n\n" + f$2(e2));
      else if ("p" === t2) {
        var c3 = p$2(e2).filter(function(n3) {
          return m$1.test(n3);
        });
        c3.length && console.error("Improper nesting of paragraph. Your <p> should not have " + c3.join(", ") + "as child-elements." + w$2(e2) + "\n\n" + f$2(e2));
      } else "a" !== t2 && "button" !== t2 || -1 !== p$2(e2).indexOf(t2) && console.error("Improper nesting of interactive content. Your <" + t2 + "> should not have other " + ("a" === t2 ? "anchor" : "button") + " tags as child-elements." + w$2(e2) + "\n\n" + f$2(e2));
    }
    if (n2 = false, r2 && r2(e2), null != e2.__k) for (var l3 = [], u2 = 0; u2 < e2.__k.length; u2++) {
      var d2 = e2.__k[u2];
      if (d2 && null != d2.key) {
        var v3 = d2.key;
        if (-1 !== l3.indexOf(v3)) {
          console.error('Following component has two or more children with the same key attribute: "' + v3 + '". This may cause glitches and misbehavior in rendering process. Component: \n\n' + w$2(e2) + "\n\n" + f$2(e2));
          break;
        }
        l3.push(v3);
      }
    }
    if (null != e2.__c && null != e2.__c.__H) {
      var b3 = e2.__c.__H.__;
      if (b3) for (var g3 = 0; g3 < b3.length; g3 += 1) {
        var E3 = b3[g3];
        if (E3.__H) {
          for (var k3 = 0; k3 < E3.__H.length; k3++) if ((o3 = E3.__H[k3]) != o3) {
            var O3 = a$2(e2);
            console.warn("Invalid argument passed to hook. Hooks should not be called with NaN in the dependency array. Hook index " + g3 + " in component " + O3 + " was called with NaN.");
          }
        }
      }
    }
  };
}();
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node2 of mutation.addedNodes) {
        if (node2.tagName === "LINK" && node2.rel === "modulepreload")
          processPreload(node2);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
window.Shopify = window.Shopify || {};
window.Shopify.cart = {};
window.Shopify.cart.add = ({
  items,
  onAdded
}) => {
  if (!items) {
    console.error("Product data is required to add an item to the cart.");
    return;
  }
  fetch(`/cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items
    })
  }).then((response) => {
    return response.json();
  }).then((data) => {
    window.dispatchEvent(new CustomEvent("cart:added", {
      detail: {
        item: data
      }
    }));
    if (onAdded && typeof onAdded === "function") {
      onAdded(data);
    }
  }).catch((error) => console.error(error));
};
window.Shopify.cart.removeItem = ({
  id,
  onRemove
}) => {
  fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id,
      quantity: 0
    })
  }).then((response) => {
    return response.json();
  }).then((data) => {
    const event = new CustomEvent("cart:removed", {
      detail: {
        id,
        cart: data
      }
    });
    window.dispatchEvent(event);
    if (onRemove && typeof onRemove === "function") {
      onRemove(data);
    }
  }).catch((error) => console.error(error));
};
window.Shopify.cart.getCart = (callback) => {
  return fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Couldn't fetch cart! Status: ${response.status}`);
    }
    return response.json();
  }).then((data) => {
    const event = new CustomEvent("cart:fetched", {
      detail: data
    });
    window.dispatchEvent(event);
    if (callback && typeof callback === "function") {
      callback(data);
    }
    return data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
};
window.Shopify.cart.updateItem = ({
  id,
  quantity,
  sellingPlanId,
  properties: properties2,
  onUpdate
}) => {
  let payload = {
    id
  };
  if (quantity) {
    payload["quantity"] = quantity;
  }
  payload["selling_plan"] = "";
  if (sellingPlanId && sellingPlanId !== "Select") {
    payload["selling_plan"] = sellingPlanId;
  }
  if (properties2) {
    payload["properties"] = properties2;
  }
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  }).then((response) => {
    return response.json();
  }).then((data) => {
    const event = new CustomEvent("cart:updated", {
      detail: {
        payload,
        cart: data
      }
    });
    window.dispatchEvent(event);
    if (onUpdate && typeof onUpdate === "function") {
      onUpdate(data);
    }
  }).catch((error) => console.error(error));
};
window.Shopify.cart.getSellingPlans = (handles = []) => {
  return handles.map((handle) => fetch(`/products/${handle}.js`).then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to fetch product: ${handle}`);
    }
    return response.json();
  }).then((product) => {
    if (product && product.selling_plan_groups) {
      return {
        productId: product.id,
        sellingPlans: product.selling_plan_groups
      };
    }
    return null;
  }).catch((error) => {
    console.error(`Error fetching product ${handle}:`, error);
    return null;
  }));
};
function r$3() {
  return (r$3 = Object.assign ? Object.assign.bind() : function(t2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var n2 = arguments[e2];
      for (var o2 in n2) Object.prototype.hasOwnProperty.call(n2, o2) && (t2[o2] = n2[o2]);
    }
    return t2;
  }).apply(this, arguments);
}
var i$1 = ["context", "children"];
function a$1(t2) {
  this.getChildContext = function() {
    return t2.context;
  };
  var e2 = t2.children, n2 = function(t3, e3) {
    if (null == t3) return {};
    var n3, o2, r2 = {}, i2 = Object.keys(t3);
    for (o2 = 0; o2 < i2.length; o2++) e3.indexOf(n3 = i2[o2]) >= 0 || (r2[n3] = t3[n3]);
    return r2;
  }(t2, i$1);
  return E$1(e2, n2);
}
function s$1() {
  var o2 = new CustomEvent("_preact", { detail: {}, bubbles: true, cancelable: true });
  this.dispatchEvent(o2), this._vdom = _$1(a$1, r$3({}, this._props, { context: o2.detail.context }), function e2(n2, o3) {
    if (3 === n2.nodeType) return n2.data;
    if (1 !== n2.nodeType) return null;
    var r2 = [], i2 = {}, a2 = 0, s2 = n2.attributes, l2 = n2.childNodes;
    for (a2 = s2.length; a2--; ) "slot" !== s2[a2].name && (i2[s2[a2].name] = s2[a2].value, i2[c$1(s2[a2].name)] = s2[a2].value);
    for (a2 = l2.length; a2--; ) {
      var u2 = e2(l2[a2], null), d2 = l2[a2].slot;
      d2 ? i2[d2] = _$1(p$1, { name: d2 }, u2) : r2[a2] = u2;
    }
    var h2 = o3 ? _$1(p$1, null, r2) : r2;
    return _$1(o3 || n2.nodeName.toLowerCase(), i2, h2);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? D$2 : B$2)(this._vdom, this._root);
}
function c$1(t2) {
  return t2.replace(/-(\w)/g, function(t3, e2) {
    return e2 ? e2.toUpperCase() : "";
  });
}
function l$1(t2, e2, r2) {
  if (this._vdom) {
    var i2 = {};
    i2[t2] = r2 = null == r2 ? void 0 : r2, i2[c$1(t2)] = r2, this._vdom = E$1(this._vdom, i2), B$2(this._vdom, this._root);
  }
}
function u$2() {
  B$2(this._vdom = null, this._root);
}
function p$1(e2, n2) {
  var o2 = this;
  return _$1("slot", r$3({}, e2, { ref: function(t2) {
    t2 ? (o2.ref = t2, o2._listener || (o2._listener = function(t3) {
      t3.stopPropagation(), t3.detail.context = n2;
    }, t2.addEventListener("_preact", o2._listener))) : o2.ref.removeEventListener("_preact", o2._listener);
  } }));
}
function register(t2, e2, n2, o2) {
  function r2() {
    var e3 = Reflect.construct(HTMLElement, [], r2);
    return e3._vdomComponent = t2, e3._root = o2 && o2.shadow ? e3.attachShadow({ mode: o2.mode || "open" }) : e3, e3;
  }
  return (r2.prototype = Object.create(HTMLElement.prototype)).constructor = r2, r2.prototype.connectedCallback = s$1, r2.prototype.attributeChangedCallback = l$1, r2.prototype.disconnectedCallback = u$2, n2 = n2 || t2.observedAttributes || Object.keys(t2.propTypes || {}), r2.observedAttributes = n2, n2.forEach(function(t3) {
    Object.defineProperty(r2.prototype, t3, { get: function() {
      return this._vdom.props[t3];
    }, set: function(e3) {
      this._vdom ? this.attributeChangedCallback(t3, null, e3) : (this._props || (this._props = {}), this._props[t3] = e3, this.connectedCallback());
      var n3 = typeof e3;
      null != e3 && "string" !== n3 && "boolean" !== n3 && "number" !== n3 || this.setAttribute(t3, e3);
    } });
  }), customElements.define(e2 || t2.tagName || t2.displayName || t2.name, r2);
}
var t, r$2, u$1, i, o = 0, f$1 = [], c = l$3, e = c.__b, a = c.__r, v = c.diffed, l = c.__c, m = c.unmount, s = c.__;
function d(n2, t2) {
  c.__h && c.__h(r$2, n2, o || t2), o = 0;
  var u2 = r$2.__H || (r$2.__H = { __: [], __h: [] });
  return n2 >= u2.__.length && u2.__.push({}), u2.__[n2];
}
function h(n2) {
  return o = 1, p(D$1, n2);
}
function p(n2, u2, i2) {
  var o2 = d(t++, 2);
  if (o2.t = n2, !o2.__c && (o2.__ = [i2 ? i2(u2) : D$1(void 0, u2), function(n3) {
    var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
    t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
  }], o2.__c = r$2, !r$2.u)) {
    var f2 = function(n3, t2, r2) {
      if (!o2.__c.__H) return true;
      var u3 = o2.__c.__H.__.filter(function(n4) {
        return !!n4.__c;
      });
      if (u3.every(function(n4) {
        return !n4.__N;
      })) return !c2 || c2.call(this, n3, t2, r2);
      var i3 = false;
      return u3.forEach(function(n4) {
        if (n4.__N) {
          var t3 = n4.__[0];
          n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
        }
      }), !(!i3 && o2.__c.props === n3) && (!c2 || c2.call(this, n3, t2, r2));
    };
    r$2.u = true;
    var c2 = r$2.shouldComponentUpdate, e2 = r$2.componentWillUpdate;
    r$2.componentWillUpdate = function(n3, t2, r2) {
      if (this.__e) {
        var u3 = c2;
        c2 = void 0, f2(n3, t2, r2), c2 = u3;
      }
      e2 && e2.call(this, n3, t2, r2);
    }, r$2.shouldComponentUpdate = f2;
  }
  return o2.__N || o2.__;
}
function y(n2, u2) {
  var i2 = d(t++, 3);
  !c.__s && C$1(i2.__H, u2) && (i2.__ = n2, i2.i = u2, r$2.__H.__h.push(i2));
}
function _(n2, u2) {
  var i2 = d(t++, 4);
  !c.__s && C$1(i2.__H, u2) && (i2.__ = n2, i2.i = u2, r$2.__h.push(i2));
}
function A$1(n2) {
  return o = 5, T$1(function() {
    return { current: n2 };
  }, []);
}
function F$1(n2, t2, r2) {
  o = 6, _(function() {
    return "function" == typeof n2 ? (n2(t2()), function() {
      return n2(null);
    }) : n2 ? (n2.current = t2(), function() {
      return n2.current = null;
    }) : void 0;
  }, null == r2 ? r2 : r2.concat(n2));
}
function T$1(n2, r2) {
  var u2 = d(t++, 7);
  return C$1(u2.__H, r2) && (u2.__ = n2(), u2.__H = r2, u2.__h = n2), u2.__;
}
function q$1(n2, t2) {
  return o = 8, T$1(function() {
    return n2;
  }, t2);
}
function x$1(n2) {
  var u2 = r$2.context[n2.__c], i2 = d(t++, 9);
  return i2.c = n2, u2 ? (null == i2.__ && (i2.__ = true, u2.sub(r$2)), u2.props.value) : n2.__;
}
function P$1(n2, t2) {
  c.useDebugValue && c.useDebugValue(t2 ? t2(n2) : n2);
}
function b(n2) {
  var u2 = d(t++, 10), i2 = h();
  return u2.__ = n2, r$2.componentDidCatch || (r$2.componentDidCatch = function(n3, t2) {
    u2.__ && u2.__(n3, t2), i2[1](n3);
  }), [i2[0], function() {
    i2[1](void 0);
  }];
}
function g$1() {
  var n2 = d(t++, 11);
  if (!n2.__) {
    for (var u2 = r$2.__v; null !== u2 && !u2.__m && null !== u2.__; ) u2 = u2.__;
    var i2 = u2.__m || (u2.__m = [0, 0]);
    n2.__ = "P" + i2[0] + "-" + i2[1]++;
  }
  return n2.__;
}
function j$1() {
  for (var n2; n2 = f$1.shift(); ) if (n2.__P && n2.__H) try {
    n2.__H.__h.forEach(z$1), n2.__H.__h.forEach(B$1), n2.__H.__h = [];
  } catch (t2) {
    n2.__H.__h = [], c.__e(t2, n2.__v);
  }
}
c.__b = function(n2) {
  r$2 = null, e && e(n2);
}, c.__ = function(n2, t2) {
  n2 && t2.__k && t2.__k.__m && (n2.__m = t2.__k.__m), s && s(n2, t2);
}, c.__r = function(n2) {
  a && a(n2), t = 0;
  var i2 = (r$2 = n2.__c).__H;
  i2 && (u$1 === r$2 ? (i2.__h = [], r$2.__h = [], i2.__.forEach(function(n3) {
    n3.__N && (n3.__ = n3.__N), n3.i = n3.__N = void 0;
  })) : (i2.__h.forEach(z$1), i2.__h.forEach(B$1), i2.__h = [], t = 0)), u$1 = r$2;
}, c.diffed = function(n2) {
  v && v(n2);
  var t2 = n2.__c;
  t2 && t2.__H && (t2.__H.__h.length && (1 !== f$1.push(t2) && i === c.requestAnimationFrame || ((i = c.requestAnimationFrame) || w$1)(j$1)), t2.__H.__.forEach(function(n3) {
    n3.i && (n3.__H = n3.i), n3.i = void 0;
  })), u$1 = r$2 = null;
}, c.__c = function(n2, t2) {
  t2.some(function(n3) {
    try {
      n3.__h.forEach(z$1), n3.__h = n3.__h.filter(function(n4) {
        return !n4.__ || B$1(n4);
      });
    } catch (r2) {
      t2.some(function(n4) {
        n4.__h && (n4.__h = []);
      }), t2 = [], c.__e(r2, n3.__v);
    }
  }), l && l(n2, t2);
}, c.unmount = function(n2) {
  m && m(n2);
  var t2, r2 = n2.__c;
  r2 && r2.__H && (r2.__H.__.forEach(function(n3) {
    try {
      z$1(n3);
    } catch (n4) {
      t2 = n4;
    }
  }), r2.__H = void 0, t2 && c.__e(t2, r2.__v));
};
var k$1 = "function" == typeof requestAnimationFrame;
function w$1(n2) {
  var t2, r2 = function() {
    clearTimeout(u2), k$1 && cancelAnimationFrame(t2), setTimeout(n2);
  }, u2 = setTimeout(r2, 100);
  k$1 && (t2 = requestAnimationFrame(r2));
}
function z$1(n2) {
  var t2 = r$2, u2 = n2.__c;
  "function" == typeof u2 && (n2.__c = void 0, u2()), r$2 = t2;
}
function B$1(n2) {
  var t2 = r$2;
  n2.__c = n2.__(), r$2 = t2;
}
function C$1(n2, t2) {
  return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
    return t3 !== n2[r2];
  });
}
function D$1(n2, t2) {
  return "function" == typeof t2 ? t2(n2) : t2;
}
var f = 0;
function u(e2, t2, n2, o2, i2, u2) {
  t2 || (t2 = {});
  var a2, c2, l2 = t2;
  "ref" in t2 && (a2 = t2.ref, delete t2.ref);
  var p2 = { type: e2, props: l2, key: n2, ref: a2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: --f, __i: -1, __u: 0, __source: i2, __self: u2 };
  if ("function" == typeof e2 && (a2 = e2.defaultProps)) for (c2 in a2) void 0 === l2[c2] && (l2[c2] = a2[c2]);
  return l$3.vnode && l$3.vnode(p2), p2;
}
var _jsxFileName$1V = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/providers/CartProvider.tsx";
const CartContext = G$1({
  cart: {},
  free_shipping_threshold: 0,
  motivators: [],
  upsells: [],
  cartRechargeSettings: {
    pct_text: "",
    select_label: "",
    tool_label: "",
    tool_text: "",
    cancel_text: ""
  }
});
const CartProvider = ({
  children
}) => {
  const [settings, setSettings] = t$2(h({
    cart: {},
    free_shipping_threshold: 0,
    motivators: [],
    upsells: [],
    cartRechargeSettings: {
      pct_text: "",
      select_label: "",
      tool_label: "",
      tool_text: "",
      cancel_text: ""
    }
  }), "settings");
  const getCartContents = async () => {
    var _a, _b, _c, _d;
    const cart = await ((_b = (_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.cart) == null ? void 0 : _b.getCart());
    const itemHandles = (_c = cart == null ? void 0 : cart.items) == null ? void 0 : _c.map((item) => item.handle);
    const lineItemSellingPlans = (itemHandles == null ? void 0 : itemHandles.length) > 0 && await Promise.all(window.Shopify.cart.getSellingPlans(itemHandles));
    (_d = cart == null ? void 0 : cart.items) == null ? void 0 : _d.forEach((item, index) => {
      const {
        sellingPlans
      } = lineItemSellingPlans == null ? void 0 : lineItemSellingPlans.find(({
        productId
      }) => productId === item.product_id);
      cart.items[index].subscription_plans = sellingPlans;
    });
    setSettings((prevState) => ({
      ...prevState,
      cart
    }));
  };
  const getFreeShippingThreshold = () => {
    var _a, _b, _c, _d, _e, _f;
    const free_shipping_threshold = ((_f = (_e = (_d = (_c = (_b = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.cart) == null ? void 0 : _b.settings) == null ? void 0 : _c.customer_motivators) == null ? void 0 : _d.find((motivator) => motivator.type === "cart_meter_free_shipping")) == null ? void 0 : _e.settings) == null ? void 0 : _f.threshold) || null;
    setSettings((prevState) => ({
      ...prevState,
      free_shipping_threshold
    }));
  };
  const getCartMotivatorsByPrice = () => {
    var _a, _b, _c, _d, _e;
    const motivators = ((_e = (_d = (_c = (_b = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.cart) == null ? void 0 : _b.settings) == null ? void 0 : _c.customer_motivators) == null ? void 0 : _d.sort) == null ? void 0 : _e.call(_d, (a2, b2) => {
      return a2.settings.threshold - b2.settings.threshold;
    })) || [];
    setSettings((prevState) => ({
      ...prevState,
      motivators
    }));
  };
  const getUpsells = () => {
    var _a, _b, _c;
    const upsells = ((_c = (_b = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.cart) == null ? void 0 : _b.settings) == null ? void 0 : _c.upsells) || [];
    setSettings((prevState) => ({
      ...prevState,
      upsells
    }));
  };
  const getCartRechargeSettings = () => {
    var _a, _b, _c;
    const cartRechargeSettings = ((_c = (_b = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.cart) == null ? void 0 : _b.settings) == null ? void 0 : _c.recharge) || {};
    setSettings((prevState) => ({
      ...prevState,
      cartRechargeSettings
    }));
  };
  y(() => {
    getCartContents();
    getFreeShippingThreshold();
    getCartMotivatorsByPrice();
    getUpsells();
    getCartRechargeSettings();
    const handleCartChange = () => {
      getCartContents();
    };
    window.addEventListener("cart:added", handleCartChange);
    window.addEventListener("cart:removed", handleCartChange);
    window.addEventListener("cart:updated", handleCartChange);
    return () => {
      window.removeEventListener("cart:added", handleCartChange);
      window.removeEventListener("cart:removed", handleCartChange);
      window.removeEventListener("cart:updated", handleCartChange);
    };
  }, []);
  return u(CartContext.Provider, {
    value: {
      ...settings
    },
    children
  }, void 0, false, {
    fileName: _jsxFileName$1V,
    lineNumber: 120,
    columnNumber: 5
  }, void 0);
};
const useCart = () => {
  return x$1(CartContext);
};
register(CartProvider, "cart-provider");
function g(n2, t2) {
  for (var e2 in n2) if ("__source" !== e2 && !(e2 in t2)) return true;
  for (var r2 in t2) if ("__source" !== r2 && n2[r2] !== t2[r2]) return true;
  return false;
}
function E(n2, t2) {
  this.props = n2, this.context = t2;
}
function C(n2, e2) {
  function r2(n3) {
    var t2 = this.props.ref, r3 = t2 == n3.ref;
    return !r3 && t2 && (t2.call ? t2(null) : t2.current = null), e2 ? !e2(this.props, n3) || !r3 : g(this.props, n3);
  }
  function u2(e3) {
    return this.shouldComponentUpdate = r2, _$1(n2, e3);
  }
  return u2.displayName = "Memo(" + (n2.displayName || n2.name) + ")", u2.prototype.isReactComponent = true, u2.__f = true, u2;
}
(E.prototype = new k$2()).isPureReactComponent = true, E.prototype.shouldComponentUpdate = function(n2, t2) {
  return g(this.props, n2) || g(this.state, t2);
};
var x = l$3.__b;
l$3.__b = function(n2) {
  n2.type && n2.type.__f && n2.ref && (n2.props.ref = n2.ref, n2.ref = null), x && x(n2);
};
var R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function w(n2) {
  function t2(t3) {
    if (!("ref" in t3)) return n2(t3, null);
    var e2 = t3.ref;
    delete t3.ref;
    var r2 = n2(t3, e2);
    return t3.ref = e2, r2;
  }
  return t2.$$typeof = R, t2.render = t2, t2.prototype.isReactComponent = t2.__f = true, t2.displayName = "ForwardRef(" + (n2.displayName || n2.name) + ")", t2;
}
var k = function(n2, t2) {
  return null == n2 ? null : H$1(H$1(n2).map(t2));
}, I = { map: k, forEach: k, count: function(n2) {
  return n2 ? H$1(n2).length : 0;
}, only: function(n2) {
  var t2 = H$1(n2);
  if (1 !== t2.length) throw "Children.only";
  return t2[0];
}, toArray: H$1 }, N = l$3.__e;
l$3.__e = function(n2, t2, e2, r2) {
  if (n2.then) {
    for (var u2, o2 = t2; o2 = o2.__; ) if ((u2 = o2.__c) && u2.__c) return null == t2.__e && (t2.__e = e2.__e, t2.__k = e2.__k), u2.__c(n2, t2);
  }
  N(n2, t2, e2, r2);
};
var M = l$3.unmount;
function T(n2, t2, e2) {
  return n2 && (n2.__c && n2.__c.__H && (n2.__c.__H.__.forEach(function(n3) {
    "function" == typeof n3.__c && n3.__c();
  }), n2.__c.__H = null), null != (n2 = function(n3, t3) {
    for (var e3 in t3) n3[e3] = t3[e3];
    return n3;
  }({}, n2)).__c && (n2.__c.__P === e2 && (n2.__c.__P = t2), n2.__c = null), n2.__k = n2.__k && n2.__k.map(function(n3) {
    return T(n3, t2, e2);
  })), n2;
}
function A(n2, t2, e2) {
  return n2 && e2 && (n2.__v = null, n2.__k = n2.__k && n2.__k.map(function(n3) {
    return A(n3, t2, e2);
  }), n2.__c && n2.__c.__P === t2 && (n2.__e && e2.appendChild(n2.__e), n2.__c.__e = true, n2.__c.__P = e2)), n2;
}
function D() {
  this.__u = 0, this.t = null, this.__b = null;
}
function L(n2) {
  var t2 = n2.__.__c;
  return t2 && t2.__a && t2.__a(n2);
}
function O(n2) {
  var e2, r2, u2;
  function o2(o3) {
    if (e2 || (e2 = n2()).then(function(n3) {
      r2 = n3.default || n3;
    }, function(n3) {
      u2 = n3;
    }), u2) throw u2;
    if (!r2) throw e2;
    return _$1(r2, o3);
  }
  return o2.displayName = "Lazy", o2.__f = true, o2;
}
function F() {
  this.u = null, this.o = null;
}
l$3.unmount = function(n2) {
  var t2 = n2.__c;
  t2 && t2.__R && t2.__R(), t2 && 32 & n2.__u && (n2.type = null), M && M(n2);
}, (D.prototype = new k$2()).__c = function(n2, t2) {
  var e2 = t2.__c, r2 = this;
  null == r2.t && (r2.t = []), r2.t.push(e2);
  var u2 = L(r2.__v), o2 = false, i2 = function() {
    o2 || (o2 = true, e2.__R = null, u2 ? u2(c2) : c2());
  };
  e2.__R = i2;
  var c2 = function() {
    if (!--r2.__u) {
      if (r2.state.__a) {
        var n3 = r2.state.__a;
        r2.__v.__k[0] = A(n3, n3.__c.__P, n3.__c.__O);
      }
      var t3;
      for (r2.setState({ __a: r2.__b = null }); t3 = r2.t.pop(); ) t3.forceUpdate();
    }
  };
  r2.__u++ || 32 & t2.__u || r2.setState({ __a: r2.__b = r2.__v.__k[0] }), n2.then(i2, i2);
}, D.prototype.componentWillUnmount = function() {
  this.t = [];
}, D.prototype.render = function(n2, e2) {
  if (this.__b) {
    if (this.__v.__k) {
      var r2 = document.createElement("div"), o2 = this.__v.__k[0].__c;
      this.__v.__k[0] = T(this.__b, r2, o2.__O = o2.__P);
    }
    this.__b = null;
  }
  var i2 = e2.__a && _$1(b$2, null, n2.fallback);
  return i2 && (i2.__u &= -33), [_$1(b$2, null, e2.__a ? null : n2.children), i2];
};
var U = function(n2, t2, e2) {
  if (++e2[1] === e2[0] && n2.o.delete(t2), n2.props.revealOrder && ("t" !== n2.props.revealOrder[0] || !n2.o.size)) for (e2 = n2.u; e2; ) {
    for (; e2.length > 3; ) e2.pop()();
    if (e2[1] < e2[0]) break;
    n2.u = e2 = e2[2];
  }
};
function V(n2) {
  return this.getChildContext = function() {
    return n2.context;
  }, n2.children;
}
function W(n2) {
  var e2 = this, r2 = n2.i;
  e2.componentWillUnmount = function() {
    B$2(null, e2.l), e2.l = null, e2.i = null;
  }, e2.i && e2.i !== r2 && e2.componentWillUnmount(), e2.l || (e2.i = r2, e2.l = { nodeType: 1, parentNode: r2, childNodes: [], contains: function() {
    return true;
  }, appendChild: function(n3) {
    this.childNodes.push(n3), e2.i.appendChild(n3);
  }, insertBefore: function(n3, t2) {
    this.childNodes.push(n3), e2.i.appendChild(n3);
  }, removeChild: function(n3) {
    this.childNodes.splice(this.childNodes.indexOf(n3) >>> 1, 1), e2.i.removeChild(n3);
  } }), B$2(_$1(V, { context: e2.context }, n2.__v), e2.l);
}
function P(n2, e2) {
  var r2 = _$1(W, { __v: n2, i: e2 });
  return r2.containerInfo = e2, r2;
}
(F.prototype = new k$2()).__a = function(n2) {
  var t2 = this, e2 = L(t2.__v), r2 = t2.o.get(n2);
  return r2[0]++, function(u2) {
    var o2 = function() {
      t2.props.revealOrder ? (r2.push(u2), U(t2, n2, r2)) : u2();
    };
    e2 ? e2(o2) : o2();
  };
}, F.prototype.render = function(n2) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var t2 = H$1(n2.children);
  n2.revealOrder && "b" === n2.revealOrder[0] && t2.reverse();
  for (var e2 = t2.length; e2--; ) this.o.set(t2[e2], this.u = [1, 0, this.u]);
  return n2.children;
}, F.prototype.componentDidUpdate = F.prototype.componentDidMount = function() {
  var n2 = this;
  this.o.forEach(function(t2, e2) {
    U(n2, e2, t2);
  });
};
var j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, z = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, B = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, H = /[A-Z0-9]/g, Z = "undefined" != typeof document, Y = function(n2) {
  return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n2);
};
function $(n2, t2, e2) {
  return null == t2.__k && (t2.textContent = ""), B$2(n2, t2), "function" == typeof e2 && e2(), n2 ? n2.__c : null;
}
function q(n2, t2, e2) {
  return D$2(n2, t2), "function" == typeof e2 && e2(), n2 ? n2.__c : null;
}
k$2.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t2) {
  Object.defineProperty(k$2.prototype, t2, { configurable: true, get: function() {
    return this["UNSAFE_" + t2];
  }, set: function(n2) {
    Object.defineProperty(this, t2, { configurable: true, writable: true, value: n2 });
  } });
});
var G = l$3.event;
function J() {
}
function K() {
  return this.cancelBubble;
}
function Q() {
  return this.defaultPrevented;
}
l$3.event = function(n2) {
  return G && (n2 = G(n2)), n2.persist = J, n2.isPropagationStopped = K, n2.isDefaultPrevented = Q, n2.nativeEvent = n2;
};
var X$1, nn = { enumerable: false, configurable: true, get: function() {
  return this.class;
} }, tn = l$3.vnode;
l$3.vnode = function(n2) {
  "string" == typeof n2.type && function(n3) {
    var t2 = n3.props, e2 = n3.type, u2 = {}, o2 = -1 === e2.indexOf("-");
    for (var i2 in t2) {
      var c2 = t2[i2];
      if (!("value" === i2 && "defaultValue" in t2 && null == c2 || Z && "children" === i2 && "noscript" === e2 || "class" === i2 || "className" === i2)) {
        var f2 = i2.toLowerCase();
        "defaultValue" === i2 && "value" in t2 && null == t2.value ? i2 = "value" : "download" === i2 && true === c2 ? c2 = "" : "translate" === f2 && "no" === c2 ? c2 = false : "o" === f2[0] && "n" === f2[1] ? "ondoubleclick" === f2 ? i2 = "ondblclick" : "onchange" !== f2 || "input" !== e2 && "textarea" !== e2 || Y(t2.type) ? "onfocus" === f2 ? i2 = "onfocusin" : "onblur" === f2 ? i2 = "onfocusout" : B.test(i2) && (i2 = f2) : f2 = i2 = "oninput" : o2 && z.test(i2) ? i2 = i2.replace(H, "-$&").toLowerCase() : null === c2 && (c2 = void 0), "oninput" === f2 && u2[i2 = f2] && (i2 = "oninputCapture"), u2[i2] = c2;
      }
    }
    "select" == e2 && u2.multiple && Array.isArray(u2.value) && (u2.value = H$1(t2.children).forEach(function(n4) {
      n4.props.selected = -1 != u2.value.indexOf(n4.props.value);
    })), "select" == e2 && null != u2.defaultValue && (u2.value = H$1(t2.children).forEach(function(n4) {
      n4.props.selected = u2.multiple ? -1 != u2.defaultValue.indexOf(n4.props.value) : u2.defaultValue == n4.props.value;
    })), t2.class && !t2.className ? (u2.class = t2.class, Object.defineProperty(u2, "className", nn)) : (t2.className && !t2.class || t2.class && t2.className) && (u2.class = u2.className = t2.className), n3.props = u2;
  }(n2), n2.$$typeof = j, tn && tn(n2);
};
var en = l$3.__r;
l$3.__r = function(n2) {
  en && en(n2), X$1 = n2.__c;
};
var rn = l$3.diffed;
l$3.diffed = function(n2) {
  rn && rn(n2);
  var t2 = n2.props, e2 = n2.__e;
  null != e2 && "textarea" === n2.type && "value" in t2 && t2.value !== e2.value && (e2.value = null == t2.value ? "" : t2.value), X$1 = null;
};
var un = { ReactCurrentDispatcher: { current: { readContext: function(n2) {
  return X$1.__n[n2.__c].props.value;
}, useCallback: q$1, useContext: x$1, useDebugValue: P$1, useDeferredValue: _n, useEffect: y, useId: g$1, useImperativeHandle: F$1, useInsertionEffect: Sn, useLayoutEffect: _, useMemo: T$1, useReducer: p, useRef: A$1, useState: h, useSyncExternalStore: En, useTransition: bn } } }, on = "18.3.1";
function cn$1(n2) {
  return _$1.bind(null, n2);
}
function fn(n2) {
  return !!n2 && n2.$$typeof === j;
}
function ln(n2) {
  return fn(n2) && n2.type === b$2;
}
function an(n2) {
  return !!n2 && !!n2.displayName && ("string" == typeof n2.displayName || n2.displayName instanceof String) && n2.displayName.startsWith("Memo(");
}
function sn(n2) {
  return fn(n2) ? E$1.apply(null, arguments) : n2;
}
function hn(n2) {
  return !!n2.__k && (B$2(null, n2), true);
}
function vn(n2) {
  return n2 && (n2.base || 1 === n2.nodeType && n2) || null;
}
var dn = function(n2, t2) {
  return n2(t2);
}, pn = function(n2, t2) {
  return n2(t2);
}, mn = b$2;
function yn(n2) {
  n2();
}
function _n(n2) {
  return n2;
}
function bn() {
  return [false, yn];
}
var Sn = _, gn = fn;
function En(n2, t2) {
  var e2 = t2(), r2 = h({ h: { __: e2, v: t2 } }), u2 = r2[0].h, o2 = r2[1];
  return _(function() {
    u2.__ = e2, u2.v = t2, Cn(u2) && o2({ h: u2 });
  }, [n2, e2, t2]), y(function() {
    return Cn(u2) && o2({ h: u2 }), n2(function() {
      Cn(u2) && o2({ h: u2 });
    });
  }, [n2]), e2;
}
function Cn(n2) {
  var t2, e2, r2 = n2.v, u2 = n2.__;
  try {
    var o2 = r2();
    return !((t2 = u2) === (e2 = o2) && (0 !== t2 || 1 / t2 == 1 / e2) || t2 != t2 && e2 != e2);
  } catch (n3) {
    return true;
  }
}
var xn = { useState: h, useId: g$1, useReducer: p, useEffect: y, useLayoutEffect: _, useInsertionEffect: Sn, useTransition: bn, useDeferredValue: _n, useSyncExternalStore: En, startTransition: yn, useRef: A$1, useImperativeHandle: F$1, useMemo: T$1, useCallback: q$1, useContext: x$1, useDebugValue: P$1, version: "18.3.1", Children: I, render: $, hydrate: q, unmountComponentAtNode: hn, createPortal: P, createElement: _$1, createContext: G$1, createFactory: cn$1, cloneElement: sn, createRef: m$2, Fragment: b$2, isValidElement: fn, isElement: gn, isFragment: ln, isMemo: an, findDOMNode: vn, Component: k$2, PureComponent: E, memo: C, forwardRef: w, flushSync: pn, unstable_batchedUpdates: dn, StrictMode: mn, Suspense: D, SuspenseList: F, lazy: O, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: un };
const React$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Children: I,
  Component: k$2,
  Fragment: b$2,
  PureComponent: E,
  StrictMode: mn,
  Suspense: D,
  SuspenseList: F,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: un,
  cloneElement: sn,
  createContext: G$1,
  createElement: _$1,
  createFactory: cn$1,
  createPortal: P,
  createRef: m$2,
  default: xn,
  findDOMNode: vn,
  flushSync: pn,
  forwardRef: w,
  hydrate: q,
  isElement: gn,
  isFragment: ln,
  isMemo: an,
  isValidElement: fn,
  lazy: O,
  memo: C,
  render: $,
  startTransition: yn,
  unmountComponentAtNode: hn,
  unstable_batchedUpdates: dn,
  useCallback: q$1,
  useContext: x$1,
  useDebugValue: P$1,
  useDeferredValue: _n,
  useEffect: y,
  useErrorBoundary: b,
  useId: g$1,
  useImperativeHandle: F$1,
  useInsertionEffect: Sn,
  useLayoutEffect: _,
  useMemo: T$1,
  useReducer: p,
  useRef: A$1,
  useState: h,
  useSyncExternalStore: En,
  useTransition: bn,
  version: on
}, Symbol.toStringTag, { value: "Module" }));
var _jsxFileName$1U = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/providers/GlobalProvider.tsx";
const GlobalContext = G$1({
  // Example default global state
  cartIsOpen: false,
  toggleCart: () => {
  },
  filterIsOpen: false,
  toggleFilter: () => {
  },
  notifyMeIsOpen: false,
  toggleNotifyMe: () => {
  },
  selectedVariant: {},
  setSelectedVariant: (variant) => {
  },
  selectedProduct: {
    variants: []
  },
  setSelectedProduct: (product) => {
  },
  quickViewIsOpen: false,
  toggleQuickView: () => {
  },
  closeQuickView: () => {
  }
});
const GlobalProvider = ({
  children
}) => {
  const [settings, setSettings] = t$2(h({
    // Example state variables
    cartIsOpen: false,
    toggleCart: () => {
    },
    filterIsOpen: false,
    toggleFilter: () => {
    },
    notifyMeIsOpen: false,
    toggleNotifyMe: () => {
    },
    selectedVariant: {},
    setSelectedVariant: (variant) => {
    },
    selectedProduct: {
      variants: []
    },
    setSelectedProduct: (product) => {
    },
    quickViewIsOpen: false,
    toggleQuickView: () => {
    },
    closeQuickView: () => {
    }
  }), "settings");
  const toggleCart = () => {
    setSettings((prevState) => ({
      ...prevState,
      cartIsOpen: !prevState.cartIsOpen,
      filterIsOpen: false,
      notifyMeIsOpen: false
    }));
  };
  const openCart = () => {
    setSettings((prevState) => ({
      ...prevState,
      cartIsOpen: true,
      filterIsOpen: false,
      notifyMeIsOpen: false
    }));
  };
  const toggleFilter = () => {
    setSettings((prevState) => ({
      ...prevState,
      filterIsOpen: !prevState.filterIsOpen,
      cartIsOpen: false,
      notifyMeIsOpen: false
    }));
  };
  const toggleNotifyMe = () => {
    setSettings((prevState) => ({
      ...prevState,
      notifyMeIsOpen: !prevState.notifyMeIsOpen,
      quickViewIsOpen: false,
      filterIsOpen: false,
      cartIsOpen: false
    }));
  };
  const toggleQuickView = () => {
    setSettings((prevState) => ({
      ...prevState,
      quickViewIsOpen: !prevState.quickViewIsOpen,
      notifyMeIsOpen: false,
      filterIsOpen: false,
      cartIsOpen: false
    }));
  };
  const closeQuickView = () => {
    setSettings((prevState) => ({
      ...prevState,
      quickViewIsOpen: false
    }));
  };
  const setSelectedVariant = (variant) => {
    setSettings((prevState) => ({
      ...prevState,
      selectedVariant: variant
    }));
  };
  const setSelectedProduct = (product) => {
    setSettings((prevState) => ({
      ...prevState,
      selectedProduct: product
    }));
  };
  y(() => {
    window.addEventListener("cart:open", openCart);
    return () => {
      window.removeEventListener("cart:open", openCart);
    };
  }, []);
  return u(GlobalContext.Provider, {
    value: {
      ...settings,
      toggleCart,
      toggleFilter,
      toggleNotifyMe,
      setSelectedVariant,
      setSelectedProduct,
      toggleQuickView,
      closeQuickView
    },
    children
  }, void 0, false, {
    fileName: _jsxFileName$1U,
    lineNumber: 123,
    columnNumber: 5
  }, void 0);
};
const useGlobal = () => {
  return x$1(GlobalContext);
};
register(GlobalProvider, "global-provider", [], {
  shadow: true
});
function r$1(e2) {
  var t2, f2, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2) n2 += e2;
  else if ("object" == typeof e2) if (Array.isArray(e2)) {
    var o2 = e2.length;
    for (t2 = 0; t2 < o2; t2++) e2[t2] && (f2 = r$1(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
  } else for (f2 in e2) e2[f2] && (n2 && (n2 += " "), n2 += f2);
  return n2;
}
function clsx$1() {
  for (var e2, t2, f2 = 0, n2 = "", o2 = arguments.length; f2 < o2; f2++) (e2 = arguments[f2]) && (t2 = r$1(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
const CLASS_PART_SEPARATOR = "-";
const createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(({
    validator
  }) => validator(classRest))) == null ? void 0 : _a.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = (className) => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
};
const createClassMap = (config) => {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = (func) => func.isThemeGetter;
const getPrefixedClassGroupEntries = (classGroupEntries, prefix) => {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map((classDefinition) => {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
};
const createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  const update2 = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update2(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update2(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = "!";
const createParseClassName = (config) => {
  const {
    separator,
    experimentalParseClassName
  } = config;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  const parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (experimentalParseClassName) {
    return (className) => experimentalParseClassName({
      className,
      parseClassName
    });
  }
  return parseClassName;
};
const sortModifiers = (modifiers) => {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach((modifier) => {
    const isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
};
const createConfigUtils = (config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  ...createClassGroupUtils(config)
});
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i2 = 0; i2 < conflictGroups.length; ++i2) {
      const group = conflictGroups[i2];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
const toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k2 = 0; k2 < mix.length; k2++) {
    if (mix[k2]) {
      if (resolvedValue = toValue(mix[k2])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isLength = (value) => isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
const isArbitraryLength = (value) => getIsArbitraryValue(value, "length", isLengthOnly);
const isNumber = (value) => Boolean(value) && !Number.isNaN(Number(value));
const isArbitraryNumber = (value) => getIsArbitraryValue(value, "number", isNumber);
const isInteger = (value) => Boolean(value) && Number.isInteger(Number(value));
const isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
const isArbitraryValue = (value) => arbitraryValueRegex.test(value);
const isTshirtSize = (value) => tshirtUnitRegex.test(value);
const sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
const isArbitrarySize = (value) => getIsArbitraryValue(value, sizeLabels, isNever);
const isArbitraryPosition = (value) => getIsArbitraryValue(value, "position", isNever);
const imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
const isArbitraryImage = (value) => getIsArbitraryValue(value, imageLabels, isImage);
const isArbitraryShadow = (value) => getIsArbitraryValue(value, "", isShadow);
const isAny = () => true;
const getIsArbitraryValue = (value, label, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === "string" ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
const isNever = () => false;
const isShadow = (value) => shadowRegex.test(value);
const isImage = (value) => imageRegex.test(value);
const getDefaultConfig = () => {
  const colors = fromTheme("colors");
  const spacing = fromTheme("spacing");
  const blur = fromTheme("blur");
  const brightness = fromTheme("brightness");
  const borderColor = fromTheme("borderColor");
  const borderRadius = fromTheme("borderRadius");
  const borderSpacing = fromTheme("borderSpacing");
  const borderWidth = fromTheme("borderWidth");
  const contrast = fromTheme("contrast");
  const grayscale = fromTheme("grayscale");
  const hueRotate = fromTheme("hueRotate");
  const invert = fromTheme("invert");
  const gap = fromTheme("gap");
  const gradientColorStops = fromTheme("gradientColorStops");
  const gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  const inset = fromTheme("inset");
  const margin = fromTheme("margin");
  const opacity = fromTheme("opacity");
  const padding = fromTheme("padding");
  const saturate = fromTheme("saturate");
  const scale = fromTheme("scale");
  const sepia = fromTheme("sepia");
  const skew = fromTheme("skew");
  const space = fromTheme("space");
  const translate2 = fromTheme("translate");
  const getOverscroll = () => ["auto", "contain", "none"];
  const getOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const getSpacingWithAutoAndArbitrary = () => ["auto", isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ["", isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ["auto", isNumber, isArbitraryValue];
  const getPositions = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const getLineStyles = () => ["solid", "dashed", "dotted", "double", "none"];
  const getBlendModes = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const getAlign = () => ["start", "end", "center", "between", "around", "evenly", "stretch"];
  const getZeroAndEmpty = () => ["", "0", isArbitraryValue];
  const getBreaks = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumberAndArbitrary(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumberAndArbitrary(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumberAndArbitrary(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumberAndArbitrary(),
      scale: getNumberAndArbitrary(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...getAlign(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...getAlign(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [isArbitraryValue, spacing, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...getLineStyles(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...getLineStyles(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [borderColor]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...getBlendModes(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate2]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate2]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
};
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
function cn(...inputs) {
  return twMerge(clsx$1(inputs));
}
function useProductPercentageOff(variant, asInt = false) {
  if (variant === void 0 || variant === null) {
    return "";
  }
  const {
    price,
    compare_at_price
  } = {
    ...variant
  };
  const originalPrice = parseFloat(compare_at_price || "0");
  const salePrice = parseFloat(price || "0");
  const amountOff = originalPrice - salePrice;
  const percentageOff = Math.abs(Math.round(amountOff / originalPrice * 100));
  return asInt ? percentageOff : `${percentageOff}% off`;
}
const resizeImageUrl = (url, size) => {
  const urlParts = url.split(".");
  const extension = urlParts.pop();
  const baseName = urlParts.join(".");
  const resizedUrl = `${baseName}_${size}.${extension}`;
  return resizedUrl;
};
function shopifyFormatCurrency(cents, formatString) {
  const placeholderRegex = /{{\s*(\w+)\s*}}/;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return "0";
    }
    const numString = (number / 100).toFixed(precision);
    const parts = numString.split(".");
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    const cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  return formatString.replace(placeholderRegex, (match, placeholder) => {
    switch (placeholder) {
      case "amount":
        return formatWithDelimiters(cents, 2);
      case "amount_no_decimals":
        return formatWithDelimiters(cents, 0);
      case "amount_with_comma_separator":
        return formatWithDelimiters(cents, 2, ".", ",");
      case "amount_no_decimals_with_comma_separator":
        return formatWithDelimiters(cents, 0, ".", ",");
      case "amount_with_apostrophe_separator":
        return formatWithDelimiters(cents, 2, "'", ".");
      case "amount_no_decimals_with_space_separator":
        return formatWithDelimiters(cents, 0, " ");
      case "amount_with_space_separator":
        return formatWithDelimiters(cents, 2, " ", ",");
      case "amount_with_period_and_space_separator":
        return formatWithDelimiters(cents, 2, " ", ".");
      default:
        return match;
    }
  });
}
const sendDatalayer = (data) => {
  if ((window == null ? void 0 : window.dataLayer) && data) {
    window.dataLayer.push(data);
  }
};
var _jsxFileName$1T = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Button.tsx";
const defaultButtonStyles = (options) => {
  const mode = (options == null ? void 0 : options.mode) || "primary";
  const tone = (options == null ? void 0 : options.tone) || "default";
  const size = (options == null ? void 0 : options.size) || "default";
  return clsx$1([size === "default" && mode !== "custom" && " h-[2.75rem]", size === "compact" && mode !== "custom" && " h-[30px]", mode === "primary" && clsx$1(["block max-w-full font-medium tracking-wide uppercase font-primary", tone === "default" && "border border-black bg-black text-[12px] text-white hover:bg-transparent hover:text-black hover:border-black focus:border-dashed disabled:bg-[#AFADAA] disabled:text-[#F4F1EE] disabled:border-transparent disabled:pointer-events-none", tone === "inverted" && "border border-transparent text-[12px] text-black bg-white hover:bg-black hover:text-white focus:border-white focus:border-dashed focus:bg-black focus:text-white disabled:bg-white disabled:text-[#BBBBBB] disabled:border-[#BBBBBB] disabled:pointer-events-none"]), mode === "secondary" && clsx$1(["block max-w-full font-medium tracking-wide uppercase font-primary", tone === "default" && "border border-black bg-white text-[12px] text-black hover:bg-black hover:text-white hover:border-black focus:bg-black focus:text-white focus:border-white focus:border-dashed disabled:bg-[#F4F1EE] disabled:text-[#AFADAA] disabled:border-transparent disabled:pointer-events-none", tone === "inverted" && "border border-white bg-black text-[12px] text-white hover:bg-white hover:text-black focus:border-black focus:border-dashed focus:bg-white focus:text-black disabled:bg-black disabled:text-[#BBBBBB] disabled:border-[#BBBBBB] disabled:pointer-events-none"]), mode !== "custom" && cn(["flex items-center justify-center", "duration-200 ease-out", "disabled:opacity-50 disabled:bg-opacity-50 disabled:border-opacity-50", "active:underline"])]);
};
function Button({
  as = "button",
  mode = "primary",
  size = "default",
  newWindow,
  tone,
  className,
  ...props
}) {
  return (props == null ? void 0 : props.to) ? u("a", {
    target: newWindow ? "_blank" : "",
    className: twMerge(defaultButtonStyles({
      mode,
      tone,
      size
    }), className),
    href: props.to || "#",
    ...props
  }, void 0, false, {
    fileName: _jsxFileName$1T,
    lineNumber: 75,
    columnNumber: 5
  }, this) : u("button", {
    className: twMerge(defaultButtonStyles({
      mode,
      tone,
      size
    }), className),
    ...props
  }, void 0, false, {
    fileName: _jsxFileName$1T,
    lineNumber: 82,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1S = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/AddToCartButton.tsx";
function AddToCartButton({
  productData,
  quantity = 1,
  mode = "primary",
  tone = "default",
  size = "default",
  openCartDrawer = true
}) {
  if (typeof productData !== "object" && typeof productData === "string") {
    productData = JSON.parse(productData);
  }
  const {
    price,
    discounted_price
  } = productData;
  const {
    toggleCart,
    toggleNotifyMe,
    setSelectedVariant,
    setSelectedProduct,
    toggleQuickView,
    quickViewIsOpen
  } = useGlobal();
  t$2(h(false), "modalShown");
  const handleAddToCart2 = () => {
    window.Shopify.cart.add({
      items: [{
        id: productData.variants[0].id,
        quantity
      }],
      onAdded: () => {
        if (openCartDrawer) {
          toggleCart();
        }
      }
    });
  };
  const handleModal = () => {
    setSelectedVariant(productData.variants[0]);
    setSelectedProduct(productData);
    toggleNotifyMe();
  };
  const handleQuickView = () => {
    setSelectedProduct(productData);
    toggleQuickView();
  };
  return u(b$2, {
    children: productData.available ? u(b$2, {
      children: productData.variants.length === 1 ? u(Button, {
        className: "min-w-min w-full",
        onClick: () => {
          handleAddToCart2();
        },
        mode,
        tone,
        size,
        children: size === "default" ? `Add to Bag - ${discounted_price ? discounted_price : price}` : `Add`
      }, void 0, false, {
        fileName: _jsxFileName$1S,
        lineNumber: 74,
        columnNumber: 13
      }, this) : u(b$2, {
        children: u(Button, {
          type: "button",
          onClick: () => handleQuickView(),
          className: "min-w-min w-full z-10",
          mode,
          tone,
          size,
          children: size === "default" ? `Select Option` : `Add`
        }, void 0, false, {
          fileName: _jsxFileName$1S,
          lineNumber: 89,
          columnNumber: 15
        }, this)
      }, void 0, false)
    }, void 0, false) : u(Button, {
      className: "min-w-min w-full",
      mode: "secondary",
      onClick: () => handleModal(),
      children: "Notify Me"
    }, void 0, false, {
      fileName: _jsxFileName$1S,
      lineNumber: 103,
      columnNumber: 9
    }, this)
  }, void 0);
}
register(AddToCartButton, "add-to-cart-button", ["quantity"]);
var _jsxFileName$1R = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/UpperRightArrow.tsx";
function UpperRightArrow(props) {
  return u("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "aria-label": "",
    children: u("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M4 16 16 4M7 4h9v9"
    }, void 0, false, {
      fileName: _jsxFileName$1R,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1R,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a2 = function a3() {
      if (this instanceof a3) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a2.prototype = f2.prototype;
  } else a2 = {};
  Object.defineProperty(a2, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var lib$3 = {};
var htmlToDom = {};
var domparser$1 = {};
Object.defineProperty(domparser$1, "__esModule", { value: true });
domparser$1.default = domparser;
var HTML = "html";
var HEAD = "head";
var BODY = "body";
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/;
var HEAD_TAG_REGEX = /<head[^]*>/i;
var BODY_TAG_REGEX = /<body[^]*>/i;
var parseFromDocument = function(html, tagName) {
  throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
};
var parseFromString = function(html, tagName) {
  throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
};
var DOMParser$1 = typeof window === "object" && window.DOMParser;
if (typeof DOMParser$1 === "function") {
  var domParser_1 = new DOMParser$1();
  var mimeType_1 = "text/html";
  parseFromString = function(html, tagName) {
    if (tagName) {
      html = "<".concat(tagName, ">").concat(html, "</").concat(tagName, ">");
    }
    return domParser_1.parseFromString(html, mimeType_1);
  };
  parseFromDocument = parseFromString;
}
if (typeof document === "object" && document.implementation) {
  var htmlDocument_1 = document.implementation.createHTMLDocument();
  parseFromDocument = function(html, tagName) {
    if (tagName) {
      var element = htmlDocument_1.documentElement.querySelector(tagName);
      if (element) {
        element.innerHTML = html;
      }
      return htmlDocument_1;
    }
    htmlDocument_1.documentElement.innerHTML = html;
    return htmlDocument_1;
  };
}
var template = typeof document === "object" && document.createElement("template");
var parseFromTemplate;
if (template && template.content) {
  parseFromTemplate = function(html) {
    template.innerHTML = html;
    return template.content.childNodes;
  };
}
function domparser(html) {
  var _a, _b;
  var match = html.match(FIRST_TAG_REGEX);
  var firstTagName = match && match[1] ? match[1].toLowerCase() : "";
  switch (firstTagName) {
    case HTML: {
      var doc = parseFromString(html);
      if (!HEAD_TAG_REGEX.test(html)) {
        var element = doc.querySelector(HEAD);
        (_a = element === null || element === void 0 ? void 0 : element.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(element);
      }
      if (!BODY_TAG_REGEX.test(html)) {
        var element = doc.querySelector(BODY);
        (_b = element === null || element === void 0 ? void 0 : element.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(element);
      }
      return doc.querySelectorAll(HTML);
    }
    case HEAD:
    case BODY: {
      var elements = parseFromDocument(html).querySelectorAll(firstTagName);
      if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
        return elements[0].parentNode.childNodes;
      }
      return elements;
    }
    default: {
      if (parseFromTemplate) {
        return parseFromTemplate(html);
      }
      var element = parseFromDocument(html, BODY).querySelector(BODY);
      return element.childNodes;
    }
  }
}
var utilities$2 = {};
var lib$2 = {};
var lib$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
  var ElementType;
  (function(ElementType2) {
    ElementType2["Root"] = "root";
    ElementType2["Text"] = "text";
    ElementType2["Directive"] = "directive";
    ElementType2["Comment"] = "comment";
    ElementType2["Script"] = "script";
    ElementType2["Style"] = "style";
    ElementType2["Tag"] = "tag";
    ElementType2["CDATA"] = "cdata";
    ElementType2["Doctype"] = "doctype";
  })(ElementType = exports.ElementType || (exports.ElementType = {}));
  function isTag2(elem) {
    return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
  }
  exports.isTag = isTag2;
  exports.Root = ElementType.Root;
  exports.Text = ElementType.Text;
  exports.Directive = ElementType.Directive;
  exports.Comment = ElementType.Comment;
  exports.Script = ElementType.Script;
  exports.Style = ElementType.Style;
  exports.Tag = ElementType.Tag;
  exports.CDATA = ElementType.CDATA;
  exports.Doctype = ElementType.Doctype;
})(lib$1);
var node = {};
var __extends = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var extendStatics = function(d2, b2) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
      d3.__proto__ = b3;
    } || function(d3, b3) {
      for (var p2 in b3) if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
    };
    return extendStatics(d2, b2);
  };
  return function(d2, b2) {
    if (typeof b2 !== "function" && b2 !== null)
      throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
    extendStatics(d2, b2);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  };
}();
var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign$1 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2))
        t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
Object.defineProperty(node, "__esModule", { value: true });
node.cloneNode = node.hasChildren = node.isDocument = node.isDirective = node.isComment = node.isText = node.isCDATA = node.isTag = node.Element = node.Document = node.CDATA = node.NodeWithChildren = node.ProcessingInstruction = node.Comment = node.Text = node.DataNode = node.Node = void 0;
var domelementtype_1 = lib$1;
var Node = (
  /** @class */
  function() {
    function Node2() {
      this.parent = null;
      this.prev = null;
      this.next = null;
      this.startIndex = null;
      this.endIndex = null;
    }
    Object.defineProperty(Node2.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(parent) {
        this.parent = parent;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node2.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(prev) {
        this.prev = prev;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node2.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(next) {
        this.next = next;
      },
      enumerable: false,
      configurable: true
    });
    Node2.prototype.cloneNode = function(recursive) {
      if (recursive === void 0) {
        recursive = false;
      }
      return cloneNode(this, recursive);
    };
    return Node2;
  }()
);
node.Node = Node;
var DataNode = (
  /** @class */
  function(_super) {
    __extends(DataNode2, _super);
    function DataNode2(data) {
      var _this = _super.call(this) || this;
      _this.data = data;
      return _this;
    }
    Object.defineProperty(DataNode2.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(data) {
        this.data = data;
      },
      enumerable: false,
      configurable: true
    });
    return DataNode2;
  }(Node)
);
node.DataNode = DataNode;
var Text = (
  /** @class */
  function(_super) {
    __extends(Text2, _super);
    function Text2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1.ElementType.Text;
      return _this;
    }
    Object.defineProperty(Text2.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: false,
      configurable: true
    });
    return Text2;
  }(DataNode)
);
node.Text = Text;
var Comment = (
  /** @class */
  function(_super) {
    __extends(Comment2, _super);
    function Comment2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1.ElementType.Comment;
      return _this;
    }
    Object.defineProperty(Comment2.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: false,
      configurable: true
    });
    return Comment2;
  }(DataNode)
);
node.Comment = Comment;
var ProcessingInstruction = (
  /** @class */
  function(_super) {
    __extends(ProcessingInstruction2, _super);
    function ProcessingInstruction2(name, data) {
      var _this = _super.call(this, data) || this;
      _this.name = name;
      _this.type = domelementtype_1.ElementType.Directive;
      return _this;
    }
    Object.defineProperty(ProcessingInstruction2.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    return ProcessingInstruction2;
  }(DataNode)
);
node.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren = (
  /** @class */
  function(_super) {
    __extends(NodeWithChildren2, _super);
    function NodeWithChildren2(children) {
      var _this = _super.call(this) || this;
      _this.children = children;
      return _this;
    }
    Object.defineProperty(NodeWithChildren2.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren2.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren2.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(children) {
        this.children = children;
      },
      enumerable: false,
      configurable: true
    });
    return NodeWithChildren2;
  }(Node)
);
node.NodeWithChildren = NodeWithChildren;
var CDATA = (
  /** @class */
  function(_super) {
    __extends(CDATA2, _super);
    function CDATA2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1.ElementType.CDATA;
      return _this;
    }
    Object.defineProperty(CDATA2.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: false,
      configurable: true
    });
    return CDATA2;
  }(NodeWithChildren)
);
node.CDATA = CDATA;
var Document = (
  /** @class */
  function(_super) {
    __extends(Document2, _super);
    function Document2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1.ElementType.Root;
      return _this;
    }
    Object.defineProperty(Document2.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: false,
      configurable: true
    });
    return Document2;
  }(NodeWithChildren)
);
node.Document = Document;
var Element$1 = (
  /** @class */
  function(_super) {
    __extends(Element2, _super);
    function Element2(name, attribs, children, type) {
      if (children === void 0) {
        children = [];
      }
      if (type === void 0) {
        type = name === "script" ? domelementtype_1.ElementType.Script : name === "style" ? domelementtype_1.ElementType.Style : domelementtype_1.ElementType.Tag;
      }
      var _this = _super.call(this, children) || this;
      _this.name = name;
      _this.attribs = attribs;
      _this.type = type;
      return _this;
    }
    Object.defineProperty(Element2.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Element2.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(name) {
        this.name = name;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Element2.prototype, "attributes", {
      get: function() {
        var _this = this;
        return Object.keys(this.attribs).map(function(name) {
          var _a, _b;
          return {
            name,
            value: _this.attribs[name],
            namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
            prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
          };
        });
      },
      enumerable: false,
      configurable: true
    });
    return Element2;
  }(NodeWithChildren)
);
node.Element = Element$1;
function isTag(node2) {
  return (0, domelementtype_1.isTag)(node2);
}
node.isTag = isTag;
function isCDATA(node2) {
  return node2.type === domelementtype_1.ElementType.CDATA;
}
node.isCDATA = isCDATA;
function isText(node2) {
  return node2.type === domelementtype_1.ElementType.Text;
}
node.isText = isText;
function isComment(node2) {
  return node2.type === domelementtype_1.ElementType.Comment;
}
node.isComment = isComment;
function isDirective(node2) {
  return node2.type === domelementtype_1.ElementType.Directive;
}
node.isDirective = isDirective;
function isDocument(node2) {
  return node2.type === domelementtype_1.ElementType.Root;
}
node.isDocument = isDocument;
function hasChildren(node2) {
  return Object.prototype.hasOwnProperty.call(node2, "children");
}
node.hasChildren = hasChildren;
function cloneNode(node2, recursive) {
  if (recursive === void 0) {
    recursive = false;
  }
  var result;
  if (isText(node2)) {
    result = new Text(node2.data);
  } else if (isComment(node2)) {
    result = new Comment(node2.data);
  } else if (isTag(node2)) {
    var children = recursive ? cloneChildren(node2.children) : [];
    var clone_1 = new Element$1(node2.name, __assign$1({}, node2.attribs), children);
    children.forEach(function(child) {
      return child.parent = clone_1;
    });
    if (node2.namespace != null) {
      clone_1.namespace = node2.namespace;
    }
    if (node2["x-attribsNamespace"]) {
      clone_1["x-attribsNamespace"] = __assign$1({}, node2["x-attribsNamespace"]);
    }
    if (node2["x-attribsPrefix"]) {
      clone_1["x-attribsPrefix"] = __assign$1({}, node2["x-attribsPrefix"]);
    }
    result = clone_1;
  } else if (isCDATA(node2)) {
    var children = recursive ? cloneChildren(node2.children) : [];
    var clone_2 = new CDATA(children);
    children.forEach(function(child) {
      return child.parent = clone_2;
    });
    result = clone_2;
  } else if (isDocument(node2)) {
    var children = recursive ? cloneChildren(node2.children) : [];
    var clone_3 = new Document(children);
    children.forEach(function(child) {
      return child.parent = clone_3;
    });
    if (node2["x-mode"]) {
      clone_3["x-mode"] = node2["x-mode"];
    }
    result = clone_3;
  } else if (isDirective(node2)) {
    var instruction = new ProcessingInstruction(node2.name, node2.data);
    if (node2["x-name"] != null) {
      instruction["x-name"] = node2["x-name"];
      instruction["x-publicId"] = node2["x-publicId"];
      instruction["x-systemId"] = node2["x-systemId"];
    }
    result = instruction;
  } else {
    throw new Error("Not implemented yet: ".concat(node2.type));
  }
  result.startIndex = node2.startIndex;
  result.endIndex = node2.endIndex;
  if (node2.sourceCodeLocation != null) {
    result.sourceCodeLocation = node2.sourceCodeLocation;
  }
  return result;
}
node.cloneNode = cloneNode;
function cloneChildren(childs) {
  var children = childs.map(function(child) {
    return cloneNode(child, true);
  });
  for (var i2 = 1; i2 < children.length; i2++) {
    children[i2].prev = children[i2 - 1];
    children[i2 - 1].next = children[i2];
  }
  return children;
}
(function(exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
    if (k22 === void 0) k22 = k2;
    var desc = Object.getOwnPropertyDescriptor(m2, k2);
    if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m2[k2];
      } };
    }
    Object.defineProperty(o2, k22, desc);
  } : function(o2, m2, k2, k22) {
    if (k22 === void 0) k22 = k2;
    o2[k22] = m2[k2];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports2) {
    for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p2)) __createBinding(exports2, m2, p2);
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.DomHandler = void 0;
  var domelementtype_12 = lib$1;
  var node_js_1 = node;
  __exportStar(node, exports);
  var defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
  };
  var DomHandler = (
    /** @class */
    function() {
      function DomHandler2(callback, options, elementCB) {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
        if (typeof options === "function") {
          elementCB = options;
          options = defaultOpts;
        }
        if (typeof callback === "object") {
          options = callback;
          callback = void 0;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
      }
      DomHandler2.prototype.onparserinit = function(parser) {
        this.parser = parser;
      };
      DomHandler2.prototype.onreset = function() {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
      };
      DomHandler2.prototype.onend = function() {
        if (this.done)
          return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
      };
      DomHandler2.prototype.onerror = function(error) {
        this.handleCallback(error);
      };
      DomHandler2.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
          elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
          this.elementCB(elem);
      };
      DomHandler2.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? domelementtype_12.ElementType.Tag : void 0;
        var element = new node_js_1.Element(name, attribs, void 0, type);
        this.addNode(element);
        this.tagStack.push(element);
      };
      DomHandler2.prototype.ontext = function(data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_12.ElementType.Text) {
          lastNode.data += data;
          if (this.options.withEndIndices) {
            lastNode.endIndex = this.parser.endIndex;
          }
        } else {
          var node2 = new node_js_1.Text(data);
          this.addNode(node2);
          this.lastNode = node2;
        }
      };
      DomHandler2.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === domelementtype_12.ElementType.Comment) {
          this.lastNode.data += data;
          return;
        }
        var node2 = new node_js_1.Comment(data);
        this.addNode(node2);
        this.lastNode = node2;
      };
      DomHandler2.prototype.oncommentend = function() {
        this.lastNode = null;
      };
      DomHandler2.prototype.oncdatastart = function() {
        var text = new node_js_1.Text("");
        var node2 = new node_js_1.CDATA([text]);
        this.addNode(node2);
        text.parent = node2;
        this.lastNode = text;
      };
      DomHandler2.prototype.oncdataend = function() {
        this.lastNode = null;
      };
      DomHandler2.prototype.onprocessinginstruction = function(name, data) {
        var node2 = new node_js_1.ProcessingInstruction(name, data);
        this.addNode(node2);
      };
      DomHandler2.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") {
          this.callback(error, this.dom);
        } else if (error) {
          throw error;
        }
      };
      DomHandler2.prototype.addNode = function(node2) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
          node2.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
          node2.endIndex = this.parser.endIndex;
        }
        parent.children.push(node2);
        if (previousSibling) {
          node2.prev = previousSibling;
          previousSibling.next = node2;
        }
        node2.parent = parent;
        this.lastNode = null;
      };
      return DomHandler2;
    }()
  );
  exports.DomHandler = DomHandler;
  exports.default = DomHandler;
})(lib$2);
var constants = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES = void 0;
  exports.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
  ];
  exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES.reduce(function(accumulator, tagName) {
    accumulator[tagName.toLowerCase()] = tagName;
    return accumulator;
  }, {});
})(constants);
Object.defineProperty(utilities$2, "__esModule", { value: true });
utilities$2.formatAttributes = formatAttributes;
utilities$2.formatDOM = formatDOM;
var domhandler_1 = lib$2;
var constants_1 = constants;
function getCaseSensitiveTagName(tagName) {
  return constants_1.CASE_SENSITIVE_TAG_NAMES_MAP[tagName];
}
function formatAttributes(attributes) {
  var map = {};
  var index = 0;
  var attributesLength = attributes.length;
  for (; index < attributesLength; index++) {
    var attribute = attributes[index];
    map[attribute.name] = attribute.value;
  }
  return map;
}
function formatTagName(tagName) {
  tagName = tagName.toLowerCase();
  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
  if (caseSensitiveTagName) {
    return caseSensitiveTagName;
  }
  return tagName;
}
function formatDOM(nodes, parent, directive) {
  if (parent === void 0) {
    parent = null;
  }
  var domNodes = [];
  var current;
  var index = 0;
  var nodesLength = nodes.length;
  for (; index < nodesLength; index++) {
    var node2 = nodes[index];
    switch (node2.nodeType) {
      case 1: {
        var tagName = formatTagName(node2.nodeName);
        current = new domhandler_1.Element(tagName, formatAttributes(node2.attributes));
        current.children = formatDOM(
          // template children are on content
          tagName === "template" ? node2.content.childNodes : node2.childNodes,
          current
        );
        break;
      }
      case 3:
        current = new domhandler_1.Text(node2.nodeValue);
        break;
      case 8:
        current = new domhandler_1.Comment(node2.nodeValue);
        break;
      default:
        continue;
    }
    var prev = domNodes[index - 1] || null;
    if (prev) {
      prev.next = current;
    }
    current.parent = parent;
    current.prev = prev;
    current.next = null;
    domNodes.push(current);
  }
  if (directive) {
    current = new domhandler_1.ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
    current.next = domNodes[0] || null;
    current.parent = parent;
    domNodes.unshift(current);
    if (domNodes[1]) {
      domNodes[1].prev = domNodes[0];
    }
  }
  return domNodes;
}
var __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(htmlToDom, "__esModule", { value: true });
htmlToDom.default = HTMLDOMParser;
var domparser_1 = __importDefault$3(domparser$1);
var utilities_1$3 = utilities$2;
var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/;
function HTMLDOMParser(html) {
  if (typeof html !== "string") {
    throw new TypeError("First argument must be a string");
  }
  if (!html) {
    return [];
  }
  var match = html.match(DIRECTIVE_REGEX);
  var directive = match ? match[1] : void 0;
  return (0, utilities_1$3.formatDOM)((0, domparser_1.default)(html), null, directive);
}
var attributesToProps$1 = {};
var lib = {};
var possibleStandardNamesOptimized$1 = {};
var SAME$1 = 0;
possibleStandardNamesOptimized$1.SAME = SAME$1;
var CAMELCASE$1 = 1;
possibleStandardNamesOptimized$1.CAMELCASE = CAMELCASE$1;
possibleStandardNamesOptimized$1.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  "accept-charset": "acceptCharset",
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: "className",
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: "htmlFor",
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  "http-equiv": "httpEquiv",
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  "accent-height": "accentHeight",
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  "alignment-baseline": "alignmentBaseline",
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  "arabic-form": "arabicForm",
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  "baseline-shift": "baselineShift",
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  "cap-height": "capHeight",
  clip: 0,
  clipPath: 1,
  "clip-path": "clipPath",
  clipPathUnits: 1,
  clipRule: 1,
  "clip-rule": "clipRule",
  color: 0,
  colorInterpolation: 1,
  "color-interpolation": "colorInterpolation",
  colorInterpolationFilters: 1,
  "color-interpolation-filters": "colorInterpolationFilters",
  colorProfile: 1,
  "color-profile": "colorProfile",
  colorRendering: 1,
  "color-rendering": "colorRendering",
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  "dominant-baseline": "dominantBaseline",
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  "enable-background": "enableBackground",
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  "fill-opacity": "fillOpacity",
  fillRule: 1,
  "fill-rule": "fillRule",
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  "flood-opacity": "floodOpacity",
  floodColor: 1,
  "flood-color": "floodColor",
  focusable: 0,
  fontFamily: 1,
  "font-family": "fontFamily",
  fontSize: 1,
  "font-size": "fontSize",
  fontSizeAdjust: 1,
  "font-size-adjust": "fontSizeAdjust",
  fontStretch: 1,
  "font-stretch": "fontStretch",
  fontStyle: 1,
  "font-style": "fontStyle",
  fontVariant: 1,
  "font-variant": "fontVariant",
  fontWeight: 1,
  "font-weight": "fontWeight",
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  "glyph-name": "glyphName",
  glyphOrientationHorizontal: 1,
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphOrientationVertical: 1,
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  "horiz-adv-x": "horizAdvX",
  horizOriginX: 1,
  "horiz-origin-x": "horizOriginX",
  ideographic: 0,
  imageRendering: 1,
  "image-rendering": "imageRendering",
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  "letter-spacing": "letterSpacing",
  lightingColor: 1,
  "lighting-color": "lightingColor",
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  "marker-end": "markerEnd",
  markerHeight: 1,
  markerMid: 1,
  "marker-mid": "markerMid",
  markerStart: 1,
  "marker-start": "markerStart",
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  "overline-position": "overlinePosition",
  overlineThickness: 1,
  "overline-thickness": "overlineThickness",
  paintOrder: 1,
  "paint-order": "paintOrder",
  panose1: 0,
  "panose-1": "panose1",
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  "pointer-events": "pointerEvents",
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  "rendering-intent": "renderingIntent",
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  "shape-rendering": "shapeRendering",
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  "stop-color": "stopColor",
  stopOpacity: 1,
  "stop-opacity": "stopOpacity",
  strikethroughPosition: 1,
  "strikethrough-position": "strikethroughPosition",
  strikethroughThickness: 1,
  "strikethrough-thickness": "strikethroughThickness",
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  "stroke-dasharray": "strokeDasharray",
  strokeDashoffset: 1,
  "stroke-dashoffset": "strokeDashoffset",
  strokeLinecap: 1,
  "stroke-linecap": "strokeLinecap",
  strokeLinejoin: 1,
  "stroke-linejoin": "strokeLinejoin",
  strokeMiterlimit: 1,
  "stroke-miterlimit": "strokeMiterlimit",
  strokeWidth: 1,
  "stroke-width": "strokeWidth",
  strokeOpacity: 1,
  "stroke-opacity": "strokeOpacity",
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  "text-anchor": "textAnchor",
  textDecoration: 1,
  "text-decoration": "textDecoration",
  textLength: 1,
  textRendering: 1,
  "text-rendering": "textRendering",
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  "underline-position": "underlinePosition",
  underlineThickness: 1,
  "underline-thickness": "underlineThickness",
  unicode: 0,
  unicodeBidi: 1,
  "unicode-bidi": "unicodeBidi",
  unicodeRange: 1,
  "unicode-range": "unicodeRange",
  unitsPerEm: 1,
  "units-per-em": "unitsPerEm",
  unselectable: 0,
  vAlphabetic: 1,
  "v-alphabetic": "vAlphabetic",
  values: 0,
  vectorEffect: 1,
  "vector-effect": "vectorEffect",
  version: 0,
  vertAdvY: 1,
  "vert-adv-y": "vertAdvY",
  vertOriginX: 1,
  "vert-origin-x": "vertOriginX",
  vertOriginY: 1,
  "vert-origin-y": "vertOriginY",
  vHanging: 1,
  "v-hanging": "vHanging",
  vIdeographic: 1,
  "v-ideographic": "vIdeographic",
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  "v-mathematical": "vMathematical",
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  "word-spacing": "wordSpacing",
  writingMode: 1,
  "writing-mode": "writingMode",
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  "x-height": "xHeight",
  xlinkActuate: 1,
  "xlink:actuate": "xlinkActuate",
  xlinkArcrole: 1,
  "xlink:arcrole": "xlinkArcrole",
  xlinkHref: 1,
  "xlink:href": "xlinkHref",
  xlinkRole: 1,
  "xlink:role": "xlinkRole",
  xlinkShow: 1,
  "xlink:show": "xlinkShow",
  xlinkTitle: 1,
  "xlink:title": "xlinkTitle",
  xlinkType: 1,
  "xlink:type": "xlinkType",
  xmlBase: 1,
  "xml:base": "xmlBase",
  xmlLang: 1,
  "xml:lang": "xmlLang",
  xmlns: 0,
  "xml:space": "xmlSpace",
  xmlnsXlink: 1,
  "xmlns:xlink": "xmlnsXlink",
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};
const RESERVED = 0;
const STRING = 1;
const BOOLEANISH_STRING = 2;
const BOOLEAN = 3;
const OVERLOADED_BOOLEAN = 4;
const NUMERIC = 5;
const POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}
function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
}
const properties = {};
const reservedProps = [
  "children",
  "dangerouslySetInnerHTML",
  // TODO: This prevents the assignment of defaultValue to regular
  // elements (not just inputs). Now that ReactDOMInput assigns to the
  // defaultValue property -- do we need this?
  "defaultValue",
  "defaultChecked",
  "innerHTML",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "style"
];
reservedProps.forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    RESERVED,
    false,
    // mustUseProperty
    name,
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  ["acceptCharset", "accept-charset"],
  ["className", "class"],
  ["htmlFor", "for"],
  ["httpEquiv", "http-equiv"]
].forEach(([name, attributeName]) => {
  properties[name] = new PropertyInfoRecord(
    name,
    STRING,
    false,
    // mustUseProperty
    attributeName,
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
["contentEditable", "draggable", "spellCheck", "value"].forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    BOOLEANISH_STRING,
    false,
    // mustUseProperty
    name.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  "autoReverse",
  "externalResourcesRequired",
  "focusable",
  "preserveAlpha"
].forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    BOOLEANISH_STRING,
    false,
    // mustUseProperty
    name,
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  "allowFullScreen",
  "async",
  // Note: there is a special case that prevents it from being written to the DOM
  // on the client side because the browsers are inconsistent. Instead we call focus().
  "autoFocus",
  "autoPlay",
  "controls",
  "default",
  "defer",
  "disabled",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "formNoValidate",
  "hidden",
  "loop",
  "noModule",
  "noValidate",
  "open",
  "playsInline",
  "readOnly",
  "required",
  "reversed",
  "scoped",
  "seamless",
  // Microdata
  "itemScope"
].forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    BOOLEAN,
    false,
    // mustUseProperty
    name.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  "checked",
  // Note: `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`. We have special logic for handling this.
  "multiple",
  "muted",
  "selected"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    BOOLEAN,
    true,
    // mustUseProperty
    name,
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  "capture",
  "download"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    OVERLOADED_BOOLEAN,
    false,
    // mustUseProperty
    name,
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  "cols",
  "rows",
  "size",
  "span"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    POSITIVE_NUMERIC,
    false,
    // mustUseProperty
    name,
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
["rowSpan", "start"].forEach((name) => {
  properties[name] = new PropertyInfoRecord(
    name,
    NUMERIC,
    false,
    // mustUseProperty
    name.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
const CAMELIZE = /[\-\:]([a-z])/g;
const capitalize$1 = (token2) => token2[1].toUpperCase();
[
  "accent-height",
  "alignment-baseline",
  "arabic-form",
  "baseline-shift",
  "cap-height",
  "clip-path",
  "clip-rule",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "dominant-baseline",
  "enable-background",
  "fill-opacity",
  "fill-rule",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "glyph-name",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "horiz-adv-x",
  "horiz-origin-x",
  "image-rendering",
  "letter-spacing",
  "lighting-color",
  "marker-end",
  "marker-mid",
  "marker-start",
  "overline-position",
  "overline-thickness",
  "paint-order",
  "panose-1",
  "pointer-events",
  "rendering-intent",
  "shape-rendering",
  "stop-color",
  "stop-opacity",
  "strikethrough-position",
  "strikethrough-thickness",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "text-decoration",
  "text-rendering",
  "underline-position",
  "underline-thickness",
  "unicode-bidi",
  "unicode-range",
  "units-per-em",
  "v-alphabetic",
  "v-hanging",
  "v-ideographic",
  "v-mathematical",
  "vector-effect",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "word-spacing",
  "writing-mode",
  "xmlns:xlink",
  "x-height"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((attributeName) => {
  const name = attributeName.replace(CAMELIZE, capitalize$1);
  properties[name] = new PropertyInfoRecord(
    name,
    STRING,
    false,
    // mustUseProperty
    attributeName,
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  "xlink:actuate",
  "xlink:arcrole",
  "xlink:role",
  "xlink:show",
  "xlink:title",
  "xlink:type"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((attributeName) => {
  const name = attributeName.replace(CAMELIZE, capitalize$1);
  properties[name] = new PropertyInfoRecord(
    name,
    STRING,
    false,
    // mustUseProperty
    attributeName,
    "http://www.w3.org/1999/xlink",
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
[
  "xml:base",
  "xml:lang",
  "xml:space"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((attributeName) => {
  const name = attributeName.replace(CAMELIZE, capitalize$1);
  properties[name] = new PropertyInfoRecord(
    name,
    STRING,
    false,
    // mustUseProperty
    attributeName,
    "http://www.w3.org/XML/1998/namespace",
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
["tabIndex", "crossOrigin"].forEach((attributeName) => {
  properties[attributeName] = new PropertyInfoRecord(
    attributeName,
    STRING,
    false,
    // mustUseProperty
    attributeName.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    false,
    // sanitizeURL
    false
    // removeEmptyString
  );
});
const xlinkHref = "xlinkHref";
properties[xlinkHref] = new PropertyInfoRecord(
  "xlinkHref",
  STRING,
  false,
  // mustUseProperty
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  true,
  // sanitizeURL
  false
  // removeEmptyString
);
["src", "href", "action", "formAction"].forEach((attributeName) => {
  properties[attributeName] = new PropertyInfoRecord(
    attributeName,
    STRING,
    false,
    // mustUseProperty
    attributeName.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    true,
    // sanitizeURL
    true
    // removeEmptyString
  );
});
const {
  CAMELCASE,
  SAME,
  possibleStandardNames: possibleStandardNamesOptimized
} = possibleStandardNamesOptimized$1;
const ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
const ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
const isCustomAttribute = RegExp.prototype.test.bind(
  // eslint-disable-next-line no-misleading-character-class
  new RegExp("^(data|aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$")
);
const possibleStandardNames = Object.keys(
  possibleStandardNamesOptimized
).reduce((accumulator, standardName) => {
  const propName = possibleStandardNamesOptimized[standardName];
  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }
  return accumulator;
}, {});
lib.BOOLEAN = BOOLEAN;
lib.BOOLEANISH_STRING = BOOLEANISH_STRING;
lib.NUMERIC = NUMERIC;
lib.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
lib.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
lib.RESERVED = RESERVED;
lib.STRING = STRING;
lib.getPropertyInfo = getPropertyInfo;
lib.isCustomAttribute = isCustomAttribute;
lib.possibleStandardNames = possibleStandardNames;
var utilities$1 = {};
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(React$1);
var cjs$1 = {};
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;
var TRIM_REGEX = /^\s+|\s+$/g;
var NEWLINE = "\n";
var FORWARD_SLASH = "/";
var ASTERISK = "*";
var EMPTY_STRING = "";
var TYPE_COMMENT = "comment";
var TYPE_DECLARATION = "declaration";
var inlineStyleParser = function(style, options) {
  if (typeof style !== "string") {
    throw new TypeError("First argument must be a string");
  }
  if (!style) return [];
  options = options || {};
  var lineno = 1;
  var column = 1;
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i2 = str.lastIndexOf(NEWLINE);
    column = ~i2 ? str.length - i2 : column + str.length;
  }
  function position() {
    var start = { line: lineno, column };
    return function(node2) {
      node2.position = new Position(start);
      whitespace();
      return node2;
    };
  }
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column };
    this.source = options.source;
  }
  Position.prototype.content = style;
  function error(msg) {
    var err = new Error(
      options.source + ":" + lineno + ":" + column + ": " + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;
    if (options.silent) ;
    else {
      throw err;
    }
  }
  function match(re) {
    var m2 = re.exec(style);
    if (!m2) return;
    var str = m2[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m2;
  }
  function whitespace() {
    match(WHITESPACE_REGEX);
  }
  function comments(rules) {
    var c2;
    rules = rules || [];
    while (c2 = comment()) {
      if (c2 !== false) {
        rules.push(c2);
      }
    }
    return rules;
  }
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
    var i2 = 2;
    while (EMPTY_STRING != style.charAt(i2) && (ASTERISK != style.charAt(i2) || FORWARD_SLASH != style.charAt(i2 + 1))) {
      ++i2;
    }
    i2 += 2;
    if (EMPTY_STRING === style.charAt(i2 - 1)) {
      return error("End of comment missing");
    }
    var str = style.slice(2, i2 - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i2);
    column += 2;
    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }
  function declaration() {
    var pos = position();
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();
    if (!match(COLON_REGEX)) return error("property missing ':'");
    var val = match(VALUE_REGEX);
    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
    });
    match(SEMICOLON_REGEX);
    return ret;
  }
  function declarations() {
    var decls = [];
    comments(decls);
    var decl;
    while (decl = declaration()) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }
    return decls;
  }
  whitespace();
  return declarations();
};
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}
var __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(cjs$1, "__esModule", { value: true });
cjs$1.default = StyleToObject;
var inline_style_parser_1 = __importDefault$2(inlineStyleParser);
function StyleToObject(style, iterator) {
  var styleObject = null;
  if (!style || typeof style !== "string") {
    return styleObject;
  }
  var declarations = (0, inline_style_parser_1.default)(style);
  var hasIterator = typeof iterator === "function";
  declarations.forEach(function(declaration) {
    if (declaration.type !== "declaration") {
      return;
    }
    var property = declaration.property, value = declaration.value;
    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      styleObject = styleObject || {};
      styleObject[property] = value;
    }
  });
  return styleObject;
}
var utilities = {};
Object.defineProperty(utilities, "__esModule", { value: true });
utilities.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function(property) {
  return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize = function(match, character) {
  return character.toUpperCase();
};
var trimHyphen = function(match, prefix) {
  return "".concat(prefix, "-");
};
var camelCase = function(property, options) {
  if (options === void 0) {
    options = {};
  }
  if (skipCamelCase(property)) {
    return property;
  }
  property = property.toLowerCase();
  if (options.reactCompat) {
    property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
  } else {
    property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
  }
  return property.replace(HYPHEN_REGEX, capitalize);
};
utilities.camelCase = camelCase;
var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
var style_to_object_1 = __importDefault$1(cjs$1);
var utilities_1$2 = utilities;
function StyleToJS(style, options) {
  var output = {};
  if (!style || typeof style !== "string") {
    return output;
  }
  (0, style_to_object_1.default)(style, function(property, value) {
    if (property && value) {
      output[(0, utilities_1$2.camelCase)(property, options)] = value;
    }
  });
  return output;
}
StyleToJS.default = StyleToJS;
var cjs = StyleToJS;
(function(exports) {
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.returnFirstArg = exports.canTextBeChildOfNode = exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = exports.PRESERVE_CUSTOM_ATTRIBUTES = void 0;
  exports.isCustomComponent = isCustomComponent;
  exports.setStyleProp = setStyleProp;
  var react_12 = require$$0;
  var style_to_js_1 = __importDefault2(cjs);
  var RESERVED_SVG_MATHML_ELEMENTS = /* @__PURE__ */ new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
  ]);
  function isCustomComponent(tagName, props) {
    if (!tagName.includes("-")) {
      return Boolean(props && typeof props.is === "string");
    }
    if (RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) {
      return false;
    }
    return true;
  }
  var styleOptions = {
    reactCompat: true
  };
  function setStyleProp(style, props) {
    if (typeof style !== "string") {
      return;
    }
    if (!style.trim()) {
      props.style = {};
      return;
    }
    try {
      props.style = (0, style_to_js_1.default)(style, styleOptions);
    } catch (error) {
      props.style = {};
    }
  }
  exports.PRESERVE_CUSTOM_ATTRIBUTES = Number(react_12.version.split(".")[0]) >= 16;
  exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
  ]);
  var canTextBeChildOfNode = function(node2) {
    return !exports.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node2.name);
  };
  exports.canTextBeChildOfNode = canTextBeChildOfNode;
  var returnFirstArg = function(arg) {
    return arg;
  };
  exports.returnFirstArg = returnFirstArg;
})(utilities$1);
Object.defineProperty(attributesToProps$1, "__esModule", { value: true });
attributesToProps$1.default = attributesToProps;
var react_property_1 = lib;
var utilities_1$1 = utilities$1;
var UNCONTROLLED_COMPONENT_ATTRIBUTES = ["checked", "value"];
var UNCONTROLLED_COMPONENT_NAMES = ["input", "select", "textarea"];
var valueOnlyInputs = {
  reset: true,
  submit: true
};
function attributesToProps(attributes, nodeName) {
  if (attributes === void 0) {
    attributes = {};
  }
  var props = {};
  var isInputValueOnly = Boolean(attributes.type && valueOnlyInputs[attributes.type]);
  for (var attributeName in attributes) {
    var attributeValue = attributes[attributeName];
    if ((0, react_property_1.isCustomAttribute)(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }
    var attributeNameLowerCased = attributeName.toLowerCase();
    var propName = getPropName(attributeNameLowerCased);
    if (propName) {
      var propertyInfo = (0, react_property_1.getPropertyInfo)(propName);
      if (UNCONTROLLED_COMPONENT_ATTRIBUTES.includes(propName) && UNCONTROLLED_COMPONENT_NAMES.includes(nodeName) && !isInputValueOnly) {
        propName = getPropName("default" + attributeNameLowerCased);
      }
      props[propName] = attributeValue;
      switch (propertyInfo && propertyInfo.type) {
        case react_property_1.BOOLEAN:
          props[propName] = true;
          break;
        case react_property_1.OVERLOADED_BOOLEAN:
          if (attributeValue === "") {
            props[propName] = true;
          }
          break;
      }
      continue;
    }
    if (utilities_1$1.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }
  (0, utilities_1$1.setStyleProp)(attributes.style, props);
  return props;
}
function getPropName(attributeName) {
  return react_property_1.possibleStandardNames[attributeName];
}
var domToReact$1 = {};
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(domToReact$1, "__esModule", { value: true });
domToReact$1.default = domToReact;
var react_1 = require$$0;
var attributes_to_props_1 = __importDefault(attributesToProps$1);
var utilities_1 = utilities$1;
var React = {
  cloneElement: react_1.cloneElement,
  createElement: react_1.createElement,
  isValidElement: react_1.isValidElement
};
function domToReact(nodes, options) {
  if (options === void 0) {
    options = {};
  }
  var reactElements = [];
  var hasReplace = typeof options.replace === "function";
  var transform = options.transform || utilities_1.returnFirstArg;
  var _a = options.library || React, cloneElement = _a.cloneElement, createElement2 = _a.createElement, isValidElement = _a.isValidElement;
  var nodesLength = nodes.length;
  for (var index = 0; index < nodesLength; index++) {
    var node2 = nodes[index];
    if (hasReplace) {
      var replaceElement = options.replace(node2, index);
      if (isValidElement(replaceElement)) {
        if (nodesLength > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || index
          });
        }
        reactElements.push(transform(replaceElement, node2, index));
        continue;
      }
    }
    if (node2.type === "text") {
      var isWhitespace = !node2.data.trim().length;
      if (isWhitespace && node2.parent && !(0, utilities_1.canTextBeChildOfNode)(node2.parent)) {
        continue;
      }
      if (options.trim && isWhitespace) {
        continue;
      }
      reactElements.push(transform(node2.data, node2, index));
      continue;
    }
    var element = node2;
    var props = {};
    if (skipAttributesToProps(element)) {
      (0, utilities_1.setStyleProp)(element.attribs.style, element.attribs);
      props = element.attribs;
    } else if (element.attribs) {
      props = (0, attributes_to_props_1.default)(element.attribs, element.name);
    }
    var children = void 0;
    switch (node2.type) {
      case "script":
      case "style":
        if (node2.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node2.children[0].data
          };
        }
        break;
      case "tag":
        if (node2.name === "textarea" && node2.children[0]) {
          props.defaultValue = node2.children[0].data;
        } else if (node2.children && node2.children.length) {
          children = domToReact(node2.children, options);
        }
        break;
      default:
        continue;
    }
    if (nodesLength > 1) {
      props.key = index;
    }
    reactElements.push(transform(createElement2(node2.name, props, children), node2, index));
  }
  return reactElements.length === 1 ? reactElements[0] : reactElements;
}
function skipAttributesToProps(node2) {
  return utilities_1.PRESERVE_CUSTOM_ATTRIBUTES && node2.type === "tag" && (0, utilities_1.isCustomComponent)(node2.name, node2.attribs);
}
(function(exports) {
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.htmlToDOM = exports.domToReact = exports.attributesToProps = exports.Text = exports.ProcessingInstruction = exports.Element = exports.Comment = void 0;
  exports.default = HTMLReactParser2;
  var html_dom_parser_1 = __importDefault2(htmlToDom);
  exports.htmlToDOM = html_dom_parser_1.default;
  var attributes_to_props_12 = __importDefault2(attributesToProps$1);
  exports.attributesToProps = attributes_to_props_12.default;
  var dom_to_react_1 = __importDefault2(domToReact$1);
  exports.domToReact = dom_to_react_1.default;
  var domhandler_12 = lib$2;
  Object.defineProperty(exports, "Comment", { enumerable: true, get: function() {
    return domhandler_12.Comment;
  } });
  Object.defineProperty(exports, "Element", { enumerable: true, get: function() {
    return domhandler_12.Element;
  } });
  Object.defineProperty(exports, "ProcessingInstruction", { enumerable: true, get: function() {
    return domhandler_12.ProcessingInstruction;
  } });
  Object.defineProperty(exports, "Text", { enumerable: true, get: function() {
    return domhandler_12.Text;
  } });
  var domParserOptions = { lowerCaseAttributeNames: false };
  function HTMLReactParser2(html, options) {
    if (typeof html !== "string") {
      throw new TypeError("First argument must be a string");
    }
    if (!html) {
      return [];
    }
    return (0, dom_to_react_1.default)((0, html_dom_parser_1.default)(html, (options === null || options === void 0 ? void 0 : options.htmlparser2) || domParserOptions), options);
  }
})(lib$3);
const HTMLReactParser = /* @__PURE__ */ getDefaultExportFromCjs(lib$3);
const parse$1 = HTMLReactParser.default || HTMLReactParser;
var _jsxFileName$1Q = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ArticleCard.tsx";
function ArticleCard({
  article
}) {
  const articleData = JSON.parse(article);
  return u("a", {
    href: articleData == null ? void 0 : articleData.url,
    className: "group p-4 min-h-[400px] flex flex-col items-end bg-cover bg-center bg-no-repeat",
    style: {
      backgroundImage: `url(${articleData.image})`
    },
    children: u("div", {
      className: cn("p-4 pr-9 relative flex flex-col gap-8 mt-auto rounded-md bg-white min-h-[172px] w-full justify-between"),
      children: [u(UpperRightArrow, {
        className: "absolute top-3 right-3"
      }, void 0, false, {
        fileName: _jsxFileName$1Q,
        lineNumber: 27,
        columnNumber: 9
      }, this), (articleData == null ? void 0 : articleData.title) && u("h3", {
        className: "font-primary text-3xl line-clamp-2",
        children: parse$1(articleData == null ? void 0 : articleData.title)
      }, void 0, false, {
        fileName: _jsxFileName$1Q,
        lineNumber: 29,
        columnNumber: 11
      }, this), articleData.excerpt && u("p", {
        className: "font-primary text-xs",
        children: articleData == null ? void 0 : articleData.excerpt
      }, void 0, false, {
        fileName: _jsxFileName$1Q,
        lineNumber: 34,
        columnNumber: 11
      }, this), u("div", {
        className: "mt-1 font-primary text-button-sm underline uppercase underline-offset-4 font-medium",
        children: "Read more"
      }, void 0, false, {
        fileName: _jsxFileName$1Q,
        lineNumber: 36,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1Q,
      lineNumber: 22,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1Q,
    lineNumber: 15,
    columnNumber: 5
  }, this);
}
register(ArticleCard, "article-card");
function isObject$2(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$2(target, src) {
  if (target === void 0) {
    target = {};
  }
  if (src === void 0) {
    src = {};
  }
  Object.keys(src).forEach((key) => {
    if (typeof target[key] === "undefined") target[key] = src[key];
    else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document !== "undefined" ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent2() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== "undefined" ? window : {};
  extend$2(win, ssrWindow);
  return win;
}
function classesToTokens(classes2) {
  if (classes2 === void 0) {
    classes2 = "";
  }
  return classes2.trim().split(" ").filter((c2) => !!c2.trim());
}
function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach((key) => {
    try {
      object[key] = null;
    } catch (e2) {
    }
    try {
      delete object[key];
    } catch (e2) {
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window2 = getWindow();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = "x";
  }
  const window2 = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a2) => a2.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$1(o2) {
  return typeof o2 === "object" && o2 !== null && o2.constructor && Object.prototype.toString.call(o2).slice(8, -1) === "Object";
}
function isNode(node2) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node2 instanceof HTMLElement;
  }
  return node2 && (node2.nodeType === 1 || node2.nodeType === 11);
}
function extend$1() {
  const to = Object(arguments.length <= 0 ? void 0 : arguments[0]);
  const noExtend = ["__proto__", "constructor", "prototype"];
  for (let i2 = 1; i2 < arguments.length; i2 += 1) {
    const nextSource = i2 < 0 || arguments.length <= i2 ? void 0 : arguments[i2];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref;
  const window2 = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current, target) => {
    return dir === "next" && current >= target || dir === "prev" && current <= target;
  };
  const animate = () => {
    time = (/* @__PURE__ */ new Date()).getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = "";
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = "";
  }
  const children = [...element.children];
  if (element instanceof HTMLSlotElement) {
    children.push(...element.assignedElements());
  }
  if (!selector) {
    return children;
  }
  return children.filter((el) => el.matches(selector));
}
function elementIsChildOf(el, parent) {
  const isChild = parent.contains(el);
  if (!isChild && parent instanceof HTMLSlotElement) {
    const children = [...parent.assignedElements()];
    return children.includes(el);
  }
  return isChild;
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
  }
}
function createElement(tag, classes2) {
  if (classes2 === void 0) {
    classes2 = [];
  }
  const el = document.createElement(tag);
  el.classList.add(...Array.isArray(classes2) ? classes2 : classesToTokens(classes2));
  return el;
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling;
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling;
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window2 = getWindow();
  return window2.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i2;
  if (child) {
    i2 = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i2 += 1;
    }
    return i2;
  }
  return void 0;
}
function elementParents(el, selector) {
  const parents = [];
  let parent = el.parentElement;
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementOuterSize(el, size, includeMargins) {
  const window2 = getWindow();
  {
    return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
  }
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter((e2) => !!e2);
}
let support;
function calcSupport() {
  const window2 = getWindow();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
let deviceCached;
function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support2 = getSupport();
  const window2 = getWindow();
  const platform = window2.navigator.platform;
  const ua = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow();
  const device = getDevice();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window2.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
  }
  if (isSafari()) {
    const ua = String(window2.navigator.userAgent);
    if (ua.includes("Version/")) {
      const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent);
  const isSafariBrowser = isSafari();
  const need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix,
    need3dFix,
    isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize(_ref) {
  let {
    swiper,
    on: on2,
    emit
  } = _ref;
  const window2 = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit("beforeResize");
    emit("resize");
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach((_ref2) => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref2;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit("orientationchange");
  };
  on2("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on2("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer(_ref) {
  let {
    swiper,
    extendParams,
    on: on2,
    emit
  } = _ref;
  const observers = [];
  const window2 = getWindow();
  const attach = function(target, options) {
    if (options === void 0) {
      options = {};
    }
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer = new ObserverFunc((mutations) => {
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === "undefined" ? true : options.attributes,
      childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
      characterData: typeof options.characterData === "undefined" ? true : options.characterData
    });
    observers.push(observer);
  };
  const init = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = elementParents(swiper.hostEl);
      for (let i2 = 0; i2 < containerParents.length; i2 += 1) {
        attach(containerParents[i2]);
      }
    }
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach((observer) => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on2("init", init);
  on2("destroy", destroy);
}
var eventsEmitter = {
  on(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event) => {
      if (!self2.eventsListeners[event]) self2.eventsListeners[event] = [];
      self2.eventsListeners[event][method](handler);
    });
    return self2;
  },
  once(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    function onceHandler() {
      self2.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self2, args);
    }
    onceHandler.__emitterProxy = handler;
    return self2.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    const method = priority ? "unshift" : "push";
    if (self2.eventsAnyListeners.indexOf(handler) < 0) {
      self2.eventsAnyListeners[method](handler);
    }
    return self2;
  },
  offAny(handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsAnyListeners) return self2;
    const index = self2.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self2.eventsAnyListeners.splice(index, 1);
    }
    return self2;
  },
  off(events2, handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsListeners) return self2;
    events2.split(" ").forEach((event) => {
      if (typeof handler === "undefined") {
        self2.eventsListeners[event] = [];
      } else if (self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self2.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self2;
  },
  emit() {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsListeners) return self2;
    let events2;
    let data;
    let context;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data = args.slice(1, args.length);
      context = self2;
    } else {
      events2 = args[0].events;
      data = args[0].data;
      context = args[0].context || self2;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event) => {
      if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
        self2.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self2.eventsListeners && self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler) => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self2;
  }
};
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }
  width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
  height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper = this;
  function getDirectionPropertyValue(node2, label) {
    return parseFloat(node2.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;
  slides.forEach((slideEl) => {
    if (rtl) {
      slideEl.style.marginLeft = "";
    } else {
      slideEl.style.marginRight = "";
    }
    slideEl.style.marginBottom = "";
    slideEl.style.marginTop = "";
  });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i2 = 0; i2 < slidesLength; i2 += 1) {
    slideSize = 0;
    let slide2;
    if (slides[i2]) slide2 = slides[i2];
    if (gridEnabled) {
      swiper.grid.updateSlide(i2, slide2, slides);
    }
    if (slides[i2] && elementStyle(slide2, "display") === "none") continue;
    if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slides[i2].style[swiper.getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2);
      const currentTransform = slide2.style.transform;
      const currentWebKitTransform = slide2.style.webkitTransform;
      if (currentTransform) {
        slide2.style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width") : elementOuterSize(slide2, "height");
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i2]) {
        slides[i2].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slides[i2]) {
      slides[i2].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i2 !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i2 === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i2 = 0; i2 < snapGrid.length; i2 += 1) {
      let slidesGridItem = snapGrid[i2];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i2 = 0; i2 < groups; i2 += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i2 = 0; i2 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i2 += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
    slides.filter((_2, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach((slideEl) => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
    snapGrid = snapGrid.map((snap) => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
    if (allSlidesSize + offsetSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v2) => v2 + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map((v2) => v2 + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit("slidesUpdated");
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i2;
  if (typeof speed === "number") {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = (index) => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i2 = 0; i2 < Math.ceil(swiper.params.slidesPerView); i2 += 1) {
        const index = swiper.activeIndex + i2;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }
  for (i2 = 0; i2 < activeSlides.length; i2 += 1) {
    if (typeof activeSlides[i2] !== "undefined") {
      const height = activeSlides[i2].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i2 = 0; i2 < slides.length; i2 += 1) {
    slides[i2].swiperSlideOffset = (swiper.isHorizontal() ? slides[i2].offsetLeft : slides[i2].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}
const toggleSlideClasses$1 = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesProgress(translate2) {
  if (translate2 === void 0) {
    translate2 = this && this.translate || 0;
  }
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl) offsetCenter = translate2;
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i2 = 0; i2 < slides.length; i2 += 1) {
    const slide2 = slides[i2];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i2];
    const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i2];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide2);
      swiper.visibleSlidesIndexes.push(i2);
    }
    toggleSlideClasses$1(slide2, isVisible, params.slideVisibleClass);
    toggleSlideClasses$1(slide2, isFullyVisible, params.slideFullyVisibleClass);
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate2 - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate2);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit("fromEdge");
  }
  swiper.emit("progress", progress);
}
const toggleSlideClasses = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const getFilteredSlide = (selector) => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  let activeSlide;
  let prevSlide;
  let nextSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.filter((slideEl) => slideEl.column === activeIndex)[0];
      nextSlide = slides.filter((slideEl) => slideEl.column === activeIndex + 1)[0];
      prevSlide = slides.filter((slideEl) => slideEl.column === activeIndex - 1)[0];
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    if (!gridEnabled) {
      nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }
      prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
    }
  }
  slides.forEach((slideEl) => {
    toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
    toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
    toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
  });
  swiper.emitSlidesClasses();
}
const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
const unlazy = (swiper, index) => {
  if (!swiper.slides[index]) return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute("loading");
};
const preload = (swiper) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_2, i2) => {
      return activeColumn + slidesPerView + i2;
    }));
    swiper.slides.forEach((slideEl, i2) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i2);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i2 = activeIndex - amount; i2 <= slideIndexLastInView + amount; i2 += 1) {
      const realIndex = (i2 % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i2 = Math.max(activeIndex - amount, 0); i2 <= Math.min(slideIndexLastInView + amount, len - 1); i2 += 1) {
      if (i2 !== activeIndex && (i2 > slideIndexLastInView || i2 < activeIndex)) {
        unlazy(swiper, i2);
      }
    }
  }
};
function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
    if (typeof slidesGrid[i2 + 1] !== "undefined") {
      if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1] - (slidesGrid[i2 + 1] - slidesGrid[i2]) / 2) {
        activeIndex = i2;
      } else if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1]) {
        activeIndex = i2 + 1;
      }
    } else if (translate2 >= slidesGrid[i2]) {
      activeIndex = i2;
    }
  }
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = (aIndex) => {
    let realIndex2 = aIndex - swiper.virtual.slidesBefore;
    if (realIndex2 < 0) {
      realIndex2 = swiper.virtual.slides.length + realIndex2;
    }
    if (realIndex2 >= swiper.virtual.slides.length) {
      realIndex2 -= swiper.virtual.slides.length;
    }
    return realIndex2;
  };
  if (typeof activeIndex === "undefined") {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit("snapIndexChange");
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (gridEnabled) {
    const firstSlideInColumn = swiper.slides.filter((slideEl) => slideEl.column === activeIndex)[0];
    let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit("activeIndexChange");
  swiper.emit("snapIndexChange");
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit("realIndexChange");
    }
    swiper.emit("slideChange");
  }
}
function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide2 = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide2 && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
      if (!slide2 && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide2 = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i2 = 0; i2 < swiper.slides.length; i2 += 1) {
      if (swiper.slides[i2] === slide2) {
        slideFound = true;
        slideIndex = i2;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper.clickedSlide = slide2;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = void 0;
    swiper.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? "x" : "y";
  }
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x2 = 0;
  let y2 = 0;
  const z2 = 0;
  if (swiper.isHorizontal()) {
    x2 = rtl ? -translate2 : translate2;
  } else {
    y2 = translate2;
  }
  if (params.roundLengths) {
    x2 = Math.floor(x2);
    y2 = Math.floor(y2);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x2 : y2;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x2 : -y2;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x2 -= swiper.cssOverflowAdjustment();
    } else {
      y2 -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x2}px, ${y2}px, ${z2}px)`;
  }
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate2);
  }
  swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2, speed, runCallbacks, translateBounds, internal) {
  if (translate2 === void 0) {
    translate2 = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper.minTranslate();
  const maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2) newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2) newTranslate = maxTranslate2;
  else newTranslate = translate2;
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionEnd");
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionStart");
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e2) {
          if (!swiper || swiper.destroyed) return;
          if (e2.target !== this) return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          swiper.animating = false;
          if (runCallbacks) {
            swiper.emit("transitionEnd");
          }
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
  }
  swiper.emit("setTransition", duration, byController);
}
function transitionEmit(_ref) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = "next";
    else if (activeIndex < previousIndex) dir = "prev";
    else dir = "reset";
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  });
}
var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === "string") {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex) {
    for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i2] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i2 + 1] * 100);
      if (typeof slidesGrid[i2 + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i2;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i2 + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i2;
      }
    }
  }
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate2 > swiper.translate && translate2 > swiper.minTranslate() : translate2 < swiper.translate && translate2 < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit("beforeSlideChangeStart");
  }
  swiper.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex) direction = "next";
  else if (slideIndex < activeIndex) direction = "prev";
  else direction = "reset";
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  const isInitialVirtual = isVirtual && initial;
  if (!isInitialVirtual && (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t2 = rtl ? translate2 : -translate2;
    if (speed === 0) {
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = "none";
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t2;
        });
      } else {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t2;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = "";
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t2,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t2,
        behavior: "smooth"
      });
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate2);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit("beforeTransitionStart", speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e2) {
        if (!swiper || swiper.destroyed) return;
        if (e2.target !== this) return;
        swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === "string") {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      let targetSlideIndex;
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      const {
        centeredSlides
      } = swiper.params;
      let slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === "auto") {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      let needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (centeredSlides) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) {
        needLoopFix = false;
      }
      if (needLoopFix) {
        const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
        swiper.loopFix({
          direction,
          slideTo: true,
          activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === "next" ? swiper.realIndex : void 0
        });
      }
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(() => {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}
function slideNext(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: "next"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: "prev"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(slideRealIndex) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const initSlides = () => {
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index) => {
      el.setAttribute("data-swiper-slide-index", index);
    });
  };
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  const addBlankSlides = (amountOfSlides) => {
    for (let i2 = 0; i2 < amountOfSlides; i2 += 1) {
      const slideEl = swiper.isElement ? createElement("swiper-slide", [params.slideBlankClass]) : createElement("div", [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    }
    initSlides();
  } else {
    initSlides();
  }
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? void 0 : "next"
  });
}
function loopFix(_temp) {
  let {
    slideRealIndex,
    slideTo: slideTo2 = true,
    direction,
    setTranslate: setTranslate2,
    activeSlideIndex,
    byController,
    byMousewheel
  } = _temp === void 0 ? {} : _temp;
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit("beforeLoopFix");
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  const {
    centeredSlides
  } = params;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo2) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
    return;
  }
  let slidesPerView = params.slidesPerView;
  if (slidesPerView === "auto") {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (centeredSlides && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  let loopedSlides = slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides) {
    showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
  } else if (gridEnabled && params.grid.fill === "row") {
    showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  }
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  let activeIndex = swiper.activeIndex;
  if (typeof activeSlideIndex === "undefined") {
    activeSlideIndex = swiper.getSlideIndex(slides.filter((el) => el.classList.contains(params.slideActiveClass))[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === "next" || !direction;
  const isPrev = direction === "prev" || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate2 === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (let i2 = 0; i2 < loopedSlides - activeColIndexWithShift; i2 += 1) {
      const index = i2 - Math.floor(i2 / cols) * cols;
      if (gridEnabled) {
        const colIndexToPrepend = cols - index - 1;
        for (let i3 = slides.length - 1; i3 >= 0; i3 -= 1) {
          if (slides[i3].column === colIndexToPrepend) prependSlidesIndexes.push(i3);
        }
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
    for (let i2 = 0; i2 < slidesAppended; i2 += 1) {
      const index = i2 - Math.floor(i2 / cols) * cols;
      if (gridEnabled) {
        slides.forEach((slide2, slideIndex) => {
          if (slide2.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(() => {
    swiper.__preventObserver__ = false;
  });
  if (isPrev) {
    prependSlidesIndexes.forEach((index) => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach((index) => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === "auto") {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach((slide2, slideIndex) => {
      swiper.grid.updateSlide(slideIndex, slide2, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo2) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
          if (setTranslate2) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate2) {
          const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate2) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate: setTranslate2,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach((c2) => {
        if (!c2.destroyed && c2.params.loop) c2.loopFix({
          ...loopParams,
          slideTo: c2.params.slidesPerView === params.slidesPerView ? slideTo2 : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo2 : false
      });
    }
  }
  swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach((slideEl) => {
    const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach((slideEl) => {
    slideEl.removeAttribute("data-swiper-slide-index");
  });
  newSlidesOrder.forEach((slideEl) => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}
var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = "move";
  el.style.cursor = moving ? "grabbing" : "grab";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  const window2 = getWindow();
  const {
    params
  } = swiper;
  const edgeSwipeDetection = params.edgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  const swiper = this;
  const document2 = getDocument();
  let e2 = event;
  if (e2.originalEvent) e2 = e2.originalEvent;
  const data = swiper.touchEventsData;
  if (e2.type === "pointerdown") {
    if (data.pointerId !== null && data.pointerId !== e2.pointerId) {
      return;
    }
    data.pointerId = e2.pointerId;
  } else if (e2.type === "touchstart" && e2.targetTouches.length === 1) {
    data.touchId = e2.targetTouches[0].identifier;
  }
  if (e2.type === "touchstart") {
    preventEdgeSwipe(swiper, e2, e2.targetTouches[0].pageX);
    return;
  }
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e2.pointerType === "mouse") return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let targetEl = e2.target;
  if (params.touchEventsTarget === "wrapper") {
    if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
  }
  if ("which" in e2 && e2.which === 3) return;
  if ("button" in e2 && e2.button > 0) return;
  if (data.isTouched && data.isMoved) return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  const eventPath = e2.composedPath ? e2.composedPath() : e2.path;
  if (swipingClassHasValue && e2.target && e2.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e2.target && e2.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e2.pageX;
  touches.currentY = e2.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  if (!preventEdgeSwipe(swiper, e2, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = void 0;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === "SELECT") {
      data.isTouched = false;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl && (e2.pointerType === "mouse" || e2.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) {
    document2.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e2.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit("touchStart", e2);
}
function onTouchMove(event) {
  const document2 = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === "mouse") return;
  let e2 = event;
  if (e2.originalEvent) e2 = e2.originalEvent;
  if (e2.type === "pointermove") {
    if (data.touchId !== null) return;
    const id = e2.pointerId;
    if (id !== data.pointerId) return;
  }
  let targetTouch;
  if (e2.type === "touchmove") {
    targetTouch = [...e2.changedTouches].filter((t2) => t2.identifier === data.touchId)[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e2;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit("touchMoveOpposite", e2);
    }
    return;
  }
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e2.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e2.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== e2.target && e2.pointerType !== "mouse") {
    document2.activeElement.blur();
  }
  if (document2.activeElement) {
    if (e2.target === document2.activeElement && e2.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit("touchMove", e2);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === "undefined") {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit("touchMoveOpposite", e2);
  }
  if (typeof data.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || e2.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e2.cancelable) {
    e2.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e2.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? "prev" : "next";
  swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent("transitionend", {
        bubbles: true,
        cancelable: true,
        detail: {
          bySwiperTouchMove: true
        }
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit("sliderFirstMove", e2);
  }
  let loopFixed;
  (/* @__PURE__ */ new Date()).getTime();
  if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit("sliderMove", e2);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
      swiper.loopFix({
        direction: "prev",
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: "next",
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e2.preventedByNestedSwiper = true;
  }
  if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  swiper.updateProgress(data.currentTranslate);
  swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  let e2 = event;
  if (e2.originalEvent) e2 = e2.originalEvent;
  let targetTouch;
  const isTouchEvent = e2.type === "touchend" || e2.type === "touchcancel";
  if (!isTouchEvent) {
    if (data.touchId !== null) return;
    if (e2.pointerId !== data.pointerId) return;
    targetTouch = e2;
  } else {
    targetTouch = [...e2.changedTouches].filter((t2) => t2.identifier === data.touchId)[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e2.type)) {
    const proceed = ["pointercancel", "contextmenu"].includes(e2.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e2.pointerType === "mouse") return;
  if (data.allowTouchCallbacks) {
    swiper.emit("touchEnd", e2);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }
  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e2.path || e2.composedPath && e2.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e2.target, pathTree);
    swiper.emit("tap click", e2);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit("doubleTap doubleClick", e2);
    }
  }
  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i2 = 0; i2 < slidesGrid.length; i2 += i2 < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i2 < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i2 + increment2] !== "undefined") {
      if (swipeToLast || currentPos >= slidesGrid[i2] && currentPos < slidesGrid[i2 + increment2]) {
        stopIndex = i2;
        groupSize = slidesGrid[i2 + increment2] - slidesGrid[i2];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i2]) {
      stopIndex = i2;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
      else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e2.target === swiper.navigation.nextEl || e2.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === "next") {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === "prev") {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e2.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e2) {
  const swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e2.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e2.stopPropagation();
      e2.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit("setTranslate", swiper.translate, false);
}
function onLoad(e2) {
  const swiper = this;
  processLazyPreloader(swiper, e2.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}
function onDocumentTouchStart() {
  const swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = "auto";
  }
}
const events = (swiper, method) => {
  const document2 = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  if (!el || typeof el === "string") return;
  document2[domMethod]("touchstart", swiper.onDocumentTouchStart, {
    passive: false,
    capture
  });
  el[domMethod]("touchstart", swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]("pointerdown", swiper.onTouchStart, {
    passive: false
  });
  document2[domMethod]("touchmove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("pointermove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("touchend", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerup", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointercancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("touchcancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerout", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerleave", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("contextmenu", swiper.onTouchEnd, {
    passive: true
  });
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper[swiperMethod]("observerUpdate", onResize, true);
  }
  el[domMethod]("load", swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, "on");
}
function detachEvents() {
  const swiper = this;
  events(swiper, "off");
}
var events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0) return;
  const breakpoint = swiper.getBreakpoint(breakpoints2, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasGrabCursor = swiper.params.grabCursor;
  const isGrabCursor = breakpointParams.grabCursor;
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  if (wasGrabCursor && !isGrabCursor) {
    swiper.unsetGrabCursor();
  } else if (!wasGrabCursor && isGrabCursor) {
    swiper.setGrabCursor();
  }
  ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    if (typeof breakpointParams[prop] === "undefined") return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit("_beforeBreakpoint", breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base, containerEl) {
  if (base === void 0) {
    base = "window";
  }
  if (!breakpoints2 || base === "container" && !containerEl) return void 0;
  let breakpoint = false;
  const window2 = getWindow();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a2, b2) => parseInt(a2.value, 10) - parseInt(b2.value, 10));
  for (let i2 = 0; i2 < points.length; i2 += 1) {
    const {
      point,
      value
    } = points[i2];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
var breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach((item) => {
    if (typeof item === "object") {
      Object.keys(item).forEach((classNames) => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === "string") {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  if (!el || typeof el === "string") return;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}
var classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? "lock" : "unlock");
  }
}
var checkOverflow$1 = {
  checkOverflow
};
var defaults = {
  init: true,
  direction: "horizontal",
  oneWayMovement: false,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: "swiper",
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
let Swiper$1 = class Swiper {
  constructor() {
    let el;
    let params;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;
    const document2 = getDocument();
    if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document2.querySelectorAll(params.el).forEach((containerEl) => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    }
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach((mod) => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend$1({}, defaults, allModulesParams);
    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params);
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach((eventName) => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit("_swiper");
    if (swiper.params.init) {
      swiper.init();
    }
    return swiper;
  }
  getDirectionLabel(property) {
    if (this.isHorizontal()) {
      return property;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property];
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = elementIndex(slides[0]);
    return elementIndex(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit("enable");
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit("disable");
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(" ").filter((className) => {
      return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return "";
    return slideEl.className.split(" ").filter((className) => {
      return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach((slideEl) => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit("_slideClass", slideEl, classNames);
    });
    swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = "current";
    }
    if (exact === void 0) {
      exact = false;
    }
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === "number") return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
      let breakLoop;
      for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
        if (slides[i2] && !breakLoop) {
          slideSize += Math.ceil(slides[i2].swiperSlideSize);
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
        if (slides[i2] && !breakLoop) {
          slideSize += slides[i2].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
          const slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i2] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate2();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper.emit("changeDirection");
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
    swiper.rtl = direction === "rtl";
    swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "rtl";
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "ltr";
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;
    let el = element || swiper.params.el;
    if (typeof el === "string") {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = createElement("div", swiper.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
      wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit("beforeInit");
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.addClasses();
    swiper.updateSize();
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }
    if (swiper.params.loop) {
      swiper.loopCreate();
    }
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener("load", (e2) => {
          processLazyPreloader(swiper, e2.target);
        });
      }
    });
    preload(swiper);
    swiper.initialized = true;
    preload(swiper);
    swiper.emit("init");
    swiper.emit("afterInit");
    return swiper;
  }
  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }
    if (cleanStyles === void 0) {
      cleanStyles = true;
    }
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === "undefined" || swiper.destroyed) {
      return null;
    }
    swiper.emit("beforeDestroy");
    swiper.initialized = false;
    swiper.detachEvents();
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (cleanStyles) {
      swiper.removeClasses();
      if (el && typeof el !== "string") {
        el.removeAttribute("style");
      }
      if (wrapperEl) {
        wrapperEl.removeAttribute("style");
      }
      if (slides && slides.length) {
        slides.forEach((slideEl) => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute("style");
          slideEl.removeAttribute("data-swiper-slide-index");
        });
      }
    }
    swiper.emit("destroy");
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      if (swiper.el && typeof swiper.el !== "string") {
        swiper.el.swiper = null;
      }
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === "function" && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m2) => Swiper.installModule(m2));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
};
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);
const paramsList = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function isObject(o2) {
  return typeof o2 === "object" && o2 !== null && o2.constructor && Object.prototype.toString.call(o2).slice(8, -1) === "Object" && !o2.__swiper__;
}
function extend(target, src) {
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    if (typeof target[key] === "undefined") target[key] = src[key];
    else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];
      else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }
  return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }
  return params.pagination && typeof params.pagination.el === "undefined";
}
function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }
  return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = "";
  }
  const classes2 = classNames.split(" ").map((c2) => c2.trim()).filter((c2) => !!c2);
  const unique = [];
  classes2.forEach((c2) => {
    if (unique.indexOf(c2) < 0) unique.push(c2);
  });
  return unique.join(" ");
}
function wrapperClass(className) {
  if (className === void 0) {
    className = "";
  }
  if (!className) return "swiper-wrapper";
  if (!className.includes("swiper-wrapper")) return `swiper-wrapper ${className}`;
  return className;
}
function updateSwiper(_ref) {
  let {
    swiper,
    slides,
    passedParams,
    changedParams,
    nextEl,
    prevEl,
    scrollbarEl,
    paginationEl
  } = _ref;
  const updateParams = changedParams.filter((key) => key !== "children" && key !== "direction" && key !== "wrapperClass");
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && !passedParams.thumbs.swiper.destroyed && currentParams.thumbs && (!currentParams.thumbs.swiper || currentParams.thumbs.swiper.destroyed)) {
    needThumbsInit = true;
  }
  if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = (mod) => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();
    if (mod === "navigation") {
      if (swiper.isElement) {
        swiper[mod].prevEl.remove();
        swiper[mod].nextEl.remove();
      }
      currentParams[mod].prevEl = void 0;
      currentParams[mod].nextEl = void 0;
      swiper[mod].prevEl = void 0;
      swiper[mod].nextEl = void 0;
    } else {
      if (swiper.isElement) {
        swiper[mod].el.remove();
      }
      currentParams[mod].el = void 0;
      swiper[mod].el = void 0;
    }
  };
  if (changedParams.includes("loop") && swiper.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach((key) => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      Object.assign(currentParams[key], passedParams[key]);
      if ((key === "navigation" || key === "pagination" || key === "scrollbar") && "enabled" in passedParams[key] && !passedParams[key].enabled) {
        destroyModule(key);
      }
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes("controller") && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes("children") && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes("virtual") && virtual && currentParams.virtual.enabled) {
    if (slides) virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes("children") && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper.isElement && (!paginationEl || typeof paginationEl === "string")) {
      paginationEl = document.createElement("div");
      paginationEl.classList.add("swiper-pagination");
      paginationEl.part.add("pagination");
      swiper.el.appendChild(paginationEl);
    }
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === "string")) {
      scrollbarEl = document.createElement("div");
      scrollbarEl.classList.add("swiper-scrollbar");
      scrollbarEl.part.add("scrollbar");
      swiper.el.appendChild(scrollbarEl);
    }
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper.isElement) {
      if (!nextEl || typeof nextEl === "string") {
        nextEl = document.createElement("div");
        nextEl.classList.add("swiper-button-next");
        nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
        nextEl.part.add("button-next");
        swiper.el.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === "string") {
        prevEl = document.createElement("div");
        prevEl.classList.add("swiper-button-prev");
        prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
        prevEl.part.add("button-prev");
        swiper.el.appendChild(prevEl);
      }
    }
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes("allowSlideNext")) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes("allowSlidePrev")) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes("direction")) {
    swiper.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper.loopCreate();
  }
  swiper.update();
}
function getParams(obj, splitEvents) {
  if (obj === void 0) {
    obj = {};
  }
  if (splitEvents === void 0) {
    splitEvents = true;
  }
  const params = {
    on: {}
  };
  const events2 = {};
  const passedParams = {};
  extend(params, defaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map((key) => key.replace(/_/, ""));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach((key) => {
    if (typeof obj[key] === "undefined") return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === "function") {
      if (splitEvents) {
        events2[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ["navigation", "pagination", "scrollbar"].forEach((key) => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events: events2
  };
}
function mountSwiper(_ref, swiperParams) {
  let {
    el,
    nextEl,
    prevEl,
    paginationEl,
    scrollbarEl,
    swiper
  } = _ref;
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}
function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;
  const addKey = (key) => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join("") !== childrenKeys.join("")) addKey("children");
    if (oldChildren.length !== children.length) addKey("children");
  }
  const watchParams = paramsList.filter((key) => key[0] === "_").map((key) => key.replace(/_/, ""));
  watchParams.forEach((key) => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach((newKey) => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach((oldKey) => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}
const updateOnVirtualData = (swiper) => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes("SwiperSlide");
}
function processChildren(c2) {
  const slides = [];
  xn.Children.toArray(c2).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach((slide2) => slides.push(slide2));
    }
  });
  return slides;
}
function getChildren(c2) {
  const slides = [];
  const slots = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  xn.Children.toArray(c2).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach((slide2) => slides.push(slide2));
      } else {
        slots["container-end"].push(child);
      }
    } else {
      slots["container-end"].push(child);
    }
  });
  return {
    slides,
    slots
  };
}
function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const getSlideIndex = (index) => {
    let slideIndex = index;
    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? "right" : "left"]: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper.params.loop ? -slides.length : 0;
  const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i2 = loopFrom; i2 < loopTo; i2 += 1) {
    if (i2 >= from && i2 <= to) {
      slidesToRender.push(slides[getSlideIndex(i2)]);
    }
  }
  return slidesToRender.map((child, index) => {
    return /* @__PURE__ */ xn.cloneElement(child, {
      swiper,
      style,
      key: child.props.virtualIndex || child.key || `slide-${index}`
    });
  });
}
function useIsomorphicLayoutEffect$1(callback, deps) {
  if (typeof window === "undefined") return y(callback, deps);
  return _(callback, deps);
}
const SwiperSlideContext = /* @__PURE__ */ G$1(null);
const SwiperContext = /* @__PURE__ */ G$1(null);
const useSwiper = () => {
  return x$1(SwiperContext);
};
const Swiper2 = /* @__PURE__ */ w(function(_temp, externalElRef) {
  let {
    className,
    tag: Tag = "div",
    wrapperTag: WrapperTag = "div",
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = h("swiper");
  const [virtualData, setVirtualData] = h(null);
  const [breakpointChanged, setBreakpointChanged] = h(false);
  const initializedRef = A$1(false);
  const swiperElRef = A$1(null);
  const swiperRef = A$1(null);
  const oldPassedParamsRef = A$1(null);
  const oldSlides = A$1(null);
  const nextElRef = A$1(null);
  const prevElRef = A$1(null);
  const paginationElRef = A$1(null);
  const scrollbarElRef = A$1(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events: events2
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes2) {
      setContainerClasses(classes2);
    }
  });
  const initSwiper = () => {
    Object.assign(swiperParams.on, events2);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new Swiper$1(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }
  if (swiperRef.current) {
    swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
  }
  const attachEvents2 = () => {
    if (eventsAssigned || !events2 || !swiperRef.current) return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.on(eventName, events2[eventName]);
    });
  };
  const detachEvents2 = () => {
    if (!events2 || !swiperRef.current) return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.off(eventName, events2[eventName]);
    });
  };
  y(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
    };
  });
  y(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });
  useIsomorphicLayoutEffect$1(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current) return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);
  useIsomorphicLayoutEffect$1(() => {
    attachEvents2();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, (c2) => c2.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents2();
    };
  });
  useIsomorphicLayoutEffect$1(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index) => {
      return /* @__PURE__ */ xn.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index
      });
    });
  }
  return /* @__PURE__ */ xn.createElement(Tag, _extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ""}`)
  }, restProps), /* @__PURE__ */ xn.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots["container-start"], /* @__PURE__ */ xn.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots["wrapper-start"], renderSlides(), slots["wrapper-end"]), needsNavigation(swiperParams) && /* @__PURE__ */ xn.createElement(xn.Fragment, null, /* @__PURE__ */ xn.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ xn.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /* @__PURE__ */ xn.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /* @__PURE__ */ xn.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots["container-end"]));
});
Swiper2.displayName = "Swiper";
const SwiperSlide = /* @__PURE__ */ w(function(_temp, externalRef) {
  let {
    tag: Tag = "div",
    children,
    className = "",
    swiper,
    zoom,
    lazy,
    virtualIndex,
    swiperSlideIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = A$1(null);
  const [slideClasses, setSlideClasses] = h("swiper-slide");
  const [lazyLoaded, setLazyLoaded] = h(false);
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect$1(() => {
    if (typeof swiperSlideIndex !== "undefined") {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== "swiper-slide") {
        setSlideClasses("swiper-slide");
      }
      return;
    }
    swiper.on("_slideClass", updateClasses);
    return () => {
      if (!swiper) return;
      swiper.off("_slideClass", updateClasses);
    };
  });
  useIsomorphicLayoutEffect$1(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf("swiper-slide-active") >= 0,
    isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
    isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0,
    isNext: slideClasses.indexOf("swiper-slide-next") >= 0
  };
  const renderChildren = () => {
    return typeof children === "function" ? children(slideData) : children;
  };
  const onLoad2 = () => {
    setLazyLoaded(true);
  };
  return /* @__PURE__ */ xn.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ""}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad2
  }, rest), zoom && /* @__PURE__ */ xn.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /* @__PURE__ */ xn.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === "number" ? zoom : void 0
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ xn.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !zoom && /* @__PURE__ */ xn.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ xn.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = "SwiperSlide";
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach((key) => {
      if (!params[key] && params.auto === true) {
        let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = createElement("div", checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}
function Navigation(_ref) {
  let {
    swiper,
    extendParams,
    on: on2,
    emit
  } = _ref;
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null
  };
  function getEl(el) {
    let res;
    if (el && typeof el === "string" && swiper.isElement) {
      res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
      if (res) return res;
    }
    if (el) {
      if (typeof el === "string") res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      } else if (res && res.length === 1) {
        res = res[0];
      }
    }
    if (el && !res) return el;
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (subEl) {
        subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
        if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        }
      }
    });
  }
  function update2() {
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e2) {
    e2.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit("navigationPrev");
  }
  function onNextClick(e2) {
    e2.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit("navigationNext");
  }
  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    });
    if (!(params.nextEl || params.prevEl)) return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(...params.lockClass.split(" "));
      }
    };
    nextEl.forEach((el) => initButton(el, "next"));
    prevEl.forEach((el) => initButton(el, "prev"));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
    };
    nextEl.forEach((el) => destroyButton(el, "next"));
    prevEl.forEach((el) => destroyButton(el, "prev"));
  }
  on2("init", () => {
    if (swiper.params.navigation.enabled === false) {
      disable();
    } else {
      init();
      update2();
    }
  });
  on2("toEdge fromEdge lock unlock", () => {
    update2();
  });
  on2("destroy", () => {
    destroy();
  });
  on2("enable disable", () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (swiper.enabled) {
      update2();
      return;
    }
    [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.add(swiper.params.navigation.lockClass));
  });
  on2("click", (_s, e2) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const targetEl = e2.target;
    let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
    if (swiper.isElement && !targetIsButton) {
      const path = e2.path || e2.composedPath && e2.composedPath();
      if (path) {
        targetIsButton = path.find((pathEl) => nextEl.includes(pathEl) || prevEl.includes(pathEl));
      }
    }
    if (swiper.params.navigation.hideOnClick && !targetIsButton) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden2;
      if (nextEl.length) {
        isHidden2 = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden2 = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden2 === true) {
        emit("navigationShow");
      } else {
        emit("navigationHide");
      }
      [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
    init();
    update2();
  };
  const disable = () => {
    swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update: update2,
    init,
    destroy
  });
}
function classesToSelector(classes2) {
  if (classes2 === void 0) {
    classes2 = "";
  }
  return `.${classes2.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination(_ref) {
  let {
    swiper,
    extendParams,
    on: on2,
    emit
  } = _ref;
  const pfx = "swiper-pagination";
  extendParams({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function getMoveDirection(prevIndex, nextIndex, length) {
    prevIndex = prevIndex % length;
    nextIndex = nextIndex % length;
    if (nextIndex === prevIndex + 1) {
      return "next";
    } else if (nextIndex === prevIndex - 1) {
      return "previous";
    }
    return;
  }
  function onBulletClick(e2) {
    const bulletEl = e2.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e2.preventDefault();
    const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index) return;
      const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
      if (moveDirection === "next") {
        swiper.slideNext();
      } else if (moveDirection === "previous") {
        swiper.slidePrev();
      } else {
        swiper.slideToLoop(index);
      }
    } else {
      swiper.slideTo(index);
    }
  }
  function update2() {
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== "undefined") {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? "width" : "height");
        el.forEach((subEl) => {
          subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== void 0) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach((bulletEl) => {
        const classesToRemove = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`)].map((s2) => typeof s2 === "string" && s2.includes(" ") ? s2.split(" ") : s2).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach((bullet) => {
          const bulletIndex = elementIndex(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(" "));
          } else if (swiper.isElement) {
            bullet.setAttribute("part", "bullet");
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, "prev");
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, "next");
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(" "));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i2 = firstIndex; i2 <= lastIndex; i2 += 1) {
            if (bullets[i2]) {
              bullets[i2].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
          }
          setSideBullets(firstDisplayedBullet, "prev");
          setSideBullets(lastDisplayedBullet, "next");
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? "right" : "left";
        bullets.forEach((bullet) => {
          bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === "fraction") {
        subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach((fractionEl) => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach((totalEl) => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === "progressbar") {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
        } else {
          progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === "horizontal") {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach((progressEl) => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === "custom" && params.renderCustom) {
        subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
        if (subElIndex === 0) emit("paginationRender", subEl);
      } else {
        if (subElIndex === 0) emit("paginationRender", subEl);
        emit("paginationUpdate", subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
      }
    });
  }
  function render() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let paginationHTML = "";
    if (params.type === "bullets") {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i2 = 0; i2 < numberOfBullets; i2 += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i2, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === "fraction") {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === "progressbar") {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach((subEl) => {
      if (params.type !== "custom") {
        subEl.innerHTML = paginationHTML || "";
      }
      if (params.type === "bullets") {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== "custom") {
      emit("paginationRender", el[0]);
    }
  }
  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: "swiper-pagination"
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === "string" && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === "string") {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      if (el.length > 1) {
        el = el.filter((subEl) => {
          if (elementParents(subEl, ".swiper")[0] !== swiper.el) return false;
          return true;
        })[0];
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (params.type === "bullets" && params.clickable) {
        subEl.classList.add(...(params.clickableClass || "").split(" "));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === "bullets" && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === "progressbar" && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener("click", onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || "").split(" "));
          subEl.removeEventListener("click", onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl) => subEl.classList.remove(...params.bulletActiveClass.split(" ")));
  }
  on2("changeDirection", () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on2("init", () => {
    if (swiper.params.pagination.enabled === false) {
      disable();
    } else {
      init();
      render();
      update2();
    }
  });
  on2("activeIndexChange", () => {
    if (typeof swiper.snapIndex === "undefined") {
      update2();
    }
  });
  on2("snapIndexChange", () => {
    update2();
  });
  on2("snapGridLengthChange", () => {
    render();
    update2();
  });
  on2("destroy", () => {
    destroy();
  });
  on2("enable disable", () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
    }
  });
  on2("lock unlock", () => {
    update2();
  });
  on2("click", (_s, e2) => {
    const targetEl = e2.target;
    const el = makeElementsArray(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden2 = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden2 === true) {
        emit("paginationShow");
      } else {
        emit("paginationHide");
      }
      el.forEach((subEl) => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init();
    render();
    update2();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update: update2,
    init,
    destroy
  });
}
function A11y(_ref) {
  let {
    swiper,
    extendParams,
    on: on2
  } = _ref;
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: true
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;
  let preventFocusHandler;
  let focusTargetSlideEl;
  let visibilityChangedTimestamp = (/* @__PURE__ */ new Date()).getTime();
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.innerHTML = "";
    notification.innerHTML = message;
  }
  function getRandomNumber(size) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("tabIndex", "0");
    });
  }
  function makeElNotFocusable(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("tabIndex", "-1");
    });
  }
  function addElRole(el, role) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("role", role);
    });
  }
  function addElRoleDescription(el, description) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-roledescription", description);
    });
  }
  function addElControls(el, controls) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-controls", controls);
    });
  }
  function addElLabel(el, label) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-label", label);
    });
  }
  function addElId(el, id) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("id", id);
    });
  }
  function addElLive(el, live) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-live", live);
    });
  }
  function disableEl(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-disabled", true);
    });
  }
  function enableEl(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-disabled", false);
    });
  }
  function onEnterOrSpaceKey(e2) {
    if (e2.keyCode !== 13 && e2.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const targetEl = e2.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e2.target))) {
      if (!e2.target.matches(classesToSelector(swiper.params.pagination.bulletClass))) return;
    }
    if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
      const prevEls = makeElementsArray(swiper.navigation.prevEl);
      const nextEls = makeElementsArray(swiper.navigation.nextEl);
      if (nextEls.includes(targetEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          notify(params.lastSlideMessage);
        } else {
          notify(params.nextSlideMessage);
        }
      }
      if (prevEls.includes(targetEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          notify(params.firstSlideMessage);
        } else {
          notify(params.prevSlideMessage);
        }
      }
    }
    if (swiper.pagination && targetEl.matches(classesToSelector(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.forEach((bulletEl) => {
      if (swiper.params.pagination.clickable) {
        makeElFocusable(bulletEl);
        if (!swiper.params.pagination.renderBullet) {
          addElRole(bulletEl, "button");
          addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(bulletEl) + 1));
        }
      }
      if (bulletEl.matches(classesToSelector(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute("aria-current", "true");
      } else {
        bulletEl.removeAttribute("aria-current");
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== "BUTTON") {
      addElRole(el, "button");
      el.addEventListener("keydown", onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const handlePointerDown = (e2) => {
    if (focusTargetSlideEl && focusTargetSlideEl !== e2.target && !focusTargetSlideEl.contains(e2.target)) {
      preventFocusHandler = true;
    }
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    preventFocusHandler = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const onVisibilityChange = (e2) => {
    visibilityChangedTimestamp = (/* @__PURE__ */ new Date()).getTime();
  };
  const handleFocus = (e2) => {
    if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
    if ((/* @__PURE__ */ new Date()).getTime() - visibilityChangedTimestamp < 100) return;
    const slideEl = e2.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    focusTargetSlideEl = slideEl;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e2.sourceCapabilities && e2.sourceCapabilities.firesTouchEvents) return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    requestAnimationFrame(() => {
      if (preventFocusHandler) return;
      if (swiper.params.loop) {
        swiper.slideToLoop(parseInt(slideEl.getAttribute("data-swiper-slide-index")), 0);
      } else {
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
      }
      preventFocusHandler = false;
    });
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }
    if (params.containerRole) {
      addElRole(containerEl, params.containerRole);
    }
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
    addElId(wrapperEl, wrapperId);
    addElLive(wrapperEl, live);
    initSlides();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach((el) => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach((el) => initNavEl(el, wrapperId, params.prevSlideMessage));
    }
    if (hasClickablePagination()) {
      const paginationEl = makeElementsArray(swiper.pagination.el);
      paginationEl.forEach((el) => {
        el.addEventListener("keydown", onEnterOrSpaceKey);
      });
    }
    const document2 = getDocument();
    document2.addEventListener("visibilitychange", onVisibilityChange);
    swiper.el.addEventListener("focus", handleFocus, true);
    swiper.el.addEventListener("focus", handleFocus, true);
    swiper.el.addEventListener("pointerdown", handlePointerDown, true);
    swiper.el.addEventListener("pointerup", handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion) liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach((el) => el.removeEventListener("keydown", onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach((el) => el.removeEventListener("keydown", onEnterOrSpaceKey));
    }
    if (hasClickablePagination()) {
      const paginationEl = makeElementsArray(swiper.pagination.el);
      paginationEl.forEach((el) => {
        el.removeEventListener("keydown", onEnterOrSpaceKey);
      });
    }
    const document2 = getDocument();
    document2.removeEventListener("visibilitychange", onVisibilityChange);
    if (swiper.el && typeof swiper.el !== "string") {
      swiper.el.removeEventListener("focus", handleFocus, true);
      swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
      swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
  }
  on2("beforeInit", () => {
    liveRegion = createElement("span", swiper.params.a11y.notificationClass);
    liveRegion.setAttribute("aria-live", "assertive");
    liveRegion.setAttribute("aria-atomic", "true");
  });
  on2("afterInit", () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on2("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on2("fromEdge toEdge afterInit lock unlock", () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on2("paginationUpdate", () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on2("destroy", () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}
function Thumb(_ref) {
  let {
    swiper,
    extendParams,
    on: on2
  } = _ref;
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };
  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
    let slideToIndex;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      swiper.slideToLoop(slideToIndex);
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper.update();
    } else if (isObject$1(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }
    swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on("tap", onThumbClick);
    return true;
  }
  function update2(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }
    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }
    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.forEach((slideEl) => slideEl.classList.remove(thumbActiveClass));
    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i2 = 0; i2 < thumbsToActivate; i2 += 1) {
        elementChildren(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i2}"]`).forEach((slideEl) => {
          slideEl.classList.add(thumbActiveClass);
        });
      }
    } else {
      for (let i2 = 0; i2 < thumbsToActivate; i2 += 1) {
        if (thumbsSwiper.slides[swiper.realIndex + i2]) {
          thumbsSwiper.slides[swiper.realIndex + i2].classList.add(thumbActiveClass);
        }
      }
    }
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      const currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper.params.loop) {
        const newThumbsSlide = thumbsSwiper.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
        newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
        direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
      }
      if (useOffset) {
        newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : void 0);
      }
    }
  }
  on2("beforeInit", () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
      const document2 = getDocument();
      const getThumbsElementAndInit = () => {
        const thumbsElement = typeof thumbs.swiper === "string" ? document2.querySelector(thumbs.swiper) : thumbs.swiper;
        if (thumbsElement && thumbsElement.swiper) {
          thumbs.swiper = thumbsElement.swiper;
          init();
          update2(true);
        } else if (thumbsElement) {
          const eventName = `${swiper.params.eventsPrefix}init`;
          const onThumbsSwiper = (e2) => {
            thumbs.swiper = e2.detail[0];
            thumbsElement.removeEventListener(eventName, onThumbsSwiper);
            init();
            update2(true);
            thumbs.swiper.update();
            swiper.update();
          };
          thumbsElement.addEventListener(eventName, onThumbsSwiper);
        }
        return thumbsElement;
      };
      const watchForThumbsToAppear = () => {
        if (swiper.destroyed) return;
        const thumbsElement = getThumbsElementAndInit();
        if (!thumbsElement) {
          requestAnimationFrame(watchForThumbsToAppear);
        }
      };
      requestAnimationFrame(watchForThumbsToAppear);
    } else {
      init();
      update2(true);
    }
  });
  on2("slideChange update resize observerUpdate", () => {
    update2();
  });
  on2("setTransition", (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on2("beforeDestroy", () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update: update2
  });
}
var _jsxFileName$1P = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/ChevronRight.tsx";
function ChevronRightIcon({
  width = "20",
  height = "20",
  color = "#1B1B1B",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": true,
    ...props,
    children: u("path", {
      d: "M8 15L13 10L8 5",
      stroke: color,
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1P,
      lineNumber: 17,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1P,
    lineNumber: 8,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1O = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/ChevronLeft.tsx";
function ChevronLeftIcon({
  width = "20",
  height = "20",
  color = "#1B1B1B",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": true,
    ...props,
    children: u("path", {
      d: "M12 5L7 10L12 15",
      stroke: color,
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1O,
      lineNumber: 17,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1O,
    lineNumber: 8,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1N = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Carousel/partials/CarouselNavigation.tsx";
const NavigationButton = ({
  disabled = false,
  prev = false,
  next = false
}) => {
  const swiper = useSwiper();
  return u("button", {
    disabled,
    className: clsx$1(["flex items-center justify-center size-10 focus:outline-dashed outline-black", disabled && "opacity-50"]),
    onClick: () => {
      if (prev) swiper.slidePrev();
      if (next) swiper.slideNext();
    },
    children: [prev && u(b$2, {
      children: [u("span", {
        className: "sr-only",
        children: "Go to previous slide"
      }, void 0, false, {
        fileName: _jsxFileName$1N,
        lineNumber: 30,
        columnNumber: 11
      }, void 0), u(ChevronLeftIcon, {}, void 0, false, {
        fileName: _jsxFileName$1N,
        lineNumber: 33,
        columnNumber: 11
      }, void 0)]
    }, void 0, true), next && u(b$2, {
      children: [u("span", {
        className: "sr-only",
        children: "Go to next slide"
      }, void 0, false, {
        fileName: _jsxFileName$1N,
        lineNumber: 39,
        columnNumber: 11
      }, void 0), u(ChevronRightIcon, {}, void 0, false, {
        fileName: _jsxFileName$1N,
        lineNumber: 42,
        columnNumber: 11
      }, void 0)]
    }, void 0, true)]
  }, void 0, true, {
    fileName: _jsxFileName$1N,
    lineNumber: 17,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$1M = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Carousel/CarouselComponent.tsx";
const TypedSwiper$2 = Swiper2;
const TypedSwiperSlide$2 = SwiperSlide;
function Carousel({
  children,
  controls = true,
  postHeader,
  slides
}) {
  if (typeof slides !== "object" || slides == null) return;
  const [atStart, setAtStart] = t$2(h(true), "atStart");
  const [atEnd, setAtEnd] = t$2(h(false), "atEnd");
  return u(b$2, {
    children: u("div", {
      className: "container swiper-overflowed",
      children: u(TypedSwiper$2, {
        modules: [Navigation],
        wrapperClass: "relative",
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesPerView: 1.2,
        spaceBetween: 10,
        breakpoints: {
          768: {
            centeredSlides: false,
            slidesPerView: 4.5,
            spaceBetween: 20
          },
          1280: {
            centeredSlides: false,
            slidesPerView: 4.5,
            spaceBetween: 20
          }
        },
        onSlideChange: (e2) => {
          setAtStart(e2.isBeginning);
          setAtEnd(e2.isEnd);
        },
        children: [u("div", {
          slot: "container-start",
          className: (children || controls || postHeader) && "mb-6 md:mb-10",
          children: [(children || controls) && u("div", {
            className: clsx$1(["flex items-end gap-2", children ? "justify-between" : "justify-end"]),
            children: [u("div", {
              class: "flex-1",
              children
            }, void 0, false, {
              fileName: _jsxFileName$1M,
              lineNumber: 74,
              columnNumber: 17
            }, this), controls && u("div", {
              className: "flex items-center justify-end gap-2 py-0.5 shrink-0 pr-1",
              children: [u(NavigationButton, {
                disabled: atStart,
                prev: true
              }, void 0, false, {
                fileName: _jsxFileName$1M,
                lineNumber: 79,
                columnNumber: 21
              }, this), u(NavigationButton, {
                disabled: atEnd,
                next: true
              }, void 0, false, {
                fileName: _jsxFileName$1M,
                lineNumber: 80,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$1M,
              lineNumber: 78,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1M,
            lineNumber: 67,
            columnNumber: 15
          }, this), postHeader && u("div", {
            children: postHeader
          }, void 0, false, {
            fileName: _jsxFileName$1M,
            lineNumber: 86,
            columnNumber: 28
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1M,
          lineNumber: 62,
          columnNumber: 11
        }, this), slides.map((slide2) => u(TypedSwiperSlide$2, {
          children: slide2
        }, void 0, false, {
          fileName: _jsxFileName$1M,
          lineNumber: 91,
          columnNumber: 13
        }, this))]
      }, void 0, true, {
        fileName: _jsxFileName$1M,
        lineNumber: 37,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1M,
      lineNumber: 36,
      columnNumber: 7
    }, this)
  }, void 0);
}
var _jsxFileName$1L = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ArticleCarousel.tsx";
function ArticleCarousel({
  title,
  blog,
  subtitle,
  titleTag = "h2"
}) {
  const Component = titleTag;
  const [carouselSlides, setCarouselSlides] = t$2(h([]), "carouselSlides");
  y(() => {
    const articlesJson = JSON.parse(blog);
    const articlesTemplate = articlesJson;
    setCarouselSlides(articlesTemplate.map((article) => u(ArticleCard, {
      article: JSON.stringify(article)
    }, void 0, false, {
      fileName: _jsxFileName$1L,
      lineNumber: 31,
      columnNumber: 9
    }, this)));
  }, []);
  return u("div", {
    className: "relative overflow-hidden",
    children: u(Carousel, {
      slides: carouselSlides,
      children: u("div", {
        children: [title && u(Component, {
          className: clsx$1("font-primary text-5xl tracking-tight leading-10"),
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$1L,
          lineNumber: 41,
          columnNumber: 13
        }, this), subtitle && u("div", {
          className: "pt-2 font-primary tracking-wide text-base leading-4 text-tints-80",
          children: subtitle
        }, void 0, false, {
          fileName: _jsxFileName$1L,
          lineNumber: 51,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1L,
        lineNumber: 39,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1L,
      lineNumber: 38,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1L,
    lineNumber: 37,
    columnNumber: 5
  }, this);
}
register(ArticleCarousel, "article-carousel", ["title", "blog", "subtitle"]);
var _jsxFileName$1K = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ArticlesGrid.tsx";
function ArticlesGrid({
  articles,
  blog_nav
}) {
  y(() => {
    const currentUrl = window.location.pathname;
    const links = document.querySelectorAll(".blog-nav-link");
    links.forEach((link) => {
      if (currentUrl.includes(new URL(link.href).pathname)) {
        link.classList.add("active");
      }
    });
  }, []);
  return u("div", {
    className: "container pb-10 md:pb-16 flex flex-col",
    children: [blog_nav && u("ul", {
      className: "flex gap-2 overflow-auto whitespace-nowrap py-6 mb-4",
      children: JSON.parse(blog_nav).map((nav, index) => u("li", {
        children: u("a", {
          href: nav.nav_link,
          className: "blog-nav-link text-button-sm font-medium px-4 py-1 border-black border uppercase rounded-[40px] hover:text-white hover:bg-black transition-all",
          children: nav.nav_label
        }, void 0, false, {
          fileName: _jsxFileName$1K,
          lineNumber: 32,
          columnNumber: 15
        }, this)
      }, index, false, {
        fileName: _jsxFileName$1K,
        lineNumber: 31,
        columnNumber: 13
      }, this))
    }, void 0, false, {
      fileName: _jsxFileName$1K,
      lineNumber: 29,
      columnNumber: 9
    }, this), console.log(articles), u("div", {
      className: "grid grid-cols-1 gap-x-5 gap-y-10 md:grid-cols-2 lg:grid-cols-4",
      children: JSON.parse(articles).map((article) => u(ArticleCard, {
        article: JSON.stringify(article)
      }, void 0, false, {
        fileName: _jsxFileName$1K,
        lineNumber: 45,
        columnNumber: 11
      }, this))
    }, void 0, false, {
      fileName: _jsxFileName$1K,
      lineNumber: 43,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1K,
    lineNumber: 27,
    columnNumber: 5
  }, this);
}
register(ArticlesGrid, "articles-grid");
var _jsxFileName$1J = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ArticleHeader.tsx";
function ArticleHeader({
  article_data
}) {
  const article_json = JSON.parse(article_data);
  const [contentsOfTable, setContentsOfTable] = t$2(h([]), "contentsOfTable");
  const handleScrollToHeading = (heading) => {
    const articleContent = document.querySelector(".rte");
    const headingElement = articleContent ? Array.from(articleContent.querySelectorAll("h2")).find((el) => el.innerText.trim().replace(/\s+/g, " ") === heading.innerText.trim().replace(/\s+/g, " ")) : null;
    if (headingElement) {
      headingElement.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  y(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(article_json.content, "text/html");
    const h2Elements = doc ? Array.from(doc.querySelectorAll("h2")) : null;
    setContentsOfTable(h2Elements);
  }, []);
  return u("div", {
    className: "container",
    children: u("div", {
      className: "md:max-w-[50%] mx-4 md:mx-auto pt-12",
      children: [u("img", {
        src: article_json.featured_image,
        alt: article_json.title,
        className: "aspect-[2/1.5] w-full object-cover"
      }, void 0, false, {
        fileName: _jsxFileName$1J,
        lineNumber: 33,
        columnNumber: 9
      }, this), u("a", {
        href: article_json.blog_url,
        className: "border flex rounded-[40px] border-shadow py-1 px-4 my-6 w-fit text-[12px] font-primary font-medium uppercase",
        children: article_json.blog
      }, void 0, false, {
        fileName: _jsxFileName$1J,
        lineNumber: 38,
        columnNumber: 9
      }, this), u("h1", {
        className: "md:text-5xl text-6xl font-primary font-normal tracking-[-0.04em] md:tracking-[-0.03em] mb-4",
        children: article_json.title
      }, void 0, false, {
        fileName: _jsxFileName$1J,
        lineNumber: 46,
        columnNumber: 9
      }, this), u("p", {
        className: "text-sm font-[450] font-primary text-tints-80",
        children: article_json.date
      }, void 0, false, {
        fileName: _jsxFileName$1J,
        lineNumber: 53,
        columnNumber: 9
      }, this), article_json.excerpt && u("div", {
        className: "mt-8",
        children: article_json.excerpt
      }, void 0, false, {
        fileName: _jsxFileName$1J,
        lineNumber: 57,
        columnNumber: 11
      }, this), contentsOfTable && (contentsOfTable == null ? void 0 : contentsOfTable.length) !== 0 && u("div", {
        className: "my-12",
        children: [u("h3", {
          className: "text-base text-shadow font-primary font-medium mb-2",
          children: "What’s in this article?"
        }, void 0, false, {
          fileName: _jsxFileName$1J,
          lineNumber: 61,
          columnNumber: 13
        }, this), u("ul", {
          className: "text-base text-shadow font-[450] font-primary flex flex-col gap-1",
          children: contentsOfTable && contentsOfTable.map((heading, index) => u("li", {
            children: u("a", {
              onClick: (e2) => {
                e2.preventDefault();
                handleScrollToHeading(heading);
              },
              className: "underline cursor-pointer",
              children: heading.innerText
            }, void 0, false, {
              fileName: _jsxFileName$1J,
              lineNumber: 74,
              columnNumber: 21
            }, this)
          }, index, false, {
            fileName: _jsxFileName$1J,
            lineNumber: 73,
            columnNumber: 19
          }, this))
        }, void 0, false, {
          fileName: _jsxFileName$1J,
          lineNumber: 66,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1J,
        lineNumber: 60,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1J,
      lineNumber: 32,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1J,
    lineNumber: 31,
    columnNumber: 5
  }, this);
}
register(ArticleHeader, "article-header");
var _jsxFileName$1I = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Logo.tsx";
function Logo() {
  return u("svg", {
    width: "203",
    height: "38",
    viewBox: "0 0 203 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [u("g", {
      "clip-path": "url(#clip0_298_1011)",
      children: [u("path", {
        d: "M40.6439 22.512C44.0479 20.08 45.9999 16.614 45.9999 13C45.9999 9.386 44.0479 5.92 40.6439 3.488C37.7339 1.41 33.9799 0.195998 29.9859 0.0239983L26.9999 5.182L26.5259 6H28.9999C34.9619 6 39.9999 9.206 39.9999 13C39.9999 15.42 37.9499 17.598 34.9199 18.86C33.1979 19.578 31.1619 20 28.9999 20H18.422L15.002 25.908C15.662 25.966 16.328 26 17.002 26H29.0019C29.6759 26 30.3419 25.966 31.0019 25.908L38.0019 38H46.0019L37.9439 24.082C38.9039 23.632 39.8099 23.108 40.6439 22.512Z",
        fill: "currentColor"
      }, void 0, false, {
        fileName: _jsxFileName$1I,
        lineNumber: 11,
        columnNumber: 9
      }, this), u("path", {
        opacity: "0.06",
        d: "M29 0H17C16.67 0 16.342 0.01 16.014 0.024C12.02 0.196 8.26599 1.41 5.35599 3.488C1.952 5.92 0 9.386 0 13C0 16.614 1.952 20.08 5.35599 22.512C6.19199 23.108 7.09799 23.632 8.05799 24.082L0 38H7.99999L15 25.908L18.42 20H16.998C14.838 20 12.8 19.578 11.078 18.86C8.04799 17.598 5.99799 15.42 5.99799 13C5.99799 9.206 11.036 6 16.998 6H26.524L26.998 5.182L29.986 0.024C29.658 0.01 29.33 0 29 0Z",
        fill: "currentColor"
      }, void 0, false, {
        fileName: _jsxFileName$1I,
        lineNumber: 15,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1I,
      lineNumber: 10,
      columnNumber: 7
    }, this), u("rect", {
      x: "56",
      width: "1",
      height: "38",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 21,
      columnNumber: 7
    }, this), u("path", {
      d: "M67 26.14H70.22V20.62H71.62L75.04 26.14H78.48L74.7 20.06C76.38 19.56 77.64 18.42 77.64 16.26V16.18C77.64 13.22 75.5 11.84 72.12 11.84H67V26.14ZM70.22 18.42V14.32H72.04C73.6 14.32 74.48 14.82 74.48 16.28V16.36C74.48 17.74 73.66 18.42 72.04 18.42H70.22Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 22,
      columnNumber: 7
    }, this), u("path", {
      d: "M86.3022 23.78C83.9622 23.78 82.2822 21.98 82.2822 19.06V18.9C82.2822 16.02 83.7822 14.2 86.2622 14.2C88.7622 14.2 90.2422 16.1 90.2422 18.88V19.04C90.2422 21.92 88.7222 23.78 86.3022 23.78ZM86.2422 26.36C90.7022 26.36 93.6222 23.26 93.6222 19V18.84C93.6222 14.54 90.5622 11.64 86.2622 11.64C82.0222 11.64 78.9022 14.66 78.9022 18.92V19.08C78.9022 23.26 81.7622 26.36 86.2422 26.36Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 26,
      columnNumber: 7
    }, this), u("path", {
      d: "M100.175 26.36C103.555 26.36 105.635 24.34 105.635 21.8C105.635 18.84 103.855 17.9 100.395 17.46C98.195 17.14 97.735 16.66 97.735 15.64C97.735 14.68 98.455 14.02 99.875 14.02C101.295 14.02 102.055 14.62 102.255 15.92H105.235C104.975 13.08 103.095 11.64 99.875 11.64C96.715 11.64 94.675 13.46 94.675 15.9C94.675 18.66 96.175 19.76 99.835 20.24C101.935 20.56 102.535 20.96 102.535 22.1C102.535 23.22 101.595 24 100.175 24C98.055 24 97.515 22.94 97.375 21.66H94.275C94.455 24.52 96.255 26.36 100.175 26.36Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 30,
      columnNumber: 7
    }, this), u("path", {
      d: "M109.435 26.14H112.555L115.175 16.26L117.755 26.14H121.055L124.535 11.84H121.535L119.215 21.78L116.675 11.84H113.915L111.475 21.72L109.235 11.84H105.955L109.435 26.14Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 34,
      columnNumber: 7
    }, this), u("path", {
      d: "M125.889 26.14H135.529V23.62H129.109V20.06H133.989V17.7H129.109V14.36H135.209V11.84H125.889V26.14Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 38,
      columnNumber: 7
    }, this), u("path", {
      d: "M137.184 26.14H146.244V23.6H140.424V11.84H137.184V26.14Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 42,
      columnNumber: 7
    }, this), u("path", {
      d: "M147.775 26.14H156.835V23.6H151.015V11.84H147.775V26.14Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 46,
      columnNumber: 7
    }, this), u("path", {
      d: "M166.836 26.16H167.916V13.1L176.096 26.16H177.416V11.86H176.356V24.62L168.356 11.86H166.836V26.16Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 50,
      columnNumber: 7
    }, this), u("path", {
      d: "M184.014 26.16H185.134V19.82L189.754 11.86H188.634L184.594 18.86L180.354 11.86H179.114L184.014 19.8V26.16Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 54,
      columnNumber: 7
    }, this), u("path", {
      d: "M196.418 26.32C199.498 26.32 201.838 24.64 202.358 21.56H201.318C200.858 24.02 199.018 25.38 196.438 25.38C193.038 25.38 190.918 22.94 190.918 19.08V18.92C190.918 15.14 193.238 12.58 196.438 12.58C199.078 12.58 200.638 13.86 201.078 16.16H202.198C201.758 13.22 199.378 11.68 196.418 11.68C192.678 11.68 189.778 14.72 189.778 18.94V19.1C189.778 23.42 192.338 26.32 196.418 26.32Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 58,
      columnNumber: 7
    }, this), u("defs", {
      children: u("clipPath", {
        id: "clip0_298_1011",
        children: u("rect", {
          width: "46",
          height: "38",
          fill: "white"
        }, void 0, false, {
          fileName: _jsxFileName$1I,
          lineNumber: 64,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1I,
        lineNumber: 63,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1I,
      lineNumber: 62,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1I,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1H = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ComingSoon.tsx";
const Countdown = () => {
  const [distance, setDistance] = t$2(h(0), "distance");
  const [days, setDays] = t$2(h(0), "days");
  const [hours, setHours] = t$2(h(0), "hours");
  const [minutes, setMinutes] = t$2(h(0), "minutes");
  const [seconds, setSeconds] = t$2(h(0), "seconds");
  const launchDate = (/* @__PURE__ */ new Date("December 12, 2024 10:00:00 GMT-05:00")).getTime();
  y(() => {
    setInterval(() => {
      const currentDate = (/* @__PURE__ */ new Date()).getTime();
      const distanceLeft = launchDate - currentDate;
      setDistance(launchDate - currentDate);
      setDays(Math.floor(distanceLeft / (1e3 * 60 * 60 * 24)));
      setHours(Math.floor(distanceLeft % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)));
      setMinutes(Math.floor(distanceLeft % (1e3 * 60 * 60) / (1e3 * 60)));
      setSeconds(Math.floor(distanceLeft % (1e3 * 60) / 1e3));
    }, 1e3);
  }, []);
  return u("div", {
    className: "font-primary text-8xl md:text-[180px] mb-20 md:mb-12",
    children: distance > 0 ? u("div", {
      children: [days, ":", hours, ":", minutes, ":", seconds]
    }, void 0, true, {
      fileName: _jsxFileName$1H,
      lineNumber: 35,
      columnNumber: 9
    }, void 0) : u("div", {
      children: "00:00:00:00"
    }, void 0, false, {
      fileName: _jsxFileName$1H,
      lineNumber: 39,
      columnNumber: 9
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$1H,
    lineNumber: 33,
    columnNumber: 5
  }, void 0);
};
function ComingSoon({
  eyebrow_text,
  title
}) {
  const [emailError, setEmailError] = t$2(h(""), "emailError");
  const [subscribeSuccess, setSubscribeSuccess] = t$2(h(false), "subscribeSuccess");
  const publicID = "PYAUyc";
  const newsLetterList = "QLTdJ4";
  const NewsletterSubscribeEndpoint = `https://a.klaviyo.com/client/subscriptions?company_id=${publicID}`;
  const handleAddToList = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const formJson = Object.fromEntries(Array.from(formData.keys()).map((key) => [key, formData.getAll(key).length > 1 ? formData.getAll(key) : formData.get(key)]));
    const SubscribePayload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: formJson.email
              }
            }
          },
          custom_source: "BIS form"
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: newsLetterList
            }
          }
        }
      }
    };
    fetch(NewsletterSubscribeEndpoint, {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        revision: "2024-10-15",
        "content-type": "application/vnd.api+json"
      },
      body: JSON.stringify(SubscribePayload)
    }).then(async (result) => {
      let response;
      if (result && !result.ok) {
        response = await result.json();
        setEmailError(response.errors[0].detail);
      } else {
        setEmailError("");
        setSubscribeSuccess(true);
        sendDatalayer({
          event: "newsletter"
        });
      }
    }).catch((error) => console.log("ERROR", error));
  };
  return u("div", {
    className: "flex flex-col h-screen",
    children: [u("div", {
      className: twMerge("flex justify-center py-4"),
      children: u(Logo, {}, void 0, false, {
        fileName: _jsxFileName$1H,
        lineNumber: 122,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1H,
      lineNumber: 121,
      columnNumber: 7
    }, this), u("div", {
      className: twMerge("flex flex-col mt-auto mb-20 md:mb-9 container"),
      children: [u(Countdown, {}, void 0, false, {
        fileName: _jsxFileName$1H,
        lineNumber: 125,
        columnNumber: 9
      }, this), (eyebrow_text || title) && u("div", {
        className: twMerge("flex flex-col md:flex-row gap-4"),
        children: [(eyebrow_text || title) && u("div", {
          className: twMerge("w-full md:w-1/3 flex flex-col gap-3"),
          children: [eyebrow_text && u("p", {
            className: twMerge("font-secondary text-2xl italic"),
            children: eyebrow_text
          }, void 0, false, {
            fileName: _jsxFileName$1H,
            lineNumber: 131,
            columnNumber: 19
          }, this), title && u("h1", {
            className: twMerge("font-primary leading-none mb-6 md:mb-0 text-6xl md:text-7xl"),
            children: title
          }, void 0, false, {
            fileName: _jsxFileName$1H,
            lineNumber: 136,
            columnNumber: 19
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1H,
          lineNumber: 129,
          columnNumber: 15
        }, this), u("div", {
          className: "relative flex md:ml-auto",
          children: !subscribeSuccess ? u("form", {
            className: "relative w-full flex md:flex-wrap md:self-end md:justify-self-end",
            onSubmit: handleAddToList,
            children: [u("input", {
              "aria-label": "Email Address",
              placeholder: "Email Address",
              id: "email",
              name: "email",
              className: clsx$1(["peer appearance-none border bg-white px-2 py-2 w-full md:w-72 text-sm leading-field outline-none", "disabled:opacity-50 disabled:border-transparent disabled:hover:border-transparent", "hover:border-tints-40", "active:text-black", "focus:border-dashed", "placeholder-shown:text-tints-80"]),
              type: "email"
            }, void 0, false, {
              fileName: _jsxFileName$1H,
              lineNumber: 153,
              columnNumber: 19
            }, this), u("div", {
              className: clsx$1(["flex items-center !m-0 top-0", "peer-disabled:opacity-50"]),
              children: u(Button, {
                className: "min-w-min w-full px-11",
                type: "submit",
                mode: "primary",
                children: "Submit"
              }, void 0, false, {
                fileName: _jsxFileName$1H,
                lineNumber: 174,
                columnNumber: 21
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$1H,
              lineNumber: 168,
              columnNumber: 19
            }, this), emailError && u("div", {
              className: "text-black absolute top-full mt-1 text-sm",
              children: emailError
            }, void 0, false, {
              fileName: _jsxFileName$1H,
              lineNumber: 183,
              columnNumber: 21
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1H,
            lineNumber: 149,
            columnNumber: 17
          }, this) : u("div", {
            className: "relative flex self-end justify-self-end font-primary",
            children: u("div", {
              className: "text-3xl md:text-4xl",
              children: "Thank you for subscribing!"
            }, void 0, false, {
              fileName: _jsxFileName$1H,
              lineNumber: 190,
              columnNumber: 19
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1H,
            lineNumber: 189,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1H,
          lineNumber: 147,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1H,
        lineNumber: 127,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1H,
      lineNumber: 124,
      columnNumber: 7
    }, this), u("div", {
      className: twMerge("flex mb-6 md:mb-7 justify-center md:justify-end container text-xs"),
      children: ["Need help with an order? ", u("a", {
        href: "#",
        children: "AddContactEmailAddress"
      }, void 0, false, {
        fileName: _jsxFileName$1H,
        lineNumber: 205,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1H,
      lineNumber: 199,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1H,
    lineNumber: 120,
    columnNumber: 5
  }, this);
}
register(ComingSoon, "coming-soon");
var _jsxFileName$1G = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Filter.tsx";
function FilterIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    ...props,
    children: [u("path", {
      d: "M3 5H17",
      stroke: "#1B1B1B",
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1G,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("path", {
      d: "M3 10H17",
      stroke: "#1B1B1B",
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1G,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("path", {
      d: "M3 15H17",
      stroke: "#1B1B1B",
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1G,
      lineNumber: 13,
      columnNumber: 7
    }, this), u("circle", {
      cx: "4.5",
      cy: "5",
      r: "1.5",
      fill: "#EFEBE7",
      stroke: "#1B1B1B",
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1G,
      lineNumber: 14,
      columnNumber: 7
    }, this), u("circle", {
      cx: "10.5",
      cy: "10",
      r: "1.5",
      fill: "#EFEBE7",
      stroke: "#1B1B1B",
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1G,
      lineNumber: 22,
      columnNumber: 7
    }, this), u("circle", {
      cx: "15.5",
      cy: "15",
      r: "1.5",
      fill: "#EFEBE7",
      stroke: "#1B1B1B",
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$1G,
      lineNumber: 30,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1G,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1F = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ProductCard.tsx";
function ProductCard({
  id,
  product,
  maxWidth = false,
  colTitle,
  colHandle
}) {
  var _a, _b;
  const productData = JSON.parse(product);
  const {
    price,
    url,
    discounted_price,
    featured_image_tag,
    hover_image_tag,
    title
  } = productData;
  const textBadge = (_a = productData.tags.split(",").find((tag) => tag.startsWith("badge"))) == null ? void 0 : _a.split("::")[1];
  const imageBadge = (_b = productData.tags.split(",").find((tag) => tag.startsWith("image_badge"))) == null ? void 0 : _b.split("::")[1];
  const [categoryId, setCategoryId] = t$2(h(null), "categoryId");
  y(() => {
    const intervalId = setInterval(() => {
      var _a2, _b2, _c;
      if (window.POWERREVIEWS && ((_a2 = window.POWERREVIEWS) == null ? void 0 : _a2.display) && ((_c = (_b2 = window.POWERREVIEWS) == null ? void 0 : _b2.display) == null ? void 0 : _c.render)) {
        setCategoryId(`${id}`);
        clearInterval(intervalId);
      }
    }, 500);
  }, [id]);
  y(() => {
    if (categoryId) {
      setTimeout(() => {
        window.POWERREVIEWS.display.render({
          api_key: window.pwrCredentials.api_key,
          locale: window.pwrCredentials.locale,
          merchant_group_id: window.pwrCredentials.merchant_group_id,
          merchant_id: window.pwrCredentials.merchant_id,
          page_id: productData.id,
          components: {
            CategorySnippet: categoryId
          }
        });
        const categorySnippets = document.querySelectorAll(`.pr-category-snippet__total`);
        if (categorySnippets) {
          categorySnippets.forEach((categorySnippet) => {
            const hasNoReviews = categorySnippet.innerHTML.includes("No");
            categorySnippet.innerHTML = categorySnippet.innerHTML.replace(" Reviews", "");
            if (!hasNoReviews) {
              categorySnippet.closest(".pwr-category-snippets").querySelector("[data-pr-component]").style.display = "block";
            }
          });
        }
      }, 1e3);
    }
  }, [categoryId]);
  const handleImageClick = () => {
    sendDatalayer({
      event: "select_item",
      ecommerce: {
        currencyCode: "USD",
        items: productData || ""
      }
    });
  };
  const handleCardClick = () => {
    var _a2;
    sendDatalayer({
      event: "product_click",
      ecommerce: {
        currencyCode: "USD",
        items: [{
          item_name: (productData == null ? void 0 : productData.title) || "",
          item_id: (productData == null ? void 0 : productData.id) || "",
          currency: productData.currency || "",
          price: ((_a2 = productData == null ? void 0 : productData.price) == null ? void 0 : _a2.replace("$", "")) || "",
          item_brand: (productData == null ? void 0 : productData.vendor) || "",
          item_category: (productData == null ? void 0 : productData.type) || "",
          item_list_id: colHandle || "",
          item_list_name: colTitle || "",
          item_variant: productData == null ? void 0 : productData.variants[0].title,
          quantity: 1,
          index: 1
        }]
      }
    });
  };
  return u("div", {
    className: clsx$1("group relative flex flex-col", !maxWidth && "max-w-[179px] md:max-w-[304px]", maxWidth && "max-w-full"),
    onClick: handleCardClick,
    children: [discounted_price && u("div", {
      className: "absolute z-10 font-primary top-2 left-3 text-raspberry flex gap-1",
      children: [textBadge && u("div", {
        className: "text-black",
        children: textBadge
      }, void 0, false, {
        fileName: _jsxFileName$1F,
        lineNumber: 144,
        columnNumber: 25
      }, this), useProductPercentageOff(productData.variants[0], false)]
    }, void 0, true, {
      fileName: _jsxFileName$1F,
      lineNumber: 143,
      columnNumber: 9
    }, this), !discounted_price && textBadge && u("div", {
      className: "absolute font-primary top-2 left-3",
      children: textBadge
    }, void 0, false, {
      fileName: _jsxFileName$1F,
      lineNumber: 149,
      columnNumber: 9
    }, this), imageBadge && // TODO Add image badge when available
    u("div", {
      className: "absolute top-2 right-3"
    }, void 0, false, {
      fileName: _jsxFileName$1F,
      lineNumber: 153,
      columnNumber: 9
    }, this), u("a", {
      href: url,
      onClick: handleImageClick,
      className: "relative block group after:pb-[100%] after:block",
      children: [featured_image_tag && u("div", {
        className: "absolute inset-0",
        children: u("div", {
          className: cn("opacity-100 transition-opacity duration-300", hover_image_tag && "group-hover:opacity-0"),
          children: parse$1(featured_image_tag)
        }, void 0, false, {
          fileName: _jsxFileName$1F,
          lineNumber: 163,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1F,
        lineNumber: 162,
        columnNumber: 11
      }, this), hover_image_tag && u("div", {
        className: "absolute inset-0",
        children: u("div", {
          className: "opacity-0 group-hover:opacity-100 transition-opacity duration-300",
          children: parse$1(hover_image_tag)
        }, void 0, false, {
          fileName: _jsxFileName$1F,
          lineNumber: 175,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1F,
        lineNumber: 174,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1F,
      lineNumber: 156,
      columnNumber: 7
    }, this), u("div", {
      className: "bg-white w-full pt-4",
      children: [u("a", {
        href: url,
        children: [u("h3", {
          className: "font-primary text-base md:text-2xl mb-2",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$1F,
          lineNumber: 184,
          columnNumber: 11
        }, this), discounted_price && u("div", {
          className: "flex gap-x-1 text-[15px] mb-1",
          children: [u("div", {
            className: "font-primary line-through text-tints-40",
            children: discounted_price
          }, void 0, false, {
            fileName: _jsxFileName$1F,
            lineNumber: 187,
            columnNumber: 15
          }, this), u("div", {
            className: "font-primary text-raspberry",
            children: price
          }, void 0, false, {
            fileName: _jsxFileName$1F,
            lineNumber: 190,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1F,
          lineNumber: 186,
          columnNumber: 13
        }, this), !discounted_price && u("div", {
          className: "text-[15px] mb-1",
          children: u("div", {
            children: price
          }, void 0, false, {
            fileName: _jsxFileName$1F,
            lineNumber: 195,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1F,
          lineNumber: 194,
          columnNumber: 13
        }, this), u("div", {
          className: clsx$1("pwr-category-snippets", id && "min-h-6"),
          children: u("div", {
            id
          }, void 0, false, {
            fileName: _jsxFileName$1F,
            lineNumber: 200,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1F,
          lineNumber: 199,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1F,
        lineNumber: 182,
        columnNumber: 9
      }, this), u("div", {
        className: "absolute bottom-0 w-full bg-white pt-2 opacity-0 group-hover:opacity-100 transition-opacity",
        children: u(AddToCartButton, {
          productData
        }, void 0, false, {
          fileName: _jsxFileName$1F,
          lineNumber: 205,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1F,
        lineNumber: 204,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1F,
      lineNumber: 181,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1F,
    lineNumber: 134,
    columnNumber: 5
  }, this);
}
register(ProductCard, "product-card");
var _jsxFileName$1E = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/filter/FilterTrigger.tsx";
function FilterTrigger({
  children,
  ...rest
}) {
  const {
    toggleFilter
  } = useGlobal();
  return u("button", {
    ...rest,
    onClick: toggleFilter,
    children
  }, void 0, false, {
    fileName: _jsxFileName$1E,
    lineNumber: 9,
    columnNumber: 5
  }, this);
}
register(FilterTrigger, "filter-trigger", [], {
  shadow: true
});
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  };
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node2) => refs.forEach((ref) => setRef(ref, node2));
}
function useComposedRefs(...refs) {
  return q$1(composeRefs(...refs), refs);
}
function createContext2(rootComponentName, defaultContext) {
  const Context = G$1(defaultContext);
  const Provider = (props) => {
    const { children, ...context } = props;
    const value = T$1(() => context, Object.values(context));
    return /* @__PURE__ */ u(Context.Provider, { value, children });
  };
  Provider.displayName = rootComponentName + "Provider";
  function useContext2(consumerName) {
    const context = x$1(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  return [Provider, useContext2];
}
function createContextScope$2(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = G$1(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider = (props) => {
      var _a;
      const { scope, children, ...context } = props;
      const Context = ((_a = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _a[index]) || BaseContext;
      const value = T$1(() => context, Object.values(context));
      return /* @__PURE__ */ u(Context.Provider, { value, children });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, scope) {
      var _a;
      const Context = ((_a = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _a[index]) || BaseContext;
      const context = x$1(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [Provider, useContext2];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return G$1(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return T$1(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes$2(createScope, ...createContextScopeDeps)];
}
function composeContextScopes$2(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return T$1(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
var useLayoutEffect2 = Boolean(globalThis == null ? void 0 : globalThis.document) ? _ : () => {
};
var useReactId = React$1["useId".toString()] || (() => void 0);
var count$1 = 0;
function useId(deterministicId) {
  const [id, setId] = h(useReactId());
  useLayoutEffect2(() => {
    if (!deterministicId) setId((reactId) => reactId ?? String(count$1++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}
function useCallbackRef$1(callback) {
  const callbackRef = A$1(callback);
  y(() => {
    callbackRef.current = callback;
  });
  return T$1(() => (...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, []);
}
function useControllableState({
  prop,
  defaultProp,
  onChange = () => {
  }
}) {
  const [uncontrolledProp, setUncontrolledProp] = useUncontrolledState({ defaultProp, onChange });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  const handleChange = useCallbackRef$1(onChange);
  const setValue = q$1(
    (nextValue) => {
      if (isControlled) {
        const setter = nextValue;
        const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
        if (value2 !== prop) handleChange(value2);
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, handleChange]
  );
  return [value, setValue];
}
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const uncontrolledState = h(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = A$1(value);
  const handleChange = useCallbackRef$1(onChange);
  y(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}
var Slot = w((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = I.toArray(children);
  const slottable = childrenArray.find(isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (I.count(newElement) > 1) return I.only(null);
        return fn(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */ u(SlotClone, { ...slotProps, ref: forwardedRef, children: fn(newElement) ? sn(newElement, void 0, newChildren) : null });
  }
  return /* @__PURE__ */ u(SlotClone, { ...slotProps, ref: forwardedRef, children });
});
Slot.displayName = "Slot";
var SlotClone = w((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (fn(children)) {
    const childrenRef = getElementRef$1(children);
    return sn(children, {
      ...mergeProps(slotProps, children.props),
      // @ts-ignore
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    });
  }
  return I.count(children) > 1 ? I.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var Slottable = ({ children }) => {
  return /* @__PURE__ */ u(b$2, { children });
};
function isSlottable(child) {
  return fn(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef$1(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node2) => {
  const Node2 = w((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot : node2;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ u(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node2.displayName = `Primitive.${node2}`;
  return { ...primitive, [node2]: Node2 };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) pn(() => target.dispatchEvent(event));
}
function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const onEscapeKeyDown = useCallbackRef$1(onEscapeKeyDownProp);
  y(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown, { capture: true });
  }, [onEscapeKeyDown, ownerDocument]);
}
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = G$1({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
var DismissableLayer = w(
  (props, forwardedRef) => {
    const {
      disableOutsidePointerEvents = false,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss,
      ...layerProps
    } = props;
    const context = x$1(DismissableLayerContext);
    const [node2, setNode] = h(null);
    const ownerDocument = (node2 == null ? void 0 : node2.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document);
    const [, force] = h({});
    const composedRefs = useComposedRefs(forwardedRef, (node22) => setNode(node22));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node2 ? layers.indexOf(node2) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event) => {
      const target = event.target;
      const isPointerDownOnBranch = [...context.branches].some((branch) => branch.contains(target));
      if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
      onPointerDownOutside == null ? void 0 : onPointerDownOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented) onDismiss == null ? void 0 : onDismiss();
    }, ownerDocument);
    const focusOutside = useFocusOutside((event) => {
      const target = event.target;
      const isFocusInBranch = [...context.branches].some((branch) => branch.contains(target));
      if (isFocusInBranch) return;
      onFocusOutside == null ? void 0 : onFocusOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented) onDismiss == null ? void 0 : onDismiss();
    }, ownerDocument);
    useEscapeKeydown((event) => {
      const isHighestLayer = index === context.layers.size - 1;
      if (!isHighestLayer) return;
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(event);
      if (!event.defaultPrevented && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    }, ownerDocument);
    y(() => {
      if (!node2) return;
      if (disableOutsidePointerEvents) {
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
          ownerDocument.body.style.pointerEvents = "none";
        }
        context.layersWithOutsidePointerEventsDisabled.add(node2);
      }
      context.layers.add(node2);
      dispatchUpdate();
      return () => {
        if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) {
          ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        }
      };
    }, [node2, ownerDocument, disableOutsidePointerEvents, context]);
    y(() => {
      return () => {
        if (!node2) return;
        context.layers.delete(node2);
        context.layersWithOutsidePointerEventsDisabled.delete(node2);
        dispatchUpdate();
      };
    }, [node2, context]);
    y(() => {
      const handleUpdate = () => force({});
      document.addEventListener(CONTEXT_UPDATE, handleUpdate);
      return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ u(
      Primitive.div,
      {
        ...layerProps,
        ref: composedRefs,
        style: {
          pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
          ...props.style
        },
        onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: composeEventHandlers(
          props.onPointerDownCapture,
          pointerDownOutside.onPointerDownCapture
        )
      }
    );
  }
);
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = w((props, forwardedRef) => {
  const context = x$1(DismissableLayerContext);
  const ref = A$1(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  y(() => {
    const node2 = ref.current;
    if (node2) {
      context.branches.add(node2);
      return () => {
        context.branches.delete(node2);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */ u(Primitive.div, { ...props, ref: composedRefs });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const handlePointerDownOutside = useCallbackRef$1(onPointerDownOutside);
  const isPointerInsideReactTreeRef = A$1(false);
  const handleClickRef = A$1(() => {
  });
  y(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            handlePointerDownOutside,
            eventDetail,
            { discrete: true }
          );
        };
        const eventDetail = { originalEvent: event };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, { once: true });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const handleFocusOutside = useCallbackRef$1(onFocusOutside);
  const isFocusInsideReactTreeRef = A$1(false);
  y(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler) target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS$1 = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = w((props, forwardedRef) => {
  const {
    loop: loop2 = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container, setContainer] = h(null);
  const onMountAutoFocus = useCallbackRef$1(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef$1(onUnmountAutoFocusProp);
  const lastFocusedElementRef = A$1(null);
  const composedRefs = useComposedRefs(forwardedRef, (node2) => setContainer(node2));
  const focusScope = A$1({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  y(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container) return;
        const target = event.target;
        if (container.contains(target)) {
          lastFocusedElementRef.current = target;
        } else {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container) return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null) return;
        if (!container.contains(relatedTarget)) {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleMutations2 = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body) return;
        for (const mutation of mutations) {
          if (mutation.removedNodes.length > 0) focus(container);
        }
      };
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container) mutationObserver.observe(container, { childList: true, subtree: true });
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  y(() => {
    if (container) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS$1);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst$1(removeLinks(getTabbableCandidates(container)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            focus(container);
          }
        }
      }
      return () => {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS$1);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus(previouslyFocusedElement ?? document.body, { select: true });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = q$1(
    (event) => {
      if (!loop2 && !trapped) return;
      if (focusScope.paused) return;
      const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
      const focusedElement = document.activeElement;
      if (isTabKey && focusedElement) {
        const container2 = event.currentTarget;
        const [first, last] = getTabbableEdges(container2);
        const hasTabbableElementsInside = first && last;
        if (!hasTabbableElementsInside) {
          if (focusedElement === container2) event.preventDefault();
        } else {
          if (!event.shiftKey && focusedElement === last) {
            event.preventDefault();
            if (loop2) focus(first, { select: true });
          } else if (event.shiftKey && focusedElement === first) {
            event.preventDefault();
            if (loop2) focus(last, { select: true });
          }
        }
      }
    },
    [loop2, trapped, focusScope.paused]
  );
  return /* @__PURE__ */ u(Primitive.div, { tabIndex: -1, ...scopeProps, ref: composedRefs, onKeyDown: handleKeyDown });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst$1(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    focus(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container);
  const first = findVisible(candidates, container);
  const last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node2) => {
      const isHiddenInput = node2.tagName === "INPUT" && node2.type === "hidden";
      if (node2.disabled || node2.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node2.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  for (const element of elements) {
    if (!isHidden(element, { upTo: container })) return element;
  }
}
function isHidden(node2, { upTo }) {
  if (getComputedStyle(node2).visibility === "hidden") return true;
  while (node2) {
    if (upTo !== void 0 && node2 === upTo) return false;
    if (getComputedStyle(node2).display === "none") return true;
    node2 = node2.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({ preventScroll: true });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select)
      element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope == null ? void 0 : activeFocusScope.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _a;
      stack = arrayRemove(stack, focusScope);
      (_a = stack[0]) == null ? void 0 : _a.resume();
    }
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array];
  const index = updatedArray.indexOf(item);
  if (index !== -1) {
    updatedArray.splice(index, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter((item) => item.tagName !== "A");
}
var PORTAL_NAME$1 = "Portal";
var Portal$1 = w((props, forwardedRef) => {
  var _a;
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = h(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container = containerProp || mounted && ((_a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a.body);
  return container ? xn.createPortal(/* @__PURE__ */ u(Primitive.div, { ...portalProps, ref: forwardedRef }), container) : null;
});
Portal$1.displayName = PORTAL_NAME$1;
function useStateMachine(initialState, machine) {
  return p((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var Presence = (props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : I.only(children);
  const ref = useComposedRefs(presence.ref, getElementRef(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? sn(child, { ref }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
  const [node2, setNode] = h();
  const stylesRef = A$1({});
  const prevPresentRef = A$1(present);
  const prevAnimationNameRef = A$1("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  y(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  useLayoutEffect2(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        send("MOUNT");
      } else if (currentAnimationName === "none" || (styles == null ? void 0 : styles.display) === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    if (node2) {
      let timeoutId;
      const ownerWindow = node2.ownerDocument.defaultView ?? window;
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node2 && isCurrentAnimation) {
          send("ANIMATION_END");
          if (!prevPresentRef.current) {
            const currentFillMode = node2.style.animationFillMode;
            node2.style.animationFillMode = "forwards";
            timeoutId = ownerWindow.setTimeout(() => {
              if (node2.style.animationFillMode === "forwards") {
                node2.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node2) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node2.addEventListener("animationstart", handleAnimationStart);
      node2.addEventListener("animationcancel", handleAnimationEnd);
      node2.addEventListener("animationend", handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node2.removeEventListener("animationstart", handleAnimationStart);
        node2.removeEventListener("animationcancel", handleAnimationEnd);
        node2.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node2, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: q$1((node22) => {
      if (node22) stylesRef.current = getComputedStyle(node22);
      setNode(node22);
    }, [])
  };
}
function getAnimationName(styles) {
  return (styles == null ? void 0 : styles.animationName) || "none";
}
function getElementRef(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var count = 0;
function useFocusGuards() {
  y(() => {
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? createFocusGuard());
    document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? createFocusGuard());
    count++;
    return () => {
      if (count === 1) {
        document.querySelectorAll("[data-radix-focus-guard]").forEach((node2) => node2.remove());
      }
      count--;
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.outline = "none";
  element.style.opacity = "0";
  element.style.position = "fixed";
  element.style.pointerEvents = "none";
  return element;
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s2, e2) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
    t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
    if (ar || !(i2 in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i2);
      ar[i2] = from[i2];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e2 = new Error(message);
  return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
};
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef(initialValue, callback) {
  var ref = h(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? _ : y;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}
function ItoI(a2) {
  return a2;
}
function innerCreateMedium(defaults2, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults2;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x2) {
          return x2 !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x2) {
          return cb(x2);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x2) {
          pendingQueue.push(x2);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}
var SideCar$1 = function(_a) {
  var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return _$1(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}
var effectCar = createSidecarMedium();
var nothing = function() {
  return;
};
var RemoveScroll = w(function(props, parentRef) {
  var ref = A$1(null);
  var _a = h({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return _$1(
    b$2,
    null,
    enabled && _$1(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode }),
    forwardProps ? sn(I.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : _$1(Container, __assign({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function() {
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles, isDynamic) {
    y(function() {
      sheet.add(styles);
      return function() {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet2 = function(_a) {
    var styles = _a.styles, dynamic = _a.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet2;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function(x2) {
  return parseInt(x2 || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a, allowRelative, gapMode, important) {
  var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
  y(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
  useLockAttribute();
  var gap = T$1(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return _$1(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? { passive: false } : false;
var alwaysContainsScroll = function(node2) {
  return node2.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node2, overflow) {
  if (!(node2 instanceof Element)) {
    return false;
  }
  var styles = window.getComputedStyle(node2);
  return (
    // not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node2) && styles[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node2) {
  return elementCanBeScrolled(node2, "overflowY");
};
var elementCouldBeHScrolled = function(node2) {
  return elementCanBeScrolled(node2, "overflowX");
};
var locationCouldBeScrolled = function(axis, node2) {
  var ownerDocument = node2.ownerDocument;
  var current = node2;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
      if (scrollHeight > clientHeight) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node2) {
  return axis === "v" ? elementCouldBeVScrolled(node2) : elementCouldBeHScrolled(node2);
};
var getScrollVariables = function(axis, node2) {
  return axis === "v" ? getVScrollVariables(node2) : getHScrollVariables(node2);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    if (target instanceof ShadowRoot) {
      target = target.host;
    } else {
      target = target.parentNode;
    }
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (Math.abs(availableScroll) < 1 || !noOverscroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (Math.abs(availableScrollTop) < 1 || !noOverscroll)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x2, y2) {
  return x2[0] === y2[0] && x2[1] === y2[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = A$1([]);
  var touchStartRef = A$1([0, 0]);
  var activeAxis = A$1();
  var id = h(idCounter++)[0];
  var Style2 = h(styleSingleton)[0];
  var lastProps = A$1(props);
  y(function() {
    lastProps.current = props;
  }, [props]);
  y(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = q$1(function(event, parent) {
    if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = q$1(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e2) {
      return e2.name === event.type && (e2.target === event.target || event.target === e2.shadowParent) && deltaCompare(e2.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node2) {
        return node2.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = q$1(function(name, delta, target, should) {
    var event = { name, delta, target, should, shadowParent: getOutermostShadowParent(target) };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e2) {
        return e2 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = q$1(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = q$1(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = q$1(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  y(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return _$1(
    b$2,
    null,
    inert ? _$1(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? _$1(RemoveScrollBar, { gapMode: props.gapMode }) : null
  );
}
function getOutermostShadowParent(node2) {
  var shadowParent = null;
  while (node2 !== null) {
    if (node2 instanceof ShadowRoot) {
      shadowParent = node2.host;
      node2 = node2.host;
    }
    node2 = node2.parentNode;
  }
  return shadowParent;
}
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = w(function(props, ref) {
  return _$1(RemoveScroll, __assign({}, props, { ref, sideCar: SideCar }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node2) {
  return node2 && (node2.host || unwrapHost(node2.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x2) {
    return Boolean(x2);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node2) {
      if (elementsToKeep.has(node2)) {
        deep(node2);
      } else {
        try {
          var attr = node2.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node2) || 0) + 1;
          var markerValue = (markerCounter.get(node2) || 0) + 1;
          counterMap.set(node2, counterValue);
          markerCounter.set(node2, markerValue);
          hiddenNodes.push(node2);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node2, true);
          }
          if (markerValue === 1) {
            node2.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node2.setAttribute(controlAttribute, "true");
          }
        } catch (e2) {
          console.error("aria-hidden: cannot operate on ", node2, e2);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node2) {
      var counterValue = counterMap.get(node2) - 1;
      var markerValue = markerCounter.get(node2) - 1;
      counterMap.set(node2, counterValue);
      markerCounter.set(node2, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node2)) {
          node2.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node2);
      }
      if (!markerValue) {
        node2.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var DIALOG_NAME = "Dialog";
var [createDialogContext, createDialogScope] = createContextScope$2(DIALOG_NAME);
var [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
var Dialog$1 = (props) => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const triggerRef = A$1(null);
  const contentRef = A$1(null);
  const [open = false, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ u(
    DialogProvider,
    {
      scope: __scopeDialog,
      triggerRef,
      contentRef,
      contentId: useId(),
      titleId: useId(),
      descriptionId: useId(),
      open,
      onOpenChange: setOpen,
      onOpenToggle: q$1(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
      modal,
      children
    }
  );
};
Dialog$1.displayName = DIALOG_NAME;
var TRIGGER_NAME$1 = "DialogTrigger";
var DialogTrigger = w(
  (props, forwardedRef) => {
    const { __scopeDialog, ...triggerProps } = props;
    const context = useDialogContext(TRIGGER_NAME$1, __scopeDialog);
    const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ u(
      Primitive.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
      }
    );
  }
);
DialogTrigger.displayName = TRIGGER_NAME$1;
var PORTAL_NAME = "DialogPortal";
var [PortalProvider, usePortalContext] = createDialogContext(PORTAL_NAME, {
  forceMount: void 0
});
var DialogPortal$1 = (props) => {
  const { __scopeDialog, forceMount, children, container } = props;
  const context = useDialogContext(PORTAL_NAME, __scopeDialog);
  return /* @__PURE__ */ u(PortalProvider, { scope: __scopeDialog, forceMount, children: I.map(children, (child) => /* @__PURE__ */ u(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ u(Portal$1, { asChild: true, container, children: child }) })) });
};
DialogPortal$1.displayName = PORTAL_NAME;
var OVERLAY_NAME = "DialogOverlay";
var DialogOverlay$1 = w(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(OVERLAY_NAME, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ u(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ u(DialogOverlayImpl, { ...overlayProps, ref: forwardedRef }) }) : null;
  }
);
DialogOverlay$1.displayName = OVERLAY_NAME;
var DialogOverlayImpl = w(
  (props, forwardedRef) => {
    const { __scopeDialog, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, __scopeDialog);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u(ReactRemoveScroll, { as: Slot, allowPinchZoom: true, shards: [context.contentRef], children: /* @__PURE__ */ u(
        Primitive.div,
        {
          "data-state": getState(context.open),
          ...overlayProps,
          ref: forwardedRef,
          style: { pointerEvents: "auto", ...overlayProps.style }
        }
      ) })
    );
  }
);
var CONTENT_NAME$1 = "DialogContent";
var DialogContent$1 = w(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(CONTENT_NAME$1, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME$1, props.__scopeDialog);
    return /* @__PURE__ */ u(Presence, { present: forceMount || context.open, children: context.modal ? /* @__PURE__ */ u(DialogContentModal, { ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ u(DialogContentNonModal, { ...contentProps, ref: forwardedRef }) });
  }
);
DialogContent$1.displayName = CONTENT_NAME$1;
var DialogContentModal = w(
  (props, forwardedRef) => {
    const context = useDialogContext(CONTENT_NAME$1, props.__scopeDialog);
    const contentRef = A$1(null);
    const composedRefs = useComposedRefs(forwardedRef, context.contentRef, contentRef);
    y(() => {
      const content = contentRef.current;
      if (content) return hideOthers(content);
    }, []);
    return /* @__PURE__ */ u(
      DialogContentImpl,
      {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, (event) => {
          var _a;
          event.preventDefault();
          (_a = context.triggerRef.current) == null ? void 0 : _a.focus();
        }),
        onPointerDownOutside: composeEventHandlers(props.onPointerDownOutside, (event) => {
          const originalEvent = event.detail.originalEvent;
          const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
          const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
          if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: composeEventHandlers(
          props.onFocusOutside,
          (event) => event.preventDefault()
        )
      }
    );
  }
);
var DialogContentNonModal = w(
  (props, forwardedRef) => {
    const context = useDialogContext(CONTENT_NAME$1, props.__scopeDialog);
    const hasInteractedOutsideRef = A$1(false);
    const hasPointerDownOutsideRef = A$1(false);
    return /* @__PURE__ */ u(
      DialogContentImpl,
      {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event) => {
          var _a, _b;
          (_a = props.onCloseAutoFocus) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented) {
            if (!hasInteractedOutsideRef.current) (_b = context.triggerRef.current) == null ? void 0 : _b.focus();
            event.preventDefault();
          }
          hasInteractedOutsideRef.current = false;
          hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event) => {
          var _a, _b;
          (_a = props.onInteractOutside) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented) {
            hasInteractedOutsideRef.current = true;
            if (event.detail.originalEvent.type === "pointerdown") {
              hasPointerDownOutsideRef.current = true;
            }
          }
          const target = event.target;
          const targetIsTrigger = (_b = context.triggerRef.current) == null ? void 0 : _b.contains(target);
          if (targetIsTrigger) event.preventDefault();
          if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) {
            event.preventDefault();
          }
        }
      }
    );
  }
);
var DialogContentImpl = w(
  (props, forwardedRef) => {
    const { __scopeDialog, trapFocus, onOpenAutoFocus, onCloseAutoFocus, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME$1, __scopeDialog);
    const contentRef = A$1(null);
    const composedRefs = useComposedRefs(forwardedRef, contentRef);
    useFocusGuards();
    return /* @__PURE__ */ u(b$2, { children: [
      /* @__PURE__ */ u(
        FocusScope,
        {
          asChild: true,
          loop: true,
          trapped: trapFocus,
          onMountAutoFocus: onOpenAutoFocus,
          onUnmountAutoFocus: onCloseAutoFocus,
          children: /* @__PURE__ */ u(
            DismissableLayer,
            {
              role: "dialog",
              id: context.contentId,
              "aria-describedby": context.descriptionId,
              "aria-labelledby": context.titleId,
              "data-state": getState(context.open),
              ...contentProps,
              ref: composedRefs,
              onDismiss: () => context.onOpenChange(false)
            }
          )
        }
      ),
      /* @__PURE__ */ u(b$2, { children: [
        /* @__PURE__ */ u(TitleWarning, { titleId: context.titleId }),
        /* @__PURE__ */ u(DescriptionWarning, { contentRef, descriptionId: context.descriptionId })
      ] })
    ] });
  }
);
var TITLE_NAME = "DialogTitle";
var DialogTitle$1 = w(
  (props, forwardedRef) => {
    const { __scopeDialog, ...titleProps } = props;
    const context = useDialogContext(TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ u(Primitive.h2, { id: context.titleId, ...titleProps, ref: forwardedRef });
  }
);
DialogTitle$1.displayName = TITLE_NAME;
var DESCRIPTION_NAME = "DialogDescription";
var DialogDescription$1 = w(
  (props, forwardedRef) => {
    const { __scopeDialog, ...descriptionProps } = props;
    const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ u(Primitive.p, { id: context.descriptionId, ...descriptionProps, ref: forwardedRef });
  }
);
DialogDescription$1.displayName = DESCRIPTION_NAME;
var CLOSE_NAME = "DialogClose";
var DialogClose = w(
  (props, forwardedRef) => {
    const { __scopeDialog, ...closeProps } = props;
    const context = useDialogContext(CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ u(
      Primitive.button,
      {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: composeEventHandlers(props.onClick, () => context.onOpenChange(false))
      }
    );
  }
);
DialogClose.displayName = CLOSE_NAME;
function getState(open) {
  return open ? "open" : "closed";
}
var TITLE_WARNING_NAME = "DialogTitleWarning";
var [WarningProvider, useWarningContext] = createContext2(TITLE_WARNING_NAME, {
  contentName: CONTENT_NAME$1,
  titleName: TITLE_NAME,
  docsSlug: "dialog"
});
var TitleWarning = ({ titleId }) => {
  const titleWarningContext = useWarningContext(TITLE_WARNING_NAME);
  const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
  y(() => {
    if (titleId) {
      const hasTitle = document.getElementById(titleId);
      if (!hasTitle) console.error(MESSAGE);
    }
  }, [MESSAGE, titleId]);
  return null;
};
var DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var DescriptionWarning = ({ contentRef, descriptionId }) => {
  const descriptionWarningContext = useWarningContext(DESCRIPTION_WARNING_NAME);
  const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
  y(() => {
    var _a;
    const describedById = (_a = contentRef.current) == null ? void 0 : _a.getAttribute("aria-describedby");
    if (descriptionId && describedById) {
      const hasDescription = document.getElementById(descriptionId);
      if (!hasDescription) console.warn(MESSAGE);
    }
  }, [MESSAGE, contentRef, descriptionId]);
  return null;
};
var Root$1 = Dialog$1;
var Portal = DialogPortal$1;
var Overlay = DialogOverlay$1;
var Content$1 = DialogContent$1;
var Title = DialogTitle$1;
var Description = DialogDescription$1;
var Close = DialogClose;
function r(e2) {
  var t2, f2, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2) n2 += e2;
  else if ("object" == typeof e2) if (Array.isArray(e2)) for (t2 = 0; t2 < e2.length; t2++) e2[t2] && (f2 = r(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
  else for (t2 in e2) e2[t2] && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function clsx() {
  for (var e2, t2, f2 = 0, n2 = ""; f2 < arguments.length; ) (e2 = arguments[f2++]) && (t2 = r(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
const falsyToString = (value) => typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const cx = clsx;
const cva = (base, config) => {
  return (props) => {
    var ref;
    if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    const { variants, defaultVariants } = config;
    const getVariantClassNames = Object.keys(variants).map((variant) => {
      const variantProp = props === null || props === void 0 ? void 0 : props[variant];
      const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
      if (variantProp === null) return null;
      const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
      return variants[variant][variantKey];
    });
    const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
      let [key, value] = param;
      if (value === void 0) {
        return acc;
      }
      acc[key] = value;
      return acc;
    }, {});
    const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1) => {
      let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param1;
      return Object.entries(compoundVariantOptions).every((param) => {
        let [key, value] = param;
        return Array.isArray(value) ? value.includes({
          ...defaultVariants,
          ...propsWithoutUndefined
        }[key]) : {
          ...defaultVariants,
          ...propsWithoutUndefined
        }[key] === value;
      }) ? [
        ...acc,
        cvClass,
        cvClassName
      ] : acc;
    }, []);
    return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  };
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const mergeClasses = (...classes2) => classes2.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Icon = w(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => {
    return _$1(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: mergeClasses("lucide", className),
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => _$1(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    );
  }
);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const createLucideIcon = (iconName, iconNode) => {
  const Component = w(
    ({ className, ...props }, ref) => _$1(Icon, {
      ref,
      iconNode,
      className: mergeClasses(`lucide-${toKebabCase(iconName)}`, className),
      ...props
    })
  );
  Component.displayName = `${iconName}`;
  return Component;
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X = createLucideIcon("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
var _jsxFileName$1D = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ui/sheet.tsx";
const Sheet = Root$1;
const SheetPortal = Portal;
const SheetOverlay = w(({
  className,
  ...props
}, ref) => u(Overlay, {
  className: cn("fixed inset-0 z-[9999999999] bg-black/50  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
  ...props,
  ref
}, void 0, false, {
  fileName: _jsxFileName$1D,
  lineNumber: 21,
  columnNumber: 3
}, void 0));
SheetOverlay.displayName = Overlay.displayName;
const sheetVariants = cva("fixed z-[99999999999] gap-4 bg-white shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 dark:bg-white", {
  variants: {
    side: {
      top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
      bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
      left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-full w-full lg:w-[393px]",
      right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-full w-full lg:w-[393px]"
    }
  },
  defaultVariants: {
    side: "right"
  }
});
const SheetContent = w(({
  side = "right",
  className,
  children,
  ...props
}, ref) => u(SheetPortal, {
  children: [u(SheetOverlay, {}, void 0, false, {
    fileName: _jsxFileName$1D,
    lineNumber: 60,
    columnNumber: 5
  }, void 0), u(Content$1, {
    ref,
    className: cn(sheetVariants({
      side
    }), className),
    ...props,
    children: [children, u(Close, {
      className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-neutral-100 dark:ring-offset-neutral-950 dark:focus:ring-neutral-300 dark:data-[state=open]:bg-white",
      children: [u(X, {
        className: "h-4 w-4"
      }, void 0, false, {
        fileName: _jsxFileName$1D,
        lineNumber: 68,
        columnNumber: 9
      }, void 0), u("span", {
        className: "sr-only",
        children: "Close"
      }, void 0, false, {
        fileName: _jsxFileName$1D,
        lineNumber: 69,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$1D,
      lineNumber: 67,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$1D,
    lineNumber: 61,
    columnNumber: 5
  }, void 0)]
}, void 0, true, {
  fileName: _jsxFileName$1D,
  lineNumber: 59,
  columnNumber: 3
}, void 0));
SheetContent.displayName = Content$1.displayName;
const SheetTitle = w(({
  className,
  ...props
}, ref) => u(Title, {
  ref,
  className: cn("text-lg font-semibold text-neutral-950 dark:text-neutral-50", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$1D,
  lineNumber: 108,
  columnNumber: 3
}, void 0));
SheetTitle.displayName = Title.displayName;
const SheetDescription = w(({
  className,
  ...props
}, ref) => u(Description, {
  ref,
  className: cn("text-sm text-neutral-500 dark:text-neutral-400", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$1D,
  lineNumber: 123,
  columnNumber: 3
}, void 0));
SheetDescription.displayName = Description.displayName;
var _jsxFileName$1C = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Checkbox.tsx";
function CheckboxIcon({
  checked
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 20 20",
    fill: "none",
    children: checked ? u(b$2, {
      children: [u("path", {
        fill: "#1B1B1B",
        d: "M.5.5h19v19H.5V.5Z"
      }, void 0, false, {
        fileName: _jsxFileName$1C,
        lineNumber: 12,
        columnNumber: 11
      }, this), u("path", {
        stroke: "#1B1B1B",
        d: "M.5.5h19v19H.5V.5Z"
      }, void 0, false, {
        fileName: _jsxFileName$1C,
        lineNumber: 13,
        columnNumber: 11
      }, this), u("path", {
        stroke: "#fff",
        strokeWidth: "1.25",
        d: "M4 10.3077 7.78947 14 16 6"
      }, void 0, false, {
        fileName: _jsxFileName$1C,
        lineNumber: 14,
        columnNumber: 11
      }, this)]
    }, void 0, true) : u(b$2, {
      children: [u("path", {
        fill: "#fff",
        d: "M.5.5h19v19H.5V.5Z"
      }, void 0, false, {
        fileName: _jsxFileName$1C,
        lineNumber: 22,
        columnNumber: 11
      }, this), u("path", {
        stroke: "#1B1B1B",
        d: "M.5.5h19v19H.5V.5Z"
      }, void 0, false, {
        fileName: _jsxFileName$1C,
        lineNumber: 23,
        columnNumber: 11
      }, this)]
    }, void 0, true)
  }, void 0, false, {
    fileName: _jsxFileName$1C,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1B = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/forms/CheckboxField.tsx";
const CheckboxField = (props) => {
  const {
    description,
    error,
    id,
    name,
    label,
    checked,
    disabled,
    onChangeCallback,
    ...rest
  } = props;
  const [isChecked, setIsChecked] = t$2(h(checked), "isChecked");
  const handleOnChange = (event) => {
    setIsChecked(!isChecked);
    if (onChangeCallback) {
      onChangeCallback(event);
    }
  };
  y(() => {
    setIsChecked(checked);
  }, [checked]);
  return u("div", {
    className: "cursor-pointer",
    children: [u("input", {
      "aria-label": label,
      name,
      className: clsx$1(["hidden", "disabled:opacity-50", error ? "border-raspberry" : "border-black"]),
      ...rest,
      type: "checkbox",
      checked: isChecked,
      id
    }, void 0, false, {
      fileName: _jsxFileName$1B,
      lineNumber: 42,
      columnNumber: 7
    }, void 0), u("div", {
      children: [label && u("label", {
        className: clsx$1(["flex cursor-pointer items-center gap-2 text-sm leading-none text-black", disabled && "opacity-50 pointer-events-none"]),
        htmlFor: id,
        onClick: handleOnChange,
        children: [u("div", {
          className: "self-start",
          children: u(CheckboxIcon, {
            checked: isChecked ? true : false
          }, void 0, false, {
            fileName: _jsxFileName$1B,
            lineNumber: 68,
            columnNumber: 15
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$1B,
          lineNumber: 67,
          columnNumber: 13
        }, void 0), u("div", {
          children: label
        }, void 0, false, {
          fileName: _jsxFileName$1B,
          lineNumber: 70,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$1B,
        lineNumber: 59,
        columnNumber: 11
      }, void 0), description && u("div", {
        className: "text-sm text-tints-40",
        children: description
      }, void 0, false, {
        fileName: _jsxFileName$1B,
        lineNumber: 75,
        columnNumber: 11
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$1B,
      lineNumber: 56,
      columnNumber: 7
    }, void 0), error && u("div", {
      className: "text-xs text-raspberry",
      children: error
    }, void 0, false, {
      fileName: _jsxFileName$1B,
      lineNumber: 80,
      columnNumber: 17
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$1B,
    lineNumber: 41,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$1A = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Accordion/Content/AccordionLinkContent.tsx";
function AccordionLinkContent({
  title,
  url
}) {
  return u(b$2, {
    children: u("li", {
      className: "font-primary leading-5",
      children: url && u("a", {
        href: url || "#",
        className: "",
        children: title || ""
      }, void 0, false, {
        fileName: _jsxFileName$1A,
        lineNumber: 12,
        columnNumber: 17
      }, this)
    }, title, false, {
      fileName: _jsxFileName$1A,
      lineNumber: 11,
      columnNumber: 7
    }, this)
  }, void 0);
}
register(AccordionLinkContent, "accordion-link-content");
var _jsxFileName$1z = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Accordion/Content/AccordionRichTextContent.tsx";
function AccordionRichTextContent({
  children
}) {
  return u(b$2, {
    children: u("div", {
      className: "rte accordion-content__rte mt-3 mr-5",
      children
    }, void 0, false, {
      fileName: _jsxFileName$1z,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0);
}
register(AccordionRichTextContent, "accordion-rich-text-content");
var _jsxFileName$1y = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/ChevronDown.tsx";
function ChevronDownIcon({
  width = "20",
  height = "20",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 20 20",
    fill: "none",
    ...props,
    "aria-label": "Toggle Select Menu",
    children: u("path", {
      stroke: "currentColor",
      d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
    }, void 0, false, {
      fileName: _jsxFileName$1y,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1y,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1x = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/ChevronUp.tsx";
function ChevronUpIcon({
  width = "20",
  height = "20",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 20 20",
    fill: "none",
    ...props,
    "aria-label": "Toggle Select Menu",
    children: u("path", {
      stroke: "currentColor",
      d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
    }, void 0, false, {
      fileName: _jsxFileName$1x,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1x,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1w = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Plus.tsx";
function PlusIcon({
  width = "16",
  height = "16",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    "aria-label": "Increase",
    children: u("path", {
      stroke: "#1B1B1B",
      "stroke-width": "1.25",
      d: "M3.19995 8H12.8M8 12.8V3.20005"
    }, void 0, false, {
      fileName: _jsxFileName$1w,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1w,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1v = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Minus.tsx";
function MinusIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    ...props,
    "aria-label": "Decrease",
    children: u("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M3.19995 8H12.8"
    }, void 0, false, {
      fileName: _jsxFileName$1v,
      lineNumber: 11,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1v,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1u = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Accordion/AccordionComponent.tsx";
function AccordionComponent({
  title,
  detailsClass = "py-4 text-button-lg pr-2",
  summaryClass = "font-primary",
  itemsClass = "gap-y-2 w-[196px]",
  linkItems,
  children,
  arrowsMode = false
}) {
  return u(b$2, {
    children: [u("slot", {}, void 0, false, {
      fileName: _jsxFileName$1u,
      lineNumber: 53,
      columnNumber: 7
    }, this), u("details", {
      className: cn(`group`, detailsClass),
      children: [u("summary", {
        className: cn(`cursor-pointer flex list-none items-center justify-between`, summaryClass),
        children: [u("p", {
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$1u,
          lineNumber: 62,
          columnNumber: 11
        }, this), arrowsMode ? u(b$2, {
          children: [u(ChevronDownIcon, {
            className: "w-4 group-open:hidden"
          }, void 0, false, {
            fileName: _jsxFileName$1u,
            lineNumber: 66,
            columnNumber: 15
          }, this), u(ChevronUpIcon, {
            className: "hidden w-4 group-open:inline-block"
          }, void 0, false, {
            fileName: _jsxFileName$1u,
            lineNumber: 67,
            columnNumber: 15
          }, this)]
        }, void 0, true) : u(b$2, {
          children: [u(PlusIcon, {
            className: "w-4 group-open:hidden"
          }, void 0, false, {
            fileName: _jsxFileName$1u,
            lineNumber: 71,
            columnNumber: 15
          }, this), u(MinusIcon, {
            className: "hidden w-4 group-open:inline-block"
          }, void 0, false, {
            fileName: _jsxFileName$1u,
            lineNumber: 72,
            columnNumber: 15
          }, this)]
        }, void 0, true)]
      }, void 0, true, {
        fileName: _jsxFileName$1u,
        lineNumber: 56,
        columnNumber: 9
      }, this), linkItems && u("ul", {
        className: cn(`flex flex-col mt-2`, itemsClass),
        children: linkItems && (linkItems == null ? void 0 : linkItems.map((linkItem, idx) => u(AccordionLinkContent, {
          title: linkItem == null ? void 0 : linkItem.title,
          url: linkItem == null ? void 0 : linkItem.url
        }, linkItem == null ? void 0 : linkItem.title, false, {
          fileName: _jsxFileName$1u,
          lineNumber: 81,
          columnNumber: 17
        }, this)))
      }, void 0, false, {
        fileName: _jsxFileName$1u,
        lineNumber: 78,
        columnNumber: 11
      }, this), u(AccordionRichTextContent, {
        children
      }, void 0, false, {
        fileName: _jsxFileName$1u,
        lineNumber: 90,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1u,
      lineNumber: 55,
      columnNumber: 7
    }, this)]
  }, void 0);
}
register(AccordionComponent, "accordion-component", ["children", "title"], {
  shadow: false
});
var _jsxFileName$1t = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Slider/PriceRangeSlider.tsx";
function RangeSlider({
  value,
  max,
  onChangeCallback
}) {
  const [rangeValue, setRangeValue] = t$2(h(value), "rangeValue");
  const handleToInputChange = (e2) => {
    const newValue = parseInt(e2.target.value, 10);
    setRangeValue(newValue);
    if (onChangeCallback) {
      onChangeCallback(newValue);
    }
  };
  y(() => {
    setRangeValue(value);
  }, [value]);
  return u("div", {
    className: "flex flex-col w-full mx-auto",
    children: u("div", {
      className: "relative",
      children: [u("input", {
        "range-thumb": true,
        type: "range",
        value: rangeValue,
        min: "0",
        max,
        onChange: handleToInputChange,
        className: "absolute w-full h-1 appearance-none bg-black z-10",
        style: {
          appearance: "none",
          WebkitAppearance: "none"
        }
      }, void 0, false, {
        fileName: _jsxFileName$1t,
        lineNumber: 32,
        columnNumber: 9
      }, this), u("div", {
        className: "absolute w-full h-1 transform -translate-y-1/2 bg-transparent rounded"
      }, void 0, false, {
        fileName: _jsxFileName$1t,
        lineNumber: 45,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1t,
      lineNumber: 31,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1t,
    lineNumber: 30,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1s = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/filter/FilterDrawer.tsx";
function FilterDrawer({
  filterData,
  onProductsUpdated,
  onNextPageUrlUpdated,
  currency_symbol
}) {
  const url = new URL(window.location.href);
  const {
    filterIsOpen,
    toggleFilter
  } = useGlobal();
  const [priceRange, setPriceRange] = t$2(h([0, 100]), "priceRange");
  const [debounceTimer, setDebounceTimer] = t$2(h(null), "debounceTimer");
  const [activeFilters, setActiveFilters] = t$2(h(() => {
    const initialFilters = /* @__PURE__ */ new Map();
    filterData.forEach((filter) => {
      filter.values.forEach((value) => {
        initialFilters.set(value.param_name + value.value, isActiveFilter(value));
      });
    });
    return initialFilters;
  }), "activeFilters");
  function handleListChange(event, paramName, filterValue) {
    const target = event.currentTarget;
    const isChecked = target.hasAttribute("checked");
    const params = new URLSearchParams(`${paramName}=${filterValue}` || "");
    if (!isChecked) {
      handleAddFilter(params);
    } else {
      handleDeleteFilter(params);
    }
    setActiveFilters((prevFilters) => {
      const newFilters = new Map(prevFilters);
      newFilters.set(paramName + filterValue, !isChecked);
      return newFilters;
    });
    updateURL();
    fetchFilteredData(url.href);
  }
  function handleAddFilter(params) {
    params.forEach((value, key) => {
      if (!url.searchParams.getAll(key).includes(value)) {
        url.searchParams.append(key, value);
      }
    });
  }
  function handleDeleteFilter(params) {
    params.forEach((value, key) => {
      const existingValues = url.searchParams.getAll(key);
      const newValues = existingValues.filter((existingValue) => existingValue !== value);
      if (!newValues.length) {
        url.searchParams.delete(key);
        return;
      }
      url.searchParams.delete(key);
      newValues.forEach((v2) => url.searchParams.append(key, v2));
    });
  }
  function clearAllFilters() {
    const allParams = Array.from(url.searchParams.keys());
    allParams.forEach((param) => url.searchParams.delete(param));
    setActiveFilters((prevFilters) => {
      const newFilters = new Map(prevFilters);
      newFilters.forEach((_2, key) => newFilters.set(key, false));
      return newFilters;
    });
    setPriceRange([0, 100]);
    updateURL();
    fetchFilteredData(url.href);
  }
  async function fetchFilteredData(url2) {
    try {
      const request = await fetch(url2);
      const response = await request.text();
      const resultsMarkup = new DOMParser().parseFromString(response, "text/html");
      const data = resultsMarkup.querySelector("[collection-data]");
      const dataJson = JSON.parse(data.innerHTML);
      const dataProducts = dataJson.products;
      onProductsUpdated(dataProducts);
      onNextPageUrlUpdated(dataJson.nextUrl);
    } catch (err) {
      console.log("Error: ", err);
    }
  }
  function isActiveFilter(value) {
    return filterData.some((filter) => filter.active_values.some((activeValue) => activeValue.url_to_add === value.url_to_add));
  }
  function updateURL() {
    window.history.replaceState(null, "", url.toString());
  }
  function handlePriceRangeChange(values, min_param, max_param) {
    setPriceRange(values);
    const [min, max] = values;
    url.searchParams.set(max_param, min);
    url.searchParams.set(min_param, max);
    updateURL();
    debounce(() => fetchFilteredData(url.href))();
  }
  function debounce(func) {
    return (...args) => {
      clearTimeout(debounceTimer);
      const timer = setTimeout(() => func(...args), 300);
      setDebounceTimer(timer);
    };
  }
  y(() => {
    const minPrice = url.searchParams.get("filter.v.price.gte");
    const maxPrice = url.searchParams.get("filter.v.price.lte");
    if (minPrice && maxPrice) {
      setPriceRange([parseInt(minPrice), parseInt(maxPrice)]);
    }
  }, []);
  return u(Sheet, {
    onOpenChange: toggleFilter,
    open: filterIsOpen,
    children: u(SheetContent, {
      className: "overflow-y-auto",
      side: window.innerWidth < 628 ? "left" : "right",
      children: u("div", {
        className: "p-4 font-primary",
        children: [u("div", {
          className: "flex gap-3 border-b border-tints-20 pb-3",
          children: [u("h2", {
            className: "flex items-start text-2xl font-primary font-normal",
            children: "Filters"
          }, void 0, false, {
            fileName: _jsxFileName$1s,
            lineNumber: 189,
            columnNumber: 13
          }, this), url.searchParams.size > 0 && u("button", {
            onClick: clearAllFilters,
            className: "text-black text-sm border-b border-black hover:text-tints-60 hover:border-tints-60 font-primary",
            children: "Clear All"
          }, void 0, false, {
            fileName: _jsxFileName$1s,
            lineNumber: 193,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1s,
          lineNumber: 187,
          columnNumber: 11
        }, this), filterData.map((filter, index) => filter.type === "list" ? u(AccordionComponent, {
          title: filter.label,
          detailsClass: "py-3.5 border-b border-tint-20",
          summaryClass: "font-primary text-base",
          arrowsMode: true,
          children: filter.values.map((filter_value, itemIndex) => u("div", {
            className: "mt-4",
            children: u(CheckboxField, {
              label: parse$1(filter_value.label),
              id: parse$1(filter_value.label),
              checked: activeFilters.get(filter_value.param_name + filter_value.value),
              id: filter_value.value + itemIndex,
              onChangeCallback: (event) => handleListChange(event, filter_value.param_name, filter_value.value)
            }, void 0, false, {
              fileName: _jsxFileName$1s,
              lineNumber: 213,
              columnNumber: 21
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1s,
            lineNumber: 212,
            columnNumber: 19
          }, this))
        }, index, false, {
          fileName: _jsxFileName$1s,
          lineNumber: 204,
          columnNumber: 15
        }, this) : filter.type === "price_range" ? u(AccordionComponent, {
          title: filter.label,
          detailsClass: "py-3.5",
          summaryClass: "font-primary text-base",
          arrowsMode: true,
          children: u("div", {
            className: "mt-6 px-6",
            children: [u(RangeSlider, {
              value: priceRange[1],
              max: 500,
              onChangeCallback: (newValue) => {
                handlePriceRangeChange([0, newValue], filter.max_value.param_name, filter.min_value.param_name);
              }
            }, void 0, false, {
              fileName: _jsxFileName$1s,
              lineNumber: 240,
              columnNumber: 19
            }, this), u("div", {
              className: "flex justify-between mt-4 text-sm",
              children: priceRange.map((price) => u("span", {
                children: [currency_symbol, " ", price]
              }, void 0, true, {
                fileName: _jsxFileName$1s,
                lineNumber: 253,
                columnNumber: 23
              }, this))
            }, void 0, false, {
              fileName: _jsxFileName$1s,
              lineNumber: 251,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1s,
            lineNumber: 239,
            columnNumber: 17
          }, this)
        }, index, false, {
          fileName: _jsxFileName$1s,
          lineNumber: 232,
          columnNumber: 15
        }, this) : null)]
      }, void 0, true, {
        fileName: _jsxFileName$1s,
        lineNumber: 186,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1s,
      lineNumber: 182,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1s,
    lineNumber: 181,
    columnNumber: 5
  }, this);
}
register(FilterDrawer, "filter-drawer");
var _jsxFileName$1r = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/CollectionGrid.tsx";
function CollectionGrid({
  title,
  titleTag = "h2",
  pagination_object = "",
  show_title,
  show_filter,
  editorial_block,
  filters,
  currency_symbol,
  handle
}) {
  const Component = titleTag;
  let paginationData = JSON.parse(pagination_object);
  const [allProducts, setAllProducts] = t$2(h(paginationData.products), "allProducts");
  const [nextPageUrl, setNextPageUrl] = t$2(h(paginationData.nextUrl), "nextPageUrl");
  async function loadMoreProducts() {
    if (!nextPageUrl) return;
    const requestURL = `${nextPageUrl}&view=api`;
    const request = await fetch(requestURL);
    const paginatedDataJson = await request.json();
    const paginationProducts = paginatedDataJson.products;
    const newUrl = paginatedDataJson.nextUrl;
    setNextPageUrl(newUrl);
    setAllProducts((prevProducts) => [...prevProducts, ...paginationProducts]);
  }
  y(() => {
    var _a, _b;
    if (((_b = (_a = window.POWERREVIEWS) == null ? void 0 : _a.display) == null ? void 0 : _b.render) instanceof Function) {
      const allProductsWithReviews = allProducts.map((product, index) => {
        return {
          ...product,
          components: {
            CategorySnippet: `cardId-${index}`
          }
        };
      });
      setAllProducts((prev) => allProductsWithReviews);
      const reviewsId = allProducts.map((product, index) => {
        return {
          api_key: window.pwrCredentials.api_key,
          locale: window.pwrCredentials.locale,
          merchant_group_id: window.pwrCredentials.merchant_group_id,
          merchant_id: window.pwrCredentials.merchant_id,
          page_id: product.id,
          components: {
            CategorySnippet: `cardId-${index}`
          }
        };
      });
      const intervalId = setInterval(() => {
        var _a2, _b2, _c;
        if ((window == null ? void 0 : window.POWERREVIEWS) && ((_a2 = window == null ? void 0 : window.POWERREVIEWS) == null ? void 0 : _a2.display) && ((_c = (_b2 = window == null ? void 0 : window.POWERREVIEWS) == null ? void 0 : _b2.display) == null ? void 0 : _c.render)) {
          window.POWERREVIEWS.display.render(reviewsId);
          clearInterval(intervalId);
        }
      }, 500);
    }
  }, [nextPageUrl]);
  return u("div", {
    className: "container",
    children: [u("div", {
      className: "flex justify-between items-center",
      children: [title && show_title == "true" && u(Component, {
        className: clsx$1("font-primary text-5xl"),
        children: title
      }, void 0, false, {
        fileName: _jsxFileName$1r,
        lineNumber: 100,
        columnNumber: 11
      }, this), show_filter == "true" && u("div", {
        className: "ml-auto",
        children: [u(FilterTrigger, {
          "aria-label": "Filter Open Button",
          children: u("div", {
            className: "flex items-center gap-2 cursor-pointer",
            children: [u("span", {
              className: "font-primary text-xl",
              children: "Filter & Sort"
            }, void 0, false, {
              fileName: _jsxFileName$1r,
              lineNumber: 109,
              columnNumber: 17
            }, this), u(FilterIcon, {}, void 0, false, {
              fileName: _jsxFileName$1r,
              lineNumber: 110,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1r,
            lineNumber: 107,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1r,
          lineNumber: 106,
          columnNumber: 13
        }, this), u(FilterDrawer, {
          filterData: JSON.parse(filters ? filters : ""),
          onProductsUpdated: setAllProducts,
          onNextPageUrlUpdated: setNextPageUrl,
          currency_symbol
        }, void 0, false, {
          fileName: _jsxFileName$1r,
          lineNumber: 114,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1r,
        lineNumber: 105,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1r,
      lineNumber: 98,
      columnNumber: 7
    }, this), u("div", {
      className: "grid grid-cols-2 gap-x-5 gap-y-10 md:grid-cols-4 py-9",
      children: [editorial_block && u("div", {
        className: "col-span-2 pr-14",
        children: u("span", {
          className: "font-primary text-2xl md:text-4xl",
          children: editorial_block
        }, void 0, false, {
          fileName: _jsxFileName$1r,
          lineNumber: 127,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1r,
        lineNumber: 126,
        columnNumber: 11
      }, this), allProducts.map((product, index) => u(ProductCard, {
        product: JSON.stringify(product),
        colTitle: title,
        colHandle: handle,
        id: `cardId-${index}`
      }, void 0, false, {
        fileName: _jsxFileName$1r,
        lineNumber: 134,
        columnNumber: 11
      }, this))]
    }, void 0, true, {
      fileName: _jsxFileName$1r,
      lineNumber: 124,
      columnNumber: 7
    }, this), nextPageUrl && u(Button, {
      onClick: loadMoreProducts,
      className: "min-w-[195px] mx-auto mt-6",
      mode: "primary",
      children: "Load more"
    }, void 0, false, {
      fileName: _jsxFileName$1r,
      lineNumber: 144,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1r,
    lineNumber: 97,
    columnNumber: 5
  }, this);
}
register(CollectionGrid, "collection-grid", ["title", "pagination_object", "show_title", "show_filter", "editorial_block", "filters", "currency_symbol"]);
var _jsxFileName$1q = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ContentFullWidth.tsx";
function ContentFullWidth({
  title,
  titleTag = "h2",
  desktopImage,
  mobileImage
}) {
  const Component = titleTag;
  return u("div", {
    children: [u("div", {
      className: cn("relative aspect-[393/197] md:aspect-[1440/720] bg-haze w-full md:flex justify-between items-end"),
      children: [desktopImage && u("div", {
        className: "hidden md:block",
        children: parse$1(JSON.parse(desktopImage))
      }, void 0, false, {
        fileName: _jsxFileName$1q,
        lineNumber: 46,
        columnNumber: 11
      }, this), mobileImage && u("div", {
        className: "md:hidden",
        children: parse$1(JSON.parse(mobileImage))
      }, void 0, false, {
        fileName: _jsxFileName$1q,
        lineNumber: 51,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1q,
      lineNumber: 40,
      columnNumber: 7
    }, this), title && u("div", {
      className: cn("container"),
      children: u("div", {
        className: "relative pt-8 md:pt-12 md:w-1/2",
        children: u(Component, {
          className: "font-primary text-2xl md:text-5xl text-black",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$1q,
          lineNumber: 57,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1q,
        lineNumber: 56,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1q,
      lineNumber: 55,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1q,
    lineNumber: 39,
    columnNumber: 5
  }, this);
}
register(ContentFullWidth, "content-full-width", ["title", "desktopImage", "mobileImage"]);
var _jsxFileName$1p = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/CountdownSection.tsx";
function CountdownSection({
  eyebrow,
  title,
  body,
  link_url,
  link_label,
  countdown_date
}) {
  const [timeLeft, setTimeLeft] = t$2(h({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00"
  }), "timeLeft");
  y(() => {
    if (!countdown_date) return;
    const targetTime = new Date(countdown_date).getTime();
    if (isNaN(targetTime)) {
      console.error("Invalid countdown_date:", countdown_date);
      return;
    }
    const updateCountdown = () => {
      const now2 = Date.now();
      const difference = targetTime - now2;
      if (difference <= 0) {
        setTimeLeft({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00"
        });
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        days: Math.floor(difference / (1e3 * 60 * 60 * 24)).toString().padStart(2, "0"),
        hours: Math.floor(difference / (1e3 * 60 * 60) % 24).toString().padStart(2, "0"),
        minutes: Math.floor(difference / (1e3 * 60) % 60).toString().padStart(2, "0"),
        seconds: Math.floor(difference / 1e3 % 60).toString().padStart(2, "0")
      });
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1e3);
    return () => clearInterval(interval);
  }, [countdown_date]);
  return u("div", {
    className: "bg-green-400",
    children: u("div", {
      className: "container text-blue font-primary py-10 flex flex-col justify-between gap-10 lg:flex-row lg:py-28 !max-w-6xl mx-auto",
      children: [u("div", {
        className: "flex text-center lg:justify-start lg:text-left flex-col gap-4",
        children: [eyebrow && u("p", {
          className: "font-normal uppercase",
          children: eyebrow
        }, void 0, false, {
          fileName: _jsxFileName$1p,
          lineNumber: 74,
          columnNumber: 23
        }, this), title && u("p", {
          className: "text-[40px] font-medium",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$1p,
          lineNumber: 75,
          columnNumber: 21
        }, this), body && u("div", {
          className: "font-normal",
          dangerouslySetInnerHTML: {
            __html: body
          }
        }, void 0, false, {
          fileName: _jsxFileName$1p,
          lineNumber: 77,
          columnNumber: 13
        }, this), link_label && link_url && u("a", {
          className: "button selft-center lg:self-start bg-white",
          href: link_url,
          children: link_label
        }, void 0, false, {
          fileName: _jsxFileName$1p,
          lineNumber: 83,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1p,
        lineNumber: 73,
        columnNumber: 9
      }, this), u("div", {
        className: "flex justify-center lg:gap-10 text-green-300 gap-8 text-3xl font-bold",
        children: [u("div", {
          className: "countdown-box",
          children: [u("span", {
            className: "text-eyebrow-lg lg:text-7xl",
            children: timeLeft.days
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 95,
            columnNumber: 13
          }, this), u("p", {
            className: "text-button-sm font-normal text-center uppercase",
            children: "Days"
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 96,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1p,
          lineNumber: 94,
          columnNumber: 11
        }, this), u("div", {
          className: "countdown-box",
          children: [u("span", {
            className: "text-eyebrow-lg lg:text-7xl",
            children: timeLeft.hours
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 101,
            columnNumber: 13
          }, this), u("p", {
            className: "text-button-sm font-normal text-center uppercase",
            children: "Hrs"
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 104,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1p,
          lineNumber: 100,
          columnNumber: 11
        }, this), u("div", {
          className: "countdown-box",
          children: [u("span", {
            className: "text-eyebrow-lg lg:text-7xl",
            children: timeLeft.minutes
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 109,
            columnNumber: 13
          }, this), u("p", {
            className: "text-button-sm font-normal text-center uppercase",
            children: "Min"
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 112,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1p,
          lineNumber: 108,
          columnNumber: 11
        }, this), u("div", {
          className: "countdown-box",
          children: [u("span", {
            className: "text-eyebrow-lg lg:text-7xl",
            children: timeLeft.seconds
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 117,
            columnNumber: 13
          }, this), u("p", {
            className: "text-button-sm font-normal text-center uppercase",
            children: "Sec"
          }, void 0, false, {
            fileName: _jsxFileName$1p,
            lineNumber: 120,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1p,
          lineNumber: 116,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1p,
        lineNumber: 93,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1p,
      lineNumber: 72,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1p,
    lineNumber: 71,
    columnNumber: 5
  }, this);
}
register(CountdownSection, "countdown-section");
var _jsxFileName$1o = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Overlay/OverlayComponent.tsx";
const OverlayComponent = ({
  clickHandler,
  overlayClass
}) => {
  return u("div", {
    class: `fixed inset-0 z-40 ${overlayClass}`,
    onClick: clickHandler
  }, void 0, false, {
    fileName: _jsxFileName$1o,
    lineNumber: 10,
    columnNumber: 5
  }, void 0);
};
register(OverlayComponent, "overlay-component");
var _jsxFileName$1n = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStyleImageCard.tsx";
function CustomizeStyleImageCard({
  topImage,
  heelImage,
  hideHeelImage,
  styleClass,
  imageClass,
  bottomImageClass
}) {
  return u("div", {
    className: clsx$1("relative max-w-full flex justify-center mx-0", styleClass ? styleClass : ""),
    children: [(topImage == null ? void 0 : topImage.upperImageUrl) && u("img", {
      src: topImage == null ? void 0 : topImage.upperImageUrl,
      className: clsx$1("bg-gray-300", imageClass ? imageClass : "")
    }, void 0, false, {
      fileName: _jsxFileName$1n,
      lineNumber: 19,
      columnNumber: 9
    }, this), (heelImage == null ? void 0 : heelImage.heelImageUrl) && !hideHeelImage && u("img", {
      src: heelImage == null ? void 0 : heelImage.heelImageUrl,
      class: clsx$1("absolute top-0 left-0 w-full h-auto", bottomImageClass ? bottomImageClass : "", (topImage == null ? void 0 : topImage.height) !== (heelImage == null ? void 0 : heelImage.height) ? "hidden" : "")
    }, void 0, false, {
      fileName: _jsxFileName$1n,
      lineNumber: 25,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1n,
    lineNumber: 12,
    columnNumber: 5
  }, this);
}
function getDomain() {
  var _a, _b;
  if (typeof window !== "undefined" && ((_a = window.Shopify) == null ? void 0 : _a.shop)) {
    return window.Shopify.shop;
  }
  if (typeof window !== "undefined" && ((_b = window.location) == null ? void 0 : _b.hostname)) {
    return window.location.hostname;
  }
  return "pashionfootweardev.myshopify.com";
}
const domain = getDomain();
const token = "4fce6efe5bbcab6c952dfe323478ec6a";
const sizeOptions = ["5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "11"];
const heelTypes = [{
  selector: "Block Heel Kit 4",
  bottomSelector: "b4",
  height: 4,
  type: "Block"
}, {
  selector: "Block Heel Kit 3",
  bottomSelector: "b3",
  height: 3,
  type: "Block"
}, {
  selector: "Block Heel Kit 1.5",
  bottomSelector: "b15",
  height: 15,
  type: "Block"
}, {
  selector: "Flare Block Heel Kit 4",
  bottomSelector: "fb4",
  height: 4,
  type: "Flare Block"
}, {
  selector: "Flare Block Heel Kit 3",
  bottomSelector: "fb3",
  height: 3,
  type: "Flare Block"
}, {
  selector: "Flare Stiletto Heel Kit 4",
  bottomSelector: "fs4",
  height: 4,
  type: "Flare Stiletto"
}, {
  selector: "Flare Stiletto Heel Kit 3",
  bottomSelector: "fs3",
  height: 3,
  type: "Flare Stiletto"
}, {
  selector: "Stiletto Heel Kit 4",
  bottomSelector: "s4",
  height: 4,
  type: "Stiletto"
}, {
  selector: "Stiletto Heel Kit 3",
  bottomSelector: "s3",
  height: 3,
  type: "Stiletto"
}, {
  selector: "Cylinder Block Heel Kit 4",
  bottomSelector: "cb4",
  height: 4,
  type: "Cylinder Block"
}, {
  selector: "Cylinder Block Heel Kit 3",
  bottomSelector: "cb3",
  height: 3,
  type: "Cylinder Block"
}];
const steps = ["Size", "Upper Color", "Heel Style", "Heel Color"];
const GET_COLLECTION_FILTERS_LIGHT = `
query getCollectionFiltersLight($id: ID!, $filters: [ProductFilter!], $first: Int = 100) {
  collection(id: $id) {
    title
    products(first: $first, filters: $filters) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          handle
          availableForSale
          featuredImage {
            url
            altText
            width
            height
          }
          metafield_option_color: metafield(namespace: "cvm", key: "option_color") {
            value
          }
          variants(first: 50) {
            edges {
              node {
                id
                availableForSale
                price {
                  amount
                  currencyCode
                }
                title
                quantityAvailable
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
      filters {
          id
          label
          type
          values {
            id
            label
            count
            input
          }
        }
      }
    }
  }`;
const GET_COLLECTION_FILTERS = `
query getCollectionFilters($id: ID!, $filters: [ProductFilter!], $cursor: String) {
  collection(id: $id) {
    title
    products(first: 250, filters: $filters, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          handle
          availableForSale
          featuredImage {
            url
            altText
            width
            height
          }
          shopify_color_pattern: metafield(key: "color-pattern", namespace: "shopify") {
            id
            updatedAt
            value
            references(first: 5) {
              nodes {
                ... on Metaobject {
                  id
                  fields {
                    type
                    value
                  }
                  field(key: "image") {
                    reference {
                      ... on MediaImage {
                        id
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          metafield_option_color: metafield(namespace: "cvm", key: "option_color") {
            value
          }
          metafield_heel_image: metafield(namespace: "cvm", key: "customizer_heel") {
            key
            reference {
              ... on MediaImage {
                image {
                  url
                  altText
                  width
                  height
                }
              }
            }
          }
          metafield_upper_image_1_5: metafield(namespace: "cvm", key: "upper_image_1-5") {
            key
            reference {
                ... on MediaImage {
                  image {
                    url
                    altText
                    width
                    height
                  }
                }
              }
          }
          metafield_upper_image_3: metafield(namespace: "cvm", key: "upper_image_3") {
            key
            reference {
              ... on MediaImage {
                image {
                  url
                  altText
                  width
                  height
                }
              }
            }
          }
          metafield_upper_image_4: metafield(namespace: "cvm", key: "upper_image_4") {
            key
            reference {
              ... on MediaImage {
                image {
                  url
                  altText
                  width
                  height
                }
              }
            }
          }
          variants(first: 250) {
            edges {
              node {
                id
                availableForSale
                price {
                  amount
                  currencyCode
                }
                title
                quantityAvailable
                selectedOptions {
                  name
                  value
                }
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
      filters {
          id
          label
          type
          values {
            id
            label
            count
            input
          }
        }
      }
    }
  }`;
async function fetchFiltersLight({
  filters = [],
  collectionId,
  onComplete,
  maxProducts = 100
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const res = await fetch(`https://${domain}/api/2024-10/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": token
    },
    body: JSON.stringify({
      query: GET_COLLECTION_FILTERS_LIGHT,
      variables: {
        id: collectionId,
        filters: filters == null ? void 0 : filters.filter(Boolean),
        first: maxProducts
      }
    })
  });
  const response = await res.json();
  const {
    data,
    errors
  } = response;
  if (errors) {
    console.error("fetchFiltersLight - GraphQL ERRORS:", errors);
  }
  const completeData = {
    collection: {
      title: ((_a = data == null ? void 0 : data.collection) == null ? void 0 : _a.title) || "",
      products: {
        edges: ((_c = (_b = data == null ? void 0 : data.collection) == null ? void 0 : _b.products) == null ? void 0 : _c.edges) || [],
        filters: ((_e = (_d = data == null ? void 0 : data.collection) == null ? void 0 : _d.products) == null ? void 0 : _e.filters) || [],
        pageInfo: (_g = (_f = data == null ? void 0 : data.collection) == null ? void 0 : _f.products) == null ? void 0 : _g.pageInfo
      }
    }
  };
  onComplete(completeData);
  return ((_i = (_h = data == null ? void 0 : data.collection) == null ? void 0 : _h.products) == null ? void 0 : _i.filters) || [];
}
async function fetchFilters({
  filters = [],
  collectionId,
  onComplete
}) {
  var _a, _b, _c, _d, _e, _f;
  const allEdges = [];
  let hasNextPage = true;
  let cursor = null;
  let finalFilters = [];
  let lastPageInfo = null;
  while (hasNextPage) {
    const res = await fetch(`https://${domain}/api/2024-10/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token
      },
      body: JSON.stringify({
        query: GET_COLLECTION_FILTERS,
        variables: {
          id: collectionId,
          filters: filters == null ? void 0 : filters.filter(Boolean),
          cursor
        }
      })
    });
    const response = await res.json();
    const {
      data,
      errors
    } = response;
    if (errors) {
      console.error("fetchFilters - GraphQL ERRORS:", errors);
    }
    const pageEdges = ((_b = (_a = data == null ? void 0 : data.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) || [];
    allEdges.push(...pageEdges);
    finalFilters = ((_d = (_c = data == null ? void 0 : data.collection) == null ? void 0 : _c.products) == null ? void 0 : _d.filters) || finalFilters;
    lastPageInfo = (_f = (_e = data == null ? void 0 : data.collection) == null ? void 0 : _e.products) == null ? void 0 : _f.pageInfo;
    hasNextPage = lastPageInfo == null ? void 0 : lastPageInfo.hasNextPage;
    cursor = lastPageInfo == null ? void 0 : lastPageInfo.endCursor;
  }
  const completeData = {
    collection: {
      handle: "",
      title: "",
      products: {
        edges: allEdges,
        filters: finalFilters,
        pageInfo: lastPageInfo
      }
    }
  };
  onComplete(completeData);
  return finalFilters;
}
function getActiveStyleFilters(filters, baseProductStyle) {
  return filters.reduce((acc, item) => {
    var _a, _b;
    if (item.id === "filter.p.m.cvm.style_title") {
      const matches = (_b = (_a = item.values) == null ? void 0 : _a.filter((v2) => {
        var _a2;
        return (_a2 = v2.label) == null ? void 0 : _a2.toLowerCase().includes(baseProductStyle == null ? void 0 : baseProductStyle.toLowerCase());
      })) == null ? void 0 : _b.map((match) => {
        var _a2;
        return JSON.parse(((_a2 = match == null ? void 0 : match.input) == null ? void 0 : _a2.replace(/\\/g, "")) || "{}");
      });
      matches == null ? void 0 : matches.forEach((match) => acc.push(match));
    }
    return acc;
  }, []);
}
const findTopImages = (productData, color, selectedSize) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n2, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C;
  const topImages = {};
  for (const size of sizeOptions) {
    for (const {
      node: product
    } of productData) {
      if (!product.availableForSale) continue;
      const matchingVariant = product.variants.edges.find(({
        node: variant
      }) => {
        var _a2;
        return (_a2 = variant.selectedOptions) == null ? void 0 : _a2.some((opt) => opt.name.toLowerCase() === "size" && opt.value === selectedSize);
      }) || ((_a = product.variants.edges) == null ? void 0 : _a[0]);
      if (color && ((_b = product == null ? void 0 : product.metafield_option_color) == null ? void 0 : _b.value) !== color) continue;
      if ((_e = (_d = (_c = product.metafield_upper_image_1_5) == null ? void 0 : _c.reference) == null ? void 0 : _d.image) == null ? void 0 : _e.url) {
        topImages[15] = {
          upperImageUrl: (_h = (_g = (_f = product.metafield_upper_image_1_5) == null ? void 0 : _f.reference) == null ? void 0 : _g.image) == null ? void 0 : _h.url,
          height: 15,
          productId: product.id,
          featuredImage: product.featuredImage,
          variant: matchingVariant == null ? void 0 : matchingVariant.node,
          size: selectedSize || ((_k = (_j = (_i = matchingVariant == null ? void 0 : matchingVariant.node) == null ? void 0 : _i.selectedOptions) == null ? void 0 : _j.find((opt) => opt.name.toLowerCase() === "size")) == null ? void 0 : _k.value) || ""
        };
      }
      if ((_n2 = (_m = (_l = product.metafield_upper_image_3) == null ? void 0 : _l.reference) == null ? void 0 : _m.image) == null ? void 0 : _n2.url) {
        topImages[3] = {
          upperImageUrl: (_q = (_p = (_o = product.metafield_upper_image_3) == null ? void 0 : _o.reference) == null ? void 0 : _p.image) == null ? void 0 : _q.url,
          height: 3,
          productId: product.id,
          featuredImage: product.featuredImage,
          variant: matchingVariant == null ? void 0 : matchingVariant.node,
          size: selectedSize || ((_t = (_s = (_r = matchingVariant == null ? void 0 : matchingVariant.node) == null ? void 0 : _r.selectedOptions) == null ? void 0 : _s.find((opt) => opt.name.toLowerCase() === "size")) == null ? void 0 : _t.value) || ""
        };
      }
      if ((_w = (_v = (_u = product.metafield_upper_image_4) == null ? void 0 : _u.reference) == null ? void 0 : _v.image) == null ? void 0 : _w.url) {
        topImages[4] = {
          upperImageUrl: (_z = (_y = (_x = product.metafield_upper_image_4) == null ? void 0 : _x.reference) == null ? void 0 : _y.image) == null ? void 0 : _z.url,
          height: 4,
          productId: product.id,
          featuredImage: product.featuredImage,
          variant: matchingVariant == null ? void 0 : matchingVariant.node,
          size: selectedSize || ((_C = (_B = (_A = matchingVariant == null ? void 0 : matchingVariant.node) == null ? void 0 : _A.selectedOptions) == null ? void 0 : _B.find((opt) => opt.name.toLowerCase() === "size")) == null ? void 0 : _C.value) || ""
        };
      }
      if (Object.keys(topImages).length === 0) continue;
      return topImages;
    }
  }
  return null;
};
const findTopImage = (images, height) => {
  if (!height) return images[15] || images[3] || images[4] || null;
  if (images[height]) {
    return images[height];
  }
  return null;
};
const getTopColors = (rawData, selectedSize, sizeFilter) => {
  var _a, _b, _c;
  return new Set(((_c = (_b = (_a = rawData == null ? void 0 : rawData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.map((item) => {
    var _a2, _b2, _c2, _d, _e;
    const size = (selectedSize == null ? void 0 : selectedSize.label) || (sizeFilter == null ? void 0 : sizeFilter.label);
    const isAvailable = (_c2 = (_b2 = (_a2 = item == null ? void 0 : item.node) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.edges) == null ? void 0 : _c2.find((variant) => {
      var _a3, _b3, _c3;
      const sizeOption = ((_b3 = (_a3 = variant == null ? void 0 : variant.node) == null ? void 0 : _a3.selectedOptions) == null ? void 0 : _b3.find((option) => {
        var _a4;
        return ((_a4 = option == null ? void 0 : option.name) == null ? void 0 : _a4.toLowerCase()) === "size";
      })) || {};
      return ((_c3 = variant == null ? void 0 : variant.node) == null ? void 0 : _c3.availableForSale) && (sizeOption == null ? void 0 : sizeOption.value) === size;
    });
    return {
      isAvailable: isAvailable ? true : false,
      color: (_e = (_d = item == null ? void 0 : item.node) == null ? void 0 : _d.metafield_option_color) == null ? void 0 : _e.value
    };
  }).filter((item) => item !== null)) || []);
};
function getHeelTypeFilters(filters) {
  return filters.reduce((acc, item) => {
    var _a;
    if (item.id === "filter.p.m.cvm.option_heel_type" || item.id === "filter.p.m.cvm.option_heel_height") {
      const matches = (_a = item.values) == null ? void 0 : _a.map((match) => JSON.parse((match == null ? void 0 : match.input) || "{}"));
      matches == null ? void 0 : matches.forEach((match) => acc.push(match));
    }
    return acc;
  }, []);
}
function getActiveHeelFilters(filters, heel) {
  return filters.reduce((acc, item) => {
    var _a, _b, _c, _d, _e, _f;
    if (item.id === "filter.p.m.cvm.option_heel_type") {
      const heelTypeSelector = ((_a = heel == null ? void 0 : heel.bottomSelector) == null ? void 0 : _a.includes("fs")) ? "Flare Stiletto" : ((_b = heel == null ? void 0 : heel.bottomSelector) == null ? void 0 : _b.includes("fb")) ? "Flare Block" : ((_c = heel == null ? void 0 : heel.bottomSelector) == null ? void 0 : _c.includes("cb")) ? "Cylinder Block" : ((_d = heel == null ? void 0 : heel.bottomSelector) == null ? void 0 : _d.includes("s")) ? "Stiletto" : "Block";
      const match = (_e = item == null ? void 0 : item.values) == null ? void 0 : _e.find((f2) => (f2 == null ? void 0 : f2.label) === heelTypeSelector);
      match && acc.push(JSON.parse((match == null ? void 0 : match.input) || "{}"));
    }
    if (item.id === "filter.p.m.cvm.option_heel_height") {
      const heelHeightSelector = (heel == null ? void 0 : heel.height) == 15 ? "1.5" : (heel == null ? void 0 : heel.height) == 3 ? "3" : "4";
      const match = (_f = item == null ? void 0 : item.values) == null ? void 0 : _f.find((f2) => {
        var _a2, _b2;
        return (_b2 = (_a2 = f2 == null ? void 0 : f2.label) == null ? void 0 : _a2.toLowerCase()) == null ? void 0 : _b2.includes(heelHeightSelector == null ? void 0 : heelHeightSelector.toLowerCase());
      });
      match && acc.push(JSON.parse((match == null ? void 0 : match.input) || "{}"));
    }
    return acc;
  }, []);
}
const findBottomImages = (products, size, color) => {
  const formattedSize = getFormattedSize(size);
  const bottomImages = {};
  heelTypes.forEach((heel) => {
    var _a, _b, _c, _d, _e;
    const {
      selector,
      bottomSelector
    } = heel;
    if (!bottomSelector || !formattedSize) {
      return;
    }
    let matchingProduct;
    let variant;
    if (color) {
      matchingProduct = products.find((item) => {
        var _a2, _b2, _c2, _d2, _e2;
        const product = item.node;
        if (!product.availableForSale || !((_b2 = (_a2 = product.title) == null ? void 0 : _a2.toLowerCase()) == null ? void 0 : _b2.includes(selector == null ? void 0 : selector.toLowerCase()))) {
          return false;
        }
        if (!((_c2 = selector == null ? void 0 : selector.toLowerCase()) == null ? void 0 : _c2.includes("flare")) && ((_e2 = (_d2 = product.title) == null ? void 0 : _d2.toLowerCase()) == null ? void 0 : _e2.includes("flare"))) {
          return false;
        }
        const colorMatchingVariant = product.variants.edges.find((edge) => {
          var _a3;
          if (color && ((_a3 = product == null ? void 0 : product.metafield_option_color) == null ? void 0 : _a3.value) !== color) {
            return false;
          }
          return edge.node.title === formattedSize && edge.node.availableForSale;
        });
        if (colorMatchingVariant) {
          variant = colorMatchingVariant.node;
        }
        return Boolean(colorMatchingVariant);
      });
    }
    if (!matchingProduct) {
      matchingProduct = products.find((item) => {
        var _a2, _b2, _c2, _d2, _e2;
        const product = item.node;
        if (!product.availableForSale || !((_b2 = (_a2 = product.title) == null ? void 0 : _a2.toLowerCase()) == null ? void 0 : _b2.includes(selector == null ? void 0 : selector.toLowerCase()))) {
          return false;
        }
        if (!((_c2 = selector == null ? void 0 : selector.toLowerCase()) == null ? void 0 : _c2.includes("flare")) && ((_e2 = (_d2 = product.title) == null ? void 0 : _d2.toLowerCase()) == null ? void 0 : _e2.includes("flare"))) {
          return false;
        }
        const fallBackMatchingVariant = product.variants.edges.find((edge) => {
          return edge.node.title === formattedSize && edge.node.availableForSale;
        });
        if (fallBackMatchingVariant) {
          variant = fallBackMatchingVariant.node;
        }
        return Boolean(fallBackMatchingVariant);
      });
    }
    if (!matchingProduct && heel.type === "Stiletto") {
      const flareStiletto = heelTypes.find((h2) => h2.type === "Flare Stiletto" && h2.height === heel.height);
      if (flareStiletto) {
        matchingProduct = products.find((item) => {
          var _a2, _b2, _c2;
          const product = item.node;
          if (!product.availableForSale || !((_c2 = (_a2 = product.title) == null ? void 0 : _a2.toLowerCase()) == null ? void 0 : _c2.includes((_b2 = flareStiletto.selector) == null ? void 0 : _b2.toLowerCase()))) {
            return false;
          }
          const fallBackMatchingVariant = product.variants.edges.find((edge) => {
            return edge.node.title === formattedSize && edge.node.availableForSale;
          });
          if (fallBackMatchingVariant) {
            variant = fallBackMatchingVariant.node;
          }
          return Boolean(fallBackMatchingVariant);
        });
      }
    }
    if (matchingProduct) {
      const imageUrl = (_c = (_b = (_a = matchingProduct.node.metafield_heel_image) == null ? void 0 : _a.reference) == null ? void 0 : _b.image) == null ? void 0 : _c.url;
      bottomImages[bottomSelector] = {
        ...heel,
        heelImageUrl: imageUrl,
        featuredImage: matchingProduct.node.featuredImage,
        color: (_e = (_d = matchingProduct.node) == null ? void 0 : _d.metafield_option_color) == null ? void 0 : _e.value,
        variant
      };
    }
  });
  return bottomImages;
};
const findBottomImage = (productData, height, size, color) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const searchHeight = height === 15 ? "1.5" : height === 3 ? "3" : "4";
  const formattedSize = getFormattedSize(size);
  for (const {
    node: product
  } of productData) {
    if (!product.availableForSale || !((_b = (_a = product == null ? void 0 : product.title) == null ? void 0 : _a.toLowerCase()) == null ? void 0 : _b.includes(searchHeight == null ? void 0 : searchHeight.toLowerCase()))) continue;
    let heelImage = "";
    if ((_e = (_d = (_c = product.metafield_heel_image) == null ? void 0 : _c.reference) == null ? void 0 : _d.image) == null ? void 0 : _e.url) {
      heelImage = (_h = (_g = (_f = product.metafield_heel_image) == null ? void 0 : _f.reference) == null ? void 0 : _g.image) == null ? void 0 : _h.url;
    }
    const matchingVariant = product.variants.edges.find(({
      node: variant
    }) => {
      var _a2;
      return (_a2 = variant.selectedOptions) == null ? void 0 : _a2.some((opt) => opt.name.toLowerCase() === "size" && opt.value === formattedSize);
    });
    if (!heelImage) continue;
    return {
      heelImageUrl: heelImage,
      productId: product.id,
      featuredImage: product.featuredImage,
      color: (_i = product == null ? void 0 : product.metafield_option_color) == null ? void 0 : _i.value,
      variant: matchingVariant == null ? void 0 : matchingVariant.node
    };
  }
  return null;
};
const getInitialBottomColors = (bottomRawData) => {
  var _a, _b, _c;
  return new Set(((_c = (_b = (_a = bottomRawData == null ? void 0 : bottomRawData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.map((item) => {
    var _a2, _b2;
    return ((_b2 = (_a2 = item == null ? void 0 : item.node) == null ? void 0 : _a2.metafield_option_color) == null ? void 0 : _b2.value) || null;
  }).filter((item) => item !== null)) || []);
};
const getUpdatedBottomColors = (bottomRawData, selectedHeelType, size) => {
  var _a, _b;
  return (((_b = (_a = bottomRawData == null ? void 0 : bottomRawData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) || []).filter((item) => {
    var _a2, _b2, _c, _d;
    return (_d = (_b2 = (_a2 = item == null ? void 0 : item.node) == null ? void 0 : _a2.title) == null ? void 0 : _b2.toLowerCase()) == null ? void 0 : _d.includes((_c = selectedHeelType == null ? void 0 : selectedHeelType.selector) == null ? void 0 : _c.toLowerCase());
  }).map((item) => {
    var _a2, _b2;
    const formattedSize = getFormattedSize(size);
    const product = item == null ? void 0 : item.node;
    const variant = product.variants.edges.find(({
      node: variant2
    }) => {
      var _a3;
      return (_a3 = variant2.selectedOptions) == null ? void 0 : _a3.some((opt) => opt.name.toLowerCase() === "size" && opt.value === formattedSize);
    });
    return {
      color: ((_a2 = product == null ? void 0 : product.metafield_option_color) == null ? void 0 : _a2.value) || null,
      isAvailable: Boolean((product == null ? void 0 : product.availableForSale) && ((_b2 = variant == null ? void 0 : variant.node) == null ? void 0 : _b2.availableForSale)),
      heelType: product == null ? void 0 : product.title
    };
  }).filter((item) => item.color !== null);
};
const getSwatch = (product) => {
  var _a, _b, _c, _d, _e;
  if (!product) {
    return {
      backgroundColor: "#f0f0f0",
      backgroundSize: "cover"
    };
  }
  if (((_b = (_a = product.shopify_color_pattern) == null ? void 0 : _a.references) == null ? void 0 : _b.nodes) && product.shopify_color_pattern.references.nodes.length > 0) {
    for (const node2 of product.shopify_color_pattern.references.nodes) {
      const swatchImageUrl = (_e = (_d = (_c = node2 == null ? void 0 : node2.field) == null ? void 0 : _c.reference) == null ? void 0 : _d.image) == null ? void 0 : _e.url;
      if (swatchImageUrl) {
        return {
          backgroundImage: `url(${swatchImageUrl})`,
          backgroundSize: "cover"
        };
      }
      if ((node2 == null ? void 0 : node2.fields) && Array.isArray(node2.fields)) {
        const colorField = node2.fields.find((field) => field.type === "color");
        if (colorField == null ? void 0 : colorField.value) {
          const colorValue = colorField.value.toString().trim();
          if (colorValue.startsWith("#")) {
            return {
              backgroundColor: colorValue,
              backgroundSize: "cover"
            };
          } else if (/^[0-9A-Fa-f]{3,6}$/.test(colorValue)) {
            const hexColor = `#${colorValue}`;
            return {
              backgroundColor: hexColor,
              backgroundSize: "cover"
            };
          }
        }
      }
    }
  }
  return {
    backgroundColor: "#f0f0f0",
    backgroundSize: "cover"
  };
};
const getSwatchByColor = (products, colorName) => {
  if (!products || products.length === 0) {
    return {
      backgroundColor: "#f0f0f0",
      backgroundSize: "cover"
    };
  }
  const product = products.find(({
    node: node2
  }) => {
    var _a;
    const productColor = (_a = node2.metafield_option_color) == null ? void 0 : _a.value;
    return productColor === colorName;
  });
  if (product) {
    return getSwatch(product.node);
  }
  return {
    backgroundColor: "#f0f0f0",
    backgroundSize: "cover"
  };
};
const formatFilters = (filterGroup) => {
  var _a;
  return ((_a = filterGroup == null ? void 0 : filterGroup.values) == null ? void 0 : _a.map((filter) => {
    var _a2;
    return {
      ...filter,
      input: JSON.parse(((_a2 = filter == null ? void 0 : filter.input) == null ? void 0 : _a2.replace(/\\/g, "")) || "{}")
    };
  })) || [];
};
const handleAddToCart = async (onComplete, topImage, heelImage, quantity) => {
  const items = getPayload(topImage, heelImage, quantity);
  if (!items) {
    console.error("Invalid items");
    return null;
  }
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items
      })
    });
    if (!response.ok) {
      throw new Error(`Failed to add items to cart: ${response.statusText}`);
    }
    const data = await response.json();
    const cart = await fetch("/cart.js").then((res) => res.json());
    onComplete();
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart,
        openMiniCart: true,
        replacementDelay: 300
      }
    }));
    return data;
  } catch (error) {
    console.error("Error adding items to cart:", error);
    return null;
  }
};
const getPayload = (topImage, bottomImage, quantity) => {
  var _a, _b, _c, _d;
  const topid = (_b = (_a = topImage == null ? void 0 : topImage.variant) == null ? void 0 : _a.id) == null ? void 0 : _b.split("/").pop();
  const bottomid = (_d = (_c = bottomImage == null ? void 0 : bottomImage.variant) == null ? void 0 : _c.id) == null ? void 0 : _d.split("/").pop();
  if (!topid || !bottomid) {
    console.error("Invalid variant IDs");
    return null;
  }
  return [{
    id: topid,
    quantity
  }, {
    id: bottomid,
    quantity
  }];
};
const getFormattedSize = (size) => {
  if (!size) return null;
  const formattedSize = size < 7 ? "5-6.5" : size >= 9 ? "9-11" : "7-8.5";
  return formattedSize;
};
const getPaymentInfo = (topImage, heelImage) => {
  var _a, _b, _c, _d;
  const topPrice = parseFloat(((_b = (_a = topImage == null ? void 0 : topImage.variant) == null ? void 0 : _a.price) == null ? void 0 : _b.amount) || 0);
  const heelPrice = parseFloat(((_d = (_c = heelImage == null ? void 0 : heelImage.variant) == null ? void 0 : _c.price) == null ? void 0 : _d.amount) || 0);
  const totalPrice = (topPrice + heelPrice).toFixed(2);
  const installmentPrice = (parseFloat(totalPrice) / 4).toFixed(2);
  return {
    totalPrice,
    installmentPrice
  };
};
const afterPayPopup = () => {
  var _a;
  if (window == null ? void 0 : window.Afterpay) {
    (_a = window == null ? void 0 : window.Afterpay) == null ? void 0 : _a.launchModal();
  }
};
const klarnaPopup = () => {
  if (window.kmerchant) {
    window.kmerchant.openHostedInterstitial({
      url: "https://na-assets.klarnaservices.com/learn-more/index.html?showButtons=true&showBackground=false#eyJsYW5ndWFnZSI6IkVOIiwiY291bnRyeSI6IlVTIiwiaXNUaHJlc2hvbGQiOmZhbHNlLCJhZFBheW1lbnRNZXRob2RzIjpbMywyLDEsOSw4LDcsNiw0LDExLDEzXSwidHJhY2tlclBhcmFtZXRlcnMiOnsiYiI6IkxrSm1teWNRU1JoaktFajFGdGtMViIsImYiOiIzNSIsImgiOiJFTiIsImkiOiJVUyIsImwiOiIxMTQ1IiwibiI6InBhc2hpb25mb290d2Vhci5jb20iLCJzIjoiMTAwMSIsImQiOiJ0b3Atc3RyaXAtcHJvbW90aW9uLWF1dG8tc2l6ZSJ9fQ=="
    });
  }
};
var _jsxFileName$1m = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStyleProgress.tsx";
function CustomizeStyleProgress({
  step,
  handleStepChange
}) {
  return u("div", {
    children: [u("div", {
      className: "flex justify-between md:grid md:grid-cols-4 place-items-center py-[17px]",
      children: steps.map((label, index) => u("button", {
        className: clsx$1(" border-b max-md:text-button-lg", step === index + 1 ? "border-black" : "border-[#00000033] text-[#00000033]"),
        onClick: () => handleStepChange(index + 1),
        disabled: index + 1 > step,
        children: label
      }, label, false, {
        fileName: _jsxFileName$1m,
        lineNumber: 12,
        columnNumber: 11
      }, this))
    }, void 0, false, {
      fileName: _jsxFileName$1m,
      lineNumber: 10,
      columnNumber: 7
    }, this), u("div", {
      className: "grid grid-cols-4 w-full h-0.5",
      children: [u("div", {
        className: clsx$1("w-full h-0.5", step === 1 ? "bg-black rounded-full" : "bg-[#00000033]")
      }, void 0, false, {
        fileName: _jsxFileName$1m,
        lineNumber: 28,
        columnNumber: 9
      }, this), u("div", {
        className: clsx$1("w-full h-0.5", step === 2 ? "bg-black rounded-full" : "bg-[#00000033]")
      }, void 0, false, {
        fileName: _jsxFileName$1m,
        lineNumber: 34,
        columnNumber: 9
      }, this), u("div", {
        className: clsx$1("w-full h-0.5", step === 3 ? "bg-black rounded-full" : "bg-[#00000033]")
      }, void 0, false, {
        fileName: _jsxFileName$1m,
        lineNumber: 40,
        columnNumber: 9
      }, this), u("div", {
        className: clsx$1("w-full h-0.5", step === 4 ? "bg-black rounded-full" : "bg-[#00000033]")
      }, void 0, false, {
        fileName: _jsxFileName$1m,
        lineNumber: 46,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1m,
      lineNumber: 27,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1m,
    lineNumber: 9,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1l = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStyleHeader.tsx";
function CustomizeStyleHeader({
  productStyle,
  selectedSize,
  step,
  handleStepChange,
  selectedTopColor,
  selectedHeelType,
  selectedHeelColor
}) {
  return u("div", {
    className: clsx$1(step === 5 ? "hidden" : "flex flex-col gap-[15px] mb-[15px]"),
    children: [u("h2", {
      className: "font-primary text-[25px] font-medium leading-[120%]",
      children: ["Customize your ", productStyle]
    }, void 0, true, {
      fileName: _jsxFileName$1l,
      lineNumber: 20,
      columnNumber: 7
    }, this), selectedSize && u("p", {
      children: [steps[0], ": ", selectedSize == null ? void 0 : selectedSize.label]
    }, void 0, true, {
      fileName: _jsxFileName$1l,
      lineNumber: 24,
      columnNumber: 9
    }, this), u(CustomizeStyleProgress, {
      step,
      handleStepChange
    }, void 0, false, {
      fileName: _jsxFileName$1l,
      lineNumber: 28,
      columnNumber: 7
    }, this), u("div", {
      className: "flex justify-start md:justify-between text-base gap-2.5",
      children: [u("p", {
        className: "font-medium leading-[150%]",
        children: ["Choose ", step !== 2 ? "a" : "an", " ", steps[step - 1], ":"]
      }, void 0, true, {
        fileName: _jsxFileName$1l,
        lineNumber: 30,
        columnNumber: 9
      }, this), u("p", {
        className: "font-normal",
        children: step === 1 ? selectedSize == null ? void 0 : selectedSize.label : step === 2 ? selectedTopColor == null ? void 0 : selectedTopColor.color : step === 3 ? `${(selectedHeelType == null ? void 0 : selectedHeelType.height) === 15 ? 1.5 : selectedHeelType == null ? void 0 : selectedHeelType.height}" ${selectedHeelType == null ? void 0 : selectedHeelType.type}` : step === 4 ? selectedHeelColor == null ? void 0 : selectedHeelColor.color : ""
      }, void 0, false, {
        fileName: _jsxFileName$1l,
        lineNumber: 33,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1l,
      lineNumber: 29,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1l,
    lineNumber: 15,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1k = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStyleATC.tsx";
function CustomizeStyleATC({
  topImage,
  heelImage,
  quantity,
  setQuantity,
  setOpen
}) {
  var _a, _b;
  return u("div", {
    className: "flex gap-[15px] w-full",
    children: [u("div", {
      class: "product-form__quantity",
      children: u("div", {
        class: "quantity-selector",
        children: [u("button", {
          type: "button",
          class: "quantity-selector__button",
          onClick: () => setQuantity(quantity - 1),
          disabled: quantity <= 1,
          children: [u("span", {
            class: "visually-hidden",
            children: "Decrease quantity"
          }, void 0, false, {
            fileName: _jsxFileName$1k,
            lineNumber: 20,
            columnNumber: 13
          }, this), u("svg", {
            focusable: "false",
            width: "10",
            height: "2",
            class: "icon icon--minus-big   ",
            viewBox: "0 0 10 2",
            children: u("path", {
              fill: "currentColor",
              d: "M0 0h10v2H0z"
            }, void 0, false, {
              fileName: _jsxFileName$1k,
              lineNumber: 28,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1k,
            lineNumber: 21,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1k,
          lineNumber: 14,
          columnNumber: 11
        }, this), u("p", {
          class: "quantity-selector__input",
          inputmode: "numeric",
          name: "quantity",
          "aria-label": "Quantity",
          children: quantity
        }, void 0, false, {
          fileName: _jsxFileName$1k,
          lineNumber: 31,
          columnNumber: 11
        }, this), u("button", {
          type: "button",
          class: "quantity-selector__button",
          onClick: () => setQuantity(quantity + 1),
          disabled: quantity >= ((_a = topImage == null ? void 0 : topImage.variant) == null ? void 0 : _a.quantityAvailable) || quantity >= ((_b = heelImage == null ? void 0 : heelImage.variant) == null ? void 0 : _b.quantityAvailable),
          children: [u("span", {
            class: "visually-hidden",
            children: "Increase quantity"
          }, void 0, false, {
            fileName: _jsxFileName$1k,
            lineNumber: 48,
            columnNumber: 13
          }, this), u("svg", {
            focusable: "false",
            width: "10",
            height: "10",
            class: "icon icon--plus-big   ",
            viewBox: "0 0 10 10",
            children: u("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M4 6v4h2V6h4V4H6V0H4v4H0v2h4z",
              fill: "currentColor"
            }, void 0, false, {
              fileName: _jsxFileName$1k,
              lineNumber: 56,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1k,
            lineNumber: 49,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1k,
          lineNumber: 39,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1k,
        lineNumber: 13,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1k,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("button", {
      is: "loader-button",
      class: "product-form__add-button button button--primary button--full",
      onClick: () => handleAddToCart(setOpen, topImage, heelImage, quantity),
      children: [u("span", {
        class: "loader-button__text",
        children: "Add to bag"
      }, void 0, false, {
        fileName: _jsxFileName$1k,
        lineNumber: 71,
        columnNumber: 9
      }, this), u("span", {
        class: "loader-button__loader",
        hidden: "",
        children: u("div", {
          class: "spinner",
          children: u("svg", {
            focusable: "false",
            width: "24",
            height: "24",
            class: "icon icon--spinner",
            viewBox: "25 25 50 50",
            children: u("circle", {
              cx: "50",
              cy: "50",
              r: "20",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "5"
            }, void 0, false, {
              fileName: _jsxFileName$1k,
              lineNumber: 81,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1k,
            lineNumber: 74,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1k,
          lineNumber: 73,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1k,
        lineNumber: 72,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1k,
      lineNumber: 66,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1k,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1j = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStylePaymentOptions.tsx";
function CustomizeStylePaymentOptions({
  topImage,
  heelImage
}) {
  const {
    totalPrice,
    installmentPrice
  } = getPaymentInfo(topImage, heelImage) || {};
  return u("div", {
    className: "flex flex-col items-center bg-[#D3BDD933] text-primary text-base font-medium leading-[150%] py-2.5 px-5 w-full",
    children: [u("p", {
      children: ["$", totalPrice]
    }, void 0, true, {
      fileName: _jsxFileName$1j,
      lineNumber: 16,
      columnNumber: 7
    }, this), u("p", {
      children: "Free Shipping in US"
    }, void 0, false, {
      fileName: _jsxFileName$1j,
      lineNumber: 17,
      columnNumber: 7
    }, this), Number(totalPrice) >= 100 && u("p", {
      className: "text-button-lg font-normal text-center",
      children: ["Pay in 4 installments of $", installmentPrice, " with", "  ", u("button", {
        onClick: afterPayPopup,
        class: "afterpay_popup",
        children: u("svg", {
          role: "img",
          focusable: "false",
          width: "54",
          height: "10",
          viewBox: "0 0 108 20",
          "aria-hidden": "true",
          class: "inline",
          children: u("path", {
            d: "M8.724 9.787c0-1.798-1.338-3.061-2.982-3.061-1.644 0-2.982 1.285-2.982 3.061 0 1.755 1.338 3.06 2.982 3.06 1.646 0 2.982-1.262 2.982-3.06zm.024 5.35v-1.391c-.811.963-2.019 1.561-3.464 1.561C2.28 15.307 0 12.953 0 9.787c0-3.146 2.367-5.542 5.351-5.542 1.404 0 2.587.6 3.398 1.54V4.437h2.697v10.7H8.748zM24.544 12.761c-.944 0-1.206-.342-1.206-1.24V6.77h1.733V4.436h-1.733v-2.61h-2.764v2.61h-3.56v-.65c0-.9.352-1.243 1.317-1.243h.606V.468h-1.33c-2.28 0-3.354.728-3.354 2.953v1.014h-1.535V6.77h1.535v8.366h2.764V6.77h3.56v5.243c0 2.183.854 3.125 3.09 3.125h1.426v-2.376h-.55zM34.455 8.823c-.197-1.39-1.36-2.225-2.719-2.225-1.36 0-2.478.813-2.762 2.225h5.48zm-5.504 1.67c.198 1.583 1.36 2.483 2.829 2.483 1.162 0 2.062-.536 2.587-1.392h2.83c-.659 2.268-2.742 3.723-5.483 3.723-3.31 0-5.634-2.267-5.634-5.499 0-3.231 2.456-5.564 5.702-5.564 3.267 0 5.634 2.354 5.634 5.564 0 .236-.021.47-.065.685h-8.4zM54.987 9.787c0-1.734-1.338-3.061-2.982-3.061-1.644 0-2.982 1.285-2.982 3.061 0 1.755 1.338 3.06 2.982 3.06 1.644 0 2.982-1.326 2.982-3.06zm-8.684-5.35H49v1.391c.81-.985 2.016-1.583 3.464-1.583 2.96 0 5.283 2.376 5.283 5.52 0 3.147-2.367 5.544-5.349 5.544-1.382 0-2.522-.536-3.31-1.434v5.665h-2.785V4.437zM67.467 9.787c0-1.798-1.336-3.061-2.982-3.061-1.644 0-2.982 1.285-2.982 3.061 0 1.755 1.338 3.06 2.982 3.06 1.646 0 2.982-1.262 2.982-3.06zm.024 5.35v-1.391c-.811.963-2.019 1.561-3.464 1.561-3.004 0-5.284-2.354-5.284-5.52 0-3.146 2.367-5.542 5.35-5.542 1.403 0 2.587.6 3.398 1.54V4.437h2.696v10.7h-2.696zM41.443 5.486s.686-1.24 2.367-1.24c.719 0 1.184.24 1.184.24v2.73s-1.014-.611-1.946-.488c-.932.123-1.521.958-1.518 2.076v6.335h-2.784v-10.7h2.697v1.047zM82.781 4.437l-6.808 15.069h-2.871l2.673-5.826-4.52-9.243h3.254l2.644 6.176 2.713-6.176h2.915zM104.514 4.194L97.764.393c-1.98-1.116-4.457.278-4.457 2.512v.39c0 .352.193.678.505.853l1.275.718c.374.212.84-.052.84-.473v-.97c0-.485.538-.789.968-.546l5.846 3.294c.43.242.43.848 0 1.09l-5.846 3.293c-.43.242-.967-.06-.967-.546v-.516c0-2.233-2.477-3.63-4.46-2.512l-6.75 3.802a2.866 2.866 0 000 5.024l6.75 3.801c1.981 1.116 4.46-.278 4.46-2.512v-.39a.983.983 0 00-.506-.853l-1.274-.72c-.374-.211-.841.053-.841.474v.97c0 .485-.538.788-.967.545l-5.847-3.293a.623.623 0 010-1.091l5.847-3.294c.43-.243.967.06.967.546v.516c0 2.233 2.476 3.63 4.457 2.512l6.75-3.802a2.864 2.864 0 000-5.02z"
          }, void 0, false, {
            fileName: _jsxFileName$1j,
            lineNumber: 31,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1j,
          lineNumber: 22,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1j,
        lineNumber: 21,
        columnNumber: 11
      }, this), " ", "or", " ", u("button", {
        onClick: klarnaPopup,
        class: "klarna_popup",
        children: u("svg", {
          role: "img",
          focusable: "false",
          width: "40",
          height: "10",
          viewBox: "0 0 81 20",
          "aria-hidden": "true",
          class: "inline",
          children: u("g", {
            transform: "translate(0, 0) scale(1)",
            children: [u("path", {
              d: "M78.3352549,14.3292706 C77.0678017,14.3292706 76.0403439,15.3567284 76.0403439,16.6243597 C76.0403439,17.8916348 77.0678017,18.9192707 78.3352549,18.9192707 C79.6027081,18.9192707 80.630344,17.8916348 80.630344,16.6243597 C80.630344,15.3567284 79.6027081,14.3292706 78.3352549,14.3292706",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 46,
              columnNumber: 17
            }, this), " ", u("path", {
              d: "M70.7958568,7.22817345 L70.7958568,6.4467803 L74.4529833,6.4467803 L74.4529833,18.6618356 L70.7958568,18.6618356 L70.7958568,17.8811547 C69.7626656,18.5857975 68.5156063,19 67.1704277,19 C63.6107082,19 60.7250027,16.1142945 60.7250027,12.554575 C60.7250027,8.99485561 63.6107082,6.10915009 67.1704277,6.10915009 C68.5156063,6.10915009 69.7626656,6.52335256 70.7958568,7.22817345 Z M67.4697718,15.6974209 C69.3000267,15.6974209 70.7835696,14.2902722 70.7835696,12.554575 C70.7835696,10.8188779 69.3000267,9.41208536 67.4697718,9.41208536 C65.6395168,9.41208536 64.1559739,10.8188779 64.1559739,12.554575 C64.1559739,14.2902722 65.6395168,15.6974209 67.4697718,15.6974209 Z",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 50,
              columnNumber: 17
            }, this), " ", u("path", {
              d: "M54.2263333,6.11823191 C52.765406,6.11823191 51.3828316,6.57178896 50.4584442,7.82312205 L50.4584442,6.4474926 L46.8169884,6.4474926 L46.8169884,18.6618356 L50.503141,18.6618356 L50.503141,12.2427657 C50.503141,10.3852653 51.7487757,9.47565814 53.2485235,9.47565814 C54.8558285,9.47565814 55.7798597,10.4358386 55.7798597,12.2174791 L55.7798597,18.6618356 L59.4327124,18.6618356 L59.4327124,10.8940256 C59.4327124,8.05141421 57.1725844,6.11823191 54.2263333,6.11823191",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 54,
              columnNumber: 17
            }, this), " ", u("path", {
              d: "M41.5278044,8.03788051 L41.5278044,6.44695838 L37.7834212,6.44695838 L37.7834212,18.6618356 L41.536174,18.6618356 L41.536174,12.9588053 C41.536174,11.0347048 43.6216104,10.0004452 45.0686479,10.0004452 C45.0834281,10.0004452 45.097318,10.0018698 45.1120982,10.0020479 L45.1120982,6.44767068 C43.6269526,6.44767068 42.2609392,7.08357654 41.5278044,8.03788051",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 58,
              columnNumber: 17
            }, this), " ", u("path", {
              d: "M32.2128788,7.22817345 L32.2128788,6.4467803 L35.8701833,6.4467803 L35.8701833,18.6618356 L32.2128788,18.6618356 L32.2128788,17.8811547 C31.1796876,18.5857975 29.9326283,19 28.5876277,19 C25.0279083,19 22.1422028,16.1142945 22.1422028,12.554575 C22.1422028,8.99485561 25.0279083,6.10915009 28.5876277,6.10915009 C29.9326283,6.10915009 31.1796876,6.52335256 32.2128788,7.22817345 Z M28.8867938,15.6974209 C30.7170487,15.6974209 32.2007697,14.2902722 32.2007697,12.554575 C32.2007697,10.8188779 30.7170487,9.41208536 28.8867938,9.41208536 C27.0567169,9.41208536 25.5729959,10.8188779 25.5729959,12.554575 C25.5729959,14.2902722 27.0567169,15.6974209 28.8867938,15.6974209 Z",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 62,
              columnNumber: 17
            }, this), " ", u("path", {
              d: "M16.8150889 18.6618356 20.6429893 18.6618356 20.6429893 1.00338343 16.8150889 1.00338343z",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 66,
              columnNumber: 17
            }, this), " ", u("path", {
              d: "M14.1770857,1 L10.2104649,1 C10.2104649,4.25111544 8.71570325,7.23511837 6.10957549,9.1873547 L4.53806353,10.3642524 L10.6271604,18.6673559 L15.6335612,18.6673559 L10.0307872,11.0272257 C12.6865979,8.38263373 14.1770857,4.82469505 14.1770857,1",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 70,
              columnNumber: 17
            }, this), " ", u("path", {
              d: "M0 18.6666436 4.05334336 18.6666436 4.05334336 1 0 1z",
              fill: "rgba(150, 147, 145, 1)"
            }, void 0, false, {
              fileName: _jsxFileName$1j,
              lineNumber: 74,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1j,
            lineNumber: 45,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1j,
          lineNumber: 36,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1j,
        lineNumber: 35,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1j,
      lineNumber: 19,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1j,
    lineNumber: 15,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1i = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStyleOptions.tsx";
function CustomizeStyleOptions({
  handleSizeChange,
  selectedSize,
  step,
  sizeFilters,
  selectedTopColor,
  selectedHeelType,
  selectedHeelColor,
  colorOptions,
  handleHeelTypeChange,
  topImages,
  heelImages,
  heelColorOptions,
  topImage,
  heelImage,
  quantity,
  setQuantity,
  setOpen,
  handleTopColorChange,
  handleBottomColorChange,
  productStyle,
  firstSizeRef,
  upperData,
  heelData
}) {
  var _a, _b, _c;
  y(() => {
    if (!selectedHeelType) {
      handleHeelTypeChange(heelTypes[0]);
    }
  }, []);
  return u("div", {
    className: clsx$1("flex flex-wrap", step === 3 ? "grid grid-cols-3 gap-1.5" : "", step === 5 ? "justify-center" : ""),
    children: [step === 1 && (sizeOptions == null ? void 0 : sizeOptions.map((val, index) => u("button", {
      className: clsx$1("block-swatch__item", (sizeFilters == null ? void 0 : sizeFilters.find((f2) => (f2 == null ? void 0 : f2.label) === val)) ? "" : ".block-swatch.is-disabled text-[#00000033] bg-gray-300", (selectedSize == null ? void 0 : selectedSize.label) === val ? "border border-black" : ""),
      ref: index === 0 ? firstSizeRef : null,
      disabled: !(sizeFilters == null ? void 0 : sizeFilters.find((f2) => (f2 == null ? void 0 : f2.label) === val)),
      onClick: () => handleSizeChange(val),
      children: [val, !(sizeFilters == null ? void 0 : sizeFilters.find((f2) => (f2 == null ? void 0 : f2.label) === val)) && u(b$2, {
        children: u("span", {
          className: "absolute inset-0 pointer-events-none after:absolute after:top-1/2 after:left-1/2 after:w-2/3 after:h-[1px] after:bg-[#00000033] after:-translate-x-1/2 after:-translate-y-1/2 after:-rotate-45"
        }, void 0, false, {
          fileName: _jsxFileName$1i,
          lineNumber: 68,
          columnNumber: 17
        }, this)
      }, void 0, false)]
    }, val, true, {
      fileName: _jsxFileName$1i,
      lineNumber: 52,
      columnNumber: 11
    }, this))), step === 2 && (colorOptions == null ? void 0 : colorOptions.map((val, index) => u("button", {
      className: clsx$1("block-swatch__item", !(val == null ? void 0 : val.isAvailable) ? "border-none" : "max-md:border-none"),
      onClick: () => handleTopColorChange(val),
      disabled: (val == null ? void 0 : val.isAvailable) === true ? false : true,
      children: u("div", {
        className: clsx$1("rounded-full", (val == null ? void 0 : val.isAvailable) ? "min-w-[40px] min-h-[40px] md:min-w-[50px] md:min-h-[50px]" : "min-w-[25px] min-h-[25px]", (selectedTopColor == null ? void 0 : selectedTopColor.color) === (val == null ? void 0 : val.color) && (val == null ? void 0 : val.isAvailable) ? "border border-black" : ""),
        style: (() => {
          var _a2, _b2;
          if (!((_b2 = (_a2 = upperData == null ? void 0 : upperData.collection) == null ? void 0 : _a2.products) == null ? void 0 : _b2.edges)) {
            return {
              backgroundColor: "#e5e5e5",
              backgroundSize: "cover"
            };
          }
          return getSwatchByColor(upperData.collection.products.edges, val == null ? void 0 : val.color);
        })(),
        children: [" ", !(val == null ? void 0 : val.isAvailable) && u(b$2, {
          children: u("span", {
            className: "absolute inset-0 before:absolute before:inset-0 before:w-full before:h-[1px] before:bg-white before:rotate-45 before:top-1/2 before:left-0 after:absolute after:inset-0 after:w-full after:h-[1px] after:bg-white after:-rotate-45 after:top-1/2 after:left-0 pointer-events-none"
          }, void 0, false, {
            fileName: _jsxFileName$1i,
            lineNumber: 112,
            columnNumber: 19
          }, this)
        }, void 0, false)]
      }, void 0, true, {
        fileName: _jsxFileName$1i,
        lineNumber: 84,
        columnNumber: 13
      }, this)
    }, val == null ? void 0 : val.color, false, {
      fileName: _jsxFileName$1i,
      lineNumber: 75,
      columnNumber: 11
    }, this))), step === 3 && ((_a = heelTypes == null ? void 0 : heelTypes.filter((heel) => heelImages == null ? void 0 : heelImages[heel == null ? void 0 : heel.bottomSelector])) == null ? void 0 : _a.map((heel, index) => u("button", {
      onClick: () => handleHeelTypeChange(heel),
      children: u(CustomizeStyleImageCard, {
        topImage: topImages == null ? void 0 : topImages[heel == null ? void 0 : heel.height],
        heelImage: heelImages == null ? void 0 : heelImages[heel == null ? void 0 : heel.bottomSelector],
        styleClass: clsx$1("border-2", (heel == null ? void 0 : heel.selector) === (selectedHeelType == null ? void 0 : selectedHeelType.selector) ? "border-black" : "border-[#00000033]"),
        imageClass: "bg-transparent"
      }, void 0, false, {
        fileName: _jsxFileName$1i,
        lineNumber: 126,
        columnNumber: 15
      }, this)
    }, heel == null ? void 0 : heel.selector, false, {
      fileName: _jsxFileName$1i,
      lineNumber: 122,
      columnNumber: 13
    }, this))), step === 4 && (heelColorOptions == null ? void 0 : heelColorOptions.map((val, index) => u("button", {
      className: clsx$1("block-swatch__item", !(val == null ? void 0 : val.isAvailable) ? "border-none" : "max-md:border-none"),
      onClick: () => handleBottomColorChange(val),
      disabled: (val == null ? void 0 : val.isAvailable) === true ? false : true,
      children: u("div", {
        className: clsx$1("rounded-full", (val == null ? void 0 : val.isAvailable) ? "min-w-[40px] min-h-[40px] md:min-w-[50px] md:min-h-[50px]" : "min-w-[25px] min-h-[25px]", (selectedHeelColor == null ? void 0 : selectedHeelColor.color) === (val == null ? void 0 : val.color) && (val == null ? void 0 : val.isAvailable) ? "border border-black" : ""),
        style: (() => {
          var _a2, _b2;
          if (!((_b2 = (_a2 = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _a2.products) == null ? void 0 : _b2.edges)) {
            return {
              backgroundColor: "#e5e5e5",
              backgroundSize: "cover"
            };
          }
          return getSwatchByColor(heelData.collection.products.edges, val == null ? void 0 : val.color);
        })(),
        children: [" ", !(val == null ? void 0 : val.isAvailable) && u(b$2, {
          children: u("span", {
            className: "absolute inset-0 before:absolute before:inset-0 before:w-full before:h-[1px] before:bg-white before:rotate-45 before:top-1/2 before:left-0 after:absolute after:inset-0 after:w-full after:h-[1px] after:bg-white after:-rotate-45 after:top-1/2 after:left-0 pointer-events-none"
          }, void 0, false, {
            fileName: _jsxFileName$1i,
            lineNumber: 178,
            columnNumber: 19
          }, this)
        }, void 0, false)]
      }, void 0, true, {
        fileName: _jsxFileName$1i,
        lineNumber: 150,
        columnNumber: 13
      }, this)
    }, val, false, {
      fileName: _jsxFileName$1i,
      lineNumber: 141,
      columnNumber: 11
    }, this))), step === 5 && u("div", {
      className: "flex flex-col gap-[30px] items-center",
      children: [u("h2", {
        className: "font-primary text-[25px] md:text-eyebrow-lg font-medium text-center",
        children: ["You have customized your ", productStyle, "!"]
      }, void 0, true, {
        fileName: _jsxFileName$1i,
        lineNumber: 186,
        columnNumber: 11
      }, this), u(CustomizeStylePaymentOptions, {
        topImage,
        heelImage
      }, void 0, false, {
        fileName: _jsxFileName$1i,
        lineNumber: 189,
        columnNumber: 11
      }, this), u("div", {
        className: "pt-[30px] pb-5 px-4",
        children: [u("div", {
          className: "flex flex-col items-center mb-[50px] gap-5",
          children: [u("div", {
            className: clsx$1("flex justify-center"),
            children: u("div", {
              className: "flex gap-2",
              children: [u("img", {
                src: (_b = topImage == null ? void 0 : topImage.featuredImage) == null ? void 0 : _b.url,
                className: "w-[69px] md:w-[75px] bg-gray-300"
              }, void 0, false, {
                fileName: _jsxFileName$1i,
                lineNumber: 197,
                columnNumber: 19
              }, this), u("img", {
                src: (_c = heelImage == null ? void 0 : heelImage.featuredImage) == null ? void 0 : _c.url,
                class: "w-[69px] md:w-[75px] bg-gray-300"
              }, void 0, false, {
                fileName: _jsxFileName$1i,
                lineNumber: 201,
                columnNumber: 19
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$1i,
              lineNumber: 196,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1i,
            lineNumber: 195,
            columnNumber: 15
          }, this), u("div", {
            class: "text-center",
            children: [u("p", {
              children: [productStyle, " ", selectedTopColor == null ? void 0 : selectedTopColor.color, " with", " ", selectedHeelColor == null ? void 0 : selectedHeelColor.color, " ", (selectedHeelType == null ? void 0 : selectedHeelType.height) === 15 ? 1.5 : selectedHeelType == null ? void 0 : selectedHeelType.height, '" ', selectedHeelType == null ? void 0 : selectedHeelType.type]
            }, void 0, true, {
              fileName: _jsxFileName$1i,
              lineNumber: 208,
              columnNumber: 17
            }, this), u("p", {
              class: "hidden md:block",
              children: ["Size: ", selectedSize == null ? void 0 : selectedSize.label]
            }, void 0, true, {
              fileName: _jsxFileName$1i,
              lineNumber: 216,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1i,
            lineNumber: 207,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1i,
          lineNumber: 194,
          columnNumber: 13
        }, this), u("div", {
          className: "hidden md:block",
          children: u(CustomizeStyleATC, {
            topImage,
            heelImage,
            quantity,
            setQuantity,
            setOpen
          }, void 0, false, {
            fileName: _jsxFileName$1i,
            lineNumber: 220,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1i,
          lineNumber: 219,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1i,
        lineNumber: 193,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1i,
      lineNumber: 185,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1i,
    lineNumber: 43,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1h = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStyleFooter.tsx";
function CustomizeStyleFooter({
  step,
  handleStepChange,
  setLoaded,
  topImage,
  heelImage,
  quantity,
  setQuantity,
  setOpen
}) {
  return u("div", {
    className: clsx$1("flex justify-between px-[30px] border-t", step === 5 ? "py-7 flex-col md:flex-row gap-2.5 md:gap-0" : "py-[15px]"),
    children: [step === 5 && u("div", {
      class: "md:hidden",
      children: u(CustomizeStyleATC, {
        topImage,
        heelImage,
        quantity,
        setQuantity,
        setOpen
      }, void 0, false, {
        fileName: _jsxFileName$1h,
        lineNumber: 22,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1h,
      lineNumber: 21,
      columnNumber: 9
    }, this), u("div", {
      className: "flex justify-between w-full",
      children: [u("button", {
        className: clsx$1("underline", step === 1 && "invisible"),
        disabled: step === 1,
        tabIndex: step === 1 ? -1 : 0,
        onClick: () => handleStepChange(step - 1),
        children: "Back"
      }, void 0, false, {
        fileName: _jsxFileName$1h,
        lineNumber: 32,
        columnNumber: 9
      }, this), step === 5 ? u("button", {
        className: "underline",
        onClick: () => {
          setLoaded(false);
          handleStepChange(1);
        },
        children: "Start Again"
      }, void 0, false, {
        fileName: _jsxFileName$1h,
        lineNumber: 41,
        columnNumber: 11
      }, this) : u("button", {
        className: "button button--primary button--full max-w-[201px]",
        disabled: step === 5,
        onClick: () => handleStepChange(step + 1),
        children: "Next"
      }, void 0, false, {
        fileName: _jsxFileName$1h,
        lineNumber: 51,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1h,
      lineNumber: 31,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1h,
    lineNumber: 14,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1g = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/CustomizeStyle/CustomizeStyleWidget.tsx";
function CustomizeStyle({
  productStyle
}) {
  const [open, setOpen] = t$2(h(false), "open");
  const [step, setStep] = t$2(h(1), "step");
  const [quantity, setQuantity] = t$2(h(1), "quantity");
  const [loaded, setLoaded] = t$2(h(false), "loaded");
  const [isLoading, setIsLoading] = t$2(h(false), "isLoading");
  const [collectionFilters, setCollectionFilters] = t$2(h([]), "collectionFilters");
  const [sizeFilters, setSizeFilters] = t$2(h([]), "sizeFilters");
  const [upperData, setUpperData] = t$2(h(null), "upperData");
  const [selectedTopFilters, setSelectedTopFilters] = t$2(h([]), "selectedTopFilters");
  const [topStyleFilters, setTopStyleFilters] = t$2(h([]), "topStyleFilters");
  const [colorOptions, setColorOptions] = t$2(h([]), "colorOptions");
  const [selectedSize, setSelectedSize] = t$2(h(null), "selectedSize");
  const [selectedTopColor, setSelectedTopColor] = t$2(h(null), "selectedTopColor");
  const [topImage, setTopImage] = t$2(h(null), "topImage");
  const [topImages, setTopImages] = t$2(h(null), "topImages");
  const [heelData, setHeelData] = t$2(h(null), "heelData");
  const [selectedBottomFilters, setSelectedBottomFilters] = t$2(h([]), "selectedBottomFilters");
  const [bottomStyleFilters, setBottomStyleFilters] = t$2(h([]), "bottomStyleFilters");
  const [selectedHeelType, setSelectedHeelType] = t$2(h(null), "selectedHeelType");
  const [selectedHeelColor, setSelectedHeelColor] = t$2(h(null), "selectedHeelColor");
  const [heelImage, setHeelImage] = t$2(h(null), "heelImage");
  const [heelImages, setHeelImages] = t$2(h(null), "heelImages");
  const [hideHeelImage, setHideHeelImage] = t$2(h(false), "hideHeelImage");
  const [heelColorOptions, setHeelColorOptions] = t$2(h([]), "heelColorOptions");
  const firstSizeRef = t$2(A$1(null), "firstSizeRef");
  const collectionId = "gid://shopify/Collection/283218018502";
  const heelCollectionId = "gid://shopify/Collection/312730353862";
  const handleStepChange = async (updatedStep) => {
    setStep(updatedStep);
    if (updatedStep === 2 && !selectedTopColor) {
      setSelectedTopColor(colorOptions[0]);
    }
    if (step === 4 && updatedStep === 3 || step === 5 && updatedStep === 1) {
      fetchFilters({
        collectionId: heelCollectionId,
        onComplete: setHeelData
      });
    }
    if (updatedStep === 3) {
      const initialHeelType = heelTypes.find((heel) => (heel == null ? void 0 : heel.selector) === (selectedHeelType == null ? void 0 : selectedHeelType.selector));
      initialHeelType && setSelectedHeelType(initialHeelType);
    }
    if (updatedStep === 4) {
      const activeHeelFilters = getActiveHeelFilters(bottomStyleFilters, selectedHeelType);
      activeHeelFilters && setSelectedBottomFilters(activeHeelFilters);
    }
    if (updatedStep === 5) {
      setQuantity(1);
    }
  };
  const handleSizeChange = (size) => {
    const sizeFilter = sizeFilters.find((f2) => f2.label === size);
    setSelectedSize(sizeFilter);
    setSelectedTopFilters([sizeFilter == null ? void 0 : sizeFilter.input, ...topStyleFilters]);
  };
  const handleTopColorChange = (color) => {
    var _a, _b;
    const topImages2 = findTopImages(((_b = (_a = upperData == null ? void 0 : upperData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) || [], color == null ? void 0 : color.color, selectedSize == null ? void 0 : selectedSize.label);
    const updatedTopImage = topImages2 ? findTopImage(topImages2, topImage == null ? void 0 : topImage.height) : null;
    setSelectedTopColor(color);
    updatedTopImage && setTopImage(updatedTopImage);
    topImages2 && setTopImages(topImages2);
  };
  const handleHeelTypeChange = (heel) => {
    setSelectedHeelType(heel);
    const newHeeltype = heelImages[heel == null ? void 0 : heel.bottomSelector];
    (topImages == null ? void 0 : topImages[heel == null ? void 0 : heel.height]) && setTopImage(topImages == null ? void 0 : topImages[heel == null ? void 0 : heel.height]);
    if (newHeeltype) {
      setSelectedHeelType(newHeeltype);
    }
    setHeelImage(newHeeltype);
  };
  const handleBottomColorChange = (color) => {
    var _a, _b, _c;
    setSelectedHeelColor(color);
    const bottomImages = findBottomImages(((_b = (_a = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) || [], Number(selectedSize == null ? void 0 : selectedSize.label), color == null ? void 0 : color.color);
    ((_c = Object.keys(bottomImages)) == null ? void 0 : _c.length) > 0 && setHeelImages(bottomImages);
    const correctHeelImage = bottomImages[selectedHeelType == null ? void 0 : selectedHeelType.bottomSelector];
    if (correctHeelImage) {
      setHeelImage(correctHeelImage);
      setHideHeelImage(false);
    } else {
      setHideHeelImage(true);
    }
  };
  y(() => {
    if (!productStyle) return;
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const baseProductStyle = productStyle.split("-")[0];
        const [filters, bottomFilters] = await Promise.all([fetchFiltersLight({
          collectionId,
          onComplete: setUpperData,
          maxProducts: 100
          // Reduce initial load
        }), fetchFiltersLight({
          collectionId: heelCollectionId,
          onComplete: setHeelData,
          maxProducts: 50
          // Even fewer heel products needed initially
        })]);
        const activeStyleFilters = getActiveStyleFilters(filters, baseProductStyle);
        setTopStyleFilters(activeStyleFilters);
        setSelectedTopFilters(activeStyleFilters);
        setCollectionFilters(filters);
        setBottomStyleFilters(bottomFilters);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [productStyle]);
  y(() => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!upperData) return;
    const topImages2 = findTopImages(((_b = (_a = upperData == null ? void 0 : upperData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) || [], null, selectedSize == null ? void 0 : selectedSize.label);
    const bottomImages = findBottomImages(((_d = (_c = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _c.products) == null ? void 0 : _d.edges) || [], Number(selectedSize == null ? void 0 : selectedSize.label), selectedHeelColor == null ? void 0 : selectedHeelColor.color);
    const initialTopImage = topImages2 ? findTopImage(topImages2, (_e = topImages2 == null ? void 0 : topImages2[0]) == null ? void 0 : _e.height) : null;
    const initialHeelImage = bottomImages ? findBottomImage(((_g = (_f = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _f.products) == null ? void 0 : _g.edges) || [], topImage == null ? void 0 : topImage.height, Number(selectedSize == null ? void 0 : selectedSize.label)) : null;
    const sizeFilter = sizeFilters.find((f2) => f2.label === (initialTopImage == null ? void 0 : initialTopImage.size));
    const colorOptions2 = getTopColors(upperData, selectedSize, sizeFilter);
    (colorOptions2 == null ? void 0 : colorOptions2.size) > 0 && setColorOptions(Array.from(colorOptions2));
    initialTopImage && setTopImage(initialTopImage);
    topImages2 && setTopImages(topImages2);
    initialHeelImage && setHeelImage(initialHeelImage);
    bottomImages && setHeelImages(bottomImages);
  }, [upperData]);
  y(() => {
    const execute = () => {
      var _a, _b, _c, _d, _e, _f, _g;
      if (!heelImage) {
        const initialHeel = findBottomImage(((_b = (_a = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) || [], topImage == null ? void 0 : topImage.height, Number(selectedSize == null ? void 0 : selectedSize.label));
        initialHeel && setHeelImage(initialHeel);
      }
      getHeelTypeFilters(((_d = (_c = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _c.products) == null ? void 0 : _d.filters) || []);
      const bottomImages = findBottomImages(((_f = (_e = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _e.products) == null ? void 0 : _f.edges) || [], Number(selectedSize == null ? void 0 : selectedSize.label), selectedHeelColor == null ? void 0 : selectedHeelColor.color);
      ((_g = Object.keys(bottomImages)) == null ? void 0 : _g.length) > 0 && setHeelImages(bottomImages);
      const initialColorOptions = getInitialBottomColors(heelData);
      setHeelColorOptions(Array.from(initialColorOptions));
      setLoaded(true);
    };
    let timer;
    if (!loaded) {
      timer = setTimeout(execute, 1500);
    } else {
      execute();
    }
    return () => clearTimeout(timer);
  }, [heelData]);
  y(() => {
    const sizeFilter = collectionFilters.find((f2) => f2.label === "Size");
    setSizeFilters(formatFilters(sizeFilter));
  }, [collectionFilters]);
  y(() => {
    fetchFilters({
      filters: selectedTopFilters,
      collectionId,
      onComplete: setUpperData
    });
  }, [selectedTopFilters]);
  y(() => {
    fetchFilters({
      filters: selectedBottomFilters ? selectedBottomFilters : [],
      collectionId: heelCollectionId,
      onComplete: setHeelData
    });
  }, [selectedBottomFilters]);
  y(() => {
    var _a, _b, _c, _d;
    const bottomImages = findBottomImages(((_b = (_a = heelData == null ? void 0 : heelData.collection) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) || [], Number(selectedSize == null ? void 0 : selectedSize.label), selectedHeelColor == null ? void 0 : selectedHeelColor.color);
    let initialHeelImage;
    for (const image in bottomImages) {
      if (((_c = bottomImages[image]) == null ? void 0 : _c.heelImageUrl) === (heelImage == null ? void 0 : heelImage.heelImageUrl)) {
        initialHeelImage = bottomImages[image];
        break;
      }
    }
    ((_d = Object.keys(bottomImages)) == null ? void 0 : _d.length) > 0 && setHeelImages(bottomImages);
    initialHeelImage && setHeelImage(initialHeelImage);
    initialHeelImage && setSelectedHeelType(initialHeelImage);
  }, [selectedSize]);
  y(() => {
    const colorOptions2 = getUpdatedBottomColors(heelData, selectedHeelType || heelTypes[0], Number(selectedSize == null ? void 0 : selectedSize.label));
    const heelColor = colorOptions2.find((item) => {
      return (item == null ? void 0 : item.color) === (heelImage == null ? void 0 : heelImage.color);
    });
    heelColor && setSelectedHeelColor(heelColor);
    setHeelColorOptions(colorOptions2);
  }, [selectedHeelType, heelData]);
  y(() => {
    var _a;
    if (step === 1 && firstSizeRef.current) {
      (_a = firstSizeRef == null ? void 0 : firstSizeRef.current) == null ? void 0 : _a.click();
    }
  }, [open]);
  y(() => {
    if ((heelImage == null ? void 0 : heelImage.height) !== (topImage == null ? void 0 : topImage.height)) {
      const height = topImage == null ? void 0 : topImage.height;
      let correctedHeelImage;
      if (height === 15) {
        correctedHeelImage = heelImages == null ? void 0 : heelImages.b15;
      } else if (height === 3) {
        correctedHeelImage = (heelImages == null ? void 0 : heelImages.s3) || (heelImages == null ? void 0 : heelImages.fs3) || (heelImages == null ? void 0 : heelImages.fb3) || (heelImages == null ? void 0 : heelImages.b3);
      } else if (height === 4) {
        correctedHeelImage = (heelImages == null ? void 0 : heelImages.s4) || (heelImages == null ? void 0 : heelImages.fs4) || (heelImages == null ? void 0 : heelImages.fb4) || (heelImages == null ? void 0 : heelImages.b4);
      }
      correctedHeelImage && setHeelImage(correctedHeelImage);
    }
  }, [heelImage]);
  return u(b$2, {
    children: [open && u("div", {
      className: "relative",
      children: [u(OverlayComponent, {
        clickHandler: () => setOpen(false),
        overlayClass: "size-full bg-black opacity-50 top-0 left-0 z-10"
      }, void 0, false, {
        fileName: _jsxFileName$1g,
        lineNumber: 357,
        columnNumber: 11
      }, this), u("div", {
        className: `${open ? "fixed z-50 inset-0 overflow-auto max-w-full md:max-w-[1440px] md:max-h-[945px] md:transform left-[50%] translate-x-[-50%] w-full" : "hidden"}`,
        children: u("div", {
          className: "relative bg-white",
          children: [u("button", {
            className: "absolute top-4 right-4 md:top-5 md:right-5 z-10",
            onClick: () => setOpen(false),
            children: u("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 18 18",
              fill: "none",
              children: u("path", {
                d: "M8.99984 10.2951L1.56834 17.7263C1.43589 17.859 1.27334 17.9298 1.08069 17.9388C0.88828 17.948 0.716761 17.8771 0.566136 17.7263C0.415274 17.5757 0.339844 17.4086 0.339844 17.2252C0.339844 17.0417 0.415274 16.8747 0.566136 16.7241L7.99729 9.29257L0.566136 1.86106C0.433453 1.72861 0.362626 1.56607 0.353655 1.37342C0.344447 1.181 0.415274 1.00948 0.566136 0.858859C0.716761 0.707997 0.883794 0.632568 1.06724 0.632568C1.25068 0.632568 1.41771 0.707997 1.56834 0.858859L8.99984 8.29001L16.4314 0.858859C16.5638 0.726176 16.7263 0.655349 16.919 0.646378C17.1114 0.63717 17.2829 0.707997 17.4336 0.858859C17.5844 1.00948 17.6598 1.17652 17.6598 1.35996C17.6598 1.5434 17.5844 1.71044 17.4336 1.86106L10.0024 9.29257L17.4336 16.7241C17.5662 16.8565 17.6371 17.0191 17.646 17.2117C17.6552 17.4041 17.5844 17.5757 17.4336 17.7263C17.2829 17.8771 17.1159 17.9526 16.9325 17.9526C16.749 17.9526 16.582 17.8771 16.4314 17.7263L8.99984 10.2951Z",
                fill: "#1C1B1F"
              }, void 0, false, {
                fileName: _jsxFileName$1g,
                lineNumber: 380,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$1g,
              lineNumber: 373,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1g,
            lineNumber: 369,
            columnNumber: 15
          }, this), u("div", {
            className: "block md:grid grid-cols-2 size-full",
            children: [u(CustomizeStyleImageCard, {
              topImage,
              heelImage,
              hideHeelImage,
              styleClass: "max-h-[300px] md:max-h-[945px]",
              imageClass: "object-contain bg-gray-300",
              bottomImageClass: "max-h-[300px] md:max-h-[945px] md:h-full object-contain"
            }, void 0, false, {
              fileName: _jsxFileName$1g,
              lineNumber: 387,
              columnNumber: 17
            }, this), u("div", {
              className: "flex flex-col justify-between",
              children: [u("div", {
                className: "md:px-[90px] flex flex-col justify-between py-5 md:py-[50px] px-[15px]",
                children: u("div", {
                  className: "",
                  children: [u(CustomizeStyleHeader, {
                    productStyle,
                    selectedSize,
                    step,
                    handleStepChange,
                    selectedTopColor,
                    selectedHeelType,
                    selectedHeelColor
                  }, void 0, false, {
                    fileName: _jsxFileName$1g,
                    lineNumber: 398,
                    columnNumber: 23
                  }, this), u(CustomizeStyleOptions, {
                    handleSizeChange,
                    selectedSize,
                    step,
                    sizeFilters,
                    selectedTopColor,
                    selectedHeelType,
                    selectedHeelColor,
                    colorOptions,
                    handleHeelTypeChange,
                    topImages,
                    heelImages,
                    heelColorOptions,
                    topImage,
                    heelImage,
                    quantity,
                    setQuantity,
                    setOpen,
                    handleTopColorChange,
                    handleBottomColorChange,
                    productStyle,
                    firstSizeRef,
                    upperData,
                    heelData
                  }, void 0, false, {
                    fileName: _jsxFileName$1g,
                    lineNumber: 407,
                    columnNumber: 23
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$1g,
                  lineNumber: 397,
                  columnNumber: 21
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$1g,
                lineNumber: 396,
                columnNumber: 19
              }, this), u(CustomizeStyleFooter, {
                step,
                handleStepChange,
                setLoaded,
                topImage,
                heelImage,
                quantity,
                setQuantity,
                setOpen
              }, void 0, false, {
                fileName: _jsxFileName$1g,
                lineNumber: 434,
                columnNumber: 19
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$1g,
              lineNumber: 395,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1g,
            lineNumber: 386,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1g,
          lineNumber: 368,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1g,
        lineNumber: 361,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1g,
      lineNumber: 356,
      columnNumber: 9
    }, this), u("button", {
      className: clsx$1("button font-medium bg-green-200 !text-blue custom-style-btn w-full", !heelImage || !topImage || isLoading ? "opacity-50 cursor-not-allowed" : ""),
      onClick: () => setOpen(true),
      disabled: !heelImage || !topImage || isLoading,
      children: isLoading ? "Loading..." : "Customize Your Style"
    }, void 0, false, {
      fileName: _jsxFileName$1g,
      lineNumber: 450,
      columnNumber: 7
    }, this)]
  }, void 0);
}
register(CustomizeStyle, "customize-style", ["product"]);
var _jsxFileName$1f = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/FeaturedCallToAction.tsx";
function FeaturedCallToAction({
  eyebrow_text,
  title,
  content,
  cta_text,
  cta_link,
  desktop_image,
  mobile_image,
  mode,
  html_tag_for_title
}) {
  const Component = html_tag_for_title;
  return u("div", {
    className: "flex container flex-col gap-6 md:gap-12",
    children: (eyebrow_text || title || content) && u("div", {
      className: twMerge("flex flex-col md:flex-row gap-9 md:gap-32", mode == "right" && "md:flex-row-reverse"),
      children: [u("div", {
        className: "-mx-5 md:mx-0 md:w-8/12",
        children: [desktop_image && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image))
        }, void 0, false, {
          fileName: _jsxFileName$1f,
          lineNumber: 43,
          columnNumber: 15
        }, this), mobile_image && u("div", {
          className: "md:hidden",
          children: parse$1(JSON.parse(mobile_image))
        }, void 0, false, {
          fileName: _jsxFileName$1f,
          lineNumber: 48,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1f,
        lineNumber: 41,
        columnNumber: 11
      }, this), u("div", {
        className: "w-full md:w-4/12",
        children: [eyebrow_text && u("p", {
          className: "font-secondary italic text-eyebrow-md text-black",
          children: eyebrow_text
        }, void 0, false, {
          fileName: _jsxFileName$1f,
          lineNumber: 54,
          columnNumber: 15
        }, this), title && u(Component, {
          className: "font-primary my-4 text-4xl md:text-5xl text-black",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$1f,
          lineNumber: 59,
          columnNumber: 15
        }, this), content && u("div", {
          className: twMerge("font-primary my-6 md:my-8 text-sm md:text-base text-black"),
          children: parse$1(content)
        }, void 0, false, {
          fileName: _jsxFileName$1f,
          lineNumber: 64,
          columnNumber: 15
        }, this), cta_text && u("div", {
          className: "md:flex md:mt-4",
          children: u(Button, {
            to: cta_link,
            mode: "secondary",
            className: "min-w-[253px]",
            children: cta_text
          }, void 0, false, {
            fileName: _jsxFileName$1f,
            lineNumber: 74,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1f,
          lineNumber: 73,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1f,
        lineNumber: 52,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1f,
      lineNumber: 35,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1f,
    lineNumber: 33,
    columnNumber: 5
  }, this);
}
register(FeaturedCallToAction, "featured-cta");
var _jsxFileName$1e = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/FeaturedCallToAction2Col.tsx";
function FeaturedCallToAction2Col({
  eyebrow_text,
  title,
  content,
  cta_text,
  cta_link,
  desktop_image_left,
  desktop_image_right,
  mobile_image,
  mode,
  html_tag_for_title
}) {
  const Component = html_tag_for_title;
  return u("div", {
    className: "flex container flex-col gap-6 md:gap-12",
    children: (eyebrow_text || title || content) && u("div", {
      className: twMerge("flex flex-col md:flex-row gap-6 md:gap-x-5 justify-between", mode == "right" && "md:flex-row-reverse"),
      children: [u("div", {
        className: "w-full lg:w-1/2",
        children: [desktop_image_left && desktop_image_right && u("div", {
          className: "hidden lg:flex items-start gap-3",
          children: [u("div", {
            children: parse$1(JSON.parse(desktop_image_left))
          }, void 0, false, {
            fileName: _jsxFileName$1e,
            lineNumber: 46,
            columnNumber: 17
          }, this), u("div", {
            children: parse$1(JSON.parse(desktop_image_right))
          }, void 0, false, {
            fileName: _jsxFileName$1e,
            lineNumber: 47,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1e,
          lineNumber: 45,
          columnNumber: 15
        }, this), mobile_image && u("div", {
          className: "lg:hidden",
          children: parse$1(JSON.parse(mobile_image))
        }, void 0, false, {
          fileName: _jsxFileName$1e,
          lineNumber: 52,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1e,
        lineNumber: 43,
        columnNumber: 11
      }, this), u("div", {
        className: twMerge("w-full lg:w-1/2", mode == "right" ? "lg:pr-[16%]" : "lg:pl-[8%]"),
        children: [eyebrow_text && u("p", {
          className: "font-secondary italic text-eyebrow-md text-black",
          children: eyebrow_text
        }, void 0, false, {
          fileName: _jsxFileName$1e,
          lineNumber: 63,
          columnNumber: 15
        }, this), title && u(Component, {
          className: "font-primary mb-4 text-4xl md:text-6xl text-black",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$1e,
          lineNumber: 68,
          columnNumber: 15
        }, this), content && u("div", {
          className: twMerge("font-primary my-6 md:my-8 text-sm lg:text-base text-black"),
          children: parse$1(content)
        }, void 0, false, {
          fileName: _jsxFileName$1e,
          lineNumber: 73,
          columnNumber: 15
        }, this), cta_text && u("div", {
          className: "md:flex md:mt-4",
          children: u(Button, {
            to: cta_link,
            mode: "secondary",
            className: "min-w-[253px]",
            children: cta_text
          }, void 0, false, {
            fileName: _jsxFileName$1e,
            lineNumber: 83,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1e,
          lineNumber: 82,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1e,
        lineNumber: 56,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1e,
      lineNumber: 37,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1e,
    lineNumber: 35,
    columnNumber: 5
  }, this);
}
register(FeaturedCallToAction2Col, "featured-cta-2col");
var _jsxFileName$1d = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/FeaturedTestimonial.tsx";
function FeaturedTestimonial({
  subtitle,
  content,
  name,
  description_title,
  desktop_image,
  mobile_image,
  mode,
  html_tag_for_title
}) {
  const Component = html_tag_for_title;
  return u("section", {
    children: (subtitle || description_title || content || name) && u("div", {
      className: twMerge("flex flex-col md:flex-row gap-10", mode == "right" && "md:flex-row-reverse"),
      children: [u("div", {
        className: "md:flex-1",
        children: [desktop_image && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image))
        }, void 0, false, {
          fileName: _jsxFileName$1d,
          lineNumber: 40,
          columnNumber: 15
        }, this), mobile_image && u("div", {
          className: "md:hidden px-4 md:px-0",
          children: parse$1(JSON.parse(mobile_image))
        }, void 0, false, {
          fileName: _jsxFileName$1d,
          lineNumber: 46,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1d,
        lineNumber: 38,
        columnNumber: 11
      }, this), u("div", {
        className: "w-full md:flex-1 container flex flex-col justify-center items-center",
        children: [subtitle && u(Component, {
          className: "font-primary text-[12px] font-medium text-[#0A0B0D] tracking-[5%] uppercase mb-6",
          children: subtitle
        }, void 0, false, {
          fileName: _jsxFileName$1d,
          lineNumber: 54,
          columnNumber: 15
        }, this), content && u("div", {
          className: twMerge("font-secondary font-light italic text-[30px]/[1] tracking-[-4%] text-center mb-6 md:w-[70%] lg:w-[55%] text-balance"),
          children: parse$1(content)
        }, void 0, false, {
          fileName: _jsxFileName$1d,
          lineNumber: 59,
          columnNumber: 15
        }, this), name && u("div", {
          className: "font-primary font-medium text-[14px] md:text-base mb-1 text-[#0A0B0D]",
          children: parse$1(name)
        }, void 0, false, {
          fileName: _jsxFileName$1d,
          lineNumber: 68,
          columnNumber: 15
        }, this), description_title && u("div", {
          className: "font-primary text-[12px] md:text-sm mb-1 text-tints-80 font-[450] capitalize",
          children: parse$1(description_title)
        }, void 0, false, {
          fileName: _jsxFileName$1d,
          lineNumber: 77,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1d,
        lineNumber: 52,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1d,
      lineNumber: 32,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1d,
    lineNumber: 30,
    columnNumber: 5
  }, this);
}
register(FeaturedTestimonial, "featured-testimonial");
var _jsxFileName$1c = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/SoundIcon.tsx";
function SoundIcon(props) {
  return u("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "aria-label": "Sound Icon",
    children: [u("path", {
      d: "M7 7.75V8.375H7.20833L7.375 8.25L7 7.75ZM10 5.5H10.625V4.25L9.625 5L10 5.5ZM4 7.75V7.125H3.375V7.75H4ZM4 12.25H3.375V12.875H4V12.25ZM7 12.25L7.375 11.75L7.20833 11.625H7V12.25ZM10 14.5L9.625 15L10.625 15.75V14.5H10ZM7.375 8.25L10.375 6L9.625 5L6.625 7.25L7.375 8.25ZM4 8.375H7V7.125H4V8.375ZM4.625 12.25V7.75H3.375V12.25H4.625ZM7 11.625H4V12.875H7V11.625ZM10.375 14L7.375 11.75L6.625 12.75L9.625 15L10.375 14ZM9.375 5.5V14.5H10.625V5.5H9.375Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1c,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("path", {
      d: "M12 8V12",
      stroke: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1c,
      lineNumber: 16,
      columnNumber: 7
    }, this), u("path", {
      d: "M14 7V13",
      stroke: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1c,
      lineNumber: 17,
      columnNumber: 7
    }, this), u("path", {
      d: "M16 6V14",
      stroke: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1c,
      lineNumber: 18,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1c,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1b = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/PauseIcon.tsx";
function PauseIcon(props) {
  return u("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "aria-label": "Pause Icon",
    children: [u("rect", {
      x: "7",
      y: "5",
      width: "2",
      height: "10",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1b,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("rect", {
      x: "11",
      y: "5",
      width: "2",
      height: "10",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1b,
      lineNumber: 13,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1b,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$1a = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/PlayIcon.tsx";
function PlayIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    ...props,
    "aria-label": "Play Icon",
    children: u("path", {
      d: "M14.5 10L6.5 15L6.5 5L14.5 10Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$1a,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1a,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$19 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/SoundMutedIcon.tsx";
function SoundMutedIcon(props) {
  return u("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "aria-label": "Sound Muted Icon",
    children: [u("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }, void 0, false, {
      fileName: _jsxFileName$19,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("path", {
      d: "M7 7.75V8.375H7.20833L7.375 8.25L7 7.75ZM10 5.5H10.625V4.25L9.625 5L10 5.5ZM4 7.75V7.125H3.375V7.75H4ZM4 12.25H3.375V12.875H4V12.25ZM7 12.25L7.375 11.75L7.20833 11.625H7V12.25ZM10 14.5L9.625 15L10.625 15.75V14.5H10ZM7.375 8.25L10.375 6L9.625 5L6.625 7.25L7.375 8.25ZM4 8.375H7V7.125H4V8.375ZM4.625 12.25V7.75H3.375V12.25H4.625ZM7 11.625H4V12.875H7V11.625ZM10.375 14L7.375 11.75L6.625 12.75L9.625 15L10.375 14ZM9.375 5.5V14.5H10.625V5.5H9.375Z",
      fill: "#1B1B1B"
    }, void 0, false, {
      fileName: _jsxFileName$19,
      lineNumber: 13,
      columnNumber: 7
    }, this), u("path", {
      d: "M12 7.5L17 12.5",
      stroke: "black"
    }, void 0, false, {
      fileName: _jsxFileName$19,
      lineNumber: 17,
      columnNumber: 7
    }, this), u("path", {
      d: "M17 7.5L12 12.5",
      stroke: "black"
    }, void 0, false, {
      fileName: _jsxFileName$19,
      lineNumber: 18,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$19,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$18 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/GridWidthHero.tsx";
function GridWidthHero({
  eyebrow_text,
  title,
  content,
  video,
  desktop_image,
  mobile_image,
  html_tag_for_title,
  section_id
}) {
  const Component = html_tag_for_title;
  const videoRef = t$2(A$1(null), "videoRef");
  const [isPlaying, setIsPlaying] = t$2(h(true), "isPlaying");
  const [isMuted, setIsMuted] = t$2(h(true), "isMuted");
  y(() => {
    const videoElement = document.querySelector(`.video-${section_id}`);
    if (videoElement) {
      videoRef.current = videoElement;
    }
    return () => {
      videoRef.current = null;
    };
  }, [video, section_id]);
  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const handleMuteUnmute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };
  return u("div", {
    className: "flex container flex-col gap-6 md:gap-12",
    children: [(eyebrow_text || title || content) && u("div", {
      className: twMerge("flex flex-col md:flex-row gap-4"),
      children: [(eyebrow_text || title) && u("div", {
        className: twMerge("w-full md:2-1/2 flex flex-col gap-3"),
        children: [eyebrow_text && u("p", {
          className: twMerge("font-secondary text-2xl italic"),
          children: eyebrow_text
        }, void 0, false, {
          fileName: _jsxFileName$18,
          lineNumber: 77,
          columnNumber: 17
        }, this), title && u(Component, {
          className: twMerge("font-primary text-6xl leading-none md:text-7xl"),
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$18,
          lineNumber: 82,
          columnNumber: 17
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$18,
        lineNumber: 75,
        columnNumber: 13
      }, this), content && u("div", {
        className: twMerge("w-full md:max-w-[412px] flex flex-col justify-end font-primary text-sm"),
        children: parse$1(content)
      }, void 0, false, {
        fileName: _jsxFileName$18,
        lineNumber: 93,
        columnNumber: 13
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$18,
      lineNumber: 73,
      columnNumber: 9
    }, this), (video || desktop_image && mobile_image) && u("div", {
      children: video ? u("div", {
        className: twMerge("relative"),
        children: [parse$1(JSON.parse(video)), u("div", {
          className: twMerge("flex absolute bottom-3 left-3 gap-4"),
          children: [u("button", {
            onClick: handleMuteUnmute,
            className: twMerge("bg-white text-black w-5 h-5"),
            children: isMuted ? u(SoundIcon, {}, void 0, false, {
              fileName: _jsxFileName$18,
              lineNumber: 114,
              columnNumber: 30
            }, this) : u(SoundMutedIcon, {}, void 0, false, {
              fileName: _jsxFileName$18,
              lineNumber: 114,
              columnNumber: 46
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$18,
            lineNumber: 109,
            columnNumber: 17
          }, this), u("button", {
            onClick: handlePlayPause,
            className: twMerge("bg-white text-black w-5 h-5"),
            children: isPlaying ? u(PauseIcon, {}, void 0, false, {
              fileName: _jsxFileName$18,
              lineNumber: 120,
              columnNumber: 32
            }, this) : u(PlayIcon, {}, void 0, false, {
              fileName: _jsxFileName$18,
              lineNumber: 120,
              columnNumber: 48
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$18,
            lineNumber: 116,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$18,
          lineNumber: 108,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$18,
        lineNumber: 106,
        columnNumber: 13
      }, this) : desktop_image && mobile_image ? u("div", {
        children: [desktop_image && u("div", {
          className: twMerge("hidden md:block"),
          children: parse$1(JSON.parse(desktop_image))
        }, void 0, false, {
          fileName: _jsxFileName$18,
          lineNumber: 127,
          columnNumber: 17
        }, this), mobile_image && u("div", {
          className: twMerge("md:hidden"),
          children: parse$1(JSON.parse(mobile_image))
        }, void 0, false, {
          fileName: _jsxFileName$18,
          lineNumber: 132,
          columnNumber: 17
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$18,
        lineNumber: 125,
        columnNumber: 13
      }, this) : ""
    }, void 0, false, {
      fileName: _jsxFileName$18,
      lineNumber: 104,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$18,
    lineNumber: 71,
    columnNumber: 5
  }, this);
}
register(GridWidthHero, "grid-width-hero");
var _jsxFileName$17 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/HelloWorld.tsx";
function HelloWorld({
  firstName,
  lastName,
  initialCount = 1
}) {
  const [counter, setCounter] = t$2(h(initialCount | 1), "counter");
  return u(b$2, {
    children: [u("h1", {
      children: ["Hello ", firstName, " ", lastName]
    }, void 0, true, {
      fileName: _jsxFileName$17,
      lineNumber: 28,
      columnNumber: 7
    }, this), u("p", {
      className: "font-primary",
      children: ["Counter: ", counter]
    }, void 0, true, {
      fileName: _jsxFileName$17,
      lineNumber: 32,
      columnNumber: 7
    }, this), u("button", {
      children: "Increase Counter"
    }, void 0, false, {
      fileName: _jsxFileName$17,
      lineNumber: 33,
      columnNumber: 7
    }, this)]
  }, void 0);
}
register(HelloWorld, "hello-world");
var _jsxFileName$16 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/HeroDoubleImage.tsx";
function HeroDoubleImage({
  title,
  titleTag = "h2",
  content,
  desktopImage,
  mobileImage
}) {
  const Component = titleTag;
  return u("div", {
    className: "container",
    children: u("div", {
      children: [desktopImage && u("div", {
        className: "hidden md:block",
        children: parse$1(JSON.parse(desktopImage))
      }, void 0, false, {
        fileName: _jsxFileName$16,
        lineNumber: 25,
        columnNumber: 11
      }, this), mobileImage && u("div", {
        className: "md:hidden",
        children: parse$1(JSON.parse(mobileImage))
      }, void 0, false, {
        fileName: _jsxFileName$16,
        lineNumber: 30,
        columnNumber: 11
      }, this), u("div", {
        className: "w-full md:flex justify-between pt-6 md:pt-10",
        children: u("div", {
          className: "md:pb-10 md:grid md:grid-cols-2",
          children: [title && u(Component, {
            className: "font-primary tracking-[-0.04em] md:tracking-[-0.03em] text-5xl mb-4 md:mb-0 md:text-7xl text-black md:pr-36",
            children: title
          }, void 0, false, {
            fileName: _jsxFileName$16,
            lineNumber: 35,
            columnNumber: 15
          }, this), content && u("p", {
            className: "font-primary text-black text-2xl md:text-4xl md:pr-36",
            children: content
          }, void 0, false, {
            fileName: _jsxFileName$16,
            lineNumber: 40,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$16,
          lineNumber: 33,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$16,
        lineNumber: 32,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$16,
      lineNumber: 23,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$16,
    lineNumber: 22,
    columnNumber: 5
  }, this);
}
register(HeroDoubleImage, "hero-double-image", ["title", "content", "desktopImage", "mobileImage", "paddingYDesktop", "paddingYMobile"]);
var _jsxFileName$15 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/HeroFullWidth.tsx";
function HeroFullWidth({
  eyebrowText,
  title,
  titleTag = "h2",
  disclaimer,
  buttonLink,
  buttonLabel,
  desktopImage,
  mobileImage,
  template: template2
}) {
  const Component = titleTag;
  const heroRef = t$2(A$1(null), "heroRef");
  const handleDataLayer = (eventType) => {
    const trackingId = template2 == "index" ? "homepage" : template2 == "collections" ? "collection" : template2 == "article" ? "article" : template2 == "product" ? "product" : template2 == "cart" ? "cart" : "other";
    const trackingName = title || "";
    const creativeName = "Hero Full Width";
    sendDatalayer({
      event: eventType == "view" ? "promo_view" : "promo_click",
      ecommerce: {
        [eventType == "view" ? "promoView" : "promoClick"]: {
          promotions: [{
            id: trackingId,
            name: trackingName,
            creative: creativeName,
            position: 1
          }]
        }
      }
    });
  };
  y(() => {
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          handleDataLayer("view");
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "0px",
      threshold: 0
    });
    if (heroRef.current) {
      observer.observe(heroRef.current);
    }
    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);
  return u("div", {
    ref: heroRef,
    className: "relative",
    onClick: () => {
      handleDataLayer("click");
    },
    children: [u("div", {
      className: "absolute inset-x-0 z-[1] bottom-6 md:bottom-12 w-full md:flex md:gap-x-5 items-end container",
      children: [u("div", {
        className: twMerge(disclaimer && "md:max-w-[33%]"),
        children: [eyebrowText && u("p", {
          className: "font-secondary italic text-eyebrow-md text-white",
          children: eyebrowText
        }, void 0, false, {
          fileName: _jsxFileName$15,
          lineNumber: 103,
          columnNumber: 13
        }, this), title && u(Component, {
          className: "font-primary py-4 -tracking-[0.04em] text-6xl md:text-7xl text-white",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$15,
          lineNumber: 108,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$15,
        lineNumber: 101,
        columnNumber: 9
      }, this), disclaimer && u("div", {
        className: twMerge("text-center"),
        children: u("p", {
          className: "font-primary text-white text-xs",
          children: disclaimer
        }, void 0, false, {
          fileName: _jsxFileName$15,
          lineNumber: 115,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$15,
        lineNumber: 114,
        columnNumber: 11
      }, this), buttonLabel && u(Button, {
        to: buttonLink,
        tone: "inverted",
        className: "md:ml-auto lg:min-w-[353px]",
        children: buttonLabel
      }, void 0, false, {
        fileName: _jsxFileName$15,
        lineNumber: 119,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$15,
      lineNumber: 100,
      columnNumber: 7
    }, this), desktopImage && u("div", {
      className: "hidden md:block",
      children: u("div", {
        className: twMerge("relative aspect-[2/1] max-h-[720px] w-full h-full bg-cover bg-center overflow-hidden"),
        style: {
          backgroundImage: `url(${desktopImage})`
        },
        children: u("div", {
          className: twMerge("absolute -bottom-3 left-0 w-full h-full bg-cover bg-center pointer-events-none"),
          style: {
            backgroundImage: `url(${desktopImage})`,
            maskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.25) 45%, rgba(0, 0, 0, 0) 60%)",
            WebkitMaskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.25) 45%, rgba(0, 0, 0, 0) 60%)",
            filter: "blur(15px)",
            opacity: 1
          }
        }, void 0, false, {
          fileName: _jsxFileName$15,
          lineNumber: 136,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$15,
        lineNumber: 130,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$15,
      lineNumber: 129,
      columnNumber: 9
    }, this), mobileImage && u("div", {
      className: "md:hidden",
      children: u("div", {
        className: twMerge("relative aspect-[393/520] w-full h-full bg-cover bg-center overflow-hidden"),
        style: {
          backgroundImage: `url(${mobileImage})`
        },
        children: u("div", {
          className: twMerge("absolute -bottom-3 left-0 w-full h-full bg-cover bg-center pointer-events-none"),
          style: {
            backgroundImage: `url(${mobileImage})`,
            maskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.25) 45%, rgba(0, 0, 0, 0) 60%)",
            WebkitMaskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.25) 45%, rgba(0, 0, 0, 0) 50%)",
            filter: "blur(15px)",
            opacity: 1
          }
        }, void 0, false, {
          fileName: _jsxFileName$15,
          lineNumber: 161,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$15,
        lineNumber: 155,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$15,
      lineNumber: 154,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$15,
    lineNumber: 93,
    columnNumber: 5
  }, this);
}
register(HeroFullWidth, "hero-full-width", ["eyebrowText", "title", "disclaimer", "buttonLink", "buttonLabel", "desktopImage", "mobileImage"]);
var _jsxFileName$14 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/LinkedCard.tsx";
function LinkedCard({
  title,
  children,
  link,
  titleTag = "h3"
}) {
  const Component = titleTag;
  return u(b$2, {
    children: [u("slot", {}, void 0, false, {
      fileName: _jsxFileName$14,
      lineNumber: 22,
      columnNumber: 7
    }, this), u("a", {
      href: link,
      className: cn("p-4 pr-9 relative flex flex-col gap-2 mt-auto rounded-md bg-white min-h-[116px] w-full justify-between w-full"),
      children: [u(UpperRightArrow, {
        className: "absolute top-3 right-3"
      }, void 0, false, {
        fileName: _jsxFileName$14,
        lineNumber: 29,
        columnNumber: 9
      }, this), title && u(Component, {
        className: "font-primary text-4xl line-clamp-2",
        children: title
      }, void 0, false, {
        fileName: _jsxFileName$14,
        lineNumber: 31,
        columnNumber: 11
      }, this), children && u("p", {
        className: "font-primary text-button-lg",
        children
      }, void 0, false, {
        fileName: _jsxFileName$14,
        lineNumber: 35,
        columnNumber: 22
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$14,
      lineNumber: 23,
      columnNumber: 7
    }, this)]
  }, void 0);
}
register(LinkedCard, "linked-card", ["title", "link", "title-tag", "children"]);
var _jsxFileName$13 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Search.tsx";
function Search(props) {
  return u("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "aria-label": "Search Icon",
    children: [u("circle", {
      cx: "10",
      cy: "10",
      r: "6",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$13,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("path", {
      d: "M14 14L20 20",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$13,
      lineNumber: 13,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$13,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$12 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/SearchResultsTabs.tsx";
function SearchResultsTabs({
  isFetching,
  searchResults
}) {
  var _a;
  const getSearchResultsJson = typeof searchResults === "string" ? JSON.parse(searchResults) : searchResults;
  let labelProducts = "products";
  let labelArticles = "articles";
  const [activeTab, setActiveTab] = t$2(h(labelProducts), "activeTab");
  const [allProducts, setAllProducts] = t$2(h([]), "allProducts");
  y(() => {
    var _a2, _b, _c, _d;
    if (((_b = (_a2 = window.POWERREVIEWS) == null ? void 0 : _a2.display) == null ? void 0 : _b.render) instanceof Function) {
      const allProductsWithReviews = (_c = getSearchResultsJson == null ? void 0 : getSearchResultsJson.products) == null ? void 0 : _c.map((product, index) => {
        return {
          ...product,
          components: {
            CategorySnippet: `${product.id}-${index}`
          }
        };
      });
      setAllProducts((prev) => allProductsWithReviews);
      const reviewsId = (_d = getSearchResultsJson == null ? void 0 : getSearchResultsJson.products) == null ? void 0 : _d.map((product, index) => {
        return {
          api_key: window.pwrCredentials.api_key,
          locale: window.pwrCredentials.locale,
          merchant_group_id: window.pwrCredentials.merchant_group_id,
          merchant_id: window.pwrCredentials.merchant_id,
          page_id: product.id,
          components: {
            CategorySnippet: `${product.id}-${index}`
          }
        };
      });
      setTimeout(() => {
        if (reviewsId) window.POWERREVIEWS.display.render(reviewsId);
      }, 500);
    }
  }, [searchResults, activeTab]);
  return u(b$2, {
    children: [u("div", {
      className: "mt-4 md:mt-8 flex gap-4 border-b border-tints-20",
      children: [u("button", {
        className: twMerge("py-2 text-black text-button-sm uppercase font-primary font-medium border-b border-b-[3px]", activeTab === labelProducts ? "border-black" : "border-transparent"),
        value: labelProducts,
        onClick: (e2) => setActiveTab(e2.currentTarget.value),
        children: labelProducts
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 65,
        columnNumber: 9
      }, this), u("button", {
        className: twMerge("py-2 text-black text-button-sm uppercase font-primary font-medium border-b border-b-[3px]", activeTab === labelArticles ? "border-black" : "border-transparent"),
        value: labelArticles,
        onClick: (e2) => setActiveTab(e2.currentTarget.value),
        children: labelArticles
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 75,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$12,
      lineNumber: 63,
      columnNumber: 7
    }, this), activeTab === labelProducts && u(b$2, {
      children: isFetching ? u("span", {
        className: twMerge("text-black text-4xl flex items-center justify-center min-h-[calc(100vh-200px)]"),
        children: "Loading..."
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 91,
        columnNumber: 13
      }, this) : (allProducts == null ? void 0 : allProducts.length) > 0 ? u("div", {
        className: twMerge("my-6 grid grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-8"),
        children: allProducts.map((product) => {
          var _a2;
          return u(ProductCard, {
            product: JSON.stringify(product),
            id: (_a2 = product == null ? void 0 : product.components) == null ? void 0 : _a2.CategorySnippet
          }, void 0, false, {
            fileName: _jsxFileName$12,
            lineNumber: 105,
            columnNumber: 17
          }, this);
        })
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 99,
        columnNumber: 13
      }, this) : u("span", {
        className: twMerge("text-black text-4xl flex items-center justify-center min-h-[calc(100vh-200px)]"),
        children: "No Results Found"
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 112,
        columnNumber: 13
      }, this)
    }, void 0, false), activeTab === labelArticles && u(b$2, {
      children: isFetching ? u("span", {
        className: twMerge("text-black text-4xl flex items-center justify-center min-h-[calc(100vh-200px)]"),
        children: "Loading..."
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 127,
        columnNumber: 13
      }, this) : ((_a = getSearchResultsJson == null ? void 0 : getSearchResultsJson.articles) == null ? void 0 : _a.length) > 0 ? u("div", {
        className: twMerge("my-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-8"),
        children: getSearchResultsJson == null ? void 0 : getSearchResultsJson.articles.map((article) => u(ArticleCard, {
          article: JSON.stringify(article)
        }, void 0, false, {
          fileName: _jsxFileName$12,
          lineNumber: 141,
          columnNumber: 17
        }, this))
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 135,
        columnNumber: 13
      }, this) : u("span", {
        className: twMerge("text-black text-4xl flex items-center justify-center min-h-[calc(100vh-200px)]"),
        children: "No Results Found"
      }, void 0, false, {
        fileName: _jsxFileName$12,
        lineNumber: 145,
        columnNumber: 13
      }, this)
    }, void 0, false)]
  }, void 0);
}
register(SearchResultsTabs, "search-results-tabs");
var _jsxFileName$11 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/MainSearch.tsx";
function MainSearch({
  search_url,
  featured_products,
  collection_title
}) {
  const [isFetching, setIsFetching] = t$2(h(false), "isFetching");
  const [searchResults, setSearchResults] = t$2(h(null), "searchResults");
  const [searchValue, setSearchValue] = t$2(h(""), "searchValue");
  const [debounceTimer, setDebounceTimer] = t$2(h(null), "debounceTimer");
  const [debounceTime, setDebounceTime] = t$2(h(500), "debounceTime");
  const [featuredProducts, setFeaturedProducts] = t$2(h([]), "featuredProducts");
  y(() => {
    search(searchValue);
  }, [searchValue]);
  y(() => {
    var _a, _b;
    const featuredProducts2 = typeof featured_products === "string" ? JSON.parse(featured_products) : featured_products;
    if (((_b = (_a = window.POWERREVIEWS) == null ? void 0 : _a.display) == null ? void 0 : _b.render) instanceof Function) {
      const allProductsWithReviews = featuredProducts2 == null ? void 0 : featuredProducts2.map((product, index) => {
        return {
          ...product,
          components: {
            CategorySnippet: `${product.id}-${index}`
          }
        };
      });
      setFeaturedProducts((prev) => allProductsWithReviews);
      const reviewsId = featuredProducts2 == null ? void 0 : featuredProducts2.map((product, index) => {
        return {
          api_key: window.pwrCredentials.api_key,
          locale: window.pwrCredentials.locale,
          merchant_group_id: window.pwrCredentials.merchant_group_id,
          merchant_id: window.pwrCredentials.merchant_id,
          page_id: product.id,
          components: {
            CategorySnippet: `${product.id}-${index}`
          }
        };
      });
      setTimeout(() => {
        if (reviewsId) window.POWERREVIEWS.display.render(reviewsId);
      }, 500);
    }
  }, [featured_products]);
  function setInputValue(value) {
    setSearchValue(value);
  }
  const handleInput = debounce((value) => {
    setInputValue(value);
  }, debounceTime);
  async function search(value) {
    var _a, _b, _c, _d;
    if (searchValue.trim().length > 0) {
      const sectionId = "predictive-search-results";
      const url = `/search/suggest?q=${value}&resources[type]=product,article&section_id=${sectionId}`;
      sendDatalayer({
        event: "site_search",
        searchTerm: value,
        userId: ((_b = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.customer) == null ? void 0 : _b.id) || "",
        userCategory: ((_d = (_c = window == null ? void 0 : window.theme) == null ? void 0 : _c.customer) == null ? void 0 : _d.status) || ""
      });
      const results = await getSearchResultsJson(url);
      setSearchResults(results);
    }
  }
  async function getSearchResultsJson(url) {
    var _a;
    try {
      setIsFetching(true);
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`Error: ${res.status} ${res.statusText}`);
      }
      const responseData = await res.text();
      const responseHTML = new DOMParser();
      const resultsMarkup = responseHTML != null ? (_a = responseHTML == null ? void 0 : responseHTML.parseFromString(responseData, "text/html")) == null ? void 0 : _a.querySelector("#shopify-section-predictive-search-results").innerHTML : null;
      const jsonData = JSON.parse(resultsMarkup);
      return jsonData;
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsFetching(false);
    }
  }
  function debounce(func, delay) {
    return (...args) => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      const newDebounceTimer = setTimeout(() => {
        func(...args);
      }, delay);
      setDebounceTimer(newDebounceTimer);
    };
  }
  return u("div", {
    className: "absolute top-[55px] pt-2 z-50 bottom-0 left-0 right-0 bg-white border-t border-tint-20 overflow-auto h-[calc(100vh-75px)]",
    children: u("div", {
      className: "container",
      children: [u("form", {
        action: search_url,
        children: u("div", {
          className: twMerge("flex items-center gap-2"),
          children: [u(Search, {}, void 0, false, {
            fileName: _jsxFileName$11,
            lineNumber: 143,
            columnNumber: 13
          }, this), u("input", {
            className: twMerge("text-base text-black font-primary placeholder:text-tints-80 focus:outline-none pr-2 py-2 w-full max-w-none"),
            onInput: (e2) => handleInput(e2.currentTarget.value),
            type: "text",
            placeholder: "Search for anything...",
            name: "q"
          }, void 0, false, {
            fileName: _jsxFileName$11,
            lineNumber: 144,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$11,
          lineNumber: 142,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$11,
        lineNumber: 141,
        columnNumber: 9
      }, this), searchValue.trim().length > 0 ? u(SearchResultsTabs, {
        searchResults: JSON.stringify(searchResults),
        isFetching
      }, void 0, false, {
        fileName: _jsxFileName$11,
        lineNumber: 157,
        columnNumber: 11
      }, this) : u("div", {
        className: "mt-8",
        children: [u("p", {
          className: "text-2xl font-primary",
          children: collection_title
        }, void 0, false, {
          fileName: _jsxFileName$11,
          lineNumber: 163,
          columnNumber: 13
        }, this), (featuredProducts == null ? void 0 : featuredProducts.length) > 0 && u("div", {
          className: "grid grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-8 mb-6 mt-8",
          children: featuredProducts.map((product) => {
            var _a;
            return u(ProductCard, {
              product: JSON.stringify(product),
              id: (_a = product.components) == null ? void 0 : _a.CategorySnippet
            }, void 0, false, {
              fileName: _jsxFileName$11,
              lineNumber: 167,
              columnNumber: 19
            }, this);
          })
        }, void 0, false, {
          fileName: _jsxFileName$11,
          lineNumber: 165,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$11,
        lineNumber: 162,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$11,
      lineNumber: 140,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$11,
    lineNumber: 139,
    columnNumber: 5
  }, this);
}
register(MainSearch, "main-search");
var _jsxFileName$10 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Close.tsx";
function CloseIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    ...props,
    fill: "none",
    children: [u("path", {
      d: "M6 6.00003L17.9999 18",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$10,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("path", {
      d: "M6 18L17.9999 6.00002",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$10,
      lineNumber: 12,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$10,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$$ = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Hide.tsx";
function HideIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "20",
    fill: "none",
    ...props,
    "aria-label": "Hide Icon",
    children: u("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M21 9c-2.7778 4.0404-7.5234 6-10 6-2.47664 0-6.11111-1.4545-10-6"
    }, void 0, false, {
      fileName: _jsxFileName$$,
      lineNumber: 11,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$$,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$_ = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Show.tsx";
function ShowIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "20",
    fill: "none",
    ...props,
    "aria-label": "Show Icon",
    children: [u("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M21 10c-2.7778 4.0404-7.5234 6-10 6-2.47664 0-6.11111-1.4545-10-6 3.33333-3.53535 6.91469-6 10-6 3.3333 0 7.2222 2.9697 10 6Z"
    }, void 0, false, {
      fileName: _jsxFileName$_,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M11 13c1.6569 0 3-1.3431 3-3 0-1.65685-1.3431-3-3-3-1.65685 0-3 1.34315-3 3 0 1.6569 1.34315 3 3 3Z"
    }, void 0, false, {
      fileName: _jsxFileName$_,
      lineNumber: 17,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$_,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$Z = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Email.tsx";
function EmailIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    ...props,
    children: u("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M4 16 16 4M7 4h9v9"
    }, void 0, false, {
      fileName: _jsxFileName$Z,
      lineNumber: 10,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$Z,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$Y = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/forms/TextField.tsx";
const TextField = (props) => {
  const {
    description,
    error,
    label,
    type,
    additionalStyles,
    ...rest
  } = props;
  const [fieldType, setFieldType] = t$2(h(type), "fieldType");
  const toggleFieldView = () => {
    fieldType == "password" ? setFieldType("text") : setFieldType("password");
  };
  return u("div", {
    className: "relative w-full space-y-1",
    children: [false, description && u("div", {
      className: "text-sm text-tints-40",
      children: description
    }, void 0, false, {
      fileName: _jsxFileName$Y,
      lineNumber: 35,
      columnNumber: 9
    }, void 0), u("input", {
      "aria-label": label,
      placeholder: label,
      className: clsx$1(["peer w-full appearance-none border bg-white px-2 py-2 text-sm leading-field outline-none", "disabled:opacity-50 disabled:border-transparent disabled:hover:border-transparent", "hover:border-tints-40", "active:text-black", "focus:border-dashed", "placeholder-shown:text-tints-80", error ? "border-raspberry text-raspberry placeholder:text-raspberry" : "border-tints-20 text-black", additionalStyles]),
      type: fieldType,
      ...rest
    }, void 0, false, {
      fileName: _jsxFileName$Y,
      lineNumber: 37,
      columnNumber: 7
    }, void 0), type == "password" && u("button", {
      className: clsx$1(["absolute flex items-center !m-0 right-2 top-3", "peer-disabled:opacity-50", error && "text-raspberry"]),
      type: "button",
      onClick: toggleFieldView,
      "aria-label": 'Toggle "Show Password" button',
      children: fieldType == "password" ? u(ShowIcon, {}, void 0, false, {
        fileName: _jsxFileName$Y,
        lineNumber: 65,
        columnNumber: 13
      }, void 0) : u(HideIcon, {}, void 0, false, {
        fileName: _jsxFileName$Y,
        lineNumber: 67,
        columnNumber: 13
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$Y,
      lineNumber: 54,
      columnNumber: 9
    }, void 0), type == "email" && u("div", {
      className: clsx$1(["absolute flex items-center !m-0 right-2 top-3", "peer-disabled:opacity-50", error && "text-raspberry"]),
      children: u(EmailIcon, {}, void 0, false, {
        fileName: _jsxFileName$Y,
        lineNumber: 79,
        columnNumber: 13
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$Y,
      lineNumber: 72,
      columnNumber: 9
    }, void 0), error && u("div", {
      className: "text-xs text-raspberry",
      children: error
    }, void 0, false, {
      fileName: _jsxFileName$Y,
      lineNumber: 83,
      columnNumber: 17
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$Y,
    lineNumber: 26,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$X = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/NotifyModal.tsx";
function NotifyModal() {
  const {
    selectedVariant,
    toggleNotifyMe,
    notifyMeIsOpen,
    selectedProduct
  } = useGlobal();
  const [emailError, setEmailError] = t$2(h(""), "emailError");
  const [subscribeError, setSubscribeError] = t$2(h(""), "subscribeError");
  const [BISSuccess, setBISSuccess] = t$2(h(false), "BISSuccess");
  const [subscribeSuccess, setSubscribeSuccess] = t$2(h(false), "subscribeSuccess");
  const [subscriber, setSubscriber] = t$2(h(false), "subscriber");
  const titleSubset = (selectedVariant == null ? void 0 : selectedVariant.title) == "Default Title" ? selectedProduct == null ? void 0 : selectedProduct.title : `${selectedProduct == null ? void 0 : selectedProduct.title} - ${selectedVariant == null ? void 0 : selectedVariant.title}`;
  y(() => {
    setBISSuccess(false);
  }, [notifyMeIsOpen]);
  const handleBISEvent = (event) => {
    event.preventDefault();
    const publicID = "PYAUyc";
    const newsLetterList = "QLTdJ4";
    const BISEndpoint = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${publicID}`;
    const NewsletterSubscribeEndpoint = `https://a.klaviyo.com/client/subscriptions?company_id=${publicID}`;
    const formData = new FormData(event.target);
    const formJson = Object.fromEntries(Array.from(formData.keys()).map((key) => [key, formData.getAll(key).length > 1 ? formData.getAll(key) : formData.get(key)]));
    const BISpayload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: formJson.email
              }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${selectedVariant == null ? void 0 : selectedVariant.id}`
            }
          }
        }
      }
    };
    const SubscribePayload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: formJson.email
              }
            }
          },
          custom_source: "BIS form"
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: newsLetterList
            }
          }
        }
      }
    };
    fetch(BISEndpoint, {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        revision: "2024-10-15",
        "content-type": "application/vnd.api+json"
      },
      body: JSON.stringify(BISpayload)
    }).then(async (result) => {
      let response;
      if (result && !result.ok) {
        response.errors.forEach((error) => {
          if (error.source.pointer.includes("email")) {
            return setEmailError(error.detail);
          }
        });
      } else {
        setEmailError("");
        setBISSuccess(true);
      }
    }).catch((error) => console.log("ERROR", error));
    if (subscriber) {
      fetch(NewsletterSubscribeEndpoint, {
        method: "POST",
        headers: {
          accept: "application/vnd.api+json",
          revision: "2024-10-15",
          "content-type": "application/vnd.api+json"
        },
        body: JSON.stringify(SubscribePayload)
      }).then(async (result) => {
        let response;
        if (result && !result.ok) {
          response = await result.json();
          setSubscribeError(response.errors[0].detail);
        } else {
          setSubscribeError("");
          setSubscribeSuccess(true);
        }
      }).catch((error) => console.log("ERROR", error));
    }
  };
  return u(b$2, {
    children: notifyMeIsOpen && u("div", {
      className: cn("fixed z-[9999999] top-0 left-0 w-screen h-screen grid place-content-center justify-center"),
      children: [u("div", {
        className: "relative z-50",
        children: u("div", {
          className: "modal-dialog relative py-8 px-6 bg-white rounded-md",
          role: "document",
          children: u("div", {
            className: "flex flex-col text-black",
            children: [u(CloseIcon, {
              className: "absolute cursor-pointer top-2 right-2",
              onClick: toggleNotifyMe
            }, void 0, false, {
              fileName: _jsxFileName$X,
              lineNumber: 161,
              columnNumber: 17
            }, this), BISSuccess && (subscriber ? subscribeSuccess : true) ? u("div", {
              className: "text-center pb-4 font-primary",
              children: [u("div", {
                className: "md:text-4xl pb-2",
                children: "Success!"
              }, void 0, false, {
                fileName: _jsxFileName$X,
                lineNumber: 167,
                columnNumber: 21
              }, this), u("p", {
                className: "text-sm",
                children: "You will be notified when this item comes back in stock."
              }, void 0, false, {
                fileName: _jsxFileName$X,
                lineNumber: 168,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$X,
              lineNumber: 166,
              columnNumber: 19
            }, this) : u(b$2, {
              children: [titleSubset && u("div", {
                className: "text-center pb-4 font-primary",
                children: [u("div", {
                  className: "text-3xl md:text-4xl pb-2 capitalize",
                  children: titleSubset
                }, void 0, false, {
                  fileName: _jsxFileName$X,
                  lineNumber: 176,
                  columnNumber: 25
                }, this), u("p", {
                  className: "text-sm",
                  children: "Register to be notified when this item comes back in stock."
                }, void 0, false, {
                  fileName: _jsxFileName$X,
                  lineNumber: 179,
                  columnNumber: 25
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$X,
                lineNumber: 175,
                columnNumber: 23
              }, this), u("div", {
                className: "font-primary",
                children: u("form", {
                  onSubmit: handleBISEvent,
                  children: [u(TextField, {
                    label: "Email Address",
                    id: "email",
                    name: "email",
                    placeholder: "Email Address",
                    error: emailError
                  }, void 0, false, {
                    fileName: _jsxFileName$X,
                    lineNumber: 187,
                    columnNumber: 25
                  }, this), u("div", {
                    className: "mt-5 mb-6",
                    children: u(CheckboxField, {
                      id: "subscribe_for_newsletter",
                      checked: subscriber,
                      onChangeCallback: () => setSubscriber(!subscriber),
                      label: "Add me to your email list",
                      error: subscribeError
                    }, void 0, false, {
                      fileName: _jsxFileName$X,
                      lineNumber: 195,
                      columnNumber: 27
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$X,
                    lineNumber: 194,
                    columnNumber: 25
                  }, this), u(Button, {
                    type: "submit",
                    className: "min-w-min w-full",
                    mode: "primary",
                    children: "Notify Me"
                  }, void 0, false, {
                    fileName: _jsxFileName$X,
                    lineNumber: 203,
                    columnNumber: 25
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$X,
                  lineNumber: 186,
                  columnNumber: 23
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$X,
                lineNumber: 185,
                columnNumber: 21
              }, this)]
            }, void 0, true)]
          }, void 0, true, {
            fileName: _jsxFileName$X,
            lineNumber: 160,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$X,
          lineNumber: 156,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$X,
        lineNumber: 155,
        columnNumber: 11
      }, this), u("div", {
        className: "absolute z-20 w-full h-full bg-black opacity-50",
        onClick: toggleNotifyMe
      }, void 0, false, {
        fileName: _jsxFileName$X,
        lineNumber: 217,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$X,
      lineNumber: 150,
      columnNumber: 9
    }, this)
  }, void 0);
}
register(NotifyModal, "notify-modal");
var _jsxFileName$W = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/OneColumn.tsx";
function OneColumn({
  eyebrow_text,
  title,
  content,
  desktop_image,
  mobile_image,
  mode,
  html_tag_for_title
}) {
  const Component = html_tag_for_title;
  return u("div", {
    className: "flex container flex-col gap-6 md:gap-12",
    children: (eyebrow_text || title || content) && u("div", {
      className: twMerge("flex flex-col md:flex-row gap-12", mode == "right" && "md:flex-row-reverse"),
      children: [u("div", {
        className: "w-full md:w-1/2",
        children: [desktop_image && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image))
        }, void 0, false, {
          fileName: _jsxFileName$W,
          lineNumber: 38,
          columnNumber: 15
        }, this), mobile_image && u("div", {
          className: "md:hidden",
          children: parse$1(JSON.parse(mobile_image))
        }, void 0, false, {
          fileName: _jsxFileName$W,
          lineNumber: 43,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$W,
        lineNumber: 36,
        columnNumber: 11
      }, this), u("div", {
        className: "w-full md:w-1/2",
        children: [eyebrow_text && u("p", {
          className: "font-secondary italic text-eyebrow-md text-black",
          children: eyebrow_text
        }, void 0, false, {
          fileName: _jsxFileName$W,
          lineNumber: 49,
          columnNumber: 15
        }, this), title && u(Component, {
          className: "font-primary py-4 text-4xl md:text-5xl text-black",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$W,
          lineNumber: 54,
          columnNumber: 15
        }, this), content && u("div", {
          className: twMerge("font-primary py-4 text-2xl md:text-4xl text-black"),
          children: parse$1(content)
        }, void 0, false, {
          fileName: _jsxFileName$W,
          lineNumber: 59,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$W,
        lineNumber: 47,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$W,
      lineNumber: 30,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$W,
    lineNumber: 28,
    columnNumber: 5
  }, this);
}
register(OneColumn, "one-column", ["eyebrow_text", "title", "content", "desktop_image", "mobile_image", "mode", "html_tag_for_title"]);
var _jsxFileName$V = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ProductCarousel.tsx";
function ProductCarousel({
  title,
  titleTag = "h2",
  subtitle,
  filters,
  products
}) {
  const Component = titleTag;
  const [carouselSlides, setCarouselSlides] = t$2(h([]), "carouselSlides");
  const [filterOptions, setFilterOptions] = t$2(h([]), "filterOptions");
  const [selectedFilter, setSelectedFilter] = t$2(h(""), "selectedFilter");
  y(() => {
    const filtersArray = filters.split(",").map((str) => {
      const filter = {
        label: null,
        value: null
      };
      if (str.length === 0) return filter;
      const array = str.split("|");
      filter.label = array[0];
      filter.value = array[1].toLowerCase();
      return filter;
    });
    const validFilterOptions = filtersArray.filter((filter) => filter.label !== null && filter.value !== null);
    setFilterOptions(validFilterOptions);
    if (validFilterOptions.length > 0 && !selectedFilter) {
      setSelectedFilter(validFilterOptions[0].value);
    }
    const productsJson = JSON.parse(products);
    let productsFiltered = productsJson;
    if (selectedFilter.length > 0) {
      productsFiltered = productsJson.filter((product) => {
        const tags = product.tags.toLowerCase().split(",");
        return tags.includes(selectedFilter);
      });
    }
    const allProductsWithReviews = productsFiltered.map((product, index) => {
      return {
        ...product,
        components: {
          CategorySnippet: `${product.id}-${index}`
        }
      };
    });
    const reviewsId = productsFiltered.map((product, index) => {
      return {
        api_key: window.pwrCredentials.api_key,
        locale: window.pwrCredentials.locale,
        merchant_group_id: window.pwrCredentials.merchant_group_id,
        merchant_id: window.pwrCredentials.merchant_id,
        page_id: product.id,
        components: {
          CategorySnippet: `${product.id}-${index}`
        }
      };
    });
    setCarouselSlides(allProductsWithReviews.map((product) => {
      var _a, _b;
      return u(ProductCard, {
        product: JSON.stringify(product),
        maxWidth: true,
        id: (_a = product.components) == null ? void 0 : _a.CategorySnippet
      }, (_b = product.components) == null ? void 0 : _b.CategorySnippet, false, {
        fileName: _jsxFileName$V,
        lineNumber: 90,
        columnNumber: 9
      }, this);
    }));
    setTimeout(() => {
      window.POWERREVIEWS.display.render(reviewsId);
    }, 500);
  }, [selectedFilter]);
  const filterHtml = filters && u("div", {
    className: "flex items-center gap-3 md:gap-2 pt-6 overflow-x-auto snap-x snap-mandatory pb-2 -mb-2 no-scrollbar",
    children: filterOptions.map((filter) => u("button", {
      onClick: () => handleSelectFilter(filter.value),
      className: clsx$1("py-1.5 px-4 border border-tints-10 rounded-[2.5rem] font-primary tracking-[0.05em] font-medium text-[12px] leading-[20px] uppercase transition duration-200 outline-raspberry snap-start shrink-0", selectedFilter === filter.value && "bg-black border-black text-white"),
      children: filter.label
    }, void 0, false, {
      fileName: _jsxFileName$V,
      lineNumber: 112,
      columnNumber: 9
    }, this))
  }, void 0, false, {
    fileName: _jsxFileName$V,
    lineNumber: 106,
    columnNumber: 5
  }, this);
  const handleSelectFilter = (filter) => {
    if (selectedFilter !== filter) {
      setSelectedFilter(filter);
    } else {
      setSelectedFilter("");
    }
  };
  return u("div", {
    className: "relative overflow-hidden",
    children: u(Carousel, {
      slides: carouselSlides,
      postHeader: filterHtml,
      children: u("div", {
        children: [title && u(Component, {
          className: clsx$1("font-primary text-4xl md:text-5xl tracking-tight leading-10"),
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$V,
          lineNumber: 140,
          columnNumber: 13
        }, this), subtitle && u("div", {
          className: "pt-2 font-primary tracking-wide text-sm md:text-base leading-4 text-tints-80",
          children: subtitle
        }, void 0, false, {
          fileName: _jsxFileName$V,
          lineNumber: 150,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$V,
        lineNumber: 138,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$V,
      lineNumber: 137,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$V,
    lineNumber: 136,
    columnNumber: 5
  }, this);
}
register(ProductCarousel, "product-carousel", ["title", "subtitle", "filters", "products"]);
var _jsxFileName$U = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ui/dialog.tsx";
const Dialog = Root$1;
const DialogPortal = Portal;
const DialogOverlay = w(({
  className,
  ...props
}, ref) => u(Overlay, {
  ref,
  className: cn("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$U,
  lineNumber: 20,
  columnNumber: 3
}, void 0));
DialogOverlay.displayName = Overlay.displayName;
const DialogContent = w(({
  className,
  children,
  ...props
}, ref) => u(DialogPortal, {
  children: [u(DialogOverlay, {}, void 0, false, {
    fileName: _jsxFileName$U,
    lineNumber: 36,
    columnNumber: 5
  }, void 0), u(Content$1, {
    ref,
    className: cn("fixed  left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-neutral-200 bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg dark:border-neutral-800 dark:bg-neutral-950", className),
    ...props,
    children
  }, void 0, false, {
    fileName: _jsxFileName$U,
    lineNumber: 37,
    columnNumber: 5
  }, void 0)]
}, void 0, true, {
  fileName: _jsxFileName$U,
  lineNumber: 35,
  columnNumber: 3
}, void 0));
DialogContent.displayName = Content$1.displayName;
const DialogTitle = w(({
  className,
  ...props
}, ref) => u(Title, {
  ref,
  className: cn("text-lg font-semibold leading-none tracking-tight", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$U,
  lineNumber: 83,
  columnNumber: 3
}, void 0));
DialogTitle.displayName = Title.displayName;
const DialogDescription = w(({
  className,
  ...props
}, ref) => u(Description, {
  ref,
  className: cn("text-sm text-neutral-500 dark:text-neutral-400", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$U,
  lineNumber: 98,
  columnNumber: 3
}, void 0));
DialogDescription.displayName = Description.displayName;
var _jsxFileName$T = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ProductQuickView.tsx";
function ProductQuickView() {
  var _a, _b, _c, _d;
  const {
    toggleCart,
    selectedVariant,
    setSelectedVariant,
    setSelectedProduct,
    selectedProduct,
    toggleNotifyMe,
    quickViewIsOpen,
    toggleQuickView,
    closeQuickView
  } = useGlobal();
  const {
    product_name,
    product_family
  } = selectedProduct;
  const handleVariantChange = (variant) => {
    setSelectedVariant(variant);
  };
  y(() => {
    if (selectedProduct && (selectedProduct == null ? void 0 : selectedProduct.variants)) {
      setSelectedVariant(selectedProduct == null ? void 0 : selectedProduct.variants[0]);
    }
  }, [selectedProduct]);
  const handleAddToCart2 = (event) => {
    event.preventDefault();
    window.Shopify.cart.add({
      items: [{
        id: selectedVariant == null ? void 0 : selectedVariant.id,
        quantity: 1
      }],
      onAdded: () => {
        toggleCart();
        closeQuickView();
      }
    });
  };
  return u(Dialog, {
    open: quickViewIsOpen,
    onOpenChange: toggleQuickView,
    children: u(DialogPortal, {
      children: u(DialogContent, {
        className: "max-w-[95%] md:max-w-sm p-0 gap-0 bg-white",
        children: u("div", {
          className: "pb-6 px-4 pt-3 bg-white",
          children: [u("div", {
            class: "flex justify-end",
            children: u("button", {
              onClick: () => closeQuickView(),
              className: "",
              children: u(X, {
                className: "h-5 w-5"
              }, void 0, false, {
                fileName: _jsxFileName$T,
                lineNumber: 58,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$T,
              lineNumber: 57,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$T,
            lineNumber: 56,
            columnNumber: 13
          }, this), u("div", {
            className: "bg-white w-full ",
            children: [u("h3", {
              className: "font-primary text-center tracking-[-0.02em] text-3xl  mb-4",
              children: product_name
            }, void 0, false, {
              fileName: _jsxFileName$T,
              lineNumber: 62,
              columnNumber: 15
            }, this), u("div", {
              className: "aspect-square w-full bg-gray-50 mb-6",
              children: u("img", {
                class: "aspect-square object-cover w-full transition-all duration-800 opacity-0",
                src: ((_a = selectedVariant == null ? void 0 : selectedVariant.featured_image) == null ? void 0 : _a.src) || (selectedProduct == null ? void 0 : selectedProduct.featured_image),
                alt: selectedVariant == null ? void 0 : selectedVariant.title,
                onLoad: (e2) => e2.currentTarget.classList.remove("opacity-0")
              }, ((_b = selectedVariant == null ? void 0 : selectedVariant.featured_image) == null ? void 0 : _b.src) || (selectedProduct == null ? void 0 : selectedProduct.featured_image), false, {
                fileName: _jsxFileName$T,
                lineNumber: 66,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$T,
              lineNumber: 65,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$T,
            lineNumber: 61,
            columnNumber: 13
          }, this), u("div", {
            className: `grid grid-cols-${((_c = selectedProduct == null ? void 0 : selectedProduct.variants) == null ? void 0 : _c.length) >= 3 ? "3" : (_d = selectedProduct == null ? void 0 : selectedProduct.variants) == null ? void 0 : _d.length} gap-2 mb-4`,
            children: selectedProduct == null ? void 0 : selectedProduct.variants.map((variant) => u("label", {
              className: `flex items-center text-[12px] font-primary border px-4 py-2 rounded cursor-pointer 
                  ${(selectedVariant == null ? void 0 : selectedVariant.id) === variant.id ? "border-black" : "border-gray-400"}`,
              children: [u("input", {
                type: "radio",
                name: "size",
                value: variant.title,
                checked: (selectedVariant == null ? void 0 : selectedVariant.id) === variant.id,
                onChange: () => handleVariantChange(variant),
                className: "hidden"
              }, void 0, false, {
                fileName: _jsxFileName$T,
                lineNumber: 100,
                columnNumber: 19
              }, this), u("span", {
                className: "flex items-center",
                children: [u("span", {
                  className: `w-3 h-3 mr-2 rounded-full 
                      ${(selectedVariant == null ? void 0 : selectedVariant.id) === variant.id ? "bg-black" : "border"}`
                }, void 0, false, {
                  fileName: _jsxFileName$T,
                  lineNumber: 109,
                  columnNumber: 21
                }, this), variant.title]
              }, void 0, true, {
                fileName: _jsxFileName$T,
                lineNumber: 108,
                columnNumber: 19
              }, this)]
            }, variant.id, true, {
              fileName: _jsxFileName$T,
              lineNumber: 91,
              columnNumber: 17
            }, this))
          }, void 0, false, {
            fileName: _jsxFileName$T,
            lineNumber: 83,
            columnNumber: 13
          }, this), (selectedVariant == null ? void 0 : selectedVariant.available) ? u(Button, {
            onClick: handleAddToCart2,
            className: "w-full",
            mode: "primary",
            children: "ADD TO BAG"
          }, void 0, false, {
            fileName: _jsxFileName$T,
            lineNumber: 123,
            columnNumber: 15
          }, this) : u(Button, {
            onClick: toggleNotifyMe,
            className: "w-full",
            mode: "primary",
            role: "button",
            children: "NOTIFY ME"
          }, void 0, false, {
            fileName: _jsxFileName$T,
            lineNumber: 132,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$T,
          lineNumber: 55,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$T,
        lineNumber: 54,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$T,
      lineNumber: 53,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$T,
    lineNumber: 52,
    columnNumber: 5
  }, this);
}
register(ProductQuickView, "product-quick-view");
var _jsxFileName$S = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/PromoBlock.tsx";
function PromoBlock({
  title,
  titleTag = "h2",
  contentPosition,
  content,
  buttonLink,
  buttonLabel,
  desktopImage,
  mobileImage
}) {
  const Component = titleTag;
  return u("div", {
    className: "relative container",
    children: u("div", {
      className: clsx$1("relative w-full", !mobileImage && "aspect-[363/450] bg-haze", !desktopImage && "md:aspect-[1274/411] bg-haze"),
      children: [desktopImage && u("div", {
        className: "hidden md:block",
        children: parse$1(JSON.parse(desktopImage))
      }, void 0, false, {
        fileName: _jsxFileName$S,
        lineNumber: 39,
        columnNumber: 11
      }, this), mobileImage && u("div", {
        className: "md:hidden",
        children: parse$1(JSON.parse(mobileImage))
      }, void 0, false, {
        fileName: _jsxFileName$S,
        lineNumber: 44,
        columnNumber: 11
      }, this), u(Button, {
        to: buttonLink,
        mode: "custom",
        className: clsx$1("px-4 pt-4 pb-5 w-[calc(100%-32px)] md:max-w-[25%] flex bg-white absolute left-4 right-4 bottom-4 md:bottom-6 rounded-md", contentPosition),
        children: [u("div", {
          children: [title && u(Component, {
            className: clsx$1(`font-primary pb-2 text-3xl md:text-4xl text-black`),
            children: title
          }, void 0, false, {
            fileName: _jsxFileName$S,
            lineNumber: 56,
            columnNumber: 15
          }, this), content && u("p", {
            className: clsx$1(`font-primary text-tints-80 text-button-lg`),
            children: content
          }, void 0, false, {
            fileName: _jsxFileName$S,
            lineNumber: 65,
            columnNumber: 15
          }, this), buttonLabel && u(Button, {
            to: buttonLink,
            mode: "custom",
            className: "uppercase mt-4 underline font-primary font-medium text-button-sm",
            children: buttonLabel
          }, void 0, false, {
            fileName: _jsxFileName$S,
            lineNumber: 70,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$S,
          lineNumber: 54,
          columnNumber: 11
        }, this), u("div", {
          className: "ml-auto w-12",
          children: u(UpperRightArrow, {}, void 0, false, {
            fileName: _jsxFileName$S,
            lineNumber: 80,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$S,
          lineNumber: 79,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$S,
        lineNumber: 46,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$S,
      lineNumber: 31,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$S,
    lineNumber: 30,
    columnNumber: 5
  }, this);
}
register(PromoBlock, "promo-block", ["title", "contentPosition", "content", "buttonLink", "buttonLabel", "desktopImage", "mobileImage"]);
var _jsxFileName$R = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/PromoTwoColumns.tsx";
function PromoTwoColumns({
  title,
  titleTag = "h2",
  blocks
}) {
  const blocksData = typeof blocks === "string" ? JSON.parse(blocks) : blocks;
  const Component = titleTag;
  return u("div", {
    className: "relative container",
    children: [u("div", {
      className: "w-full md:flex",
      children: u("div", {
        children: title && u(Component, {
          className: "font-primary pb-4 md:pb-6 text-5xl text-black",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$R,
          lineNumber: 30,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$R,
        lineNumber: 28,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$R,
      lineNumber: 27,
      columnNumber: 7
    }, this), u("div", {
      className: "grid md:grid-cols-2 gap-y-6 md:gap-y-0 md:gap-x-5",
      children: blocksData.map((block, index) => u("div", {
        className: "relative aspect-[353/246] md:aspect-[628/437] overflow-hidden",
        children: u("a", {
          href: block.link ? block.link : "",
          "aria-label": block.title,
          children: [block.title && u("h3", {
            className: "font-primary z-10 absolute bottom-4 left-6 text-3xl md:text-4xl text-white",
            children: block.title
          }, void 0, false, {
            fileName: _jsxFileName$R,
            lineNumber: 44,
            columnNumber: 17
          }, this), block.desktopImage && u("div", {
            className: "hidden md:block",
            children: u("div", {
              className: twMerge("absolute w-full h-full bg-cover bg-center overflow-hidden hover:scale-105 transition-all"),
              style: {
                backgroundImage: `url(${block.desktopImage})`
              },
              children: u("div", {
                className: twMerge("absolute -bottom-3 left-0 w-full h-full bg-cover bg-center pointer-events-none"),
                style: {
                  backgroundImage: `url(${block.desktopImage})`,
                  maskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 10%, rgba(0, 0, 0, 0.5) 15%, rgba(0, 0, 0, 0.25) 20%, rgba(0, 0, 0, 0) 25%)",
                  WebkitMaskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 10%, rgba(0, 0, 0, 0.5) 15%, rgba(0, 0, 0, 0.25) 20%, rgba(0, 0, 0, 0) 25%)",
                  filter: "blur(10px)",
                  opacity: 1
                }
              }, void 0, false, {
                fileName: _jsxFileName$R,
                lineNumber: 56,
                columnNumber: 21
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$R,
              lineNumber: 50,
              columnNumber: 19
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$R,
            lineNumber: 49,
            columnNumber: 17
          }, this), block.mobileImage && u("div", {
            className: "md:hidden",
            children: u("div", {
              className: twMerge("absolute w-full h-full bg-cover bg-center overflow-hidden"),
              style: {
                backgroundImage: `url(${block.mobileImage})`
              },
              children: u("div", {
                className: twMerge("absolute -bottom-3 left-0 w-full h-full bg-cover bg-center pointer-events-none"),
                style: {
                  backgroundImage: `url(${block.mobileImage})`,
                  maskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 20%, rgba(0, 0, 0, 0.25) 35%, rgba(0, 0, 0, 0) 50%)",
                  WebkitMaskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 20%, rgba(0, 0, 0, 0.25) 35%, rgba(0, 0, 0, 0) 50%)",
                  filter: "blur(10px)",
                  opacity: 1
                }
              }, void 0, false, {
                fileName: _jsxFileName$R,
                lineNumber: 81,
                columnNumber: 21
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$R,
              lineNumber: 75,
              columnNumber: 19
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$R,
            lineNumber: 74,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$R,
          lineNumber: 42,
          columnNumber: 13
        }, this)
      }, `promo-block-${index}`, false, {
        fileName: _jsxFileName$R,
        lineNumber: 38,
        columnNumber: 11
      }, this))
    }, void 0, false, {
      fileName: _jsxFileName$R,
      lineNumber: 36,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$R,
    lineNumber: 26,
    columnNumber: 5
  }, this);
}
register(PromoTwoColumns, "promo-two-columns", ["title", "blocks", "titleTag"]);
var _jsxFileName$Q = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/QuantitySelector.tsx";
function QuantitySelector({
  onQuanityUpdate,
  currentQuantity = 1,
  maxQuantity = 4,
  mode = "small"
}) {
  const [quantity, setQuantity] = t$2(h(currentQuantity), "quantity");
  const [isDisabled, setIsDisabled] = t$2(h(false), "isDisabled");
  const handleUpdate = (newQuantity) => {
    setIsDisabled(true);
    if (newQuantity > 0) {
      const updatedQuantity = newQuantity > 4 ? 4 : newQuantity;
      if (maxQuantity && newQuantity > maxQuantity) {
        setQuantity(maxQuantity);
      } else {
        setQuantity(updatedQuantity);
      }
    } else {
      setQuantity(1);
    }
    setTimeout(function() {
      setIsDisabled(false);
    }, 600);
  };
  y(() => {
    if (onQuanityUpdate && typeof onQuanityUpdate === "function") {
      onQuanityUpdate(quantity);
    }
  }, [quantity]);
  y(() => {
    if (quantity !== currentQuantity) {
      setQuantity(currentQuantity);
    }
  }, [currentQuantity]);
  return u("div", {
    children: u("div", {
      className: cn("flex  items-center justify-between gap-4 border border-tints-20 bg-white py-2 px-3 text-button-sm font-medium", mode === "small" && "h-8", mode === "large" && "h-11 w-full max-w-[100px]"),
      children: [u(Button, {
        mode: "custom",
        className: "group",
        "aria-label": "reduce quantity",
        role: "button",
        onClick: () => {
          handleUpdate(quantity - 1);
        },
        disabled: isDisabled,
        children: u(MinusIcon, {
          className: "group-disabled:text-tints-40"
        }, void 0, false, {
          fileName: _jsxFileName$Q,
          lineNumber: 73,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$Q,
        lineNumber: 62,
        columnNumber: 9
      }, this), u("span", {
        className: "text-center w-[20px]",
        children: quantity
      }, void 0, false, {
        fileName: _jsxFileName$Q,
        lineNumber: 75,
        columnNumber: 9
      }, this), u("input", {
        name: "quantity",
        value: quantity,
        type: "hidden"
      }, void 0, false, {
        fileName: _jsxFileName$Q,
        lineNumber: 76,
        columnNumber: 9
      }, this), u(Button, {
        mode: "custom",
        className: "group",
        "aria-label": "increase quantity",
        role: "button",
        onClick: () => {
          handleUpdate(quantity + 1);
        },
        disabled: isDisabled,
        children: u(PlusIcon, {
          className: "group-disabled:text-tints-40"
        }, void 0, false, {
          fileName: _jsxFileName$Q,
          lineNumber: 88,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$Q,
        lineNumber: 77,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$Q,
      lineNumber: 55,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$Q,
    lineNumber: 54,
    columnNumber: 5
  }, this);
}
register(QuantitySelector, "quantity-selector-preact");
var _jsxFileName$P = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ScrollingText.tsx";
function ScrollingText({
  font_size,
  text_color,
  background_color,
  blocks
}) {
  const containerRef = t$2(A$1(null), "containerRef");
  const trackRef = t$2(A$1(null), "trackRef");
  const offsetRef = t$2(A$1(0), "offsetRef");
  const isHoveredRef = t$2(A$1(false), "isHoveredRef");
  const [initialRenderDone, setInitialRenderDone] = t$2(h(false), "initialRenderDone");
  const [repeatedBlocks, setRepeatedBlocks] = t$2(h([]), "repeatedBlocks");
  const blocksData = typeof blocks === "string" ? JSON.parse(blocks) : blocks;
  y(() => {
    if (!initialRenderDone) return;
    const container = containerRef.current;
    const track = trackRef.current;
    if (!container || !track) return;
    const containerWidth = container.offsetWidth;
    const contentWidth = track.scrollWidth;
    let duplicationCount = Math.ceil(containerWidth * 4 / contentWidth);
    if (duplicationCount < 4) {
      duplicationCount = 4;
    }
    const duplicated = Array.from({
      length: duplicationCount
    }, () => blocksData).flat();
    setRepeatedBlocks(duplicated);
  }, [initialRenderDone, blocksData]);
  y(() => {
    setInitialRenderDone(true);
  }, []);
  y(() => {
    const track = trackRef.current;
    if (!track) return;
    const speed = 0.5;
    let animationFrameId;
    const step = () => {
      if (!isHoveredRef.current) {
        offsetRef.current -= speed;
        const trackWidth = track.scrollWidth / 2;
        if (Math.abs(offsetRef.current) >= trackWidth) {
          offsetRef.current = 0;
        }
        track.style.transform = `translateX(${offsetRef.current}px)`;
      }
      animationFrameId = requestAnimationFrame(step);
    };
    animationFrameId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationFrameId);
  }, [repeatedBlocks.length]);
  return u("div", {
    ref: containerRef,
    className: "overflow-hidden whitespace-nowrap w-full relative py-3",
    style: {
      backgroundColor: background_color,
      color: text_color,
      fontSize: `${font_size}px`
    },
    onMouseEnter: () => isHoveredRef.current = true,
    onMouseLeave: () => isHoveredRef.current = false,
    children: u("div", {
      ref: trackRef,
      className: "inline-flex whitespace-nowrap will-change-transform",
      children: (repeatedBlocks.length ? repeatedBlocks : blocksData).map((block, index) => {
        var _a;
        return u("span", {
          className: "inline-flex items-center",
          children: [((_a = block.link) == null ? void 0 : _a.trim()) ? u("a", {
            href: block.link,
            "aria-label": block.text,
            className: "no-underline",
            children: block.text
          }, void 0, false, {
            fileName: _jsxFileName$P,
            lineNumber: 106,
            columnNumber: 17
          }, this) : block.text, u("span", {
            className: "mx-3",
            children: "✷"
          }, void 0, false, {
            fileName: _jsxFileName$P,
            lineNumber: 116,
            columnNumber: 15
          }, this)]
        }, `scrolling-text-${index}`, true, {
          fileName: _jsxFileName$P,
          lineNumber: 101,
          columnNumber: 13
        }, this);
      })
    }, void 0, false, {
      fileName: _jsxFileName$P,
      lineNumber: 95,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$P,
    lineNumber: 84,
    columnNumber: 5
  }, this);
}
register(ScrollingText, "scrolling-text", ["blocks", "font-size", "text-color", "background-color"]);
var _jsxFileName$O = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/SearchResults.tsx";
function SearchResults({
  search_value
}) {
  const [isFetching, setIsFetching] = t$2(h(false), "isFetching");
  const [searchResults, setSearchResults] = t$2(h(null), "searchResults");
  async function search(value) {
    if (search_value.trim().length > 0) {
      const sectionId = "predictive-search-results";
      const url = `search/suggest?q=${value}&resources[type]=product,article&section_id=${sectionId}`;
      const results = await getSearchResultsJson(url);
      setSearchResults(results);
    }
  }
  async function getSearchResultsJson(url) {
    try {
      setIsFetching(true);
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`Error: ${res.status} ${res.statusText}`);
      }
      const responseData = await res.text();
      const resultsMarkup = new DOMParser().parseFromString(responseData, "text/html").querySelector("#shopify-section-predictive-search-results").innerHTML;
      const jsonData = JSON.parse(resultsMarkup);
      return jsonData;
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsFetching(false);
    }
  }
  y(() => {
    search(search_value);
  }, [search_value]);
  return u("div", {
    className: "container",
    children: u(SearchResultsTabs, {
      searchResults: JSON.stringify(searchResults),
      isFetching
    }, void 0, false, {
      fileName: _jsxFileName$O,
      lineNumber: 55,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$O,
    lineNumber: 54,
    columnNumber: 5
  }, this);
}
register(SearchResults, "search-results", ["search_value"]);
var _jsxFileName$N = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/SeoBlock.tsx";
function SeoBlock({
  html_tag_for_title,
  padding_bottom_desktop,
  padding_top_desktop,
  padding_top_mobile,
  padding_bottom_mobile,
  title,
  content
}) {
  const Component = html_tag_for_title;
  return u("div", {
    className: clsx$1("text-left container", padding_top_desktop && padding_top_desktop, padding_bottom_desktop && padding_bottom_desktop, padding_top_mobile && padding_top_mobile, padding_bottom_mobile && padding_bottom_mobile),
    children: u("div", {
      className: "max-w-[628px]",
      children: [title && /* @ts-ignore */
      u(Component, {
        className: "font-primary text-base font-medium mb-3",
        children: title
      }, void 0, false, {
        fileName: _jsxFileName$N,
        lineNumber: 40,
        columnNumber: 11
      }, this), content && u("div", {
        className: "font-primary text-sm",
        children: parse$1(content)
      }, void 0, false, {
        fileName: _jsxFileName$N,
        lineNumber: 46,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$N,
      lineNumber: 37,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$N,
    lineNumber: 28,
    columnNumber: 5
  }, this);
}
register(SeoBlock, "seo-block", ["html_tag_for_title", "padding_top_desktop", "padding_bottom_desktop", "padding_top_mobile", "padding_bottom_mobile"]);
var _jsxFileName$M = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/TextBlock.tsx";
function TextBlock({
  html_tag_for_title,
  title
}) {
  const Component = html_tag_for_title;
  return u(b$2, {
    children: [u("slot", {}, void 0, false, {
      fileName: _jsxFileName$M,
      lineNumber: 19,
      columnNumber: 7
    }, this), u("div", {
      className: "text-center container",
      children: u(Component, {
        className: "font-secondary text-[50px] lg:text-10xl",
        children: title
      }, void 0, false, {
        fileName: _jsxFileName$M,
        lineNumber: 23,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$M,
      lineNumber: 21,
      columnNumber: 7
    }, this)]
  }, void 0);
}
register(TextBlock, "text-block", ["html_tag_for_title"]);
var _jsxFileName$L = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ThreeColumns.tsx";
function ThreeColumns({
  eyebrow_text,
  title,
  content,
  desktop_image1,
  desktop_image2,
  desktop_image3,
  mobile_image,
  mode,
  html_tag_for_title
}) {
  const Component = html_tag_for_title;
  return u("div", {
    className: "flex container flex-col gap-6 md:gap-12",
    children: (eyebrow_text || title || content) && u("div", {
      className: twMerge("flex flex-col md:flex-row gap-6 md:gap-16", mode == "right" && "md:flex-row-reverse"),
      children: [u("div", {
        className: "w-full md:w-7/12 flex md:gap-5",
        children: [desktop_image1 && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image1))
        }, void 0, false, {
          fileName: _jsxFileName$L,
          lineNumber: 42,
          columnNumber: 15
        }, this), desktop_image2 && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image2))
        }, void 0, false, {
          fileName: _jsxFileName$L,
          lineNumber: 47,
          columnNumber: 15
        }, this), desktop_image3 && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image3))
        }, void 0, false, {
          fileName: _jsxFileName$L,
          lineNumber: 52,
          columnNumber: 15
        }, this), mobile_image && u("div", {
          className: "md:hidden",
          children: parse$1(JSON.parse(mobile_image))
        }, void 0, false, {
          fileName: _jsxFileName$L,
          lineNumber: 57,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$L,
        lineNumber: 40,
        columnNumber: 11
      }, this), u("div", {
        className: "w-full md:w-5/12",
        children: [eyebrow_text && u("p", {
          className: "font-secondary italic text-2xl md:text-eyebrow-md text-black",
          children: eyebrow_text
        }, void 0, false, {
          fileName: _jsxFileName$L,
          lineNumber: 63,
          columnNumber: 15
        }, this), title && u(Component, {
          className: "font-primary py-4 text-6xl md:text-7xl text-black",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$L,
          lineNumber: 68,
          columnNumber: 15
        }, this), content && u("div", {
          className: twMerge("font-primary py-4 text-2xl lg:text-4xl text-black"),
          children: parse$1(content)
        }, void 0, false, {
          fileName: _jsxFileName$L,
          lineNumber: 73,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$L,
        lineNumber: 61,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$L,
      lineNumber: 34,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$L,
    lineNumber: 32,
    columnNumber: 5
  }, this);
}
register(ThreeColumns, "three-columns", ["eyebrow_text", "title", "content", "desktop_image1", "desktop_image2", "desktop_image3", "mobile_image", "mode", "html_tag_for_title"]);
var _jsxFileName$K = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/TwoColumns.tsx";
function TwoColumns({
  eyebrow_text,
  title,
  content,
  desktop_image1,
  desktop_image2,
  mobile_image,
  mode,
  html_tag_for_title
}) {
  const Component = html_tag_for_title;
  return u("div", {
    className: "flex container flex-col gap-6 md:gap-12",
    children: (eyebrow_text || title || content) && u("div", {
      className: twMerge("flex flex-col md:flex-row gap-6 md:gap-16", mode == "right" && "md:flex-row-reverse"),
      children: [u("div", {
        className: "w-full md:w-1/2 flex md:gap-5",
        children: [desktop_image1 && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image1))
        }, void 0, false, {
          fileName: _jsxFileName$K,
          lineNumber: 40,
          columnNumber: 15
        }, this), desktop_image2 && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image2))
        }, void 0, false, {
          fileName: _jsxFileName$K,
          lineNumber: 45,
          columnNumber: 15
        }, this), mobile_image && u("div", {
          className: "md:hidden",
          children: parse$1(JSON.parse(mobile_image))
        }, void 0, false, {
          fileName: _jsxFileName$K,
          lineNumber: 50,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$K,
        lineNumber: 38,
        columnNumber: 11
      }, this), u("div", {
        className: "w-full md:w-1/2",
        children: [eyebrow_text && u("p", {
          className: "font-secondary italic text-2xl md:text-eyebrow-md text-black",
          children: eyebrow_text
        }, void 0, false, {
          fileName: _jsxFileName$K,
          lineNumber: 56,
          columnNumber: 15
        }, this), title && u(Component, {
          className: "font-primary py-4 text-6xl md:text-7xl text-black",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$K,
          lineNumber: 61,
          columnNumber: 15
        }, this), content && u("div", {
          className: twMerge("font-primary py-4 text-2xl lg:text-4xl text-black"),
          children: parse$1(content)
        }, void 0, false, {
          fileName: _jsxFileName$K,
          lineNumber: 66,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$K,
        lineNumber: 54,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$K,
      lineNumber: 32,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$K,
    lineNumber: 30,
    columnNumber: 5
  }, this);
}
register(TwoColumns, "two-columns", ["eyebrow_text", "title", "content", "desktop_image1", "desktop_image2", "mobile_image", "mode", "html_tag_for_title"]);
var _jsxFileName$J = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/LargePlayIcon.tsx";
function LargePlayIcon(props) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    ...props,
    "aria-label": "Play Icon",
    children: u("path", {
      d: "M29 20L13 30L13 10L29 20Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$J,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$J,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$I = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/VideoPlayer.tsx";
function VideoPlayer({
  video,
  videoEmbed,
  poster,
  autoplay,
  video_id
}) {
  const [isPlaying, setIsPlaying] = t$2(h(autoplay === "true"), "isPlaying");
  const handlePlayClick = () => {
    setIsPlaying(true);
    const videoElement = document.getElementById(video_id);
    if (videoElement) {
      videoElement.play();
    }
  };
  return u("div", {
    className: "relative container-m",
    children: [poster && autoplay != "true" && u("div", {
      className: twMerge("absolute z-10 inset-0 transition-all container-m w-full h-full overflow-hidden", isPlaying ? "opacity-0 pointer-events-none" : "opacity-100"),
      children: u("div", {
        className: twMerge("w-full h-full bg-cover bg-center"),
        style: {
          backgroundImage: `url(${poster})`
        },
        children: [u("div", {
          className: twMerge("w-full h-full bg-cover bg-center"),
          style: {
            backgroundImage: `url(${poster})`,
            maskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 10%, rgba(0, 0, 0, 0.5) 15%, rgba(0, 0, 0, 0.25) 25%, rgba(0, 0, 0, 0) 25%)",
            WebkitMaskImage: "linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 10%, rgba(0, 0, 0, 0.5) 15%, rgba(0, 0, 0, 0.25) 25%, rgba(0, 0, 0, 0) 25%)",
            filter: "blur(10px)",
            opacity: 1
          }
        }, void 0, false, {
          fileName: _jsxFileName$I,
          lineNumber: 45,
          columnNumber: 13
        }, this), u("button", {
          className: "absolute flex bottom-4 p-1 text-white text-5xl font-primary",
          onClick: handlePlayClick,
          "aria-label": "Play video",
          children: [u(LargePlayIcon, {}, void 0, false, {
            fileName: _jsxFileName$I,
            lineNumber: 63,
            columnNumber: 15
          }, this), " Play"]
        }, void 0, true, {
          fileName: _jsxFileName$I,
          lineNumber: 58,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$I,
        lineNumber: 41,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$I,
      lineNumber: 35,
      columnNumber: 9
    }, this), video ? (
      // @ts-ignore
      u(b$2, {
        children: parse$1(video)
      }, void 0, false)
    ) : videoEmbed ? (
      // @ts-ignore
      u(b$2, {
        children: parse$1(videoEmbed)
      }, void 0, false)
    ) : null]
  }, void 0, true, {
    fileName: _jsxFileName$I,
    lineNumber: 33,
    columnNumber: 5
  }, this);
}
register(VideoPlayer, "video-player", ["video", "videoEmbed"]);
var _jsxFileName$H = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/QuestionCircle.tsx";
function QuestionCircleIcon({
  width = "16",
  height = "16",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    children: [u("circle", {
      cx: "6",
      cy: "6",
      r: "5.625",
      stroke: "#1B1B1B",
      "stroke-width": "0.75"
    }, void 0, false, {
      fileName: _jsxFileName$H,
      lineNumber: 10,
      columnNumber: 7
    }, this), u("path", {
      d: "M5.58542 7.09346H6.29613C6.32346 6.80374 6.46925 6.65421 6.76993 6.43925C7.43508 5.97196 8 5.56075 8 4.74766C8 3.82243 7.3713 3 6.041 3C4.82005 3 4 3.78505 4 4.98131C4 5.11215 4.00911 5.23364 4.02733 5.37383L4.83827 5.42056C4.81093 5.29907 4.80182 5.15888 4.80182 5.03738C4.80182 4.16822 5.23918 3.65421 6.03189 3.65421C6.78815 3.65421 7.17995 4.14019 7.17995 4.76636C7.17995 5.38318 6.72437 5.65421 6.25057 6.00935C5.78588 6.35514 5.60364 6.62617 5.58542 7.09346ZM5.36674 7.86916V9H6.48747V7.86916H5.36674Z",
      fill: "#1B1B1B"
    }, void 0, false, {
      fileName: _jsxFileName$H,
      lineNumber: 11,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$H,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$G = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/SelectDown.tsx";
function SelectDownIcon({
  width = "16",
  height = "16",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    "aria-label": "Toggle Select Menu",
    children: u("path", {
      d: "M4 6.40002L8 10.4L12 6.40002",
      stroke: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$G,
      lineNumber: 12,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$G,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$F = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/LineItemRechargeWidget.tsx";
function LineItemRechargeWidget({
  plans,
  item,
  selectedPlan
}) {
  const {
    cartRechargeSettings
  } = useCart();
  const [percentOff, setPercentOff] = t$2(h(0), "percentOff");
  const handleSubscriptionFrequency = (e2) => {
    const eventValue = e2.target.value;
    window.Shopify.cart.updateItem({
      id: item == null ? void 0 : item.key,
      quantity: item == null ? void 0 : item.quantity,
      sellingPlanId: eventValue === "Select" ? null : eventValue
    });
  };
  const getShorterPlanName = (plan) => {
    if (!plan) return "";
    const regex = /\d{1,2}\s\w+/g;
    const shorterPlanName = plan.match(regex);
    if (shorterPlanName && shorterPlanName.length) {
      return shorterPlanName[0];
    }
    return plan;
  };
  y(() => {
    var _a, _b, _c;
    if (selectedPlan) {
      const priceAdjustment = (_c = (_b = (_a = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _a.selling_plan) == null ? void 0 : _b.price_adjustments) == null ? void 0 : _c[0];
      if ((priceAdjustment == null ? void 0 : priceAdjustment.value_type) == "percentage" && (priceAdjustment == null ? void 0 : priceAdjustment.value)) {
        setPercentOff(priceAdjustment == null ? void 0 : priceAdjustment.value);
      }
    }
  }, [selectedPlan]);
  return u("div", {
    className: "flex justify-between font-primary text-xs mt-2.5",
    children: [u("div", {
      className: "",
      children: [u("div", {
        className: "flex items-center gap-1",
        children: [u("p", {
          children: `${cartRechargeSettings == null ? void 0 : cartRechargeSettings.pct_text}${percentOff ? ` ${percentOff}%` : ""}`
        }, void 0, false, {
          fileName: _jsxFileName$F,
          lineNumber: 55,
          columnNumber: 11
        }, this), u("div", {
          className: "cursor-pointer relative group",
          children: [u(QuestionCircleIcon, {}, void 0, false, {
            fileName: _jsxFileName$F,
            lineNumber: 59,
            columnNumber: 13
          }, this), u("p", {
            className: "absolute z-50 left-1/2 top-full -translate-x-1/2 translate-y-1 transform p-2 hidden group-hover:block group-focus-within:block w-52 border border-black bg-white",
            children: [u("strong", {
              className: "mr-1",
              children: `${cartRechargeSettings == null ? void 0 : cartRechargeSettings.tool_label}`
            }, void 0, false, {
              fileName: _jsxFileName$F,
              lineNumber: 61,
              columnNumber: 15
            }, this), `${cartRechargeSettings == null ? void 0 : cartRechargeSettings.tool_text}`]
          }, void 0, true, {
            fileName: _jsxFileName$F,
            lineNumber: 60,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$F,
          lineNumber: 58,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$F,
        lineNumber: 54,
        columnNumber: 9
      }, this), u("p", {
        className: "text-tints-80",
        children: `${cartRechargeSettings == null ? void 0 : cartRechargeSettings.cancel_text}`
      }, void 0, false, {
        fileName: _jsxFileName$F,
        lineNumber: 66,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$F,
      lineNumber: 53,
      columnNumber: 7
    }, this), u("div", {
      className: "relative flex whitespace-nowrap items-center gap-2",
      children: [u("label", {
        htmlFor: "subscriptionFrequency",
        className: "",
        children: `${cartRechargeSettings == null ? void 0 : cartRechargeSettings.select_label}`
      }, void 0, false, {
        fileName: _jsxFileName$F,
        lineNumber: 69,
        columnNumber: 9
      }, this), u("select", {
        id: "subscriptionFrequency",
        onChange: handleSubscriptionFrequency,
        value: selectedPlan || "Select",
        className: clsx$1(["w-full min-w-20 appearance-none border bg-white pl-2.5 py-[5px] leading-field outline-none !text-xs font-medium", "disabled:opacity-50", "active:bg-cream-500 active:text-black", "focus:border-dashed focus:text-black", "placeholder-shown:text-tints-40 !appearance-none !text-xs bg-[length:16px]"]),
        style: "background-position: right 0px center;",
        children: [u("option", {
          value: "Select",
          children: "Select"
        }, void 0, false, {
          fileName: _jsxFileName$F,
          lineNumber: 85,
          columnNumber: 11
        }, this), plans.map((plan) => u("option", {
          value: plan.id,
          children: getShorterPlanName(plan == null ? void 0 : plan.name)
        }, plan.id, false, {
          fileName: _jsxFileName$F,
          lineNumber: 88,
          columnNumber: 13
        }, this))]
      }, void 0, true, {
        fileName: _jsxFileName$F,
        lineNumber: 72,
        columnNumber: 9
      }, this), u(SelectDownIcon, {
        className: "pointer-events-none absolute right-1 top-1/2 !mt-0 -translate-y-1/2 text-black"
      }, void 0, false, {
        fileName: _jsxFileName$F,
        lineNumber: 93,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$F,
      lineNumber: 68,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$F,
    lineNumber: 52,
    columnNumber: 5
  }, this);
}
var _jsxFileName$E = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/LineItem.tsx";
function LineItem({
  item,
  size = "full"
}) {
  var _a, _b, _c, _d, _e, _f;
  const isGift = (_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._GWP;
  const offerTerms = (_b = item == null ? void 0 : item.properties) == null ? void 0 : _b._offer_terms;
  const subscriptionPlans = (_c = item == null ? void 0 : item.subscription_plans) == null ? void 0 : _c[0];
  const selectedPlan = ((_e = (_d = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _d.selling_plan) == null ? void 0 : _e.id) || "";
  const handleRemove = () => {
    window.Shopify.cart.removeItem({
      id: item == null ? void 0 : item.key
    });
  };
  const handleQuantityUpdate = ({
    newQuantity
  }) => {
    if (newQuantity !== item.quantity) {
      window.Shopify.cart.updateItem({
        id: item == null ? void 0 : item.key,
        quantity: newQuantity
      });
    }
  };
  return u("div", {
    children: [u("div", {
      className: "flex gap-3 justify-between",
      children: [u("div", {
        className: cn(size === "compact" && "w-[100px] h-[100px]", size === "full" && "w-[110px] h-[110px]", "overflow-hidden bg-haze aspect-square	flex justify-center items-center"),
        children: u("a", {
          href: item == null ? void 0 : item.url,
          children: u("img", {
            src: resizeImageUrl(item == null ? void 0 : item.image, "200x"),
            alt: item == null ? void 0 : item.product_title,
            className: "object-contain w-auto h-full"
          }, void 0, false, {
            fileName: _jsxFileName$E,
            lineNumber: 39,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$E,
          lineNumber: 38,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$E,
        lineNumber: 31,
        columnNumber: 9
      }, this), u("div", {
        className: cn("flex flex-col flex-grow justify-between", size === "compact" && "max-w-[157px]"),
        children: [u("div", {
          children: [u("a", {
            href: item == null ? void 0 : item.url,
            className: cn("font-primary", size === "compact" && "text-sm", size === "full" && "text-2xl font-normal"),
            children: item == null ? void 0 : item.product_title
          }, void 0, false, {
            fileName: _jsxFileName$E,
            lineNumber: 54,
            columnNumber: 13
          }, this), u("div", {
            className: "font-primary text-sm lowercase text-tint-80 font-normal",
            children: [!isGift && (item == null ? void 0 : item.variant_title), isGift && offerTerms && u("div", {
              className: "cursor-pointer relative flex gap-1 text-tints-80 items-center text-sm group",
              children: ["Offer Terms", u(QuestionCircleIcon, {}, void 0, false, {
                fileName: _jsxFileName$E,
                lineNumber: 69,
                columnNumber: 19
              }, this), u("div", {
                className: "absolute z-50 left-1/2 top-full -translate-x-1/2 translate-y-1 transform p-2 hidden group-hover:block group-focus-within:block w-52 border border-black bg-white",
                children: [u("strong", {
                  className: "mr-1",
                  children: "Offer Terms"
                }, void 0, false, {
                  fileName: _jsxFileName$E,
                  lineNumber: 71,
                  columnNumber: 21
                }, this), u("p", {
                  children: offerTerms
                }, void 0, false, {
                  fileName: _jsxFileName$E,
                  lineNumber: 72,
                  columnNumber: 21
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$E,
                lineNumber: 70,
                columnNumber: 19
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$E,
              lineNumber: 67,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$E,
            lineNumber: 64,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$E,
          lineNumber: 53,
          columnNumber: 11
        }, this), !isGift && u("div", {
          className: "max-w-[100px]",
          children: u(QuantitySelector, {
            mode: "small",
            currentQuantity: item == null ? void 0 : item.quantity,
            onQuanityUpdate: (quantity) => {
              handleQuantityUpdate({
                newQuantity: quantity
              });
            }
          }, void 0, false, {
            fileName: _jsxFileName$E,
            lineNumber: 80,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$E,
          lineNumber: 79,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$E,
        lineNumber: 47,
        columnNumber: 9
      }, this), u("div", {
        className: "flex flex-col flex-grow justify-between items-end text-right",
        children: [u("div", {
          className: "text-sm font-primary font-medium",
          children: shopifyFormatCurrency(item == null ? void 0 : item.price, "${{ amount }}")
        }, void 0, false, {
          fileName: _jsxFileName$E,
          lineNumber: 92,
          columnNumber: 11
        }, this), u(Button, {
          className: "text-xs font-primary underline hover:no-underline",
          mode: "custom",
          tone: "default",
          onClick: handleRemove,
          children: "Remove"
        }, void 0, false, {
          fileName: _jsxFileName$E,
          lineNumber: 95,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$E,
        lineNumber: 91,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$E,
      lineNumber: 30,
      columnNumber: 7
    }, this), !isGift && ((_f = subscriptionPlans == null ? void 0 : subscriptionPlans.selling_plans) == null ? void 0 : _f.length) > 0 && u(LineItemRechargeWidget, {
      plans: subscriptionPlans == null ? void 0 : subscriptionPlans.selling_plans,
      item,
      selectedPlan
    }, void 0, false, {
      fileName: _jsxFileName$E,
      lineNumber: 106,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$E,
    lineNumber: 29,
    columnNumber: 5
  }, this);
}
var _jsxFileName$D = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/CartItems.tsx";
function CartItems({
  size = "compact"
}) {
  var _a, _b;
  const {
    cart
  } = useCart();
  return u(b$2, {
    children: ((_a = cart == null ? void 0 : cart.items) == null ? void 0 : _a.length) > 0 ? (_b = cart == null ? void 0 : cart.items) == null ? void 0 : _b.map((item, index) => {
      return u(LineItem, {
        size,
        item
      }, `${item == null ? void 0 : item.id}--${index}`, false, {
        fileName: _jsxFileName$D,
        lineNumber: 19,
        columnNumber: 13
      }, this);
    }) : u(b$2, {
      children: "Your cart is currently empty."
    }, void 0, false)
  }, void 0);
}
register(CartItems, "cart-items");
var _jsxFileName$C = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Truck.tsx";
function TruckIcon() {
  return u("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [u("g", {
      "clip-path": "url(#clip0_5008_6811)",
      children: [u("path", {
        d: "M7.24138 17.5H5V5.5H17.5V8H20.5L23 12V17.5H20.4138",
        stroke: "#1B1B1B",
        "stroke-width": "1.24138"
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 11,
        columnNumber: 9
      }, this), u("circle", {
        cx: "18.655",
        cy: "17.5862",
        r: "1.86207",
        stroke: "#1B1B1B",
        "stroke-width": "1.24138"
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 16,
        columnNumber: 9
      }, this), u("circle", {
        cx: "8.72437",
        cy: "17.5862",
        r: "1.86207",
        stroke: "#1B1B1B",
        "stroke-width": "1.24138"
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 23,
        columnNumber: 9
      }, this), u("path", {
        d: "M10.207 17.5862H17.1725",
        stroke: "#1B1B1B",
        "stroke-width": "1.24138"
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 30,
        columnNumber: 9
      }, this), u("path", {
        d: "M8.5 7.5H1",
        stroke: "#1B1B1B",
        "stroke-width": "1.24138"
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 35,
        columnNumber: 9
      }, this), u("path", {
        d: "M10.5 10H3",
        stroke: "#1B1B1B",
        "stroke-width": "1.24138"
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 36,
        columnNumber: 9
      }, this), u("path", {
        d: "M6.5 12.5H-1",
        stroke: "#1B1B1B",
        "stroke-width": "1.24138"
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 37,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$C,
      lineNumber: 10,
      columnNumber: 7
    }, this), u("defs", {
      children: u("clipPath", {
        id: "clip0_5008_6811",
        children: u("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, void 0, false, {
          fileName: _jsxFileName$C,
          lineNumber: 41,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$C,
        lineNumber: 40,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$C,
      lineNumber: 39,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$C,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$B = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/FreeShippingBar.tsx";
function FreeShippingBar() {
  const {
    free_shipping_threshold,
    cart
  } = useCart();
  t$2(h(false), "alreadyDispalyed");
  const [isVisible, setIsVisible] = t$2(h(false), "isVisible");
  y(() => {
    setIsVisible((cart == null ? void 0 : cart.total_price) >= free_shipping_threshold);
  }, [cart, free_shipping_threshold]);
  return u(b$2, {
    children: isVisible && u("div", {
      className: "my-4 bg-[#9DBEEC] font-primary font-normal text-sm p-2 flex items-center justify-center gap-2 b2b-hide",
      children: [u(TruckIcon, {}, void 0, false, {
        fileName: _jsxFileName$B,
        lineNumber: 21,
        columnNumber: 11
      }, this), " Congrats! You earned free shipping"]
    }, void 0, true, {
      fileName: _jsxFileName$B,
      lineNumber: 20,
      columnNumber: 9
    }, this)
  }, void 0);
}
register(FreeShippingBar, "free-shipping-bar");
var _jsxFileName$A = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/CartMotivationBar.tsx";
function CartMotivationBar() {
  var _a, _b, _c;
  const {
    motivators,
    cart
  } = useCart();
  const totalThreshold = (motivators == null ? void 0 : motivators.length) > 0 && ((_b = (_a = motivators[0]) == null ? void 0 : _a.settings) == null ? void 0 : _b.threshold);
  const [awayFromNextGoal, setAwayFromNextGoal] = t$2(h(totalThreshold), "awayFromNextGoal");
  const [awayPercentage, setAwayPercentage] = t$2(h(0), "awayPercentage");
  const [currentGoal, setCurrentGoal] = t$2(h(), "currentGoal");
  const [previouslyEarnedGoal, setPreviouslyEarnedGoal] = t$2(h(), "previouslyEarnedGoal");
  y(() => {
    const unattainedGoals = motivators == null ? void 0 : motivators.filter((motivator) => {
      var _a2;
      return (cart == null ? void 0 : cart.total_price) < ((_a2 = motivator == null ? void 0 : motivator.settings) == null ? void 0 : _a2.threshold);
    });
    const nextGoal = unattainedGoals[0];
    const earnedGoals = motivators == null ? void 0 : motivators.filter((motivator) => {
      var _a2;
      return (cart == null ? void 0 : cart.total_price) >= ((_a2 = motivator == null ? void 0 : motivator.settings) == null ? void 0 : _a2.threshold);
    });
    const prevEarnedGoal = earnedGoals[earnedGoals.length - 1];
    setCurrentGoal(nextGoal);
    setPreviouslyEarnedGoal(prevEarnedGoal);
  }, [cart, totalThreshold, motivators]);
  y(() => {
    var _a2;
    if (currentGoal) {
      const goalThreshold = (_a2 = currentGoal == null ? void 0 : currentGoal.settings) == null ? void 0 : _a2.threshold;
      setAwayFromNextGoal(goalThreshold - cart.total_price);
      setAwayPercentage(cart.total_price / goalThreshold * 100);
    } else if (previouslyEarnedGoal) {
      setAwayFromNextGoal(0);
    }
  }, [currentGoal, previouslyEarnedGoal, cart]);
  y(() => {
    var _a2, _b2, _c2, _d, _e, _f, _g;
    if ((previouslyEarnedGoal == null ? void 0 : previouslyEarnedGoal.type) === "cart_meter_free_gift" && ((_a2 = previouslyEarnedGoal == null ? void 0 : previouslyEarnedGoal.settings) == null ? void 0 : _a2.auto_add) === true && ((_b2 = previouslyEarnedGoal == null ? void 0 : previouslyEarnedGoal.settings) == null ? void 0 : _b2.variant_id)) {
      const giftAlreadyInCart = (_c2 = cart == null ? void 0 : cart.items) == null ? void 0 : _c2.find((item) => {
        var _a3, _b3;
        return ((_a3 = item.properties) == null ? void 0 : _a3._GWP) === true && item.variant_id == ((_b3 = previouslyEarnedGoal == null ? void 0 : previouslyEarnedGoal.settings) == null ? void 0 : _b3.variant_id);
      });
      if (giftAlreadyInCart) return;
      window.Shopify.cart.add({
        items: [{
          id: (_d = previouslyEarnedGoal == null ? void 0 : previouslyEarnedGoal.settings) == null ? void 0 : _d.variant_id,
          quantity: ((_e = previouslyEarnedGoal == null ? void 0 : previouslyEarnedGoal.settings) == null ? void 0 : _e.quantity) || 1,
          properties: {
            _GWP: true,
            _offer_terms: (_f = previouslyEarnedGoal == null ? void 0 : previouslyEarnedGoal.settings) == null ? void 0 : _f.offer_terms
          }
        }]
      });
    } else {
      const unattainedGoals = motivators == null ? void 0 : motivators.filter((motivator) => {
        var _a3;
        return (cart == null ? void 0 : cart.total_price) < ((_a3 = motivator == null ? void 0 : motivator.settings) == null ? void 0 : _a3.threshold);
      });
      const giftToRemove = unattainedGoals == null ? void 0 : unattainedGoals.find((goal) => {
        var _a3;
        return (goal == null ? void 0 : goal.type) === "cart_meter_free_gift" && ((_a3 = goal == null ? void 0 : goal.settings) == null ? void 0 : _a3.auto_add) === true;
      });
      const giftAlreadyInCart = (_g = cart == null ? void 0 : cart.items) == null ? void 0 : _g.find((item) => {
        var _a3, _b3;
        return ((_a3 = item.properties) == null ? void 0 : _a3._GWP) === true && item.variant_id == ((_b3 = giftToRemove == null ? void 0 : giftToRemove.settings) == null ? void 0 : _b3.variant_id);
      });
      if (giftAlreadyInCart) {
        window.Shopify.cart.removeItem({
          id: giftAlreadyInCart.variant_id.toString()
        });
      }
    }
  }, [previouslyEarnedGoal]);
  const goalReachedMessage = () => {
    var _a2;
    const hasOnlyShippingMotivator = (motivators == null ? void 0 : motivators.length) === 1 && ((_a2 = motivators[0]) == null ? void 0 : _a2.type) === "cart_meter_free_shipping";
    if (hasOnlyShippingMotivator) {
      return "Congrats! You earned free shipping!";
    } else {
      return "Congrats! You earned a free gift";
    }
  };
  return u("div", {
    className: "mb-3 mt-2 flex items-center justify-between b2b-hide",
    children: [u("div", {
      className: "text-sm mb-1 font-primary",
      children: awayFromNextGoal <= 0 ? u(b$2, {
        children: goalReachedMessage()
      }, void 0, false) : u(b$2, {
        children: ["You're ", shopifyFormatCurrency(awayFromNextGoal, "${{amount}}"), " ", "away from ", (_c = currentGoal == null ? void 0 : currentGoal.settings) == null ? void 0 : _c.title]
      }, void 0, true)
    }, void 0, false, {
      fileName: _jsxFileName$A,
      lineNumber: 101,
      columnNumber: 7
    }, this), u("div", {
      className: "w-full h-1 border border-black overflow-hidden max-w-[140px]",
      children: u("div", {
        className: "h-full bg-black transition-all duration-300",
        style: {
          width: `${awayPercentage}%`
        }
      }, void 0, false, {
        fileName: _jsxFileName$A,
        lineNumber: 112,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$A,
      lineNumber: 111,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$A,
    lineNumber: 100,
    columnNumber: 5
  }, this);
}
register(CartMotivationBar, "cart-motivation-bar");
var _jsxFileName$z = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/CartTitle.tsx";
function CartTitle({
  size = "small"
}) {
  const {
    cart
  } = useCart();
  return u("h2", {
    className: cn("flex items-start", size === "small" && "text-3xl font-primary font-normal", size === "large" && "text-5xl lg:text-6xl font-primary font-normal"),
    children: ["Cart", " ", u("span", {
      className: "text-eyebrow-md lg:text-3xl ml-1",
      children: ["(", cart == null ? void 0 : cart.item_count, ")"]
    }, void 0, true, {
      fileName: _jsxFileName$z,
      lineNumber: 22,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$z,
    lineNumber: 14,
    columnNumber: 5
  }, this);
}
register(CartTitle, "cart-title");
var _jsxFileName$y = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/CartSummary.tsx";
function CartSummary() {
  var _a, _b;
  const {
    cart
  } = useCart();
  ((_b = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.customer) == null ? void 0 : _b.status) === "Logged-In" ? true : false;
  const handleCartView = () => {
    const cartItems = cart.items.map((item, index) => {
      var _a2, _b2, _c, _d;
      const subscriptionType = (item == null ? void 0 : item.selling_plan_allocation) ? "subscribe" : "one-time-purchase";
      const subscriptionInterval = ((_b2 = (_a2 = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _a2.selling_plan) == null ? void 0 : _b2.name) ? (_d = (_c = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _c.selling_plan) == null ? void 0 : _d.name : "one-time";
      return {
        item_name: (item == null ? void 0 : item.product_title) || "",
        item_id: (item == null ? void 0 : item.sku) || "",
        currency: "USD",
        price: ((item == null ? void 0 : item.final_price) / 100).toFixed(2) || "",
        item_brand: item == null ? void 0 : item.vendor,
        item_category: item == null ? void 0 : item.product_type,
        item_category2: subscriptionType,
        item_category3: subscriptionInterval,
        item_variant: item == null ? void 0 : item.title,
        item_list_name: "",
        item_list_id: "",
        quantity: item == null ? void 0 : item.quantity,
        index
      };
    });
    (cartItems == null ? void 0 : cartItems.length) > 0 && sendDatalayer({
      event: "viewcart",
      ecommerce: {
        currencyCode: "USD",
        checkout: {
          actionField: {
            step: 0,
            action: "View Cart"
          },
          items: cartItems
        }
      }
    });
  };
  return u(b$2, {
    children: [u("div", {
      className: "flex font-primary justify-between text-sm w-full",
      children: [u("div", {
        children: "Subtotal"
      }, void 0, false, {
        fileName: _jsxFileName$y,
        lineNumber: 55,
        columnNumber: 9
      }, this), u("div", {
        className: "font-medium",
        children: shopifyFormatCurrency(cart == null ? void 0 : cart.total_price, "${{amount}}")
      }, void 0, false, {
        fileName: _jsxFileName$y,
        lineNumber: 56,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$y,
      lineNumber: 54,
      columnNumber: 7
    }, this), u(Button, {
      mode: "primary",
      tone: "default",
      to: "/checkout",
      onClick: handleCartView,
      children: "Checkout"
    }, void 0, false, {
      fileName: _jsxFileName$y,
      lineNumber: 75,
      columnNumber: 7
    }, this)]
  }, void 0);
}
register(CartSummary, "cart-summary");
var _jsxFileName$x = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/UpsellCarousel.tsx";
const TypedSwiper$1 = Swiper2;
const TypedSwiperSlide$1 = SwiperSlide;
function UpsellCarousel({
  children,
  controls = true,
  slides,
  slidesPerViewDesktop = 1,
  slidesPerViewMobile = 1
}) {
  if (typeof slides !== "object" || slides == null) return;
  const [atStart, setAtStart] = t$2(h(true), "atStart");
  const [atEnd, setAtEnd] = t$2(h(false), "atEnd");
  return u(b$2, {
    children: u(TypedSwiper$1, {
      modules: [Navigation],
      wrapperClass: "relative",
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 10,
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: 20
        }
      },
      onSlideChange: (e2) => {
        setAtStart(e2.isBeginning);
        setAtEnd(e2.isEnd);
      },
      children: [u("div", {
        slot: "container-start",
        children: (children || controls) && u("div", {
          className: clsx$1(["flex items-end gap-2 items-center", children ? "justify-between" : "justify-end"]),
          children: [u("div", {
            class: "flex-1",
            children
          }, void 0, false, {
            fileName: _jsxFileName$x,
            lineNumber: 67,
            columnNumber: 15
          }, this), controls && u("div", {
            className: "flex items-center justify-end gap-2 py-0.5 shrink-0 pr-1",
            children: [u(NavigationButton, {
              disabled: atStart,
              prev: true
            }, void 0, false, {
              fileName: _jsxFileName$x,
              lineNumber: 72,
              columnNumber: 19
            }, this), u(NavigationButton, {
              disabled: atEnd,
              next: true
            }, void 0, false, {
              fileName: _jsxFileName$x,
              lineNumber: 73,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$x,
            lineNumber: 71,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$x,
          lineNumber: 60,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$x,
        lineNumber: 58,
        columnNumber: 9
      }, this), slides.map((slide2) => u(TypedSwiperSlide$1, {
        children: slide2
      }, void 0, false, {
        fileName: _jsxFileName$x,
        lineNumber: 82,
        columnNumber: 11
      }, this))]
    }, void 0, true, {
      fileName: _jsxFileName$x,
      lineNumber: 38,
      columnNumber: 7
    }, this)
  }, void 0);
}
var _jsxFileName$w = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/CartUpsells.tsx";
function CartUpsells({
  numberOfSlidesDesktop = 1
}) {
  const {
    upsells
  } = useCart();
  const carouselSlides = upsells.map((upsell) => {
    var _a;
    return u("div", {
      className: "flex justify-between",
      children: [u("div", {
        className: "h-[100px] w-[100px] bg-haze flex items-center justify-center",
        children: u("img", {
          src: upsell.featured_image,
          alt: upsell.alt_text,
          className: "h-full w-auto cover"
        }, void 0, false, {
          fileName: _jsxFileName$w,
          lineNumber: 14,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$w,
        lineNumber: 13,
        columnNumber: 9
      }, this), u("div", {
        className: "flex items-stretch font-primary gap-3 p-3 border-l-0 border border-tints-20",
        children: [u("div", {
          children: [u("h4", {
            className: "text-sm",
            children: upsell == null ? void 0 : upsell.title
          }, void 0, false, {
            fileName: _jsxFileName$w,
            lineNumber: 22,
            columnNumber: 13
          }, this), u("div", {
            className: "text-sm text-tints-80",
            children: (_a = upsell == null ? void 0 : upsell.variants[0]) == null ? void 0 : _a.title
          }, void 0, false, {
            fileName: _jsxFileName$w,
            lineNumber: 23,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$w,
          lineNumber: 21,
          columnNumber: 11
        }, this), u("div", {
          className: "flex flex-col justify-between grow max-w-[58px] w-full items-end",
          children: [u("div", {
            className: "text-sm text-black font-medium",
            children: upsell == null ? void 0 : upsell.price
          }, void 0, false, {
            fileName: _jsxFileName$w,
            lineNumber: 28,
            columnNumber: 13
          }, this), u(AddToCartButton, {
            size: "compact",
            productData: upsell,
            openCartDrawer: false
          }, void 0, false, {
            fileName: _jsxFileName$w,
            lineNumber: 31,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$w,
          lineNumber: 27,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$w,
        lineNumber: 20,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$w,
      lineNumber: 12,
      columnNumber: 7
    }, this);
  });
  return u(b$2, {
    children: upsells && upsells.length > 0 && u(UpsellCarousel, {
      slidesPerViewDesktop: numberOfSlidesDesktop,
      slides: carouselSlides,
      children: u("div", {
        className: "font-secondary italic font-light text-eyebrow-sm",
        children: "Works Well With"
      }, void 0, false, {
        fileName: _jsxFileName$w,
        lineNumber: 49,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$w,
      lineNumber: 45,
      columnNumber: 9
    }, this)
  }, void 0);
}
register(CartUpsells, "cart-upsells", ["number-of-slides-desktop"]);
var _jsxFileName$v = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/AjaxCartDrawer.tsx";
function AjaxCartDrawer() {
  const {
    cartIsOpen,
    toggleCart
  } = useGlobal();
  const {
    cart
  } = useCart();
  return u(Sheet, {
    onOpenChange: toggleCart,
    open: cartIsOpen,
    children: u(SheetContent, {
      children: (cart == null ? void 0 : cart.item_count) === 0 ? u("div", {
        className: "flex h-full justify-between flex-col",
        children: [u("div", {
          className: "px-4 pt-6",
          children: [u("h2", {
            className: "text-3xl font-primary font-normal flex items-start",
            children: ["Cart", " "]
          }, void 0, true, {
            fileName: _jsxFileName$v,
            lineNumber: 27,
            columnNumber: 15
          }, this), u("div", {
            className: "text-sm font-primary",
            children: "Your cart is currently empty."
          }, void 0, false, {
            fileName: _jsxFileName$v,
            lineNumber: 30,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$v,
          lineNumber: 26,
          columnNumber: 13
        }, this), u("div", {
          className: "px-4 py-6",
          children: u(Button, {
            className: "w-full",
            mode: "primary",
            tone: "default",
            onClick: toggleCart,
            children: "Continue Shopping"
          }, void 0, false, {
            fileName: _jsxFileName$v,
            lineNumber: 35,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$v,
          lineNumber: 34,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$v,
        lineNumber: 25,
        columnNumber: 11
      }, this) : u("div", {
        className: "flex flex-col justify-between h-full",
        children: [u("div", {
          className: "px-4 pt-6",
          children: u("div", {
            className: "border-b border-tints-20",
            children: [u(CartTitle, {
              size: "small"
            }, void 0, false, {
              fileName: _jsxFileName$v,
              lineNumber: 49,
              columnNumber: 17
            }, this), u(CartMotivationBar, {}, void 0, false, {
              fileName: _jsxFileName$v,
              lineNumber: 50,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$v,
            lineNumber: 48,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$v,
          lineNumber: 47,
          columnNumber: 13
        }, this), u("div", {
          className: "mx-4",
          children: u(FreeShippingBar, {}, void 0, false, {
            fileName: _jsxFileName$v,
            lineNumber: 54,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$v,
          lineNumber: 53,
          columnNumber: 13
        }, this), u("div", {
          className: "flex flex-col gap-4 flex-grow py-5 px-4 overflow-auto lex ",
          children: [u(CartItems, {}, void 0, false, {
            fileName: _jsxFileName$v,
            lineNumber: 57,
            columnNumber: 15
          }, this), u("div", {
            className: "relative",
            children: u(CartUpsells, {
              numberOfSlidesDesktop: 1
            }, void 0, false, {
              fileName: _jsxFileName$v,
              lineNumber: 59,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$v,
            lineNumber: 58,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$v,
          lineNumber: 56,
          columnNumber: 13
        }, this), u("div", {
          className: "flex flex-col border-t border-tints-20 justify-center px-4 py-3",
          children: [u(CartSummary, {}, void 0, false, {
            fileName: _jsxFileName$v,
            lineNumber: 63,
            columnNumber: 15
          }, this), u("div", {
            className: "text-2xs text-center mt-3",
            children: "Have a promo code? Promotions, shipping and taxes are calculated at checkout."
          }, void 0, false, {
            fileName: _jsxFileName$v,
            lineNumber: 64,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$v,
          lineNumber: 62,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$v,
        lineNumber: 46,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$v,
      lineNumber: 23,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$v,
    lineNumber: 22,
    columnNumber: 5
  }, this);
}
register(AjaxCartDrawer, "ajax-cart-drawer");
var _jsxFileName$u = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/cart/AjaxCartTrigger.tsx";
function AjaxCartTrigger({
  children,
  ...rest
}) {
  const {
    toggleCart
  } = useGlobal();
  return u("button", {
    ...rest,
    onClick: toggleCart,
    children
  }, void 0, false, {
    fileName: _jsxFileName$u,
    lineNumber: 9,
    columnNumber: 5
  }, this);
}
register(AjaxCartTrigger, "ajax-cart-trigger", [], {
  shadow: true
});
var _jsxFileName$t = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Accordion/Content/AccordionImageTextContent.tsx";
function AccordionImageTextContent({
  item
}) {
  const title = item == null ? void 0 : item.title;
  const body = item == null ? void 0 : item.body;
  const listItems = item == null ? void 0 : item.listItems;
  const image = item == null ? void 0 : item.image;
  const link = item == null ? void 0 : item.link;
  return u(b$2, {
    children: u("div", {
      className: "mb-4 md:mb-8",
      children: [image && u("img", {
        src: image,
        className: "w-full mb-8"
      }, void 0, false, {
        fileName: _jsxFileName$t,
        lineNumber: 18,
        columnNumber: 19
      }, this), u("div", {
        className: "mb-8",
        children: [title && u("h2", {
          className: "text-4xl mb-3",
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$t,
          lineNumber: 20,
          columnNumber: 21
        }, this), body && u("p", {
          className: "text-xl",
          children: body
        }, void 0, false, {
          fileName: _jsxFileName$t,
          lineNumber: 21,
          columnNumber: 20
        }, this), (link == null ? void 0 : link.text) && (link == null ? void 0 : link.url) && u("a", {
          href: link.url,
          className: "underline mt-6 block text-xl",
          children: link.text
        }, void 0, false, {
          fileName: _jsxFileName$t,
          lineNumber: 23,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$t,
        lineNumber: 19,
        columnNumber: 9
      }, this), listItems && listItems.length > 0 && u("ul", {
        className: "flex flex-col gap-6",
        children: listItems.map(({
          title: title2,
          content
        }, index) => u("li", {
          children: [u("div", {
            className: "flex items-center mb-2",
            children: [u("div", {
              className: "bg-black size-3 rounded-full mr-3"
            }, void 0, false, {
              fileName: _jsxFileName$t,
              lineNumber: 33,
              columnNumber: 19
            }, this), u("h3", {
              className: "text-2xl",
              children: title2
            }, void 0, false, {
              fileName: _jsxFileName$t,
              lineNumber: 34,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$t,
            lineNumber: 32,
            columnNumber: 17
          }, this), u("p", {
            className: "text-base ml-6",
            children: content
          }, void 0, false, {
            fileName: _jsxFileName$t,
            lineNumber: 36,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$t,
          lineNumber: 31,
          columnNumber: 15
        }, this))
      }, void 0, false, {
        fileName: _jsxFileName$t,
        lineNumber: 29,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$t,
      lineNumber: 17,
      columnNumber: 7
    }, this)
  }, void 0);
}
var _jsxFileName$s = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Accordion/AccordionImageText.tsx";
function AccordionImageText({
  title,
  items,
  onToggle,
  isOpen,
  index
}) {
  const handleClick = () => {
    if (onToggle && typeof onToggle === "function") {
      onToggle();
    }
  };
  return u(b$2, {
    children: u("div", {
      className: "font-primary",
      onClick: () => handleClick(),
      children: [u("div", {
        className: "flex justify-start container my-3",
        children: [u("span", {
          className: "text-button-lg leading-5 mr-[15px]",
          children: `0${index}`
        }, void 0, false, {
          fileName: _jsxFileName$s,
          lineNumber: 28,
          columnNumber: 11
        }, this), u("h2", {
          className: "text-3xl md:text-5xl",
          children: title || ""
        }, void 0, false, {
          fileName: _jsxFileName$s,
          lineNumber: 29,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$s,
        lineNumber: 27,
        columnNumber: 9
      }, this), u("div", {
        className: `container transition-all duration-100 grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-8 ${isOpen ? "max-h-full opacity-100 mt-8 mb-10 md:mb-20 pointer-events-auto" : "max-h-0 opacity-0 pointer-events-none"}`,
        children: items == null ? void 0 : items.map(({
          content
        }, index2) => u(AccordionImageTextContent, {
          item: content
        }, content == null ? void 0 : content.title, false, {
          fileName: _jsxFileName$s,
          lineNumber: 39,
          columnNumber: 13
        }, this))
      }, void 0, false, {
        fileName: _jsxFileName$s,
        lineNumber: 31,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$s,
      lineNumber: 26,
      columnNumber: 7
    }, this)
  }, void 0);
}
var _jsxFileName$r = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Accordion/AccordionWrapper.tsx";
function AccordionWrapper({
  accordionSettings,
  title
}) {
  const [openIndex, setOpenIndex] = t$2(h(null), "openIndex");
  const parsedSettings = JSON.parse(accordionSettings);
  const refs = t$2(A$1([]), "refs");
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  y(() => {
    setTimeout(() => {
      if (openIndex !== null && refs.current[openIndex]) {
        refs.current[openIndex].scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }, 300);
  }, [openIndex]);
  return u("div", {
    children: [u("div", {
      className: "container",
      children: u("h2", {
        className: "text-3xl md:text-4xl md:max-w-[628px] mb-12 md:mb-20 font-primary",
        children: title
      }, void 0, false, {
        fileName: _jsxFileName$r,
        lineNumber: 38,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$r,
      lineNumber: 37,
      columnNumber: 7
    }, this), parsedSettings == null ? void 0 : parsedSettings.map(({
      title: title2,
      items
    }, index) => u("div", {
      ref: (el) => refs.current[index] = el,
      className: "last:border-b border-t border-black",
      children: u(AccordionImageText, {
        title: title2,
        items,
        onToggle: () => {
          handleToggle(index);
        },
        isOpen: openIndex === index,
        index: index + 1
      }, void 0, false, {
        fileName: _jsxFileName$r,
        lineNumber: 48,
        columnNumber: 11
      }, this)
    }, title2, false, {
      fileName: _jsxFileName$r,
      lineNumber: 43,
      columnNumber: 9
    }, this))]
  }, void 0, true, {
    fileName: _jsxFileName$r,
    lineNumber: 36,
    columnNumber: 5
  }, this);
}
register(AccordionWrapper, "accordion-wrapper");
var _jsxFileName$q = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/HeadphonesIcon.tsx";
function HeadphonesIcon({
  width = "20",
  height = "20",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 20 20",
    ...props,
    children: [u("path", {
      d: "M17 14V9C17 5.13401 13.866 2 10 2V2C6.13401 2 3 5.13401 3 9V14",
      stroke: "black",
      "stroke-linejoin": "round"
    }, void 0, false, {
      fileName: _jsxFileName$q,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("rect", {
      x: "3",
      y: "10",
      width: "3",
      height: "5",
      stroke: "black",
      "stroke-linejoin": "round"
    }, void 0, false, {
      fileName: _jsxFileName$q,
      lineNumber: 16,
      columnNumber: 7
    }, this), u("rect", {
      x: "9",
      y: "17",
      width: "3",
      height: "2",
      stroke: "black",
      "stroke-linejoin": "round"
    }, void 0, false, {
      fileName: _jsxFileName$q,
      lineNumber: 24,
      columnNumber: 7
    }, this), u("rect", {
      x: "14",
      y: "10",
      width: "3",
      height: "5",
      stroke: "black",
      "stroke-linejoin": "round"
    }, void 0, false, {
      fileName: _jsxFileName$q,
      lineNumber: 32,
      columnNumber: 7
    }, this), u("path", {
      d: "M15.5 15V17C15.5 17.5523 15.0523 18 14.5 18H12",
      stroke: "black",
      "stroke-linejoin": "round"
    }, void 0, false, {
      fileName: _jsxFileName$q,
      lineNumber: 40,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$q,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$p = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/ToolIcon.tsx";
function ToolIcon({
  width = "20",
  height = "20",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 20 20",
    ...props,
    children: [u("path", {
      d: "M2 4.06639C2 3.76564 2.26359 3.53295 2.56202 3.57025L6 4V8L2.56202 8.42975C2.26359 8.46705 2 8.23436 2 7.93361V4.06639Z",
      stroke: "black"
    }, void 0, false, {
      fileName: _jsxFileName$p,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("path", {
      d: "M6 8V4L9.6437 2.78543C11.1911 2.26965 12.8411 2.14018 14.45 2.40833L17.1644 2.86073C17.6466 2.9411 18 3.35829 18 3.84713V8.15287C18 8.64171 17.6466 9.0589 17.1644 9.13927L14.45 9.59167C12.8411 9.85982 11.1911 9.73035 9.6437 9.21457L6 8Z",
      stroke: "black"
    }, void 0, false, {
      fileName: _jsxFileName$p,
      lineNumber: 15,
      columnNumber: 7
    }, this), u("path", {
      d: "M12 15.6126V10L15 9.5V16L13.3162 16.5613C12.6687 16.7771 12 16.2951 12 15.6126Z",
      stroke: "black",
      "stroke-linejoin": "round"
    }, void 0, false, {
      fileName: _jsxFileName$p,
      lineNumber: 19,
      columnNumber: 7
    }, this), u("path", {
      d: "M13 16.5L14.5 16V19H14L13 16.5Z",
      fill: "black"
    }, void 0, false, {
      fileName: _jsxFileName$p,
      lineNumber: 24,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$p,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$o = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/SpeechBubbleIcon.tsx";
function SpeechBubbleIcon({
  width = "20",
  height = "20",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 20 20",
    ...props,
    children: u("path", {
      d: "M3.85355 16.1464L3.5 15.7929L3.85355 16.1464ZM7 13V12.5H6.79289L6.64645 12.6464L7 13ZM3.5 5C3.5 4.72386 3.72386 4.5 4 4.5V3.5C3.17157 3.5 2.5 4.17157 2.5 5H3.5ZM3.5 13L3.5 5H2.5L2.5 13H3.5ZM3.5 15.7929L3.5 13H2.5L2.5 15.7929H3.5ZM3.5 15.7929H3.5H2.5C2.5 16.6838 3.57714 17.13 4.20711 16.5L3.5 15.7929ZM6.64645 12.6464L3.5 15.7929L4.20711 16.5L7.35355 13.3536L6.64645 12.6464ZM16 12.5H7V13.5H16V12.5ZM16.5 12C16.5 12.2761 16.2761 12.5 16 12.5V13.5C16.8284 13.5 17.5 12.8284 17.5 12H16.5ZM16.5 5V12H17.5V5H16.5ZM16 4.5C16.2761 4.5 16.5 4.72386 16.5 5H17.5C17.5 4.17157 16.8284 3.5 16 3.5V4.5ZM4 4.5L16 4.5V3.5L4 3.5V4.5Z",
      fill: "black"
    }, void 0, false, {
      fileName: _jsxFileName$o,
      lineNumber: 11,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$o,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$n = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Footer/IconNavigation/IconNavigation.tsx";
function IconNavigation({
  text,
  items
}) {
  return u(b$2, {
    children: u("div", {
      className: "bg-transparent md:w-1/4 mb-[30px] md:mb-0 md:max-w-[304px] font-primary",
      children: [u("div", {
        className: "rte icon-navigation__rte",
        dangerouslySetInnerHTML: {
          __html: text || ""
        }
      }, void 0, false, {
        fileName: _jsxFileName$n,
        lineNumber: 25,
        columnNumber: 9
      }, this), u("div", {
        className: "bg-white rounded-md",
        children: u("ul", {
          className: "flex flex-col items-start mt-4",
          children: items == null ? void 0 : items.map((item) => u("li", {
            className: "flex last:border-none border-b border-haze w-full",
            children: u("a", {
              className: "flex items-center py-[13px] px-4 text-sm w-full",
              href: (item == null ? void 0 : item.url) || "#",
              children: [(item == null ? void 0 : item.icon) === "contact" ? u(HeadphonesIcon, {
                className: "mr-4"
              }, void 0, false, {
                fileName: _jsxFileName$n,
                lineNumber: 40,
                columnNumber: 21
              }, this) : (item == null ? void 0 : item.icon) === "tool" ? u(ToolIcon, {
                className: "mr-4"
              }, void 0, false, {
                fileName: _jsxFileName$n,
                lineNumber: 42,
                columnNumber: 21
              }, this) : u(SpeechBubbleIcon, {
                className: "mr-4"
              }, void 0, false, {
                fileName: _jsxFileName$n,
                lineNumber: 44,
                columnNumber: 21
              }, this), u("span", {
                children: (item == null ? void 0 : item.text) || ""
              }, void 0, false, {
                fileName: _jsxFileName$n,
                lineNumber: 46,
                columnNumber: 19
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$n,
              lineNumber: 35,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$n,
            lineNumber: 32,
            columnNumber: 15
          }, this))
        }, void 0, false, {
          fileName: _jsxFileName$n,
          lineNumber: 30,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$n,
        lineNumber: 29,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$n,
      lineNumber: 20,
      columnNumber: 7
    }, this)
  }, void 0);
}
register(IconNavigation, "icon-navigation");
var _jsxFileName$m = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/OfferIcon.tsx";
function OfferIcon({
  width = "24",
  height = "24",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [u("path", {
      d: "M2.39999 2.3999H12L21.6 11.9999L12 21.5999L2.39999 11.9999V2.3999Z",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$m,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("circle", {
      cx: "7.2",
      cy: "7.2",
      r: "1.2",
      fill: "#EFEBE7",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$m,
      lineNumber: 16,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$m,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$l = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/ReturnIcon.tsx";
function ReturnIcon({
  width = "24",
  height = "24",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [u("path", {
      d: "M9.59998 9.6001L3.59998 15.6001L9.59998 21.6001",
      stroke: "#1B1B1B",
      "stroke-width": "1.2"
    }, void 0, false, {
      fileName: _jsxFileName$l,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("path", {
      d: "M8.39998 3.6001H15.6C18.9137 3.6001 21.6 6.28639 21.6 9.6001V9.6001C21.6 12.9138 18.9137 15.6001 15.6 15.6001H3.59998",
      stroke: "#1B1B1B",
      "stroke-width": "1.2"
    }, void 0, false, {
      fileName: _jsxFileName$l,
      lineNumber: 16,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$l,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$k = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/SecureIcon.tsx";
function SecureIcon({
  width = "24",
  height = "24",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [u("path", {
      d: "M4.79999 4.7999L12 2.3999L19.2 4.7999V11.6621C19.2 14.8719 17.5958 17.8693 14.9251 19.6498L12 21.5999L9.07487 19.6498C6.40416 17.8693 4.79999 14.8719 4.79999 11.6621V4.7999Z",
      stroke: "#1B1B1B",
      "stroke-width": "1.2"
    }, void 0, false, {
      fileName: _jsxFileName$k,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("path", {
      d: "M12 2.3999V21.5999",
      stroke: "black",
      "stroke-width": "1.2"
    }, void 0, false, {
      fileName: _jsxFileName$k,
      lineNumber: 16,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$k,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$j = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/DeliveryIcon.tsx";
function DeliveryIcon({
  width = "24",
  height = "24",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [u("path", {
      d: "M2.39999 5.99995L12 1.19995L21.6 5.99995V17.9999L12 22.8L2.39999 17.9999L2.39999 5.99995Z",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$j,
      lineNumber: 11,
      columnNumber: 7
    }, this), u("path", {
      d: "M2.39999 6L12 10.8L21.6 6",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$j,
      lineNumber: 16,
      columnNumber: 7
    }, this), u("path", {
      d: "M12 10.8V22.8",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$j,
      lineNumber: 17,
      columnNumber: 7
    }, this), u("path", {
      d: "M7.8 3.6001L16.8 8.4001",
      stroke: "#1B1B1B",
      "stroke-width": "1.5"
    }, void 0, false, {
      fileName: _jsxFileName$j,
      lineNumber: 18,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$j,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$i = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Footer/TopBar/TopBar.tsx";
function TopBar({
  items = []
}) {
  return u("div", {
    className: "border-[#1B1B1B17] border-b mb-8 py-4",
    children: u("ul", {
      className: `flex container gap-5 justify-between`,
      children: items == null ? void 0 : items.map((item) => u("li", {
        className: `flex flex-col md:flex-row text-button-lg md:text-[17px] font-secondary items-center gap-2 md:gap-0 md:justify-start`,
        children: [u("div", {
          className: "flex items-center md:py-[13px]",
          children: (item == null ? void 0 : item.icon) === "contact" ? u(HeadphonesIcon, {
            height: "24",
            width: "24",
            className: "md:mr-3"
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 29,
            columnNumber: 17
          }, this) : (item == null ? void 0 : item.icon) === "tool" ? u(ToolIcon, {
            height: "24",
            width: "24",
            className: "md:mr-3"
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 35,
            columnNumber: 17
          }, this) : (item == null ? void 0 : item.icon) === "offer" ? u(OfferIcon, {
            height: "24",
            width: "24",
            className: "md:mr-3"
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 37,
            columnNumber: 17
          }, this) : (item == null ? void 0 : item.icon) === "return" ? u(ReturnIcon, {
            height: "24",
            width: "24",
            className: "md:mr-3"
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 39,
            columnNumber: 17
          }, this) : (item == null ? void 0 : item.icon) === "delivery" ? u(DeliveryIcon, {
            height: "24",
            width: "24",
            className: "md:mr-3"
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 41,
            columnNumber: 17
          }, this) : (item == null ? void 0 : item.icon) === "secure" ? u(SecureIcon, {
            height: "24",
            width: "24",
            className: "md:mr-3"
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 47,
            columnNumber: 17
          }, this) : u(SpeechBubbleIcon, {
            height: "24",
            width: "24",
            className: "md:mr-3"
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 49,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$i,
          lineNumber: 27,
          columnNumber: 13
        }, this), u("p", {
          className: "text-center",
          children: (item == null ? void 0 : item.text) || ""
        }, void 0, false, {
          fileName: _jsxFileName$i,
          lineNumber: 56,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$i,
        lineNumber: 24,
        columnNumber: 11
      }, this))
    }, void 0, false, {
      fileName: _jsxFileName$i,
      lineNumber: 22,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$i,
    lineNumber: 21,
    columnNumber: 5
  }, this);
}
register(TopBar, "top-bar");
var _jsxFileName$h = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/TiktokIcon.tsx";
function TiktokIcon({
  width = "13",
  height = "15",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width,
    height,
    viewBox: "0 0 13 15",
    fill: "none",
    ...props,
    children: [u("rect", {
      width,
      height,
      fill: "url(#pattern0_3085_904)"
    }, void 0, false, {
      fileName: _jsxFileName$h,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("defs", {
      children: [u("pattern", {
        id: "pattern0_3085_904",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: u("use", {
          xlinkHref: "#image0_3085_904",
          transform: "matrix(0.00384615 0 0 0.00333333 -0.00769231 0)"
        }, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 20,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$h,
        lineNumber: 14,
        columnNumber: 9
      }, this), u("image", {
        id: "image0_3085_904",
        width: 264,
        height: 300,
        xlinkHref: "data:image/png;base64,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"
      }, void 0, false, {
        fileName: _jsxFileName$h,
        lineNumber: 25,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$h,
      lineNumber: 13,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$h,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$g = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/InstagramIcon.tsx";
function InstagramIcon({
  width = "17",
  height = "17",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width,
    height,
    viewBox: "0 0 17 17",
    fill: "none",
    ...props,
    children: [u("rect", {
      width: 17,
      height: 17,
      fill: "url(#pattern0_3085_902)"
    }, void 0, false, {
      fileName: _jsxFileName$g,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("defs", {
      children: [u("pattern", {
        id: "pattern0_3085_902",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: u("use", {
          xlinkHref: "#image0_3085_902",
          transform: "scale(0.00195312)"
        }, void 0, false, {
          fileName: _jsxFileName$g,
          lineNumber: 20,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$g,
        lineNumber: 14,
        columnNumber: 9
      }, this), u("image", {
        id: "image0_3085_902",
        width: 512,
        height: 512,
        xlinkHref: "data:image/png;base64,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"
      }, void 0, false, {
        fileName: _jsxFileName$g,
        lineNumber: 22,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$g,
      lineNumber: 13,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$g,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$f = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/YoutubeIcon.tsx";
function YoutubeIcon({
  width = "15",
  height = "15",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ...props,
    children: [u("rect", {
      width: 15,
      height: 15,
      fill: "url(#pattern0_3085_905)"
    }, void 0, false, {
      fileName: _jsxFileName$f,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("defs", {
      children: [u("pattern", {
        id: "pattern0_3085_905",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: u("use", {
          xlinkHref: "#image0_3085_905",
          transform: "scale(0.00195312)"
        }, void 0, false, {
          fileName: _jsxFileName$f,
          lineNumber: 20,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$f,
        lineNumber: 14,
        columnNumber: 9
      }, this), u("image", {
        id: "image0_3085_905",
        width: 512,
        height: 512,
        xlinkHref: "data:image/png;base64,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"
      }, void 0, false, {
        fileName: _jsxFileName$f,
        lineNumber: 22,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$f,
      lineNumber: 13,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$f,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$e = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/PinterestIcon.tsx";
function PinterestIcon({
  width = "17",
  height = "17",
  ...props
}) {
  return u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ...props,
    children: [u("rect", {
      width: 15,
      height: 15,
      fill: "url(#pattern0_3085_906)"
    }, void 0, false, {
      fileName: _jsxFileName$e,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("defs", {
      children: [u("pattern", {
        id: "pattern0_3085_906",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: u("use", {
          xlinkHref: "#image0_3085_906",
          transform: "translate(0 -0.0113095) scale(0.00119048)"
        }, void 0, false, {
          fileName: _jsxFileName$e,
          lineNumber: 20,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$e,
        lineNumber: 14,
        columnNumber: 9
      }, this), u("image", {
        id: "image0_3085_906",
        width: 840,
        height: 859,
        xlinkHref: "data:image/png;base64,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"
      }, void 0, false, {
        fileName: _jsxFileName$e,
        lineNumber: 25,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$e,
      lineNumber: 13,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$e,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$d = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Social/SocialIcons.tsx";
function SocialIcons({
  socialItems
}) {
  return u(b$2, {
    children: u("div", {
      className: "flex gap-4 mt-5 mb-[27px] md:m-0",
      children: socialItems == null ? void 0 : socialItems.map((item) => u("a", {
        href: (item == null ? void 0 : item.url) || "#",
        children: [(item == null ? void 0 : item.icon) === "Instagram" ? u(InstagramIcon, {
          className: ""
        }, void 0, false, {
          fileName: _jsxFileName$d,
          lineNumber: 19,
          columnNumber: 43
        }, this) : "", (item == null ? void 0 : item.icon) === "Tiktok" ? u(TiktokIcon, {
          className: ""
        }, void 0, false, {
          fileName: _jsxFileName$d,
          lineNumber: 20,
          columnNumber: 40
        }, this) : "", (item == null ? void 0 : item.icon) === "Youtube" ? u(YoutubeIcon, {
          className: ""
        }, void 0, false, {
          fileName: _jsxFileName$d,
          lineNumber: 21,
          columnNumber: 41
        }, this) : "", (item == null ? void 0 : item.icon) === "Pinterest" ? u(PinterestIcon, {
          className: ""
        }, void 0, false, {
          fileName: _jsxFileName$d,
          lineNumber: 22,
          columnNumber: 43
        }, this) : ""]
      }, void 0, true, {
        fileName: _jsxFileName$d,
        lineNumber: 18,
        columnNumber: 11
      }, this))
    }, void 0, false, {
      fileName: _jsxFileName$d,
      lineNumber: 16,
      columnNumber: 7
    }, this)
  }, void 0);
}
register(SocialIcons, "social-icons");
var _jsxFileName$c = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Footer/BottomBar/BottomBar.tsx";
function BottomBar({
  items,
  logo,
  socialItems
}) {
  return u(b$2, {
    children: u("div", {
      className: "flex flex-col md:flex-row items-center justify-between mt-12 md:mt-16 container",
      children: [u("a", {
        href: "/",
        children: u("img", {
          src: logo,
          alt: "logo",
          className: "w-[86px] mb-3"
        }, void 0, false, {
          fileName: _jsxFileName$c,
          lineNumber: 25,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 24,
        columnNumber: 9
      }, this), u("ul", {
        className: "flex items-center gap-x-3 md:gap-x-6 px-3.5 flex-wrap justify-center ",
        children: items == null ? void 0 : items.map((item) => u("li", {
          className: "flex whitespace-nowrap",
          children: u("a", {
            className: "flex items-center md:py-[13px] text-xs md:text-[10px] font-primary",
            href: (item == null ? void 0 : item.url) || "#",
            children: u("span", {
              children: (item == null ? void 0 : item.text) || ""
            }, void 0, false, {
              fileName: _jsxFileName$c,
              lineNumber: 40,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 34,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$c,
          lineNumber: 33,
          columnNumber: 13
        }, this))
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 27,
        columnNumber: 9
      }, this), u(SocialIcons, {
        socialItems
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 45,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$c,
      lineNumber: 19,
      columnNumber: 7
    }, this)
  }, void 0);
}
register(BottomBar, "bottom-bar");
var _jsxFileName$b = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/elements/Footer/Footer.tsx";
function Footer({
  footerNavigation,
  iconNavigation,
  topBar,
  bottomBar,
  logo,
  socialMedia
}) {
  const parsedFooterNavigation = JSON.parse(footerNavigation || "[]");
  const parsedIconNavigation = JSON.parse(iconNavigation || "{}");
  const parsedTopBar = JSON.parse(topBar || "{}");
  const parsedBottomBar = JSON.parse(bottomBar || "{}");
  const parsedSocialMedia = JSON.parse(socialMedia || "{}");
  return u(b$2, {
    children: u("div", {
      className: "",
      children: [u(TopBar, {
        items: parsedTopBar
      }, void 0, false, {
        fileName: _jsxFileName$b,
        lineNumber: 33,
        columnNumber: 9
      }, this), u("div", {
        className: "md:flex container md:justify-between",
        children: [u(IconNavigation, {
          text: (parsedIconNavigation == null ? void 0 : parsedIconNavigation.icon_navigation_text) || "",
          items: (parsedIconNavigation == null ? void 0 : parsedIconNavigation.items) || []
        }, void 0, false, {
          fileName: _jsxFileName$b,
          lineNumber: 35,
          columnNumber: 11
        }, this), parsedFooterNavigation.map((navItem, index) => u("div", {
          className: `md:hidden border-t border-shadow ${index === parsedFooterNavigation.length - 1 ? "border-b" : ""}`,
          children: u(AccordionComponent, {
            title: navItem == null ? void 0 : navItem.title,
            detailsClass: "py-3.5 pr-2.5",
            summaryClass: "font-primary text-sm text-[17px]",
            itemsClass: "gap-y-2 w-[196px] text-sm",
            linkItems: navItem == null ? void 0 : navItem.links
          }, void 0, false, {
            fileName: _jsxFileName$b,
            lineNumber: 47,
            columnNumber: 15
          }, this)
        }, index, false, {
          fileName: _jsxFileName$b,
          lineNumber: 40,
          columnNumber: 13
        }, this)), u("div", {
          className: "hidden md:flex md:w-3/4 md:justify-end md:ml-5",
          children: parsedFooterNavigation.map((navItem) => {
            var _a;
            return u("ul", {
              className: "text-sm flex flex-col gap-y-2 mr-5 md:min-w-[150px] lg:min-w-[196px] gap-x-5",
              children: [u("p", {
                className: "font-secondary text-[17px] italic",
                children: navItem == null ? void 0 : navItem.title
              }, void 0, false, {
                fileName: _jsxFileName$b,
                lineNumber: 63,
                columnNumber: 17
              }, this), (_a = navItem == null ? void 0 : navItem.links) == null ? void 0 : _a.map((linkItem) => u("li", {
                children: u("a", {
                  href: (linkItem == null ? void 0 : linkItem.url) || "#",
                  className: "font-primary leading-5",
                  children: (linkItem == null ? void 0 : linkItem.title) || ""
                }, void 0, false, {
                  fileName: _jsxFileName$b,
                  lineNumber: 68,
                  columnNumber: 21
                }, this)
              }, linkItem == null ? void 0 : linkItem.url, false, {
                fileName: _jsxFileName$b,
                lineNumber: 67,
                columnNumber: 19
              }, this))]
            }, navItem == null ? void 0 : navItem.title, true, {
              fileName: _jsxFileName$b,
              lineNumber: 59,
              columnNumber: 15
            }, this);
          })
        }, void 0, false, {
          fileName: _jsxFileName$b,
          lineNumber: 57,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$b,
        lineNumber: 34,
        columnNumber: 9
      }, this), u(BottomBar, {
        items: parsedBottomBar,
        logo,
        socialItems: parsedSocialMedia
      }, void 0, false, {
        fileName: _jsxFileName$b,
        lineNumber: 80,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$b,
      lineNumber: 32,
      columnNumber: 7
    }, this)
  }, void 0);
}
register(Footer, "footer-section");
var _jsxFileName$a = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/forms/WufooForm.tsx";
function WufooForm({
  form_hash
}) {
  return u("div", {
    className: "flex justify-center py-16 wufoo-form",
    id: `wufoo-${form_hash}`
  }, void 0, false, {
    fileName: _jsxFileName$a,
    lineNumber: 9,
    columnNumber: 5
  }, this);
}
register(WufooForm, "wufoo-form");
var _jsxFileName$9 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/icons/Cart.tsx";
function Cart(props) {
  return u("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "aria-label": "Cart Icon",
    children: [u("path", {
      d: "M3.33334 17.5L4.16668 5.83333H15.8333L16.6667 17.5H3.33334Z",
      stroke: "currentColor",
      "stroke-width": "1.25",
      "stroke-linejoin": "round"
    }, void 0, false, {
      fileName: _jsxFileName$9,
      lineNumber: 12,
      columnNumber: 7
    }, this), u("path", {
      d: "M7.50001 8.33334V5.00001V4.33334C7.50001 2.86058 8.6193 1.66667 10 1.66667C11.3807 1.66667 12.5 2.86058 12.5 4.33334V5.00001V8.33334",
      stroke: "currentColor",
      "stroke-width": "1.25"
    }, void 0, false, {
      fileName: _jsxFileName$9,
      lineNumber: 18,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$9,
    lineNumber: 3,
    columnNumber: 5
  }, this);
}
var _jsxFileName$8 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/header/MobileNav/MobileNavDrawer.tsx";
const MobileNavDrawer = ({
  toggleMenu,
  navItems,
  btnText,
  btnUrl
}) => {
  var _a, _b, _c;
  const [menuItems, setMenuItems] = t$2(h([]), "menuItems");
  y(() => {
    const parsedNavItems = {
      links: JSON.parse(navItems || "")
    };
    setMenuItems([parsedNavItems]);
  }, [navItems]);
  return u(b$2, {
    children: [u(OverlayComponent, {
      clickHandler: toggleMenu,
      overlayClass: "backdrop-blur-[72px]"
    }, void 0, false, {
      fileName: _jsxFileName$8,
      lineNumber: 31,
      columnNumber: 7
    }, void 0), u("div", {
      class: "fixed z-50 inset-0 flex items-start justify-start pointer-events-none mx-5 mt-12 overflow-auto",
      children: u("div", {
        class: "bg-white px-4 pt-6 pb-8 w-full rounded shadow-lg pointer-events-auto h-[90vh] min-w-[335px]",
        children: [u("div", {
          className: "flex justify-between items-start",
          children: [u("div", {
            className: "flex",
            children: (menuItems == null ? void 0 : menuItems.length) > 1 ? u("button", {
              onClick: () => {
                setMenuItems(menuItems.slice(0, -1));
              },
              children: u(ChevronDownIcon, {
                className: "transform rotate-90",
                height: "24",
                width: "24"
              }, void 0, false, {
                fileName: _jsxFileName$8,
                lineNumber: 45,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 40,
              columnNumber: 17
            }, void 0) : null
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 38,
            columnNumber: 13
          }, void 0), u("div", {
            children: (menuItems == null ? void 0 : menuItems.length) > 1 ? ((_a = menuItems == null ? void 0 : menuItems[(menuItems == null ? void 0 : menuItems.length) - 1 || 0]) == null ? void 0 : _a.title) && u("h2", {
              class: "text-2xl font-secondary italic font-light",
              children: menuItems == null ? void 0 : menuItems[(menuItems == null ? void 0 : menuItems.length) - 1 || 0].title
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 56,
              columnNumber: 19
            }, void 0) : u("a", {
              href: "/",
              children: u(Logo, {}, void 0, false, {
                fileName: _jsxFileName$8,
                lineNumber: 62,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 61,
              columnNumber: 17
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 53,
            columnNumber: 13
          }, void 0), u("button", {
            onClick: toggleMenu,
            children: u(PlusIcon, {
              className: "transform rotate-45",
              height: "24",
              width: "24"
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 67,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 66,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$8,
          lineNumber: 37,
          columnNumber: 11
        }, void 0), u("div", {
          class: "mt-9 mb-[92px] flex flex-col gap-y-5 font-primary",
          children: (_c = (_b = menuItems == null ? void 0 : menuItems[(menuItems == null ? void 0 : menuItems.length) - 1 || 0]) == null ? void 0 : _b.links) == null ? void 0 : _c.map((item) => {
            var _a2;
            return u("div", {
              class: "",
              children: ((_a2 = item == null ? void 0 : item.links) == null ? void 0 : _a2.length) > 0 ? u(Button, {
                className: "flex justify-between text-[24px] w-full font-normal",
                mode: "custom",
                onClick: () => {
                  setMenuItems([...menuItems, item]);
                },
                children: [item.title, " ", item.links.length > 0 && u(ChevronDownIcon, {
                  className: "transform rotate-[-90deg]",
                  height: "28",
                  width: "28"
                }, void 0, false, {
                  fileName: _jsxFileName$8,
                  lineNumber: 87,
                  columnNumber: 23
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$8,
                lineNumber: 78,
                columnNumber: 19
              }, void 0) : u(Button, {
                to: item.url,
                className: "flex justify-between text-[24px] font-normal",
                mode: "custom",
                children: item.title
              }, void 0, false, {
                fileName: _jsxFileName$8,
                lineNumber: 95,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 76,
              columnNumber: 15
            }, void 0);
          })
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 74,
          columnNumber: 11
        }, void 0), (menuItems == null ? void 0 : menuItems.length) === 1 && u("div", {
          className: "flex gap-[15px] justify-center",
          children: [btnText && btnUrl && u(Button, {
            mode: "secondary",
            className: "min-w-fit w-full px-[21px] text-button-sm",
            to: btnUrl,
            children: btnText
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 109,
            columnNumber: 17
          }, void 0), u(Button, {
            mode: "secondary",
            className: "min-w-fit w-full px-[21px] text-button-sm",
            to: "#",
            children: "Login/Register"
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 117,
            columnNumber: 15
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$8,
          lineNumber: 107,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$8,
        lineNumber: 36,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$8,
      lineNumber: 35,
      columnNumber: 7
    }, void 0)]
  }, void 0);
};
register(MobileNavDrawer, "mobile-nav-drawer");
var _jsxFileName$7 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/header/Header.tsx";
function MainHeader({
  main_nav,
  secondary_nav,
  mobile_nav,
  button_text,
  button_url,
  search_url = "/search",
  collection_products,
  collection_title,
  promo_text,
  promo_link
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = t$2(h(false), "mobileMenuOpen");
  const [searchBarOpen, setSearchBarOpen] = t$2(h(false), "searchBarOpen");
  const body = document.body;
  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (mobileMenuOpen) {
      body.classList.remove("no-scroll");
    } else {
      body.classList.add("no-scroll");
    }
  };
  const headerRef = t$2(A$1(null), "headerRef");
  const [headerHeight, setHeaderHeight] = t$2(h(0), "headerHeight");
  y(() => {
    const headerElement = headerRef.current;
    if (headerElement) {
      setHeaderHeight(headerElement.clientHeight);
    }
    const handleResize = () => {
      if (headerElement) {
        setHeaderHeight(headerElement.clientHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  function toggleSearchBar(e2) {
    e2.preventDefault();
    if (searchBarOpen) {
      setSearchBarOpen(false);
      document.body.style.overflow = "auto";
    } else {
      setSearchBarOpen(true);
      window.scroll(0, 0);
      document.body.style.overflow = "hidden";
    }
  }
  y(() => {
    const header = document.getElementById("header-container");
    const mainContent = document.getElementById("main-content");
    let lastScrollY = window.scrollY;
    if (header && mainContent) {
      const headerHeight2 = header.offsetHeight;
      mainContent.style.marginTop = `${headerHeight2}px`;
      const handleScroll2 = () => {
        const currentScrollY = window.scrollY;
        if (currentScrollY > lastScrollY && currentScrollY > headerHeight2) {
          header.classList.add("hide");
        } else {
          header.classList.remove("hide");
        }
        lastScrollY = currentScrollY;
      };
      window.addEventListener("scroll", handleScroll2);
      return () => {
        window.removeEventListener("scroll", handleScroll2);
      };
    }
  }, []);
  return u("div", {
    id: "header-container",
    className: "fixed w-full top-0 z-[999] transition-all",
    children: [promo_text && u("div", {
      className: twMerge("bg-shadow text-white text-center py-2 px-4 md:px-20"),
      children: u("div", {
        className: twMerge("text-2xs lg:text-[10px] font-medium tracking-wider font-primary", promo_link != "" && "underline underline-offset-2"),
        children: promo_link != "" ? parse$1(JSON.parse(promo_link)) : promo_text
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 133,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$7,
      lineNumber: 128,
      columnNumber: 9
    }, this), u("div", {
      ref: headerRef,
      className: twMerge("relative z-20 bg-white top-0"),
      children: [u("div", {
        className: "gap-5 flex items-center justify-between container",
        children: [main_nav && u("div", {
          className: "min-w-16",
          children: [u("div", {
            className: twMerge("hidden md:flex gap-5 justify-between"),
            children: JSON.parse(main_nav).map((menu, index) => {
              var _a;
              return u("div", {
                className: "py-4 group",
                children: [u("a", {
                  className: twMerge("uppercase text-button-sm tracking-wider font-medium font-primary"),
                  href: menu.url,
                  "aria-label": `Link to ${menu.title}`,
                  children: menu.title
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 150,
                  columnNumber: 21
                }, this), menu.links && menu.megamenu && u("div", {
                  className: twMerge(`max-w-[100%] absolute opacity-0 invisible group-hover:visible group-hover:opacity-100 transition py-12 left-0 w-screen bg-white z-10`),
                  style: `top: ${headerHeight}px`,
                  children: u("div", {
                    className: twMerge("flex gap-4 justify-between container"),
                    children: [menu.links.map((submenu, index2) => u("div", {
                      className: twMerge("flex-1 flex gap-5 flex-col"),
                      children: [submenu.url == "#" ? u("p", {
                        className: twMerge("font-secondary text-eyebrow-sm italic"),
                        children: submenu.title
                      }, void 0, false, {
                        fileName: _jsxFileName$7,
                        lineNumber: 177,
                        columnNumber: 33
                      }, this) : u("a", {
                        className: twMerge("font-secondary text-eyebrow-sm italic"),
                        href: submenu.url,
                        "aria-label": `Link to ${submenu.title}`,
                        children: submenu.title
                      }, void 0, false, {
                        fileName: _jsxFileName$7,
                        lineNumber: 185,
                        columnNumber: 33
                      }, this), u("ul", {
                        className: twMerge("gap-3 flex flex-col"),
                        children: submenu.links.map((sublink, index3) => u("li", {
                          children: u("a", {
                            className: twMerge("text-xl font-primary"),
                            href: sublink.url,
                            "aria-label": `Link to ${sublink.title}`,
                            children: sublink.title
                          }, void 0, false, {
                            fileName: _jsxFileName$7,
                            lineNumber: 198,
                            columnNumber: 37
                          }, this)
                        }, index3, false, {
                          fileName: _jsxFileName$7,
                          lineNumber: 197,
                          columnNumber: 35
                        }, this))
                      }, void 0, false, {
                        fileName: _jsxFileName$7,
                        lineNumber: 195,
                        columnNumber: 31
                      }, this)]
                    }, index2, true, {
                      fileName: _jsxFileName$7,
                      lineNumber: 172,
                      columnNumber: 29
                    }, this)), ((_a = menu.cards[0]) == null ? void 0 : _a.image) && u("div", {
                      className: twMerge("relative min-w-[300px] flex-1"),
                      children: [u("img", {
                        className: twMerge("absolute w-full inset-0 h-full z-0 object-cover"),
                        src: menu.cards[0].image,
                        alt: menu.cards[0].text
                      }, void 0, false, {
                        fileName: _jsxFileName$7,
                        lineNumber: 218,
                        columnNumber: 31
                      }, this), u("div", {
                        className: twMerge("z-10 absolute inset-0 h-full flex p-4 flex-col justify-between"),
                        children: [menu.cards[0].text && u("p", {
                          className: twMerge("text-4xl font-primary text-white"),
                          children: menu.cards[0].text
                        }, void 0, false, {
                          fileName: _jsxFileName$7,
                          lineNumber: 231,
                          columnNumber: 35
                        }, this), menu.cards[0].url && u(Button, {
                          className: "min-w-0 text-button-sm",
                          mode: "primary",
                          tone: "inverted",
                          to: menu.cards[0].url,
                          children: menu.cards[0].label
                        }, void 0, false, {
                          fileName: _jsxFileName$7,
                          lineNumber: 240,
                          columnNumber: 35
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName$7,
                        lineNumber: 225,
                        columnNumber: 31
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$7,
                      lineNumber: 213,
                      columnNumber: 29
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName$7,
                    lineNumber: 166,
                    columnNumber: 25
                  }, this)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 160,
                  columnNumber: 23
                }, this)]
              }, index, true, {
                fileName: _jsxFileName$7,
                lineNumber: 149,
                columnNumber: 19
              }, this);
            })
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 147,
            columnNumber: 15
          }, this), u("button", {
            className: twMerge("block md:hidden uppercase text-button-sm tracking-wider font-medium font-primary"),
            onClick: handleMobileMenuToggle,
            children: "MENU"
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 258,
            columnNumber: 15
          }, this), mobileMenuOpen && u(MobileNavDrawer, {
            toggleMenu: handleMobileMenuToggle,
            navItems: mobile_nav,
            btnText: button_text,
            btnUrl: button_url
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 267,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$7,
          lineNumber: 146,
          columnNumber: 13
        }, this), u("a", {
          href: "/",
          "aria-label": "Company Logo and link to Homepage",
          className: twMerge("flex justify-center items-center"),
          children: u(Logo, {}, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 283,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$7,
          lineNumber: 277,
          columnNumber: 11
        }, this), secondary_nav && u("div", {
          className: twMerge("flex min-w-16 gap-4 md:gap-5"),
          children: [u("div", {
            className: twMerge("hidden md:flex gap-4 md:gap-5 justify-between"),
            children: JSON.parse(secondary_nav).map((menu, index) => u("div", {
              className: "py-4 group",
              children: [u("a", {
                className: twMerge("uppercase text-button-sm tracking-wider font-medium font-primary"),
                href: menu.url,
                "aria-label": `Link to ${menu.title}`,
                children: menu.title
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 297,
                columnNumber: 21
              }, this), menu.is_columns == true && u("div", {
                className: twMerge(`max-w-[100%] absolute opacity-0 invisible group-hover:visible group-hover:opacity-100 transition py-12 left-0 w-screen bg-white z-10`),
                style: `top: ${headerHeight}px`,
                children: u("div", {
                  className: twMerge("flex gap-4 container"),
                  children: [1, 2, 3, 4].map((index2) => {
                    const image = menu[`image_${index2}`];
                    const text = menu[`text_${index2}`];
                    const url = menu[`url_${index2}`];
                    return image && text && url && u("a", {
                      href: url,
                      className: twMerge(`relative bg-cover bg-center rounded basis-1/4 p-2 min-h-40 overflow-hidden`),
                      style: {
                        backgroundImage: `url(${image})`
                      },
                      children: [u("div", {
                        className: twMerge("absolute -bottom-3 left-0 w-full h-full bg-cover bg-center pointer-events-none"),
                        style: {
                          backgroundImage: `url(${image})`,
                          maskImage: "linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.25) 40%, rgba(0, 0, 0, 0) 50%)",
                          // Gradient mask to control the blur intensity
                          WebkitMaskImage: "linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.75) 15%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.25) 40%, rgba(0, 0, 0, 0) 50%)",
                          // For Safari compatibility
                          filter: "blur(10px)",
                          // Adjust the blur value for the maximum blur at the bottom
                          opacity: 1
                          // Optional: Adjust the opacity for better blending
                        }
                      }, void 0, false, {
                        fileName: _jsxFileName$7,
                        lineNumber: 333,
                        columnNumber: 35
                      }, this), u("p", {
                        className: twMerge("text-3xl capitalize z-10 leading-none font-normal absolute bottom-2 left-2 font-primary text-white"),
                        children: text
                      }, void 0, false, {
                        fileName: _jsxFileName$7,
                        lineNumber: 349,
                        columnNumber: 35
                      }, this)]
                    }, index2, true, {
                      fileName: _jsxFileName$7,
                      lineNumber: 322,
                      columnNumber: 33
                    }, this);
                  })
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 313,
                  columnNumber: 25
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 307,
                columnNumber: 23
              }, this)]
            }, index, true, {
              fileName: _jsxFileName$7,
              lineNumber: 296,
              columnNumber: 19
            }, this))
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 290,
            columnNumber: 15
          }, this), u("div", {
            className: twMerge("hidden py-4 md:block"),
            children: u("button", {
              onClick: toggleSearchBar,
              className: twMerge("uppercase text-button-sm tracking-wider font-medium font-primary"),
              "aria-label": "Search Open Button",
              children: "Search"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 367,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 366,
            columnNumber: 15
          }, this), u("div", {
            className: twMerge("py-4 block md:hidden"),
            children: u("button", {
              onClick: toggleSearchBar,
              className: twMerge("uppercase text-button-sm tracking-wider font-medium font-primary"),
              "aria-label": "Search Open Button",
              children: searchBarOpen ? u(CloseIcon, {}, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 385,
                columnNumber: 36
              }, this) : u(Search, {}, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 385,
                columnNumber: 52
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 378,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 377,
            columnNumber: 15
          }, this), u("div", {
            className: twMerge("hidden md:block py-4"),
            children: u("a", {
              className: twMerge("uppercase text-button-sm tracking-wider font-medium font-primary"),
              href: "/account",
              "aria-label": "Link to Login page",
              children: "Login"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 389,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 388,
            columnNumber: 15
          }, this), u("div", {
            className: twMerge("py-4 hidden md:block"),
            children: u(AjaxCartTrigger, {
              "aria-label": "Cart Open Button",
              className: twMerge("uppercase text-button-sm tracking-wider font-medium font-primary"),
              children: "Cart"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 400,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 399,
            columnNumber: 15
          }, this), u("div", {
            className: twMerge("block py-4 md:hidden"),
            children: u(AjaxCartTrigger, {
              className: twMerge("uppercase text-button-sm tracking-wider font-medium font-primary"),
              "aria-label": "Cart Open Button",
              children: u(Cart, {}, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 416,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 410,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 409,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$7,
          lineNumber: 289,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$7,
        lineNumber: 144,
        columnNumber: 9
      }, this), searchBarOpen && u(MainSearch, {
        search_url,
        featured_products: collection_products,
        collection_title
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 423,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$7,
      lineNumber: 143,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$7,
    lineNumber: 123,
    columnNumber: 5
  }, this);
}
register(MainHeader, "main-header");
var _jsxFileName$6 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/ProductImageCarousel.tsx";
const TypedSwiper = Swiper2;
const TypedSwiperSlide = SwiperSlide;
function ProductImageCarousel({
  images = ""
}) {
  const imageArray = JSON.parse(images);
  const [mainSwiper, setMainSwiper] = t$2(h(null), "mainSwiper");
  const [thumbsSwiper, setThumbsSwiper] = t$2(h(null), "thumbsSwiper");
  const [atStart, setAtStart] = t$2(h(true), "atStart");
  const [atEnd, setAtEnd] = t$2(h(false), "atEnd");
  const [activeIndex, setActiveIndex] = t$2(h(0), "activeIndex");
  return u(b$2, {
    children: u("div", {
      className: "relative",
      children: [u(TypedSwiper, {
        modules: [Navigation, Pagination, A11y, Thumb],
        thumbs: {
          swiper: thumbsSwiper
        },
        centeredSlides: true,
        centeredSlidesBounds: true,
        pagination: {
          el: "#containerForBullets",
          type: "bullets",
          bulletClass: "h-1.5 w-1.5 bg-black/20 rounded-full inline-block",
          bulletActiveClass: "!bg-black",
          clickable: true
        },
        slidesPerView: "auto",
        onSwiper: setMainSwiper,
        onSlideChange: (e2) => {
          setActiveIndex(e2.activeIndex);
          setAtStart(e2.isBeginning);
          setAtEnd(e2.isEnd);
        },
        children: [imageArray.filter((image) => {
          return image.alt.toLowerCase().indexOf("exclude") === -1;
        }).map((image, index) => u(TypedSwiperSlide, {
          children: u("img", {
            src: image.src,
            alt: image.alt,
            loading: index === 0 ? "eager" : "lazy"
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 63,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 62,
          columnNumber: 15
        }, this)), u("div", {
          className: "absolute top-1/2 left-0.5 z-50",
          children: u(NavigationButton, {
            prev: true
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 71,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 70,
          columnNumber: 11
        }, this), u("div", {
          className: "absolute top-1/2 right-0.5 z-50",
          children: u(NavigationButton, {
            next: true
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 74,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 73,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$6,
        lineNumber: 37,
        columnNumber: 9
      }, this), u("div", {
        className: "flex flex-col lg:flex-row items-end justify-between absolute z-10 p-5 bottom-0 left-0 w-full",
        children: [u("div", {
          className: "w-full lg:w-1/2",
          children: u(TypedSwiper, {
            modules: [Thumb, A11y],
            watchSlidesProgress: true,
            onSwiper: setThumbsSwiper,
            slidesPerView: 10,
            spaceBetween: 0,
            children: imageArray.filter((image) => {
              return image.alt.toLowerCase().indexOf("exclude") === -1;
            }).map((image, index) => u(TypedSwiperSlide, {
              children: ({
                isActive
              }) => u("img", {
                className: cn("rounded-full w-8 h-8 border border-white cursor-pointer mr-2", index === activeIndex && "border-black"),
                src: image.src,
                alt: image.alt,
                loading: "lazy"
              }, void 0, false, {
                fileName: _jsxFileName$6,
                lineNumber: 94,
                columnNumber: 23
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$6,
              lineNumber: 92,
              columnNumber: 19
            }, this))
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 80,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 79,
          columnNumber: 11
        }, this), u("div", {
          className: "w-full lg:w-1/2",
          children: u("div", {
            id: "containerForBullets",
            className: "flex items-center justify-end gap-2"
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 109,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 108,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$6,
        lineNumber: 78,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$6,
      lineNumber: 36,
      columnNumber: 7
    }, this)
  }, void 0);
}
register(ProductImageCarousel, "product-image-carousel");
var _jsxFileName$5 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/ProductFormButtons.tsx";
function ProductFormButtons({
  inStock,
  productData
}) {
  const product = typeof productData === "string" ? JSON.parse(productData) : productData;
  const isInStock = inStock.toLowerCase() === "true";
  const {
    toggleNotifyMe,
    setSelectedProduct
  } = useGlobal();
  const handleNotifyMe = () => {
    setSelectedProduct(product);
    toggleNotifyMe();
  };
  return u(b$2, {
    children: isInStock ? u(Button, {
      type: "submit",
      "data-atc": true,
      className: "w-full",
      children: "Add to cart"
    }, void 0, false, {
      fileName: _jsxFileName$5,
      lineNumber: 20,
      columnNumber: 9
    }, this) : u(Button, {
      className: "min-w-min w-full",
      mode: "secondary",
      onClick: () => handleNotifyMe(),
      type: "button",
      children: "Notify Me"
    }, void 0, false, {
      fileName: _jsxFileName$5,
      lineNumber: 24,
      columnNumber: 9
    }, this)
  }, void 0);
}
register(ProductFormButtons, "product-form-buttons", ["in-stock", "variant-id", "product-data"]);
function createContextScope$1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = G$1(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const value = T$1(() => context, Object.values(context));
      return /* @__PURE__ */ u(Context.Provider, { value, children });
    }
    function useContext2(consumerName, scope) {
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const context = x$1(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [Provider, useContext2];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return G$1(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return T$1(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes$1(createScope, ...createContextScopeDeps)];
}
function composeContextScopes$1(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return T$1(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
function createCollection(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope2] = createContextScope$1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(
    PROVIDER_NAME,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  );
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = xn.useRef(null);
    const itemMap = xn.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ u(CollectionProviderImpl, { scope, itemMap, collectionRef: ref, children });
  };
  CollectionProvider.displayName = PROVIDER_NAME;
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = xn.forwardRef(
    (props, forwardedRef) => {
      const { scope, children } = props;
      const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
      const composedRefs = useComposedRefs(forwardedRef, context.collectionRef);
      return /* @__PURE__ */ u(Slot, { ref: composedRefs, children });
    }
  );
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = xn.forwardRef(
    (props, forwardedRef) => {
      const { scope, children, ...itemData } = props;
      const ref = xn.useRef(null);
      const composedRefs = useComposedRefs(forwardedRef, ref);
      const context = useCollectionContext(ITEM_SLOT_NAME, scope);
      xn.useEffect(() => {
        context.itemMap.set(ref, { ref, ...itemData });
        return () => void context.itemMap.delete(ref);
      });
      return /* @__PURE__ */ u(Slot, { ...{ [ITEM_DATA_ATTR]: "" }, ref: composedRefs, children });
    }
  );
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection2(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = xn.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a2, b2) => orderedNodes.indexOf(a2.ref.current) - orderedNodes.indexOf(b2.ref.current)
      );
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [
    { Provider: CollectionProvider, Slot: CollectionSlot, ItemSlot: CollectionItemSlot },
    useCollection2,
    createCollectionScope2
  ];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = G$1(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const value = T$1(() => context, Object.values(context));
      return /* @__PURE__ */ u(Context.Provider, { value, children });
    }
    function useContext2(consumerName, scope) {
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const context = x$1(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [Provider, useContext2];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return G$1(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return T$1(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return T$1(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
var DirectionContext = G$1(void 0);
function useDirection(localDir) {
  const globalDir = x$1(DirectionContext);
  return localDir || globalDir || "ltr";
}
var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var GROUP_NAME = "RovingFocusGroup";
var [Collection, useCollection, createCollectionScope] = createCollection(GROUP_NAME);
var [createRovingFocusGroupContext, createRovingFocusGroupScope] = createContextScope(
  GROUP_NAME,
  [createCollectionScope]
);
var [RovingFocusProvider, useRovingFocusContext] = createRovingFocusGroupContext(GROUP_NAME);
var RovingFocusGroup = w(
  (props, forwardedRef) => {
    return /* @__PURE__ */ u(Collection.Provider, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(Collection.Slot, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(RovingFocusGroupImpl, { ...props, ref: forwardedRef }) }) });
  }
);
RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = w((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    orientation,
    loop: loop2 = false,
    dir,
    currentTabStopId: currentTabStopIdProp,
    defaultCurrentTabStopId,
    onCurrentTabStopIdChange,
    onEntryFocus,
    preventScrollOnEntryFocus = false,
    ...groupProps
  } = props;
  const ref = A$1(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const direction = useDirection(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = useControllableState({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = h(false);
  const handleEntryFocus = useCallbackRef$1(onEntryFocus);
  const getItems = useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = A$1(false);
  const [focusableItemsCount, setFocusableItemsCount] = h(0);
  y(() => {
    const node2 = ref.current;
    if (node2) {
      node2.addEventListener(ENTRY_FOCUS, handleEntryFocus);
      return () => node2.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */ u(
    RovingFocusProvider,
    {
      scope: __scopeRovingFocusGroup,
      orientation,
      dir: direction,
      loop: loop2,
      currentTabStopId,
      onItemFocus: q$1(
        (tabStopId) => setCurrentTabStopId(tabStopId),
        [setCurrentTabStopId]
      ),
      onItemShiftTab: q$1(() => setIsTabbingBackOut(true), []),
      onFocusableItemAdd: q$1(
        () => setFocusableItemsCount((prevCount) => prevCount + 1),
        []
      ),
      onFocusableItemRemove: q$1(
        () => setFocusableItemsCount((prevCount) => prevCount - 1),
        []
      ),
      children: /* @__PURE__ */ u(
        Primitive.div,
        {
          tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
          "data-orientation": orientation,
          ...groupProps,
          ref: composedRefs,
          style: { outline: "none", ...props.style },
          onMouseDown: composeEventHandlers(props.onMouseDown, () => {
            isClickFocusRef.current = true;
          }),
          onFocus: composeEventHandlers(props.onFocus, (event) => {
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
              const entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
              event.currentTarget.dispatchEvent(entryFocusEvent);
              if (!entryFocusEvent.defaultPrevented) {
                const items = getItems().filter((item) => item.focusable);
                const activeItem = items.find((item) => item.active);
                const currentItem = items.find((item) => item.id === currentTabStopId);
                const candidateItems = [activeItem, currentItem, ...items].filter(
                  Boolean
                );
                const candidateNodes = candidateItems.map((item) => item.ref.current);
                focusFirst(candidateNodes, preventScrollOnEntryFocus);
              }
            }
            isClickFocusRef.current = false;
          }),
          onBlur: composeEventHandlers(props.onBlur, () => setIsTabbingBackOut(false))
        }
      )
    }
  );
});
var ITEM_NAME = "RovingFocusGroupItem";
var RovingFocusGroupItem = w(
  (props, forwardedRef) => {
    const {
      __scopeRovingFocusGroup,
      focusable = true,
      active = false,
      tabStopId,
      ...itemProps
    } = props;
    const autoId = useId();
    const id = tabStopId || autoId;
    const context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd, onFocusableItemRemove } = context;
    y(() => {
      if (focusable) {
        onFocusableItemAdd();
        return () => onFocusableItemRemove();
      }
    }, [focusable, onFocusableItemAdd, onFocusableItemRemove]);
    return /* @__PURE__ */ u(
      Collection.ItemSlot,
      {
        scope: __scopeRovingFocusGroup,
        id,
        focusable,
        active,
        children: /* @__PURE__ */ u(
          Primitive.span,
          {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: composeEventHandlers(props.onMouseDown, (event) => {
              if (!focusable) event.preventDefault();
              else context.onItemFocus(id);
            }),
            onFocus: composeEventHandlers(props.onFocus, () => context.onItemFocus(id)),
            onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
              if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
              }
              if (event.target !== event.currentTarget) return;
              const focusIntent = getFocusIntent(event, context.orientation, context.dir);
              if (focusIntent !== void 0) {
                if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                event.preventDefault();
                const items = getItems().filter((item) => item.focusable);
                let candidateNodes = items.map((item) => item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                  if (focusIntent === "prev") candidateNodes.reverse();
                  const currentIndex = candidateNodes.indexOf(event.currentTarget);
                  candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                setTimeout(() => focusFirst(candidateNodes));
              }
            })
          }
        )
      }
    );
  }
);
RovingFocusGroupItem.displayName = ITEM_NAME;
var MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
  const key = getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates, preventScroll = false) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus({ preventScroll });
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function wrapArray(array, startIndex) {
  return array.map((_2, index) => array[(startIndex + index) % array.length]);
}
var Root = RovingFocusGroup;
var Item = RovingFocusGroupItem;
var TABS_NAME = "Tabs";
var [createTabsContext, createTabsScope] = createContextScope$2(TABS_NAME, [
  createRovingFocusGroupScope
]);
var useRovingFocusGroupScope = createRovingFocusGroupScope();
var [TabsProvider, useTabsContext] = createTabsContext(TABS_NAME);
var Tabs$1 = w(
  (props, forwardedRef) => {
    const {
      __scopeTabs,
      value: valueProp,
      onValueChange,
      defaultValue,
      orientation = "horizontal",
      dir,
      activationMode = "automatic",
      ...tabsProps
    } = props;
    const direction = useDirection(dir);
    const [value, setValue] = useControllableState({
      prop: valueProp,
      onChange: onValueChange,
      defaultProp: defaultValue
    });
    return /* @__PURE__ */ u(
      TabsProvider,
      {
        scope: __scopeTabs,
        baseId: useId(),
        value,
        onValueChange: setValue,
        orientation,
        dir: direction,
        activationMode,
        children: /* @__PURE__ */ u(
          Primitive.div,
          {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
          }
        )
      }
    );
  }
);
Tabs$1.displayName = TABS_NAME;
var TAB_LIST_NAME = "TabsList";
var TabsList$1 = w(
  (props, forwardedRef) => {
    const { __scopeTabs, loop: loop2 = true, ...listProps } = props;
    const context = useTabsContext(TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ u(
      Root,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop: loop2,
        children: /* @__PURE__ */ u(
          Primitive.div,
          {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
          }
        )
      }
    );
  }
);
TabsList$1.displayName = TAB_LIST_NAME;
var TRIGGER_NAME = "TabsTrigger";
var TabsTrigger$1 = w(
  (props, forwardedRef) => {
    const { __scopeTabs, value, disabled = false, ...triggerProps } = props;
    const context = useTabsContext(TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
    const triggerId = makeTriggerId(context.baseId, value);
    const contentId = makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ u(
      Item,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ u(
          Primitive.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: composeEventHandlers(props.onMouseDown, (event) => {
              if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onValueChange(value);
              } else {
                event.preventDefault();
              }
            }),
            onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
              if ([" ", "Enter"].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: composeEventHandlers(props.onFocus, () => {
              const isAutomaticActivation = context.activationMode !== "manual";
              if (!isSelected && !disabled && isAutomaticActivation) {
                context.onValueChange(value);
              }
            })
          }
        )
      }
    );
  }
);
TabsTrigger$1.displayName = TRIGGER_NAME;
var CONTENT_NAME = "TabsContent";
var TabsContent$1 = w(
  (props, forwardedRef) => {
    const { __scopeTabs, value, forceMount, children, ...contentProps } = props;
    const context = useTabsContext(CONTENT_NAME, __scopeTabs);
    const triggerId = makeTriggerId(context.baseId, value);
    const contentId = makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = A$1(isSelected);
    y(() => {
      const rAF = requestAnimationFrame(() => isMountAnimationPreventedRef.current = false);
      return () => cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ u(Presence, { present: forceMount || isSelected, children: ({ present }) => /* @__PURE__ */ u(
      Primitive.div,
      {
        "data-state": isSelected ? "active" : "inactive",
        "data-orientation": context.orientation,
        role: "tabpanel",
        "aria-labelledby": triggerId,
        hidden: !present,
        id: contentId,
        tabIndex: 0,
        ...contentProps,
        ref: forwardedRef,
        style: {
          ...props.style,
          animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
        },
        children: present && children
      }
    ) });
  }
);
TabsContent$1.displayName = CONTENT_NAME;
function makeTriggerId(baseId, value) {
  return `${baseId}-trigger-${value}`;
}
function makeContentId(baseId, value) {
  return `${baseId}-content-${value}`;
}
var Root2 = Tabs$1;
var List = TabsList$1;
var Trigger = TabsTrigger$1;
var Content = TabsContent$1;
var _jsxFileName$4 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/ui/tabs.tsx";
const Tabs = Root2;
const TabsList = w(({
  className,
  ...props
}, ref) => u(List, {
  ref,
  className: cn("h-auto p-0 bg-transparent border-b border-border", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$4,
  lineNumber: 13,
  columnNumber: 3
}, void 0));
TabsList.displayName = List.displayName;
const TabsTrigger = w(({
  className,
  ...props
}, ref) => u(Trigger, {
  ref,
  className: cn("py-2 font-medium data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:border-b-2 data-[state=active]:border-black text-button-sm uppercase mr-3", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$4,
  lineNumber: 28,
  columnNumber: 3
}, void 0));
TabsTrigger.displayName = Trigger.displayName;
const TabsContent = w(({
  className,
  ...props
}, ref) => u(Content, {
  ref,
  className: cn("mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 dark:ring-offset-neutral-950 dark:focus-visible:ring-neutral-300", className),
  ...props
}, void 0, false, {
  fileName: _jsxFileName$4,
  lineNumber: 43,
  columnNumber: 3
}, void 0));
TabsContent.displayName = Content.displayName;
var _jsxFileName$3 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/ReviewTabs.tsx";
function ReviewTabs(props) {
  const {
    id
  } = props;
  const initReviews = () => {
    var _a, _b, _c, _d, _e;
    if ((window == null ? void 0 : window.POWERREVIEWS) && ((_a = window == null ? void 0 : window.POWERREVIEWS) == null ? void 0 : _a.display) && ((_c = (_b = window == null ? void 0 : window.POWERREVIEWS) == null ? void 0 : _b.display) == null ? void 0 : _c.render)) {
      (_e = (_d = window == null ? void 0 : window.POWERREVIEWS) == null ? void 0 : _d.display) == null ? void 0 : _e.render({
        api_key: window.pwrCredentials.api_key,
        locale: window.pwrCredentials.locale,
        merchant_group_id: window.pwrCredentials.merchant_group_id,
        merchant_id: window.pwrCredentials.merchant_id,
        page_id: id,
        components: {
          QuestionDisplay: "pr-questiondisplay",
          ReviewDisplay: "pr-reviewdisplay",
          ReviewSnippet: "pr-reviewsnippet"
        }
      });
    }
  };
  y(() => {
    const intervalId = setInterval(() => {
      var _a, _b, _c;
      if ((window == null ? void 0 : window.POWERREVIEWS) && ((_a = window == null ? void 0 : window.POWERREVIEWS) == null ? void 0 : _a.display) && ((_c = (_b = window == null ? void 0 : window.POWERREVIEWS) == null ? void 0 : _b.display) == null ? void 0 : _c.render)) {
        initReviews();
        clearInterval(intervalId);
      }
    }, 500);
  }, []);
  return u(Tabs, {
    defaultValue: "reviews",
    onValueChange: () => {
      initReviews();
    },
    className: "w-full",
    children: [u(TabsList, {
      className: "border-b w-full justify-start",
      children: u("div", {
        className: "container",
        children: [u(TabsTrigger, {
          value: "reviews",
          children: "Reviews"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 53,
          columnNumber: 11
        }, this), u(TabsTrigger, {
          value: "questions",
          children: "Questions"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 54,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$3,
        lineNumber: 52,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$3,
      lineNumber: 51,
      columnNumber: 7
    }, this), u("div", {
      className: "container py-6 lg:py-10 ",
      children: [u(TabsContent, {
        value: "reviews",
        children: u("div", {
          id: "pr-reviewdisplay"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 59,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$3,
        lineNumber: 58,
        columnNumber: 9
      }, this), u(TabsContent, {
        value: "questions",
        children: u("div", {
          id: "pr-questiondisplay"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 62,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$3,
        lineNumber: 61,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$3,
      lineNumber: 57,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$3,
    lineNumber: 44,
    columnNumber: 5
  }, this);
}
register(ReviewTabs, "review-tabs");
var _jsxFileName$2 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/InstructionsColumn.tsx";
function InstructionsColumn({
  title,
  content,
  bullet_points,
  desktop_image,
  mobile_image,
  mode,
  html_tag_for_title
}) {
  const Component = html_tag_for_title;
  return u("div", {
    className: "md:container flex flex-col gap-6 md:gap-12",
    children: (title || content || bullet_points) && u("div", {
      className: twMerge("flex flex-col md:flex-row", mode == "right" && "md:flex-row-reverse"),
      children: [u("div", {
        className: "w-full md:w-[60%]",
        children: [desktop_image && u("div", {
          className: "hidden md:block",
          children: parse$1(JSON.parse(desktop_image))
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 38,
          columnNumber: 15
        }, this), mobile_image && u("div", {
          className: "md:hidden",
          children: [title && u(Component, {
            className: "font-primary pt-4 pb-6 md:pb-4 text-4xl text-black px-5 md:px-0",
            children: title
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 45,
            columnNumber: 19
          }, this), parse$1(JSON.parse(mobile_image))]
        }, void 0, true, {
          fileName: _jsxFileName$2,
          lineNumber: 43,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$2,
        lineNumber: 36,
        columnNumber: 11
      }, this), u("div", {
        className: twMerge("w-full md:w-[40%] px-5 md:pl-24 md:pr-0", mode == "right" && "md:pl-0 md:pr-24"),
        children: [title && u(Component, {
          className: twMerge("font-primary hidden md:block py-4 text-4xl md:text-6xl text-black"),
          children: title
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 61,
          columnNumber: 15
        }, this), content && u("div", {
          className: twMerge("font-primary py-4 text-2xl md:text-4xl text-black"),
          children: parse$1(content)
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 70,
          columnNumber: 15
        }, this), bullet_points && u("div", {
          className: twMerge("font-primary list-none text-shadow text-base md:text-xl pt-3.5 [&>ul>li]:relative [&>ul>li]:pl-[28px] [&>ul>li]:mb-2 [&>ul>li:last-child]:mb-0 [&>ul>li]:before:content-['●'] [&>ul>li]:before:absolute [&>ul>li]:before:left-0 [&>ul>li]:before:top-[-11px] md:[&>ul>li]:before:top-[-10px] [&>ul>li]:before:text-[30px]"),
          children: parse$1(bullet_points)
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 79,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$2,
        lineNumber: 54,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$2,
      lineNumber: 30,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$2,
    lineNumber: 28,
    columnNumber: 5
  }, this);
}
register(InstructionsColumn, "instructions-column");
var _jsxFileName$1 = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/WarrantyModal.tsx";
const WarrantyModal = ({
  children
}) => {
  const [open, setOpen] = t$2(h(false), "open");
  y(() => {
    const showFormButton = document.querySelector(".modal-wufoo");
    showFormButton == null ? void 0 : showFormButton.addEventListener("click", function() {
      const formWrapperEl = document.querySelector("#warranty-popup");
      formWrapperEl.classList.remove("hidden");
      setOpen(true);
    });
  }, []);
  return u("div", {
    className: "relative",
    children: [open && u(OverlayComponent, {
      clickHandler: () => setOpen(false),
      overlayClass: "backdrop-blur-[72px]"
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 25,
      columnNumber: 9
    }, void 0), u("div", {
      className: `${open ? "block fixed z-50 inset-0 overflow-auto max-w-full md:max-w-[700px] md:transform md:translate-x-1/2" : "hidden"}`,
      children: u("div", {
        className: "relative bg-white py-10 md:py-14",
        children: [u("button", {
          className: "absolute top-4 right-4 md:top-5 md:right-5",
          onClick: () => setOpen(false),
          children: u(PlusIcon, {
            className: "transform rotate-45",
            height: "24",
            width: "24"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 42,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 38,
          columnNumber: 11
        }, void 0), children]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 37,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 30,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$1,
    lineNumber: 23,
    columnNumber: 5
  }, void 0);
};
register(WarrantyModal, "warranty-modal");
var _jsxFileName = "/home/runner/work/PASH2024_PASH/PASH2024_PASH/src/components/products/VariantSelects.tsx";
function VariantSelects({
  productObject,
  defaultVariant,
  pickerType
}) {
  var _a;
  const {
    selectedVariant,
    setSelectedVariant
  } = useGlobal();
  const productData = JSON.parse(productObject);
  const [selectedOptions, setSelectedOptions] = t$2(h([]), "selectedOptions");
  y(() => {
    const initialVariant = productData.variants.find((variant) => variant.id === parseInt(defaultVariant));
    if (initialVariant) {
      setSelectedVariant(initialVariant);
      setSelectedOptions(initialVariant.options);
    }
  }, []);
  y(() => {
    document.querySelectorAll("[data-price]").forEach((selector) => {
      selector.innerHTML = shopifyFormatCurrency(selectedVariant.price, "${{ amount }}");
    });
    document.querySelectorAll("[data-compare-at-price]").forEach((selector) => {
      selector.innerHTML = shopifyFormatCurrency(selectedVariant.compare_at_price, "${{ amount }}");
    });
    document.querySelectorAll("product-form-buttons").forEach((selector) => {
      selector.setAttribute("in-stock", selectedVariant.available);
      selector.setAttribute("variant-id", selectedVariant.id);
    });
    document.querySelectorAll("[name=id]").forEach((selector) => {
      selector.value = selectedVariant.id;
    });
  }, [selectedVariant, selectedOptions]);
  const handleOptionChange = (optionIndex, value) => {
    const newOptions = selectedOptions;
    newOptions[optionIndex] = value;
    const matchingVariant = productData.variants.find((variant) => Object.entries(newOptions).every(([key, val]) => {
      return variant.options[key] === val;
    }));
    setSelectedOptions(newOptions);
    setSelectedVariant(matchingVariant);
  };
  y(() => {
    if (selectedVariant) {
      updateProductUrl(selectedVariant);
    }
  }, [selectedVariant]);
  const updateProductUrl = (selectedVariant2) => {
    if (!window.history.replaceState) return;
    if ((selectedVariant2 == null ? void 0 : selectedVariant2.id) === void 0) return;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", selectedVariant2 == null ? void 0 : selectedVariant2.id);
    window.history.replaceState(null, "", url.toString());
  };
  return u("div", {
    children: productData && ((_a = productData == null ? void 0 : productData.options) == null ? void 0 : _a.map((option, optionIndex) => u("div", {
      className: cn(option.values.length === 1 && "hidden"),
      children: [u("label", {
        class: "sr-only",
        children: option.name
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 13
      }, this), pickerType === "dropdown" ? u("select", {
        value: selectedOptions[optionIndex],
        onChange: (e2) => handleOptionChange(optionIndex, e2.target.value),
        class: "border border-tints-20 py-3 px-4 w-full",
        children: [u("option", {
          value: "",
          disabled: true,
          children: ["Select ", option.name]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 107,
          columnNumber: 17
        }, this), option.values.map((value) => u("option", {
          value,
          children: value
        }, value, false, {
          fileName: _jsxFileName,
          lineNumber: 111,
          columnNumber: 19
        }, this))]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 15
      }, this) : u("div", {
        className: cn("grid gap-2.5", option.values.length === 1 && "grid-cols-1", option.values.length == 2 && "grid-cols-2", option.values.length > 2 && "grid-cols-3", option.values.length === 1 && "hidden"),
        children: option.values.map((value) => u("button", {
          type: "button",
          className: cn(`cursor-pointer text-button-sm flex gap-3 items-center border py-3 px-8 text-center border-tint-40 peer-checked: relative before:content-[''] before:w-2 before:h-2 before:block before:rounded-full before:border before:border-black before:transition-colors`, selectedOptions[optionIndex] === value && "border-black before:bg-black before:border-transparent"),
          onClick: () => handleOptionChange(optionIndex, value),
          children: value
        }, value, false, {
          fileName: _jsxFileName,
          lineNumber: 127,
          columnNumber: 19
        }, this))
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 15
      }, this)]
    }, option.name, true, {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 11
    }, this)))
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 88,
    columnNumber: 5
  }, this);
}
register(VariantSelects, "variant-selects", [], {
  shadow: false
});
